// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z%27 fill=%27%235f6b7c%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cg fill=%27%235f6b7c%27%3e%3cpath d=%27M2 6.03a2 2 0 100 4 2 2 0 100-4zM14 6.03a2 2 0 100 4 2 2 0 100-4zM8 6.03a2 2 0 100 4 2 2 0 100-4z%27/%3e%3c/g%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z%27 fill=%27%23abb3bf%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cg fill=%27%23abb3bf%27%3e%3cpath d=%27M2 6.03a2 2 0 100 4 2 2 0 100-4zM14 6.03a2 2 0 100 4 2 2 0 100-4zM8 6.03a2 2 0 100 4 2 2 0 100-4z%27/%3e%3c/g%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z%27 fill=%27white%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z%27 fill=%27white%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z%27 fill=%27%23111418%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z%27 fill=%27%23111418%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
html{
  box-sizing:border-box;
}

*,
*::before,
*::after{
  box-sizing:inherit;
}

body{
  font-size:14px;
  font-weight:400;
  letter-spacing:0;
  line-height:1.28581;
  text-transform:none;
  color:#1c2127;
  font-family:-apple-system, "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Open Sans", "Helvetica Neue", "blueprint-icons-16", sans-serif;
}

p{
  margin-bottom:10px;
  margin-top:0;
}

small{
  font-size:12px;
}

strong{
  font-weight:600;
}

::selection{
  background:rgba(125, 188, 255, 0.6);
}
.bp4-icon{
  display:inline-block;
  flex:0 0 auto;
  vertical-align:text-bottom;
}
.bp4-icon:not(:empty)::before{
  content:"" !important;
  content:unset !important;
}
.bp4-icon > svg{
  display:block;
}
.bp4-icon > svg:not([fill]){
  fill:currentcolor;
}

span.bp4-icon-standard{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  display:inline-block;
}

span.bp4-icon-large{
  font-family:"blueprint-icons-20", sans-serif;
  font-size:20px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  display:inline-block;
}

span.bp4-icon:empty{
  font-family:"blueprint-icons-20";
  font-size:inherit;
  font-style:normal;
  font-weight:400;
  line-height:1;
}
span.bp4-icon:empty::before{
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
}

.bp4-icon-add::before{
  content:"\\f109";
}

.bp4-icon-add-clip::before{
  content:"\\f101";
}

.bp4-icon-add-column-left::before{
  content:"\\f102";
}

.bp4-icon-add-column-right::before{
  content:"\\f103";
}

.bp4-icon-add-location::before{
  content:"\\f104";
}

.bp4-icon-add-row-bottom::before{
  content:"\\f105";
}

.bp4-icon-add-row-top::before{
  content:"\\f106";
}

.bp4-icon-add-to-artifact::before{
  content:"\\f107";
}

.bp4-icon-add-to-folder::before{
  content:"\\f108";
}

.bp4-icon-aimpoints-target::before{
  content:"\\f335";
}

.bp4-icon-airplane::before{
  content:"\\f10a";
}

.bp4-icon-align-center::before{
  content:"\\f10b";
}

.bp4-icon-align-justify::before{
  content:"\\f10c";
}

.bp4-icon-align-left::before{
  content:"\\f10d";
}

.bp4-icon-align-right::before{
  content:"\\f10e";
}

.bp4-icon-alignment-bottom::before{
  content:"\\f10f";
}

.bp4-icon-alignment-horizontal-center::before{
  content:"\\f110";
}

.bp4-icon-alignment-left::before{
  content:"\\f111";
}

.bp4-icon-alignment-right::before{
  content:"\\f112";
}

.bp4-icon-alignment-top::before{
  content:"\\f113";
}

.bp4-icon-alignment-vertical-center::before{
  content:"\\f114";
}

.bp4-icon-ammunition::before{
  content:"\\f342";
}

.bp4-icon-anchor::before{
  content:"\\f330";
}

.bp4-icon-annotation::before{
  content:"\\f115";
}

.bp4-icon-antenna::before{
  content:"\\f116";
}

.bp4-icon-app-header::before{
  content:"\\f117";
}

.bp4-icon-application::before{
  content:"\\f118";
}

.bp4-icon-applications::before{
  content:"\\f119";
}

.bp4-icon-archive::before{
  content:"\\f11a";
}

.bp4-icon-area-of-interest::before{
  content:"\\f11b";
}

.bp4-icon-array::before{
  content:"\\f121";
}

.bp4-icon-array-boolean::before{
  content:"\\f11c";
}

.bp4-icon-array-date::before{
  content:"\\f11d";
}

.bp4-icon-array-floating-point::before{
  content:"\\f32d";
}

.bp4-icon-array-numeric::before{
  content:"\\f11e";
}

.bp4-icon-array-string::before{
  content:"\\f11f";
}

.bp4-icon-array-timestamp::before{
  content:"\\f120";
}

.bp4-icon-arrow-bottom-left::before{
  content:"\\f122";
}

.bp4-icon-arrow-bottom-right::before{
  content:"\\f123";
}

.bp4-icon-arrow-down::before{
  content:"\\f124";
}

.bp4-icon-arrow-left::before{
  content:"\\f125";
}

.bp4-icon-arrow-right::before{
  content:"\\f126";
}

.bp4-icon-arrow-top-left::before{
  content:"\\f127";
}

.bp4-icon-arrow-top-right::before{
  content:"\\f128";
}

.bp4-icon-arrow-up::before{
  content:"\\f129";
}

.bp4-icon-arrows-horizontal::before{
  content:"\\f12a";
}

.bp4-icon-arrows-vertical::before{
  content:"\\f12b";
}

.bp4-icon-asterisk::before{
  content:"\\f12c";
}

.bp4-icon-at::before{
  content:"\\f331";
}

.bp4-icon-automatic-updates::before{
  content:"\\f12d";
}

.bp4-icon-axle::before{
  content:"\\f338";
}

.bp4-icon-backlink::before{
  content:"\\f12e";
}

.bp4-icon-badge::before{
  content:"\\f12f";
}

.bp4-icon-ban-circle::before{
  content:"\\f130";
}

.bp4-icon-bank-account::before{
  content:"\\f131";
}

.bp4-icon-barcode::before{
  content:"\\f132";
}

.bp4-icon-blank::before{
  content:"\\f133";
}

.bp4-icon-blocked-person::before{
  content:"\\f134";
}

.bp4-icon-bold::before{
  content:"\\f135";
}

.bp4-icon-book::before{
  content:"\\f136";
}

.bp4-icon-bookmark::before{
  content:"\\f137";
}

.bp4-icon-box::before{
  content:"\\f138";
}

.bp4-icon-briefcase::before{
  content:"\\f139";
}

.bp4-icon-bring-data::before{
  content:"\\f13a";
}

.bp4-icon-bug::before{
  content:"\\f32e";
}

.bp4-icon-buggy::before{
  content:"\\f13b";
}

.bp4-icon-build::before{
  content:"\\f13c";
}

.bp4-icon-calculator::before{
  content:"\\f13d";
}

.bp4-icon-calendar::before{
  content:"\\f13e";
}

.bp4-icon-camera::before{
  content:"\\f13f";
}

.bp4-icon-caret-down::before{
  content:"\\f140";
}

.bp4-icon-caret-left::before{
  content:"\\f141";
}

.bp4-icon-caret-right::before{
  content:"\\f142";
}

.bp4-icon-caret-up::before{
  content:"\\f143";
}

.bp4-icon-cargo-ship::before{
  content:"\\f144";
}

.bp4-icon-cell-tower::before{
  content:"\\f145";
}

.bp4-icon-changes::before{
  content:"\\f146";
}

.bp4-icon-chart::before{
  content:"\\f147";
}

.bp4-icon-chat::before{
  content:"\\f148";
}

.bp4-icon-chevron-backward::before{
  content:"\\f149";
}

.bp4-icon-chevron-down::before{
  content:"\\f14a";
}

.bp4-icon-chevron-forward::before{
  content:"\\f14b";
}

.bp4-icon-chevron-left::before{
  content:"\\f14c";
}

.bp4-icon-chevron-right::before{
  content:"\\f14d";
}

.bp4-icon-chevron-up::before{
  content:"\\f14e";
}

.bp4-icon-circle::before{
  content:"\\f153";
}

.bp4-icon-circle-arrow-down::before{
  content:"\\f14f";
}

.bp4-icon-circle-arrow-left::before{
  content:"\\f150";
}

.bp4-icon-circle-arrow-right::before{
  content:"\\f151";
}

.bp4-icon-circle-arrow-up::before{
  content:"\\f152";
}

.bp4-icon-citation::before{
  content:"\\f154";
}

.bp4-icon-clean::before{
  content:"\\f155";
}

.bp4-icon-clip::before{
  content:"\\f156";
}

.bp4-icon-clipboard::before{
  content:"\\f157";
}

.bp4-icon-cloud::before{
  content:"\\f15a";
}

.bp4-icon-cloud-download::before{
  content:"\\f158";
}

.bp4-icon-cloud-upload::before{
  content:"\\f159";
}

.bp4-icon-code::before{
  content:"\\f15c";
}

.bp4-icon-code-block::before{
  content:"\\f15b";
}

.bp4-icon-cog::before{
  content:"\\f15d";
}

.bp4-icon-collapse-all::before{
  content:"\\f15e";
}

.bp4-icon-color-fill::before{
  content:"\\f328";
}

.bp4-icon-column-layout::before{
  content:"\\f15f";
}

.bp4-icon-comment::before{
  content:"\\f160";
}

.bp4-icon-comparison::before{
  content:"\\f161";
}

.bp4-icon-compass::before{
  content:"\\f162";
}

.bp4-icon-compressed::before{
  content:"\\f163";
}

.bp4-icon-confirm::before{
  content:"\\f164";
}

.bp4-icon-console::before{
  content:"\\f165";
}

.bp4-icon-contrast::before{
  content:"\\f166";
}

.bp4-icon-control::before{
  content:"\\f167";
}

.bp4-icon-credit-card::before{
  content:"\\f168";
}

.bp4-icon-cross::before{
  content:"\\f169";
}

.bp4-icon-cross-circle::before{
  content:"\\f336";
}

.bp4-icon-crown::before{
  content:"\\f16a";
}

.bp4-icon-cube::before{
  content:"\\f16d";
}

.bp4-icon-cube-add::before{
  content:"\\f16b";
}

.bp4-icon-cube-remove::before{
  content:"\\f16c";
}

.bp4-icon-curved-range-chart::before{
  content:"\\f16e";
}

.bp4-icon-cut::before{
  content:"\\f16f";
}

.bp4-icon-cycle::before{
  content:"\\f170";
}

.bp4-icon-dashboard::before{
  content:"\\f171";
}

.bp4-icon-data-connection::before{
  content:"\\f172";
}

.bp4-icon-data-lineage::before{
  content:"\\f173";
}

.bp4-icon-database::before{
  content:"\\f174";
}

.bp4-icon-delete::before{
  content:"\\f175";
}

.bp4-icon-delta::before{
  content:"\\f176";
}

.bp4-icon-derive-column::before{
  content:"\\f177";
}

.bp4-icon-desktop::before{
  content:"\\f178";
}

.bp4-icon-detection::before{
  content:"\\f341";
}

.bp4-icon-diagnosis::before{
  content:"\\f179";
}

.bp4-icon-diagram-tree::before{
  content:"\\f17a";
}

.bp4-icon-direction-left::before{
  content:"\\f17b";
}

.bp4-icon-direction-right::before{
  content:"\\f17c";
}

.bp4-icon-disable::before{
  content:"\\f17d";
}

.bp4-icon-divide::before{
  content:"\\f327";
}

.bp4-icon-document::before{
  content:"\\f180";
}

.bp4-icon-document-open::before{
  content:"\\f17e";
}

.bp4-icon-document-share::before{
  content:"\\f17f";
}

.bp4-icon-dollar::before{
  content:"\\f181";
}

.bp4-icon-dot::before{
  content:"\\f182";
}

.bp4-icon-double-caret-horizontal::before{
  content:"\\f183";
}

.bp4-icon-double-caret-vertical::before{
  content:"\\f184";
}

.bp4-icon-double-chevron-down::before{
  content:"\\f185";
}

.bp4-icon-double-chevron-left::before{
  content:"\\f186";
}

.bp4-icon-double-chevron-right::before{
  content:"\\f187";
}

.bp4-icon-double-chevron-up::before{
  content:"\\f188";
}

.bp4-icon-doughnut-chart::before{
  content:"\\f189";
}

.bp4-icon-download::before{
  content:"\\f18a";
}

.bp4-icon-drag-handle-horizontal::before{
  content:"\\f18b";
}

.bp4-icon-drag-handle-vertical::before{
  content:"\\f18c";
}

.bp4-icon-draw::before{
  content:"\\f18d";
}

.bp4-icon-drawer-left::before{
  content:"\\f18f";
}

.bp4-icon-drawer-left-filled::before{
  content:"\\f18e";
}

.bp4-icon-drawer-right::before{
  content:"\\f191";
}

.bp4-icon-drawer-right-filled::before{
  content:"\\f190";
}

.bp4-icon-drive-time::before{
  content:"\\f192";
}

.bp4-icon-duplicate::before{
  content:"\\f193";
}

.bp4-icon-edit::before{
  content:"\\f194";
}

.bp4-icon-eject::before{
  content:"\\f195";
}

.bp4-icon-emoji::before{
  content:"\\f196";
}

.bp4-icon-endorsed::before{
  content:"\\f197";
}

.bp4-icon-envelope::before{
  content:"\\f198";
}

.bp4-icon-equals::before{
  content:"\\f199";
}

.bp4-icon-eraser::before{
  content:"\\f19a";
}

.bp4-icon-error::before{
  content:"\\f19b";
}

.bp4-icon-euro::before{
  content:"\\f19c";
}

.bp4-icon-exchange::before{
  content:"\\f19d";
}

.bp4-icon-exclude-row::before{
  content:"\\f19e";
}

.bp4-icon-expand-all::before{
  content:"\\f19f";
}

.bp4-icon-export::before{
  content:"\\f1a0";
}

.bp4-icon-eye-off::before{
  content:"\\f1a1";
}

.bp4-icon-eye-on::before{
  content:"\\f1a2";
}

.bp4-icon-eye-open::before{
  content:"\\f1a3";
}

.bp4-icon-fast-backward::before{
  content:"\\f1a4";
}

.bp4-icon-fast-forward::before{
  content:"\\f1a5";
}

.bp4-icon-feed::before{
  content:"\\f1a7";
}

.bp4-icon-feed-subscribed::before{
  content:"\\f1a6";
}

.bp4-icon-film::before{
  content:"\\f1a8";
}

.bp4-icon-filter::before{
  content:"\\f1ad";
}

.bp4-icon-filter-keep::before{
  content:"\\f1a9";
}

.bp4-icon-filter-list::before{
  content:"\\f1aa";
}

.bp4-icon-filter-open::before{
  content:"\\f1ab";
}

.bp4-icon-filter-remove::before{
  content:"\\f1ac";
}

.bp4-icon-flag::before{
  content:"\\f1ae";
}

.bp4-icon-flame::before{
  content:"\\f1af";
}

.bp4-icon-flash::before{
  content:"\\f1b0";
}

.bp4-icon-floating-point::before{
  content:"\\f32c";
}

.bp4-icon-floppy-disk::before{
  content:"\\f1b1";
}

.bp4-icon-flow-branch::before{
  content:"\\f1b2";
}

.bp4-icon-flow-end::before{
  content:"\\f1b3";
}

.bp4-icon-flow-linear::before{
  content:"\\f1b4";
}

.bp4-icon-flow-review::before{
  content:"\\f1b6";
}

.bp4-icon-flow-review-branch::before{
  content:"\\f1b5";
}

.bp4-icon-flows::before{
  content:"\\f1b7";
}

.bp4-icon-folder-close::before{
  content:"\\f1b8";
}

.bp4-icon-folder-new::before{
  content:"\\f1b9";
}

.bp4-icon-folder-open::before{
  content:"\\f1ba";
}

.bp4-icon-folder-shared::before{
  content:"\\f1bc";
}

.bp4-icon-folder-shared-open::before{
  content:"\\f1bb";
}

.bp4-icon-follower::before{
  content:"\\f1bd";
}

.bp4-icon-following::before{
  content:"\\f1be";
}

.bp4-icon-font::before{
  content:"\\f1bf";
}

.bp4-icon-fork::before{
  content:"\\f1c0";
}

.bp4-icon-form::before{
  content:"\\f1c1";
}

.bp4-icon-fuel::before{
  content:"\\f323";
}

.bp4-icon-full-circle::before{
  content:"\\f1c2";
}

.bp4-icon-full-stacked-chart::before{
  content:"\\f1c3";
}

.bp4-icon-fullscreen::before{
  content:"\\f1c4";
}

.bp4-icon-function::before{
  content:"\\f1c5";
}

.bp4-icon-gantt-chart::before{
  content:"\\f1c6";
}

.bp4-icon-geofence::before{
  content:"\\f1c7";
}

.bp4-icon-geolocation::before{
  content:"\\f1c8";
}

.bp4-icon-geosearch::before{
  content:"\\f1c9";
}

.bp4-icon-git-branch::before{
  content:"\\f1ca";
}

.bp4-icon-git-commit::before{
  content:"\\f1cb";
}

.bp4-icon-git-merge::before{
  content:"\\f1cc";
}

.bp4-icon-git-new-branch::before{
  content:"\\f1cd";
}

.bp4-icon-git-pull::before{
  content:"\\f1ce";
}

.bp4-icon-git-push::before{
  content:"\\f1cf";
}

.bp4-icon-git-repo::before{
  content:"\\f1d0";
}

.bp4-icon-glass::before{
  content:"\\f1d1";
}

.bp4-icon-globe::before{
  content:"\\f1d3";
}

.bp4-icon-globe-network::before{
  content:"\\f1d2";
}

.bp4-icon-graph::before{
  content:"\\f1d5";
}

.bp4-icon-graph-remove::before{
  content:"\\f1d4";
}

.bp4-icon-greater-than::before{
  content:"\\f1d7";
}

.bp4-icon-greater-than-or-equal-to::before{
  content:"\\f1d6";
}

.bp4-icon-grid::before{
  content:"\\f1d9";
}

.bp4-icon-grid-view::before{
  content:"\\f1d8";
}

.bp4-icon-group-objects::before{
  content:"\\f1da";
}

.bp4-icon-grouped-bar-chart::before{
  content:"\\f1db";
}

.bp4-icon-hand::before{
  content:"\\f1e0";
}

.bp4-icon-hand-down::before{
  content:"\\f1dc";
}

.bp4-icon-hand-left::before{
  content:"\\f1dd";
}

.bp4-icon-hand-right::before{
  content:"\\f1de";
}

.bp4-icon-hand-up::before{
  content:"\\f1df";
}

.bp4-icon-hat::before{
  content:"\\f1e1";
}

.bp4-icon-header::before{
  content:"\\f1e5";
}

.bp4-icon-header-one::before{
  content:"\\f1e2";
}

.bp4-icon-header-three::before{
  content:"\\f1e3";
}

.bp4-icon-header-two::before{
  content:"\\f1e4";
}

.bp4-icon-headset::before{
  content:"\\f1e6";
}

.bp4-icon-heart::before{
  content:"\\f1e8";
}

.bp4-icon-heart-broken::before{
  content:"\\f1e7";
}

.bp4-icon-heat-grid::before{
  content:"\\f1e9";
}

.bp4-icon-heatmap::before{
  content:"\\f1ea";
}

.bp4-icon-helicopter::before{
  content:"\\f1eb";
}

.bp4-icon-help::before{
  content:"\\f1ec";
}

.bp4-icon-helper-management::before{
  content:"\\f1ed";
}

.bp4-icon-high-priority::before{
  content:"\\f1ee";
}

.bp4-icon-high-voltage-pole::before{
  content:"\\f333";
}

.bp4-icon-highlight::before{
  content:"\\f1ef";
}

.bp4-icon-history::before{
  content:"\\f1f0";
}

.bp4-icon-home::before{
  content:"\\f1f1";
}

.bp4-icon-horizontal-bar-chart::before{
  content:"\\f1f4";
}

.bp4-icon-horizontal-bar-chart-asc::before{
  content:"\\f1f2";
}

.bp4-icon-horizontal-bar-chart-desc::before{
  content:"\\f1f3";
}

.bp4-icon-horizontal-distribution::before{
  content:"\\f1f5";
}

.bp4-icon-horizontal-inbetween::before{
  content:"\\f329";
}

.bp4-icon-hurricane::before{
  content:"\\f1f6";
}

.bp4-icon-id-number::before{
  content:"\\f1f7";
}

.bp4-icon-image-rotate-left::before{
  content:"\\f1f8";
}

.bp4-icon-image-rotate-right::before{
  content:"\\f1f9";
}

.bp4-icon-import::before{
  content:"\\f1fa";
}

.bp4-icon-inbox::before{
  content:"\\f1ff";
}

.bp4-icon-inbox-filtered::before{
  content:"\\f1fb";
}

.bp4-icon-inbox-geo::before{
  content:"\\f1fc";
}

.bp4-icon-inbox-search::before{
  content:"\\f1fd";
}

.bp4-icon-inbox-update::before{
  content:"\\f1fe";
}

.bp4-icon-info-sign::before{
  content:"\\f200";
}

.bp4-icon-inheritance::before{
  content:"\\f201";
}

.bp4-icon-inherited-group::before{
  content:"\\f202";
}

.bp4-icon-inner-join::before{
  content:"\\f203";
}

.bp4-icon-insert::before{
  content:"\\f204";
}

.bp4-icon-intelligence::before{
  content:"\\f337";
}

.bp4-icon-intersection::before{
  content:"\\f205";
}

.bp4-icon-ip-address::before{
  content:"\\f206";
}

.bp4-icon-issue::before{
  content:"\\f209";
}

.bp4-icon-issue-closed::before{
  content:"\\f207";
}

.bp4-icon-issue-new::before{
  content:"\\f208";
}

.bp4-icon-italic::before{
  content:"\\f20a";
}

.bp4-icon-join-table::before{
  content:"\\f20b";
}

.bp4-icon-key::before{
  content:"\\f215";
}

.bp4-icon-key-backspace::before{
  content:"\\f20c";
}

.bp4-icon-key-command::before{
  content:"\\f20d";
}

.bp4-icon-key-control::before{
  content:"\\f20e";
}

.bp4-icon-key-delete::before{
  content:"\\f20f";
}

.bp4-icon-key-enter::before{
  content:"\\f210";
}

.bp4-icon-key-escape::before{
  content:"\\f211";
}

.bp4-icon-key-option::before{
  content:"\\f212";
}

.bp4-icon-key-shift::before{
  content:"\\f213";
}

.bp4-icon-key-tab::before{
  content:"\\f214";
}

.bp4-icon-known-vehicle::before{
  content:"\\f216";
}

.bp4-icon-lab-test::before{
  content:"\\f217";
}

.bp4-icon-label::before{
  content:"\\f218";
}

.bp4-icon-layer::before{
  content:"\\f21a";
}

.bp4-icon-layer-outline::before{
  content:"\\f219";
}

.bp4-icon-layers::before{
  content:"\\f21b";
}

.bp4-icon-layout::before{
  content:"\\f225";
}

.bp4-icon-layout-auto::before{
  content:"\\f21c";
}

.bp4-icon-layout-balloon::before{
  content:"\\f21d";
}

.bp4-icon-layout-circle::before{
  content:"\\f21e";
}

.bp4-icon-layout-grid::before{
  content:"\\f21f";
}

.bp4-icon-layout-group-by::before{
  content:"\\f220";
}

.bp4-icon-layout-hierarchy::before{
  content:"\\f221";
}

.bp4-icon-layout-linear::before{
  content:"\\f222";
}

.bp4-icon-layout-skew-grid::before{
  content:"\\f223";
}

.bp4-icon-layout-sorted-clusters::before{
  content:"\\f224";
}

.bp4-icon-learning::before{
  content:"\\f226";
}

.bp4-icon-left-join::before{
  content:"\\f227";
}

.bp4-icon-lengthen-text::before{
  content:"\\f33e";
}

.bp4-icon-less-than::before{
  content:"\\f229";
}

.bp4-icon-less-than-or-equal-to::before{
  content:"\\f228";
}

.bp4-icon-lifesaver::before{
  content:"\\f22a";
}

.bp4-icon-lightbulb::before{
  content:"\\f22b";
}

.bp4-icon-lightning::before{
  content:"\\f22c";
}

.bp4-icon-link::before{
  content:"\\f22d";
}

.bp4-icon-list::before{
  content:"\\f230";
}

.bp4-icon-list-columns::before{
  content:"\\f22e";
}

.bp4-icon-list-detail-view::before{
  content:"\\f22f";
}

.bp4-icon-locate::before{
  content:"\\f231";
}

.bp4-icon-lock::before{
  content:"\\f232";
}

.bp4-icon-locomotive::before{
  content:"\\f33b";
}

.bp4-icon-log-in::before{
  content:"\\f233";
}

.bp4-icon-log-out::before{
  content:"\\f234";
}

.bp4-icon-low-voltage-pole::before{
  content:"\\f332";
}

.bp4-icon-manual::before{
  content:"\\f235";
}

.bp4-icon-manually-entered-data::before{
  content:"\\f236";
}

.bp4-icon-many-to-many::before{
  content:"\\f237";
}

.bp4-icon-many-to-one::before{
  content:"\\f238";
}

.bp4-icon-map::before{
  content:"\\f23b";
}

.bp4-icon-map-create::before{
  content:"\\f239";
}

.bp4-icon-map-marker::before{
  content:"\\f23a";
}

.bp4-icon-maximize::before{
  content:"\\f23c";
}

.bp4-icon-media::before{
  content:"\\f23d";
}

.bp4-icon-menu::before{
  content:"\\f240";
}

.bp4-icon-menu-closed::before{
  content:"\\f23e";
}

.bp4-icon-menu-open::before{
  content:"\\f23f";
}

.bp4-icon-merge-columns::before{
  content:"\\f241";
}

.bp4-icon-merge-links::before{
  content:"\\f242";
}

.bp4-icon-minimize::before{
  content:"\\f243";
}

.bp4-icon-minus::before{
  content:"\\f244";
}

.bp4-icon-mobile-phone::before{
  content:"\\f245";
}

.bp4-icon-mobile-video::before{
  content:"\\f246";
}

.bp4-icon-modal::before{
  content:"\\f248";
}

.bp4-icon-modal-filled::before{
  content:"\\f247";
}

.bp4-icon-model::before{
  content:"\\f33d";
}

.bp4-icon-moon::before{
  content:"\\f249";
}

.bp4-icon-more::before{
  content:"\\f24a";
}

.bp4-icon-mountain::before{
  content:"\\f24b";
}

.bp4-icon-move::before{
  content:"\\f24c";
}

.bp4-icon-mugshot::before{
  content:"\\f24d";
}

.bp4-icon-multi-select::before{
  content:"\\f24e";
}

.bp4-icon-music::before{
  content:"\\f24f";
}

.bp4-icon-nest::before{
  content:"\\f250";
}

.bp4-icon-new-drawing::before{
  content:"\\f251";
}

.bp4-icon-new-grid-item::before{
  content:"\\f252";
}

.bp4-icon-new-layer::before{
  content:"\\f253";
}

.bp4-icon-new-layers::before{
  content:"\\f254";
}

.bp4-icon-new-link::before{
  content:"\\f255";
}

.bp4-icon-new-object::before{
  content:"\\f256";
}

.bp4-icon-new-person::before{
  content:"\\f257";
}

.bp4-icon-new-prescription::before{
  content:"\\f258";
}

.bp4-icon-new-text-box::before{
  content:"\\f259";
}

.bp4-icon-ninja::before{
  content:"\\f25a";
}

.bp4-icon-not-equal-to::before{
  content:"\\f25b";
}

.bp4-icon-notifications::before{
  content:"\\f25e";
}

.bp4-icon-notifications-snooze::before{
  content:"\\f25c";
}

.bp4-icon-notifications-updated::before{
  content:"\\f25d";
}

.bp4-icon-numbered-list::before{
  content:"\\f25f";
}

.bp4-icon-numerical::before{
  content:"\\f260";
}

.bp4-icon-office::before{
  content:"\\f261";
}

.bp4-icon-offline::before{
  content:"\\f262";
}

.bp4-icon-oil-field::before{
  content:"\\f263";
}

.bp4-icon-one-column::before{
  content:"\\f264";
}

.bp4-icon-one-to-many::before{
  content:"\\f265";
}

.bp4-icon-one-to-one::before{
  content:"\\f266";
}

.bp4-icon-open-application::before{
  content:"\\f32b";
}

.bp4-icon-outdated::before{
  content:"\\f267";
}

.bp4-icon-page-layout::before{
  content:"\\f268";
}

.bp4-icon-panel-stats::before{
  content:"\\f269";
}

.bp4-icon-panel-table::before{
  content:"\\f26a";
}

.bp4-icon-paperclip::before{
  content:"\\f26b";
}

.bp4-icon-paragraph::before{
  content:"\\f26c";
}

.bp4-icon-path::before{
  content:"\\f26e";
}

.bp4-icon-path-search::before{
  content:"\\f26d";
}

.bp4-icon-pause::before{
  content:"\\f26f";
}

.bp4-icon-people::before{
  content:"\\f270";
}

.bp4-icon-percentage::before{
  content:"\\f271";
}

.bp4-icon-person::before{
  content:"\\f272";
}

.bp4-icon-phone::before{
  content:"\\f273";
}

.bp4-icon-pie-chart::before{
  content:"\\f274";
}

.bp4-icon-pin::before{
  content:"\\f275";
}

.bp4-icon-pivot::before{
  content:"\\f277";
}

.bp4-icon-pivot-table::before{
  content:"\\f276";
}

.bp4-icon-play::before{
  content:"\\f278";
}

.bp4-icon-playbook::before{
  content:"\\f324";
}

.bp4-icon-plus::before{
  content:"\\f279";
}

.bp4-icon-polygon-filter::before{
  content:"\\f27a";
}

.bp4-icon-power::before{
  content:"\\f27b";
}

.bp4-icon-predictive-analysis::before{
  content:"\\f27c";
}

.bp4-icon-prescription::before{
  content:"\\f27d";
}

.bp4-icon-presentation::before{
  content:"\\f27e";
}

.bp4-icon-print::before{
  content:"\\f27f";
}

.bp4-icon-projects::before{
  content:"\\f280";
}

.bp4-icon-properties::before{
  content:"\\f281";
}

.bp4-icon-property::before{
  content:"\\f282";
}

.bp4-icon-publish-function::before{
  content:"\\f283";
}

.bp4-icon-pulse::before{
  content:"\\f284";
}

.bp4-icon-rain::before{
  content:"\\f285";
}

.bp4-icon-random::before{
  content:"\\f286";
}

.bp4-icon-record::before{
  content:"\\f287";
}

.bp4-icon-rect-height::before{
  content:"\\f325";
}

.bp4-icon-rect-width::before{
  content:"\\f326";
}

.bp4-icon-rectangle::before{
  content:"\\f321";
}

.bp4-icon-redo::before{
  content:"\\f288";
}

.bp4-icon-refresh::before{
  content:"\\f289";
}

.bp4-icon-regex::before{
  content:"\\f32f";
}

.bp4-icon-regression-chart::before{
  content:"\\f28a";
}

.bp4-icon-remove::before{
  content:"\\f290";
}

.bp4-icon-remove-column::before{
  content:"\\f28d";
}

.bp4-icon-remove-column-left::before{
  content:"\\f28b";
}

.bp4-icon-remove-column-right::before{
  content:"\\f28c";
}

.bp4-icon-remove-row-bottom::before{
  content:"\\f28e";
}

.bp4-icon-remove-row-top::before{
  content:"\\f28f";
}

.bp4-icon-repeat::before{
  content:"\\f291";
}

.bp4-icon-reset::before{
  content:"\\f292";
}

.bp4-icon-resolve::before{
  content:"\\f293";
}

.bp4-icon-rig::before{
  content:"\\f294";
}

.bp4-icon-right-join::before{
  content:"\\f295";
}

.bp4-icon-ring::before{
  content:"\\f296";
}

.bp4-icon-rocket::before{
  content:"\\f298";
}

.bp4-icon-rocket-slant::before{
  content:"\\f297";
}

.bp4-icon-rotate-document::before{
  content:"\\f299";
}

.bp4-icon-rotate-page::before{
  content:"\\f29a";
}

.bp4-icon-route::before{
  content:"\\f29b";
}

.bp4-icon-satellite::before{
  content:"\\f29c";
}

.bp4-icon-saved::before{
  content:"\\f29d";
}

.bp4-icon-scatter-plot::before{
  content:"\\f29e";
}

.bp4-icon-search::before{
  content:"\\f2a2";
}

.bp4-icon-search-around::before{
  content:"\\f29f";
}

.bp4-icon-search-template::before{
  content:"\\f2a0";
}

.bp4-icon-search-text::before{
  content:"\\f2a1";
}

.bp4-icon-segmented-control::before{
  content:"\\f2a3";
}

.bp4-icon-select::before{
  content:"\\f2a4";
}

.bp4-icon-selection::before{
  content:"\\f2a5";
}

.bp4-icon-send-message::before{
  content:"\\f2a6";
}

.bp4-icon-send-to::before{
  content:"\\f2a9";
}

.bp4-icon-send-to-graph::before{
  content:"\\f2a7";
}

.bp4-icon-send-to-map::before{
  content:"\\f2a8";
}

.bp4-icon-sensor::before{
  content:"\\f33c";
}

.bp4-icon-series-add::before{
  content:"\\f2aa";
}

.bp4-icon-series-configuration::before{
  content:"\\f2ab";
}

.bp4-icon-series-derived::before{
  content:"\\f2ac";
}

.bp4-icon-series-filtered::before{
  content:"\\f2ad";
}

.bp4-icon-series-search::before{
  content:"\\f2ae";
}

.bp4-icon-settings::before{
  content:"\\f2af";
}

.bp4-icon-shapes::before{
  content:"\\f2b0";
}

.bp4-icon-share::before{
  content:"\\f2b1";
}

.bp4-icon-shared-filter::before{
  content:"\\f2b2";
}

.bp4-icon-shield::before{
  content:"\\f2b3";
}

.bp4-icon-ship::before{
  content:"\\f2b4";
}

.bp4-icon-shop::before{
  content:"\\f2b5";
}

.bp4-icon-shopping-cart::before{
  content:"\\f2b6";
}

.bp4-icon-shorten-text::before{
  content:"\\f33f";
}

.bp4-icon-signal-search::before{
  content:"\\f2b7";
}

.bp4-icon-sim-card::before{
  content:"\\f2b8";
}

.bp4-icon-slash::before{
  content:"\\f2b9";
}

.bp4-icon-small-cross::before{
  content:"\\f2ba";
}

.bp4-icon-small-info-sign::before{
  content:"\\f334";
}

.bp4-icon-small-minus::before{
  content:"\\f2bb";
}

.bp4-icon-small-plus::before{
  content:"\\f2bc";
}

.bp4-icon-small-square::before{
  content:"\\f2bd";
}

.bp4-icon-small-tick::before{
  content:"\\f2be";
}

.bp4-icon-snowflake::before{
  content:"\\f2bf";
}

.bp4-icon-social-media::before{
  content:"\\f2c0";
}

.bp4-icon-sort::before{
  content:"\\f2c7";
}

.bp4-icon-sort-alphabetical::before{
  content:"\\f2c2";
}

.bp4-icon-sort-alphabetical-desc::before{
  content:"\\f2c1";
}

.bp4-icon-sort-asc::before{
  content:"\\f2c3";
}

.bp4-icon-sort-desc::before{
  content:"\\f2c4";
}

.bp4-icon-sort-numerical::before{
  content:"\\f2c6";
}

.bp4-icon-sort-numerical-desc::before{
  content:"\\f2c5";
}

.bp4-icon-spell-check::before{
  content:"\\f340";
}

.bp4-icon-split-columns::before{
  content:"\\f2c8";
}

.bp4-icon-square::before{
  content:"\\f2c9";
}

.bp4-icon-stacked-chart::before{
  content:"\\f2ca";
}

.bp4-icon-stadium-geometry::before{
  content:"\\f2cb";
}

.bp4-icon-star::before{
  content:"\\f2cd";
}

.bp4-icon-star-empty::before{
  content:"\\f2cc";
}

.bp4-icon-step-backward::before{
  content:"\\f2ce";
}

.bp4-icon-step-chart::before{
  content:"\\f2cf";
}

.bp4-icon-step-forward::before{
  content:"\\f2d0";
}

.bp4-icon-stop::before{
  content:"\\f2d1";
}

.bp4-icon-stopwatch::before{
  content:"\\f2d2";
}

.bp4-icon-strikethrough::before{
  content:"\\f2d3";
}

.bp4-icon-style::before{
  content:"\\f2d4";
}

.bp4-icon-subscript::before{
  content:"\\f339";
}

.bp4-icon-superscript::before{
  content:"\\f33a";
}

.bp4-icon-swap-horizontal::before{
  content:"\\f2d5";
}

.bp4-icon-swap-vertical::before{
  content:"\\f2d6";
}

.bp4-icon-switch::before{
  content:"\\f2d7";
}

.bp4-icon-symbol-circle::before{
  content:"\\f2d8";
}

.bp4-icon-symbol-cross::before{
  content:"\\f2d9";
}

.bp4-icon-symbol-diamond::before{
  content:"\\f2da";
}

.bp4-icon-symbol-rectangle::before{
  content:"\\f322";
}

.bp4-icon-symbol-square::before{
  content:"\\f2db";
}

.bp4-icon-symbol-triangle-down::before{
  content:"\\f2dc";
}

.bp4-icon-symbol-triangle-up::before{
  content:"\\f2dd";
}

.bp4-icon-syringe::before{
  content:"\\f2de";
}

.bp4-icon-tag::before{
  content:"\\f2df";
}

.bp4-icon-take-action::before{
  content:"\\f2e0";
}

.bp4-icon-tank::before{
  content:"\\f2e1";
}

.bp4-icon-target::before{
  content:"\\f2e2";
}

.bp4-icon-taxi::before{
  content:"\\f2e3";
}

.bp4-icon-temperature::before{
  content:"\\f2e4";
}

.bp4-icon-text-highlight::before{
  content:"\\f2e5";
}

.bp4-icon-th::before{
  content:"\\f2ea";
}

.bp4-icon-th-derived::before{
  content:"\\f2e6";
}

.bp4-icon-th-disconnect::before{
  content:"\\f2e7";
}

.bp4-icon-th-filtered::before{
  content:"\\f2e8";
}

.bp4-icon-th-list::before{
  content:"\\f2e9";
}

.bp4-icon-third-party::before{
  content:"\\f2eb";
}

.bp4-icon-thumbs-down::before{
  content:"\\f2ec";
}

.bp4-icon-thumbs-up::before{
  content:"\\f2ed";
}

.bp4-icon-tick::before{
  content:"\\f2ef";
}

.bp4-icon-tick-circle::before{
  content:"\\f2ee";
}

.bp4-icon-time::before{
  content:"\\f2f0";
}

.bp4-icon-timeline-area-chart::before{
  content:"\\f2f1";
}

.bp4-icon-timeline-bar-chart::before{
  content:"\\f2f2";
}

.bp4-icon-timeline-events::before{
  content:"\\f2f3";
}

.bp4-icon-timeline-line-chart::before{
  content:"\\f2f4";
}

.bp4-icon-tint::before{
  content:"\\f2f5";
}

.bp4-icon-torch::before{
  content:"\\f2f6";
}

.bp4-icon-tractor::before{
  content:"\\f2f7";
}

.bp4-icon-train::before{
  content:"\\f2f8";
}

.bp4-icon-translate::before{
  content:"\\f2f9";
}

.bp4-icon-trash::before{
  content:"\\f2fa";
}

.bp4-icon-tree::before{
  content:"\\f2fb";
}

.bp4-icon-trending-down::before{
  content:"\\f2fc";
}

.bp4-icon-trending-up::before{
  content:"\\f2fd";
}

.bp4-icon-truck::before{
  content:"\\f2fe";
}

.bp4-icon-two-columns::before{
  content:"\\f2ff";
}

.bp4-icon-unarchive::before{
  content:"\\f300";
}

.bp4-icon-underline::before{
  content:"\\f301";
}

.bp4-icon-undo::before{
  content:"\\f302";
}

.bp4-icon-ungroup-objects::before{
  content:"\\f303";
}

.bp4-icon-unknown-vehicle::before{
  content:"\\f304";
}

.bp4-icon-unlock::before{
  content:"\\f305";
}

.bp4-icon-unpin::before{
  content:"\\f306";
}

.bp4-icon-unresolve::before{
  content:"\\f307";
}

.bp4-icon-updated::before{
  content:"\\f308";
}

.bp4-icon-upload::before{
  content:"\\f309";
}

.bp4-icon-user::before{
  content:"\\f30a";
}

.bp4-icon-variable::before{
  content:"\\f30b";
}

.bp4-icon-vertical-bar-chart-asc::before{
  content:"\\f30c";
}

.bp4-icon-vertical-bar-chart-desc::before{
  content:"\\f30d";
}

.bp4-icon-vertical-distribution::before{
  content:"\\f30e";
}

.bp4-icon-vertical-inbetween::before{
  content:"\\f32a";
}

.bp4-icon-video::before{
  content:"\\f30f";
}

.bp4-icon-virus::before{
  content:"\\f310";
}

.bp4-icon-volume-down::before{
  content:"\\f311";
}

.bp4-icon-volume-off::before{
  content:"\\f312";
}

.bp4-icon-volume-up::before{
  content:"\\f313";
}

.bp4-icon-walk::before{
  content:"\\f314";
}

.bp4-icon-warning-sign::before{
  content:"\\f315";
}

.bp4-icon-waterfall-chart::before{
  content:"\\f316";
}

.bp4-icon-waves::before{
  content:"\\f317";
}

.bp4-icon-widget::before{
  content:"\\f31b";
}

.bp4-icon-widget-button::before{
  content:"\\f318";
}

.bp4-icon-widget-footer::before{
  content:"\\f319";
}

.bp4-icon-widget-header::before{
  content:"\\f31a";
}

.bp4-icon-wind::before{
  content:"\\f31c";
}

.bp4-icon-wrench::before{
  content:"\\f31d";
}

.bp4-icon-zoom-in::before{
  content:"\\f31e";
}

.bp4-icon-zoom-out::before{
  content:"\\f31f";
}

.bp4-icon-zoom-to-fit::before{
  content:"\\f320";
}

.bp4-text-muted{
  color:#5f6b7c;
}

.bp4-text-disabled{
  color:rgba(95, 107, 124, 0.6);
}

.bp4-running-text hr{
  border-color:rgba(17, 20, 24, 0.15);
}

a{
  color:#215db0;
}
a:hover{
  color:#215db0;
}
a .bp4-icon, a .bp4-icon-standard, a .bp4-icon-large{
  color:inherit;
}
a code{
  color:inherit;
}

.bp4-code,
.bp4-running-text code{
  background:rgba(255, 255, 255, 0.7);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2);
  color:#5f6b7c;
}
a > .bp4-code,
a > .bp4-running-text code{
  color:#2d72d2;
}

.bp4-code-block,
.bp4-running-text pre{
  background:rgba(255, 255, 255, 0.7);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.15);
  color:#1c2127;
}
.bp4-code-block > code,
.bp4-running-text pre > code{
  background:none;
  box-shadow:none;
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-code-block,
  .bp4-running-text pre{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}

.bp4-key,
.bp4-running-text kbd{
  background:#ffffff;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);
  color:#5f6b7c;
}

.bp4-icon.bp4-intent-primary, .bp4-icon-standard.bp4-intent-primary, .bp4-icon-large.bp4-intent-primary{
  color:#215db0;
}
.bp4-icon.bp4-intent-success, .bp4-icon-standard.bp4-intent-success, .bp4-icon-large.bp4-intent-success{
  color:#1c6e42;
}
.bp4-icon.bp4-intent-warning, .bp4-icon-standard.bp4-intent-warning, .bp4-icon-large.bp4-intent-warning{
  color:#935610;
}
.bp4-icon.bp4-intent-danger, .bp4-icon-standard.bp4-intent-danger, .bp4-icon-large.bp4-intent-danger{
  color:#ac2f33;
}
.bp4-heading{
  color:#1c2127;
  font-weight:600;
  margin:0 0 10px;
  padding:0;
}
.bp4-dark .bp4-heading{
  color:#f6f7f9;
}

.bp4-running-text h1, h1.bp4-heading{
  font-size:36px;
  line-height:40px;
}

.bp4-running-text h2, h2.bp4-heading{
  font-size:28px;
  line-height:32px;
}

.bp4-running-text h3, h3.bp4-heading{
  font-size:22px;
  line-height:25px;
}

.bp4-running-text h4, h4.bp4-heading{
  font-size:18px;
  line-height:21px;
}

.bp4-running-text h5, h5.bp4-heading{
  font-size:16px;
  line-height:19px;
}

.bp4-running-text h6, h6.bp4-heading{
  font-size:14px;
  line-height:16px;
}
.bp4-ui-text{
  font-size:14px;
  font-weight:400;
  letter-spacing:0;
  line-height:1.28581;
  text-transform:none;
}

.bp4-monospace-text{
  font-family:monospace;
  text-transform:none;
}

.bp4-text-overflow-ellipsis{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
}
.bp4-running-text{
  font-size:14px;
  line-height:1.5;
}
.bp4-running-text h1{
  color:#1c2127;
  font-weight:600;
  margin-bottom:20px;
  margin-top:40px;
}
.bp4-dark .bp4-running-text h1{
  color:#f6f7f9;
}
.bp4-running-text h2{
  color:#1c2127;
  font-weight:600;
  margin-bottom:20px;
  margin-top:40px;
}
.bp4-dark .bp4-running-text h2{
  color:#f6f7f9;
}
.bp4-running-text h3{
  color:#1c2127;
  font-weight:600;
  margin-bottom:20px;
  margin-top:40px;
}
.bp4-dark .bp4-running-text h3{
  color:#f6f7f9;
}
.bp4-running-text h4{
  color:#1c2127;
  font-weight:600;
  margin-bottom:20px;
  margin-top:40px;
}
.bp4-dark .bp4-running-text h4{
  color:#f6f7f9;
}
.bp4-running-text h5{
  color:#1c2127;
  font-weight:600;
  margin-bottom:20px;
  margin-top:40px;
}
.bp4-dark .bp4-running-text h5{
  color:#f6f7f9;
}
.bp4-running-text h6{
  color:#1c2127;
  font-weight:600;
  margin-bottom:20px;
  margin-top:40px;
}
.bp4-dark .bp4-running-text h6{
  color:#f6f7f9;
}
.bp4-running-text hr{
  border:none;
  border-bottom:1px solid rgba(17, 20, 24, 0.15);
  margin:20px 0;
}
.bp4-running-text p{
  margin:0 0 10px;
  padding:0;
}
.bp4-text-large{
  font-size:16px;
}

.bp4-text-small{
  font-size:12px;
}
a{
  text-decoration:none;
}
a:hover{
  cursor:pointer;
  text-decoration:underline;
}
.bp4-code, .bp4-running-text code{
  font-family:monospace;
  text-transform:none;
  border-radius:2px;
  font-size:smaller;
  padding:2px 5px;
}

.bp4-code-block, .bp4-running-text pre{
  font-family:monospace;
  text-transform:none;
  border-radius:2px;
  display:block;
  font-size:13px;
  line-height:1.4;
  margin:10px 0;
  padding:13px 15px 12px;
  word-break:break-all;
  word-wrap:break-word;
}
.bp4-code-block > code, .bp4-running-text pre > code{
  font-size:inherit;
  padding:0;
}

.bp4-key, .bp4-running-text kbd{
  align-items:center;
  border-radius:2px;
  display:inline-flex;
  font-family:inherit;
  font-size:12px;
  height:24px;
  justify-content:center;
  line-height:24px;
  min-width:24px;
  padding:2px 4px;
  vertical-align:middle;
}
.bp4-key .bp4-icon, .bp4-running-text kbd .bp4-icon, .bp4-key .bp4-icon-standard, .bp4-running-text kbd .bp4-icon-standard, .bp4-key .bp4-icon-large, .bp4-running-text kbd .bp4-icon-large{
  margin-right:5px;
}
.bp4-blockquote, .bp4-running-text blockquote{
  border-left:solid 4px rgba(171, 179, 191, 0.5);
  margin:0 0 10px;
  padding:0 20px;
}
.bp4-dark .bp4-blockquote, .bp4-dark .bp4-running-text blockquote, .bp4-running-text .bp4-dark blockquote{
  border-color:rgba(115, 128, 145, 0.5);
}
.bp4-list, .bp4-running-text ul,
.bp4-running-text ol{
  margin:10px 0;
  padding-left:30px;
}
.bp4-list li:not(:last-child), .bp4-running-text ul li:not(:last-child),
.bp4-running-text ol li:not(:last-child){
  margin-bottom:5px;
}
.bp4-list ol, .bp4-running-text ul ol,
.bp4-running-text ol ol,
.bp4-list ul,
.bp4-running-text ul ul,
.bp4-running-text ol ul{
  margin-top:5px;
}

.bp4-list-unstyled{
  list-style:none;
  margin:0;
  padding:0;
}
.bp4-list-unstyled li{
  padding:0;
}
.bp4-rtl{
  text-align:right;
}
.bp4-dark{
  color:#f6f7f9;
}
.bp4-dark .bp4-text-muted{
  color:#abb3bf;
}
.bp4-dark .bp4-text-disabled{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-running-text hr{
  border-color:rgba(255, 255, 255, 0.2);
}
.bp4-dark a{
  color:#8abbff;
}
.bp4-dark a:hover{
  color:#8abbff;
}
.bp4-dark a .bp4-icon, .bp4-dark a .bp4-icon-standard, .bp4-dark a .bp4-icon-large{
  color:inherit;
}
.bp4-dark a code{
  color:inherit;
}
.bp4-dark .bp4-code,
.bp4-dark .bp4-running-text code{
  background:rgba(17, 20, 24, 0.3);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.4);
  color:#abb3bf;
}
a > .bp4-dark .bp4-code,
a > .bp4-dark .bp4-running-text code{
  color:inherit;
}
.bp4-dark .bp4-code-block,
.bp4-dark .bp4-running-text pre{
  background:rgba(17, 20, 24, 0.3);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.4);
  color:#f6f7f9;
}
.bp4-dark .bp4-code-block > code,
.bp4-dark .bp4-running-text pre > code{
  background:none;
  box-shadow:none;
  color:inherit;
}
.bp4-dark .bp4-key,
.bp4-dark .bp4-running-text kbd{
  background:#383e47;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);
  color:#abb3bf;
}
.bp4-dark .bp4-icon.bp4-intent-primary, .bp4-dark .bp4-icon-standard.bp4-intent-primary, .bp4-dark .bp4-icon-large.bp4-intent-primary{
  color:#8abbff;
}
.bp4-dark .bp4-icon.bp4-intent-success, .bp4-dark .bp4-icon-standard.bp4-intent-success, .bp4-dark .bp4-icon-large.bp4-intent-success{
  color:#72ca9b;
}
.bp4-dark .bp4-icon.bp4-intent-warning, .bp4-dark .bp4-icon-standard.bp4-intent-warning, .bp4-dark .bp4-icon-large.bp4-intent-warning{
  color:#fbb360;
}
.bp4-dark .bp4-icon.bp4-intent-danger, .bp4-dark .bp4-icon-standard.bp4-intent-danger, .bp4-dark .bp4-icon-large.bp4-intent-danger{
  color:#fa999c;
}

:focus{
  outline:rgba(45, 114, 210, 0.6) solid 2px;
  outline-offset:2px;
  -moz-outline-radius:6px;
}

.bp4-focus-disabled :focus:not(.bp4-focus-style-manager-ignore *){
  outline:none !important;
}
.bp4-focus-disabled :focus:not(.bp4-focus-style-manager-ignore *) ~ .bp4-control-indicator{
  outline:none !important;
}

.bp4-dark{
  color-scheme:dark;
}
.bp4-alert{
  max-width:400px;
  padding:20px;
}

.bp4-alert-body{
  display:flex;
}
.bp4-alert-body .bp4-icon{
  font-size:40px;
  margin-right:20px;
  margin-top:0;
}

.bp4-alert-contents{
  word-break:break-word;
}

.bp4-alert-footer{
  display:flex;
  flex-direction:row-reverse;
  margin-top:10px;
}
.bp4-alert-footer .bp4-button{
  margin-left:10px;
}
.bp4-breadcrumbs{
  align-items:center;
  cursor:default;
  display:flex;
  flex-wrap:wrap;
  height:30px;
  list-style:none;
  margin:0;
  padding:0;
}
.bp4-breadcrumbs > li{
  align-items:center;
  display:flex;
}
.bp4-breadcrumbs > li::after{
  background:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  content:"";
  display:block;
  height:16px;
  margin:0 5px;
  width:16px;
}
.bp4-breadcrumbs > li:last-of-type::after{
  display:none;
}

.bp4-breadcrumb,
.bp4-breadcrumb-current,
.bp4-breadcrumbs-collapsed{
  align-items:center;
  display:inline-flex;
  font-size:16px;
}

.bp4-breadcrumb,
.bp4-breadcrumbs-collapsed{
  color:#5f6b7c;
}

.bp4-breadcrumb:hover{
  text-decoration:none;
}
.bp4-breadcrumb.bp4-disabled{
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
.bp4-breadcrumb .bp4-icon{
  margin-right:5px;
}

.bp4-breadcrumb-current{
  color:inherit;
  font-weight:600;
}
.bp4-breadcrumb-current .bp4-input{
  font-size:inherit;
  font-weight:inherit;
  vertical-align:baseline;
}

.bp4-breadcrumbs-collapsed{
  background:rgba(143, 153, 168, 0.15);
  border:none;
  border-radius:2px;
  cursor:pointer;
  margin-right:2px;
  padding:1px 5px;
  vertical-align:text-bottom;
}
.bp4-breadcrumbs-collapsed::before{
  background:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
  content:"";
  display:block;
  height:16px;
  width:16px;
}
.bp4-breadcrumbs-collapsed:hover{
  background:rgba(143, 153, 168, 0.3);
  color:#1c2127;
  text-decoration:none;
}

.bp4-dark .bp4-breadcrumb,
.bp4-dark .bp4-breadcrumbs-collapsed{
  color:#abb3bf;
}
.bp4-dark .bp4-breadcrumbs > li::after{
  background:url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  color:#abb3bf;
}
.bp4-dark .bp4-breadcrumb.bp4-disabled{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-breadcrumb-current{
  color:#f6f7f9;
}
.bp4-dark .bp4-breadcrumbs-collapsed{
  background:rgba(143, 153, 168, 0.2);
}
.bp4-dark .bp4-breadcrumbs-collapsed::before{
  background:url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center no-repeat;
}
.bp4-dark .bp4-breadcrumbs-collapsed:hover{
  background:rgba(143, 153, 168, 0.3);
  color:#f6f7f9;
}
.bp4-button{
  display:inline-flex;
  flex-direction:row;
  align-items:center;
  border:none;
  border-radius:2px;
  cursor:pointer;
  font-size:14px;
  justify-content:center;
  padding:5px 10px;
  text-align:left;
  vertical-align:middle;
  min-height:30px;
  min-width:30px;
}
.bp4-button > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-button > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-button::before,
.bp4-button > *{
  margin-right:7px;
}
.bp4-button:empty::before,
.bp4-button > :last-child{
  margin-right:0;
}
.bp4-button:empty{
  padding:0 !important;
}
.bp4-button:disabled, .bp4-button.bp4-disabled{
  cursor:not-allowed;
}
.bp4-button.bp4-fill{
  display:flex;
  width:100%;
}
.bp4-button.bp4-align-right, .bp4-align-right .bp4-button{
  text-align:right;
}
.bp4-button.bp4-align-left, .bp4-align-left .bp4-button{
  text-align:left;
}
.bp4-button:not([class*=bp4-intent-]){
  background-color:#f6f7f9;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#1c2127;
}
.bp4-button:not([class*=bp4-intent-]):hover{
  background-clip:padding-box;
  background-color:#edeff2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button:not([class*=bp4-intent-]):active, .bp4-button:not([class*=bp4-intent-]).bp4-active{
  background-color:#dce0e5;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button:not([class*=bp4-intent-]):active, .bp4-button:not([class*=bp4-intent-]).bp4-active{
    background:highlight;
  }
}
.bp4-button:not([class*=bp4-intent-]):disabled, .bp4-button:not([class*=bp4-intent-]).bp4-disabled{
  background-color:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
  outline:none;
}
.bp4-button:not([class*=bp4-intent-]):disabled.bp4-active, .bp4-button:not([class*=bp4-intent-]):disabled.bp4-active:hover, .bp4-button:not([class*=bp4-intent-]).bp4-disabled.bp4-active, .bp4-button:not([class*=bp4-intent-]).bp4-disabled.bp4-active:hover{
  background:rgba(211, 216, 222, 0.7);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button:not([class*=bp4-intent-]){
    border:1px solid buttonborder;
  }
}
.bp4-button.bp4-intent-primary{
  background-color:#2d72d2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#ffffff;
}
.bp4-button.bp4-intent-primary:hover, .bp4-button.bp4-intent-primary:active, .bp4-button.bp4-intent-primary.bp4-active{
  color:#ffffff;
}
.bp4-button.bp4-intent-primary:hover{
  background-color:#215db0;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-primary:active, .bp4-button.bp4-intent-primary.bp4-active{
  background-color:#184a90;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-primary:disabled, .bp4-button.bp4-intent-primary.bp4-disabled{
  background-color:rgba(45, 114, 210, 0.5);
  border-color:transparent;
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-primary:disabled, .bp4-button.bp4-intent-primary.bp4-disabled{
    border-color:graytext;
    color:graytext;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-primary{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}
.bp4-button.bp4-intent-success{
  background-color:#238551;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#ffffff;
}
.bp4-button.bp4-intent-success:hover, .bp4-button.bp4-intent-success:active, .bp4-button.bp4-intent-success.bp4-active{
  color:#ffffff;
}
.bp4-button.bp4-intent-success:hover{
  background-color:#1c6e42;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-success:active, .bp4-button.bp4-intent-success.bp4-active{
  background-color:#165a36;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-success:disabled, .bp4-button.bp4-intent-success.bp4-disabled{
  background-color:rgba(35, 133, 81, 0.5);
  border-color:transparent;
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-success:disabled, .bp4-button.bp4-intent-success.bp4-disabled{
    border-color:graytext;
    color:graytext;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-success{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}
.bp4-button.bp4-intent-warning{
  background-color:#c87619;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#ffffff;
}
.bp4-button.bp4-intent-warning:hover, .bp4-button.bp4-intent-warning:active, .bp4-button.bp4-intent-warning.bp4-active{
  color:#ffffff;
}
.bp4-button.bp4-intent-warning:hover{
  background-color:#935610;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-warning:active, .bp4-button.bp4-intent-warning.bp4-active{
  background-color:#77450d;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-warning:disabled, .bp4-button.bp4-intent-warning.bp4-disabled{
  background-color:rgba(200, 118, 25, 0.5);
  border-color:transparent;
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-warning:disabled, .bp4-button.bp4-intent-warning.bp4-disabled{
    border-color:graytext;
    color:graytext;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-warning{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}
.bp4-button.bp4-intent-danger{
  background-color:#cd4246;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#ffffff;
}
.bp4-button.bp4-intent-danger:hover, .bp4-button.bp4-intent-danger:active, .bp4-button.bp4-intent-danger.bp4-active{
  color:#ffffff;
}
.bp4-button.bp4-intent-danger:hover{
  background-color:#ac2f33;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-danger:active, .bp4-button.bp4-intent-danger.bp4-active{
  background-color:#8e292c;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-button.bp4-intent-danger:disabled, .bp4-button.bp4-intent-danger.bp4-disabled{
  background-color:rgba(205, 66, 70, 0.5);
  border-color:transparent;
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-danger:disabled, .bp4-button.bp4-intent-danger.bp4-disabled{
    border-color:graytext;
    color:graytext;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-danger{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}
.bp4-button[class*=bp4-intent-] .bp4-button-spinner .bp4-spinner-head{
  stroke:#ffffff;
}
.bp4-button.bp4-large, .bp4-large .bp4-button{
  min-height:40px;
  min-width:40px;
  font-size:16px;
  padding:5px 15px;
}
.bp4-button.bp4-large::before,
.bp4-button.bp4-large > *, .bp4-large .bp4-button::before,
.bp4-large .bp4-button > *{
  margin-right:10px;
}
.bp4-button.bp4-large:empty::before,
.bp4-button.bp4-large > :last-child, .bp4-large .bp4-button:empty::before,
.bp4-large .bp4-button > :last-child{
  margin-right:0;
}
.bp4-button.bp4-small, .bp4-small .bp4-button{
  min-height:24px;
  min-width:24px;
  padding:0 7px;
}
.bp4-button.bp4-loading{
  position:relative;
}
.bp4-button.bp4-loading[class*=bp4-icon-]::before{
  visibility:hidden;
}
.bp4-button.bp4-loading .bp4-button-spinner{
  margin:0;
  position:absolute;
}
.bp4-button.bp4-loading > :not(.bp4-button-spinner){
  visibility:hidden;
}
.bp4-button[class*=bp4-icon-]::before{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  color:#5f6b7c;
}
.bp4-button .bp4-icon, .bp4-button .bp4-icon-standard, .bp4-button .bp4-icon-large{
  color:#5f6b7c;
}
.bp4-button .bp4-icon.bp4-align-right, .bp4-button .bp4-icon-standard.bp4-align-right, .bp4-button .bp4-icon-large.bp4-align-right{
  margin-left:7px;
}
.bp4-button .bp4-icon:first-child:last-child,
.bp4-button .bp4-spinner + .bp4-icon:last-child{
  margin:0 -7px;
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]){
  background-color:#383e47;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);
  color:#f6f7f9;
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]):hover, .bp4-dark .bp4-button:not([class*=bp4-intent-]):active, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-active{
  color:#f6f7f9;
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]):hover{
  background-color:#2f343c;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]):active, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-active{
  background-color:#1c2127;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]):disabled, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-disabled{
  background-color:rgba(64, 72, 84, 0.5);
  box-shadow:none;
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]):disabled.bp4-active, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-disabled.bp4-active{
  background:rgba(64, 72, 84, 0.7);
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-button-spinner .bp4-spinner-head{
  background:rgba(17, 20, 24, 0.5);
  stroke:#8f99a8;
}
.bp4-dark .bp4-button:not([class*=bp4-intent-])[class*=bp4-icon-]::before{
  color:#abb3bf;
}
.bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-icon:not([class*=bp4-intent-]), .bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-icon-standard:not([class*=bp4-intent-]), .bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-icon-large:not([class*=bp4-intent-]){
  color:#abb3bf;
}
.bp4-dark .bp4-button[class*=bp4-intent-]{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-dark .bp4-button[class*=bp4-intent-]:hover{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-dark .bp4-button[class*=bp4-intent-]:active, .bp4-dark .bp4-button[class*=bp4-intent-].bp4-active{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-button[class*=bp4-intent-]:disabled, .bp4-dark .bp4-button[class*=bp4-intent-].bp4-disabled{
  box-shadow:none;
  color:rgba(255, 255, 255, 0.3);
}
.bp4-dark .bp4-button[class*=bp4-intent-] .bp4-button-spinner .bp4-spinner-head{
  stroke:#8f99a8;
}
.bp4-button:disabled::before,
.bp4-button:disabled .bp4-icon, .bp4-button:disabled .bp4-icon-standard, .bp4-button:disabled .bp4-icon-large, .bp4-button.bp4-disabled::before,
.bp4-button.bp4-disabled .bp4-icon, .bp4-button.bp4-disabled .bp4-icon-standard, .bp4-button.bp4-disabled .bp4-icon-large, .bp4-button[class*=bp4-intent-]::before,
.bp4-button[class*=bp4-intent-] .bp4-icon, .bp4-button[class*=bp4-intent-] .bp4-icon-standard, .bp4-button[class*=bp4-intent-] .bp4-icon-large{
  color:inherit !important;
}
.bp4-button.bp4-minimal{
  background:none;
  box-shadow:none;
}
.bp4-button.bp4-minimal:hover{
  background:rgba(143, 153, 168, 0.15);
  box-shadow:none;
  color:#1c2127;
  text-decoration:none;
}
.bp4-button.bp4-minimal:active, .bp4-button.bp4-minimal.bp4-active{
  background:rgba(143, 153, 168, 0.3);
  box-shadow:none;
  color:#1c2127;
}
.bp4-button.bp4-minimal:disabled, .bp4-button.bp4-minimal:disabled:hover, .bp4-button.bp4-minimal.bp4-disabled, .bp4-button.bp4-minimal.bp4-disabled:hover{
  background:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
.bp4-button.bp4-minimal:disabled.bp4-active, .bp4-button.bp4-minimal:disabled:hover.bp4-active, .bp4-button.bp4-minimal.bp4-disabled.bp4-active, .bp4-button.bp4-minimal.bp4-disabled:hover.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-button.bp4-minimal{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-button.bp4-minimal:hover, .bp4-dark .bp4-button.bp4-minimal:active, .bp4-dark .bp4-button.bp4-minimal.bp4-active{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-button.bp4-minimal:hover{
  background:rgba(143, 153, 168, 0.15);
}
.bp4-dark .bp4-button.bp4-minimal:active, .bp4-dark .bp4-button.bp4-minimal.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-button.bp4-minimal:disabled, .bp4-dark .bp4-button.bp4-minimal:disabled:hover, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled:hover{
  background:none;
  color:rgba(171, 179, 191, 0.6);
  cursor:not-allowed;
}
.bp4-dark .bp4-button.bp4-minimal:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal:disabled:hover.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled:hover.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-primary{
  color:#215db0;
}
.bp4-button.bp4-minimal.bp4-intent-primary:hover, .bp4-button.bp4-minimal.bp4-intent-primary:active, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-active{
  background:none;
  box-shadow:none;
  color:#215db0;
}
.bp4-button.bp4-minimal.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.15);
  color:#215db0;
}
.bp4-button.bp4-minimal.bp4-intent-primary:active, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#184a90;
}
.bp4-button.bp4-minimal.bp4-intent-primary:disabled, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(33, 93, 176, 0.5);
}
.bp4-button.bp4-minimal.bp4-intent-primary:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head{
  stroke:#215db0;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary{
  color:#8abbff;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#99c4ff;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(138, 187, 255, 0.5);
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-success{
  color:#1c6e42;
}
.bp4-button.bp4-minimal.bp4-intent-success:hover, .bp4-button.bp4-minimal.bp4-intent-success:active, .bp4-button.bp4-minimal.bp4-intent-success.bp4-active{
  background:none;
  box-shadow:none;
  color:#1c6e42;
}
.bp4-button.bp4-minimal.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.15);
  color:#1c6e42;
}
.bp4-button.bp4-minimal.bp4-intent-success:active, .bp4-button.bp4-minimal.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#165a36;
}
.bp4-button.bp4-minimal.bp4-intent-success:disabled, .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(28, 110, 66, 0.5);
}
.bp4-button.bp4-minimal.bp4-intent-success:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-success .bp4-button-spinner .bp4-spinner-head{
  stroke:#1c6e42;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success{
  color:#72ca9b;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#7cd7a2;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(114, 202, 155, 0.5);
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-warning{
  color:#935610;
}
.bp4-button.bp4-minimal.bp4-intent-warning:hover, .bp4-button.bp4-minimal.bp4-intent-warning:active, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-active{
  background:none;
  box-shadow:none;
  color:#935610;
}
.bp4-button.bp4-minimal.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.15);
  color:#935610;
}
.bp4-button.bp4-minimal.bp4-intent-warning:active, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#77450d;
}
.bp4-button.bp4-minimal.bp4-intent-warning:disabled, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(147, 86, 16, 0.5);
}
.bp4-button.bp4-minimal.bp4-intent-warning:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head{
  stroke:#935610;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning{
  color:#fbb360;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#f5c186;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(251, 179, 96, 0.5);
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-danger{
  color:#ac2f33;
}
.bp4-button.bp4-minimal.bp4-intent-danger:hover, .bp4-button.bp4-minimal.bp4-intent-danger:active, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-active{
  background:none;
  box-shadow:none;
  color:#ac2f33;
}
.bp4-button.bp4-minimal.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.15);
  color:#ac2f33;
}
.bp4-button.bp4-minimal.bp4-intent-danger:active, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#8e292c;
}
.bp4-button.bp4-minimal.bp4-intent-danger:disabled, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(172, 47, 51, 0.5);
}
.bp4-button.bp4-minimal.bp4-intent-danger:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}
.bp4-button.bp4-minimal.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head{
  stroke:#ac2f33;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger{
  color:#fa999c;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#ffa1a4;
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(250, 153, 156, 0.5);
}
.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}
.bp4-button.bp4-outlined{
  background:none;
  box-shadow:none;
  border:1px solid rgba(28, 33, 39, 0.2);
  box-sizing:border-box;
}
.bp4-button.bp4-outlined:hover{
  background:rgba(143, 153, 168, 0.15);
  box-shadow:none;
  color:#1c2127;
  text-decoration:none;
}
.bp4-button.bp4-outlined:active, .bp4-button.bp4-outlined.bp4-active{
  background:rgba(143, 153, 168, 0.3);
  box-shadow:none;
  color:#1c2127;
}
.bp4-button.bp4-outlined:disabled, .bp4-button.bp4-outlined:disabled:hover, .bp4-button.bp4-outlined.bp4-disabled, .bp4-button.bp4-outlined.bp4-disabled:hover{
  background:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
.bp4-button.bp4-outlined:disabled.bp4-active, .bp4-button.bp4-outlined:disabled:hover.bp4-active, .bp4-button.bp4-outlined.bp4-disabled.bp4-active, .bp4-button.bp4-outlined.bp4-disabled:hover.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-button.bp4-outlined{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-button.bp4-outlined:hover, .bp4-dark .bp4-button.bp4-outlined:active, .bp4-dark .bp4-button.bp4-outlined.bp4-active{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-button.bp4-outlined:hover{
  background:rgba(143, 153, 168, 0.15);
}
.bp4-dark .bp4-button.bp4-outlined:active, .bp4-dark .bp4-button.bp4-outlined.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-button.bp4-outlined:disabled, .bp4-dark .bp4-button.bp4-outlined:disabled:hover, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled:hover{
  background:none;
  color:rgba(171, 179, 191, 0.6);
  cursor:not-allowed;
}
.bp4-dark .bp4-button.bp4-outlined:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined:disabled:hover.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled:hover.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-primary{
  color:#215db0;
}
.bp4-button.bp4-outlined.bp4-intent-primary:hover, .bp4-button.bp4-outlined.bp4-intent-primary:active, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-active{
  background:none;
  box-shadow:none;
  color:#215db0;
}
.bp4-button.bp4-outlined.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.15);
  color:#215db0;
}
.bp4-button.bp4-outlined.bp4-intent-primary:active, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#184a90;
}
.bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(33, 93, 176, 0.5);
}
.bp4-button.bp4-outlined.bp4-intent-primary:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head{
  stroke:#215db0;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary{
  color:#8abbff;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#99c4ff;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(138, 187, 255, 0.5);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-success{
  color:#1c6e42;
}
.bp4-button.bp4-outlined.bp4-intent-success:hover, .bp4-button.bp4-outlined.bp4-intent-success:active, .bp4-button.bp4-outlined.bp4-intent-success.bp4-active{
  background:none;
  box-shadow:none;
  color:#1c6e42;
}
.bp4-button.bp4-outlined.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.15);
  color:#1c6e42;
}
.bp4-button.bp4-outlined.bp4-intent-success:active, .bp4-button.bp4-outlined.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#165a36;
}
.bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(28, 110, 66, 0.5);
}
.bp4-button.bp4-outlined.bp4-intent-success:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-success .bp4-button-spinner .bp4-spinner-head{
  stroke:#1c6e42;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success{
  color:#72ca9b;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#7cd7a2;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(114, 202, 155, 0.5);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-warning{
  color:#935610;
}
.bp4-button.bp4-outlined.bp4-intent-warning:hover, .bp4-button.bp4-outlined.bp4-intent-warning:active, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-active{
  background:none;
  box-shadow:none;
  color:#935610;
}
.bp4-button.bp4-outlined.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.15);
  color:#935610;
}
.bp4-button.bp4-outlined.bp4-intent-warning:active, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#77450d;
}
.bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(147, 86, 16, 0.5);
}
.bp4-button.bp4-outlined.bp4-intent-warning:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head{
  stroke:#935610;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning{
  color:#fbb360;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#f5c186;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(251, 179, 96, 0.5);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-danger{
  color:#ac2f33;
}
.bp4-button.bp4-outlined.bp4-intent-danger:hover, .bp4-button.bp4-outlined.bp4-intent-danger:active, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-active{
  background:none;
  box-shadow:none;
  color:#ac2f33;
}
.bp4-button.bp4-outlined.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.15);
  color:#ac2f33;
}
.bp4-button.bp4-outlined.bp4-intent-danger:active, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#8e292c;
}
.bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(172, 47, 51, 0.5);
}
.bp4-button.bp4-outlined.bp4-intent-danger:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}
.bp4-button.bp4-outlined.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head{
  stroke:#ac2f33;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger{
  color:#fa999c;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#ffa1a4;
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(250, 153, 156, 0.5);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}
.bp4-button.bp4-outlined:disabled, .bp4-button.bp4-outlined.bp4-disabled, .bp4-button.bp4-outlined:disabled:hover, .bp4-button.bp4-outlined.bp4-disabled:hover{
  border-color:rgba(95, 107, 124, 0.1);
}
.bp4-dark .bp4-button.bp4-outlined{
  border-color:rgba(255, 255, 255, 0.4);
}
.bp4-dark .bp4-button.bp4-outlined:disabled, .bp4-dark .bp4-button.bp4-outlined:disabled:hover, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled:hover{
  border-color:rgba(255, 255, 255, 0.2);
}
.bp4-button.bp4-outlined.bp4-intent-primary{
  border-color:rgba(33, 93, 176, 0.6);
}
.bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled{
  border-color:rgba(33, 93, 176, 0.2);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary{
  border-color:rgba(138, 187, 255, 0.6);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled{
  border-color:rgba(138, 187, 255, 0.2);
}
.bp4-button.bp4-outlined.bp4-intent-success{
  border-color:rgba(28, 110, 66, 0.6);
}
.bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled{
  border-color:rgba(28, 110, 66, 0.2);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success{
  border-color:rgba(114, 202, 155, 0.6);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled{
  border-color:rgba(114, 202, 155, 0.2);
}
.bp4-button.bp4-outlined.bp4-intent-warning{
  border-color:rgba(147, 86, 16, 0.6);
}
.bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled{
  border-color:rgba(147, 86, 16, 0.2);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning{
  border-color:rgba(251, 179, 96, 0.6);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled{
  border-color:rgba(251, 179, 96, 0.2);
}
.bp4-button.bp4-outlined.bp4-intent-danger{
  border-color:rgba(172, 47, 51, 0.6);
}
.bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled{
  border-color:rgba(172, 47, 51, 0.2);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger{
  border-color:rgba(250, 153, 156, 0.6);
}
.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled{
  border-color:rgba(250, 153, 156, 0.2);
}
.bp4-button.bp4-intent-warning{
  background:#fbb360;
  color:#1c2127;
}
.bp4-button.bp4-intent-warning:not(.bp4-disabled).bp4-icon > svg{
  fill:rgba(28, 33, 39, 0.7);
}
.bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined):hover{
  background:#ec9a3c;
  color:#1c2127;
}
.bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined):active, .bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined).bp4-active{
  background:#c87619;
  color:#1c2127;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined):active, .bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined).bp4-active{
    background:highlight;
  }
}
.bp4-button.bp4-intent-warning:disabled, .bp4-button.bp4-intent-warning.bp4-disabled{
  background:rgba(200, 118, 25, 0.5);
  color:rgba(28, 33, 39, 0.35);
}
.bp4-dark .bp4-button.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-intent-warning.bp4-disabled{
  color:rgba(28, 33, 39, 0.6);
}
.bp4-button.bp4-intent-warning.bp4-minimal, .bp4-button.bp4-intent-warning.bp4-outlined{
  background:none;
}
.bp4-dark .bp4-button.bp4-intent-warning.bp4-minimal:not(.bp4-disabled).bp4-icon > svg, .bp4-dark .bp4-button.bp4-intent-warning.bp4-outlined:not(.bp4-disabled).bp4-icon > svg{
  fill:#fbb360;
}

a.bp4-button{
  text-align:center;
  text-decoration:none;
  transition:none;
}
a.bp4-button, a.bp4-button:hover, a.bp4-button:active{
  color:#1c2127;
}
a.bp4-button.bp4-disabled{
  color:rgba(95, 107, 124, 0.6);
}

.bp4-button-text{
  flex:0 1 auto;
}

.bp4-button.bp4-align-left .bp4-button-text, .bp4-button.bp4-align-right .bp4-button-text,
.bp4-button-group.bp4-align-left .bp4-button-text,
.bp4-button-group.bp4-align-right .bp4-button-text{
  flex:1 1 auto;
}
.bp4-button-group{
  display:inline-flex;
}
.bp4-button-group .bp4-button{
  flex:0 0 auto;
  position:relative;
  z-index:4;
}
.bp4-button-group .bp4-button:focus{
  z-index:5;
}
.bp4-button-group .bp4-button:hover{
  z-index:6;
}
.bp4-button-group .bp4-button:active, .bp4-button-group .bp4-button.bp4-active{
  z-index:7;
}
.bp4-button-group .bp4-button:disabled, .bp4-button-group .bp4-button.bp4-disabled{
  z-index:3;
}
.bp4-button-group .bp4-button[class*=bp4-intent-]{
  z-index:9;
}
.bp4-button-group .bp4-button[class*=bp4-intent-]:focus{
  z-index:10;
}
.bp4-button-group .bp4-button[class*=bp4-intent-]:hover{
  z-index:11;
}
.bp4-button-group .bp4-button[class*=bp4-intent-]:active, .bp4-button-group .bp4-button[class*=bp4-intent-].bp4-active{
  z-index:12;
}
.bp4-button-group .bp4-button[class*=bp4-intent-]:disabled, .bp4-button-group .bp4-button[class*=bp4-intent-].bp4-disabled{
  z-index:8;
}
.bp4-button-group:not(.bp4-minimal) > .bp4-popover-wrapper:not(:first-child) .bp4-button,
.bp4-button-group:not(.bp4-minimal) > .bp4-button:not(:first-child){
  border-bottom-left-radius:0;
  border-top-left-radius:0;
}
.bp4-button-group:not(.bp4-minimal) > .bp4-popover-wrapper:not(:last-child) .bp4-button,
.bp4-button-group:not(.bp4-minimal) > .bp4-button:not(:last-child){
  border-bottom-right-radius:0;
  border-top-right-radius:0;
  margin-right:-1px;
}
.bp4-button-group.bp4-minimal .bp4-button{
  background:none;
  box-shadow:none;
}
.bp4-button-group.bp4-minimal .bp4-button:hover{
  background:rgba(143, 153, 168, 0.15);
  box-shadow:none;
  color:#1c2127;
  text-decoration:none;
}
.bp4-button-group.bp4-minimal .bp4-button:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-active{
  background:rgba(143, 153, 168, 0.3);
  box-shadow:none;
  color:#1c2127;
}
.bp4-button-group.bp4-minimal .bp4-button:disabled, .bp4-button-group.bp4-minimal .bp4-button:disabled:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover{
  background:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
.bp4-button-group.bp4-minimal .bp4-button:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button:disabled:hover.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:hover, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-active{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:hover{
  background:rgba(143, 153, 168, 0.15);
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled:hover, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover{
  background:none;
  color:rgba(171, 179, 191, 0.6);
  cursor:not-allowed;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled:hover.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary{
  color:#215db0;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-active{
  background:none;
  box-shadow:none;
  color:#215db0;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.15);
  color:#215db0;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#184a90;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(33, 93, 176, 0.5);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head{
  stroke:#215db0;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary{
  color:#8abbff;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#99c4ff;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(138, 187, 255, 0.5);
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success{
  color:#1c6e42;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-active{
  background:none;
  box-shadow:none;
  color:#1c6e42;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.15);
  color:#1c6e42;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#165a36;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(28, 110, 66, 0.5);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success .bp4-button-spinner .bp4-spinner-head{
  stroke:#1c6e42;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success{
  color:#72ca9b;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#7cd7a2;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(114, 202, 155, 0.5);
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning{
  color:#935610;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-active{
  background:none;
  box-shadow:none;
  color:#935610;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.15);
  color:#935610;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#77450d;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(147, 86, 16, 0.5);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head{
  stroke:#935610;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning{
  color:#fbb360;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#f5c186;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(251, 179, 96, 0.5);
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger{
  color:#ac2f33;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-active{
  background:none;
  box-shadow:none;
  color:#ac2f33;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.15);
  color:#ac2f33;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#8e292c;
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(172, 47, 51, 0.5);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}
.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head{
  stroke:#ac2f33;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger{
  color:#fa999c;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#ffa1a4;
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(250, 153, 156, 0.5);
}
.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-button-group.bp4-minimal:not(:first-child){
    border-bottom-left-radius:0;
    border-left:none;
    border-top-left-radius:0;
  }
  .bp4-button-group.bp4-minimal:not(:last-child){
    border-bottom-right-radius:0;
    border-top-right-radius:0;
    margin-right:-1px;
  }
}
.bp4-button-group .bp4-popover-wrapper,
.bp4-button-group .bp4-popover-target{
  display:flex;
  flex:1 1 auto;
}
.bp4-button-group.bp4-fill{
  display:flex;
  width:100%;
}
.bp4-button-group .bp4-button.bp4-fill, .bp4-button-group.bp4-fill .bp4-button:not(.bp4-fixed){
  flex:1 1 auto;
}
.bp4-button-group.bp4-vertical{
  align-items:stretch;
  flex-direction:column;
  vertical-align:top;
}
.bp4-button-group.bp4-vertical.bp4-fill{
  height:100%;
  width:unset;
}
.bp4-button-group.bp4-vertical .bp4-button{
  margin-right:0 !important;
  width:100%;
}
.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-popover-wrapper:first-child .bp4-button,
.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-button:first-child{
  border-radius:2px 2px 0 0;
}
.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-popover-wrapper:last-child .bp4-button,
.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-button:last-child{
  border-radius:0 0 2px 2px;
}
.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-popover-wrapper:not(:last-child) .bp4-button,
.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-button:not(:last-child){
  margin-bottom:-1px;
}
.bp4-button-group.bp4-align-left .bp4-button{
  text-align:left;
}
.bp4-callout{
  font-size:14px;
  line-height:1.5;
  background-color:rgba(143, 153, 168, 0.15);
  border-radius:2px;
  padding:15px;
  position:relative;
  width:100%;
}
.bp4-callout[class*=bp4-icon-]{
  padding-left:38px;
}
.bp4-callout[class*=bp4-icon-]::before{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  color:#5f6b7c;
  left:15px;
  position:absolute;
  top:17px;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-callout{
    border:1px solid buttonborder;
  }
}
.bp4-callout.bp4-callout-icon{
  padding-left:38px;
}
.bp4-callout.bp4-callout-icon > .bp4-icon:first-child{
  color:#5f6b7c;
  left:15px;
  position:absolute;
  top:17px;
}
.bp4-callout .bp4-heading{
  line-height:16px;
  margin-bottom:5px;
  margin-top:2px;
}
.bp4-callout .bp4-heading:last-child{
  margin-bottom:0;
}
.bp4-dark .bp4-callout{
  background-color:rgba(143, 153, 168, 0.2);
}
.bp4-dark .bp4-callout[class*=bp4-icon-]::before, .bp4-dark .bp4-callout.bp4-callout-icon > .bp4-icon:first-child{
  color:#abb3bf;
}
.bp4-callout.bp4-intent-primary{
  background-color:rgba(45, 114, 210, 0.1);
  color:#215db0;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-callout.bp4-intent-primary{
    border:1px solid buttonborder;
  }
}
.bp4-callout.bp4-intent-primary[class*=bp4-icon-]::before,
.bp4-callout.bp4-intent-primary > .bp4-icon:first-child,
.bp4-callout.bp4-intent-primary .bp4-heading{
  color:#215db0;
}
.bp4-dark .bp4-callout.bp4-intent-primary{
  background-color:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-callout.bp4-intent-primary[class*=bp4-icon-]::before,
.bp4-dark .bp4-callout.bp4-intent-primary > .bp4-icon:first-child,
.bp4-dark .bp4-callout.bp4-intent-primary .bp4-heading{
  color:#8abbff;
}
.bp4-callout.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.1);
  color:#1c6e42;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-callout.bp4-intent-success{
    border:1px solid buttonborder;
  }
}
.bp4-callout.bp4-intent-success[class*=bp4-icon-]::before,
.bp4-callout.bp4-intent-success > .bp4-icon:first-child,
.bp4-callout.bp4-intent-success .bp4-heading{
  color:#1c6e42;
}
.bp4-dark .bp4-callout.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-callout.bp4-intent-success[class*=bp4-icon-]::before,
.bp4-dark .bp4-callout.bp4-intent-success > .bp4-icon:first-child,
.bp4-dark .bp4-callout.bp4-intent-success .bp4-heading{
  color:#72ca9b;
}
.bp4-callout.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.1);
  color:#935610;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-callout.bp4-intent-warning{
    border:1px solid buttonborder;
  }
}
.bp4-callout.bp4-intent-warning[class*=bp4-icon-]::before,
.bp4-callout.bp4-intent-warning > .bp4-icon:first-child,
.bp4-callout.bp4-intent-warning .bp4-heading{
  color:#935610;
}
.bp4-dark .bp4-callout.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-callout.bp4-intent-warning[class*=bp4-icon-]::before,
.bp4-dark .bp4-callout.bp4-intent-warning > .bp4-icon:first-child,
.bp4-dark .bp4-callout.bp4-intent-warning .bp4-heading{
  color:#fbb360;
}
.bp4-callout.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.1);
  color:#ac2f33;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-callout.bp4-intent-danger{
    border:1px solid buttonborder;
  }
}
.bp4-callout.bp4-intent-danger[class*=bp4-icon-]::before,
.bp4-callout.bp4-intent-danger > .bp4-icon:first-child,
.bp4-callout.bp4-intent-danger .bp4-heading{
  color:#ac2f33;
}
.bp4-dark .bp4-callout.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-callout.bp4-intent-danger[class*=bp4-icon-]::before,
.bp4-dark .bp4-callout.bp4-intent-danger > .bp4-icon:first-child,
.bp4-dark .bp4-callout.bp4-intent-danger .bp4-heading{
  color:#fa999c;
}
.bp4-callout.bp4-intent-primary a{
  text-decoration:underline;
}
.bp4-callout.bp4-intent-primary a:hover{
  color:#184a90;
}
.bp4-dark .bp4-callout.bp4-intent-primary a:hover{
  color:#99c4ff;
}
.bp4-running-text .bp4-callout{
  margin:20px 0;
}
.bp4-card{
  background-color:#ffffff;
  border-radius:2px;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.15);
  padding:20px;
  transition:transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-card.bp4-dark, .bp4-dark .bp4-card{
  background-color:#2f343c;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-card{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}

.bp4-elevation-0{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.15);
}
.bp4-elevation-0.bp4-dark, .bp4-dark .bp4-elevation-0{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-elevation-0{
    border:1px solid buttonborder;
  }
}

.bp4-elevation-1{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-elevation-1.bp4-dark, .bp4-dark .bp4-elevation-1{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-elevation-1{
    border:1px solid buttonborder;
  }
}

.bp4-elevation-2{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2), 0 2px 6px rgba(17, 20, 24, 0.2);
}
.bp4-elevation-2.bp4-dark, .bp4-dark .bp4-elevation-2{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px rgba(17, 20, 24, 0.4), 0 2px 6px rgba(17, 20, 24, 0.4);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-elevation-2{
    border:1px solid buttonborder;
  }
}

.bp4-elevation-3{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
}
.bp4-elevation-3.bp4-dark, .bp4-dark .bp4-elevation-3{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-elevation-3{
    border:1px solid buttonborder;
  }
}

.bp4-elevation-4{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 4px 8px rgba(17, 20, 24, 0.2), 0 18px 46px 6px rgba(17, 20, 24, 0.2);
}
.bp4-elevation-4.bp4-dark, .bp4-dark .bp4-elevation-4{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 4px 8px rgba(17, 20, 24, 0.4), 0 18px 46px 6px rgba(17, 20, 24, 0.4);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-elevation-4{
    border:1px solid buttonborder;
  }
}

.bp4-card.bp4-interactive:hover{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
  cursor:pointer;
}
.bp4-card.bp4-interactive:hover.bp4-dark, .bp4-dark .bp4-card.bp4-interactive:hover{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
}
.bp4-card.bp4-interactive:active{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);
  opacity:0.9;
  transition-duration:0;
}
.bp4-card.bp4-interactive:active.bp4-dark, .bp4-dark .bp4-card.bp4-interactive:active{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);
}
.bp4-collapse{
  height:0;
  overflow-y:hidden;
  transition:height 200ms cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-collapse .bp4-collapse-body{
  transition:transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-collapse .bp4-collapse-body[aria-hidden=true]{
  display:none;
}

.bp4-context-menu .bp4-popover-target{
  display:block;
}

.bp4-context-menu-popover-target{
  position:fixed;
}
.bp4-divider{
  border-bottom:1px solid rgba(17, 20, 24, 0.15);
  border-right:1px solid rgba(17, 20, 24, 0.15);
  margin:5px;
}
.bp4-dark .bp4-divider{
  border-color:rgba(255, 255, 255, 0.2);
}
.bp4-dialog-container{
  opacity:1;
  transform:scale(1);
  align-items:center;
  display:flex;
  justify-content:center;
  min-height:100%;
  pointer-events:none;
  -webkit-user-select:none;
          user-select:none;
  width:100%;
}
.bp4-dialog-container.bp4-overlay-enter > .bp4-dialog, .bp4-dialog-container.bp4-overlay-appear > .bp4-dialog{
  opacity:0;
  transform:scale(0.5);
}
.bp4-dialog-container.bp4-overlay-enter-active > .bp4-dialog, .bp4-dialog-container.bp4-overlay-appear-active > .bp4-dialog{
  opacity:1;
  transform:scale(1);
  transition-delay:0;
  transition-duration:300ms;
  transition-property:opacity, transform;
  transition-timing-function:cubic-bezier(0.54, 1.12, 0.38, 1.11);
}
.bp4-dialog-container.bp4-overlay-exit > .bp4-dialog{
  opacity:1;
  transform:scale(1);
}
.bp4-dialog-container.bp4-overlay-exit-active > .bp4-dialog{
  opacity:0;
  transform:scale(0.5);
  transition-delay:0;
  transition-duration:300ms;
  transition-property:opacity, transform;
  transition-timing-function:cubic-bezier(0.54, 1.12, 0.38, 1.11);
}

.bp4-dialog{
  background:#f6f7f9;
  border-radius:4px;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
  display:flex;
  flex-direction:column;
  margin:30px 0;
  pointer-events:all;
  -webkit-user-select:text;
          user-select:text;
  width:500px;
}
.bp4-dialog:focus{
  outline:0;
}
.bp4-dialog.bp4-dark, .bp4-dark .bp4-dialog{
  background:#252a31;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
  color:#f6f7f9;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dialog{
    border:1px solid buttonborder;
  }
}

.bp4-dialog-header{
  align-items:center;
  background:#ffffff;
  border-radius:4px 4px 0 0;
  box-shadow:0 1px 0 rgba(17, 20, 24, 0.15);
  display:flex;
  flex:0 0 auto;
  min-height:40px;
  padding:5px;
  padding-left:15px;
  z-index:0;
}
.bp4-dialog-header .bp4-icon-large,
.bp4-dialog-header .bp4-icon{
  color:#5f6b7c;
  flex:0 0 auto;
  margin-left:-3px;
  margin-right:7.5px;
}
.bp4-dialog-header .bp4-heading{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  flex:1 1 auto;
  line-height:inherit;
  margin:0;
}
.bp4-dialog-header .bp4-heading:last-child{
  margin-right:15px;
}
.bp4-dark .bp4-dialog-header{
  background:#2f343c;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
.bp4-dark .bp4-dialog-header .bp4-icon-large,
.bp4-dark .bp4-dialog-header .bp4-icon{
  color:#abb3bf;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dialog-header{
    border-bottom:1px solid buttonborder;
  }
}

.bp4-dialog-body{
  flex:1 1 auto;
  margin:15px;
}

.bp4-dialog-body-scroll-container{
  margin:0;
  max-height:70vh;
  overflow:auto;
  padding:15px;
}

.bp4-dialog-footer{
  flex:0 0 auto;
  margin:15px;
}

.bp4-dialog-footer-fixed{
  align-items:center;
  background-color:#ffffff;
  border-radius:0 0 4px 4px;
  border-top:1px solid rgba(17, 20, 24, 0.15);
  display:flex;
  gap:15px;
  justify-content:space-between;
  margin:0;
  padding:10px 10px 10px 15px;
}
.bp4-dark .bp4-dialog-footer-fixed{
  background:#383e47;
  border-top:1px solid rgba(255, 255, 255, 0.2);
}

.bp4-dialog-footer-main-section{
  flex:1 0 auto;
}

.bp4-dialog-footer-actions{
  display:flex;
  justify-content:flex-end;
}
.bp4-dialog-footer-actions .bp4-button{
  margin-left:10px;
}
.bp4-multistep-dialog-panels{
  display:flex;
}
.bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:first-child{
  border-radius:4px 0 0 0;
}
.bp4-multistep-dialog-panels:first-child .bp4-multistep-dialog-right-panel{
  border-top-right-radius:4px;
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels{
  flex-direction:column;
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:first-child{
  border-radius:4px 0 0 0;
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:last-child{
  border-radius:0 4px 0 0;
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-left-panel{
  flex-direction:row;
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-dialog-step-container{
  flex-grow:1;
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-dialog-step-container:not(:first-child){
  border-left:1px solid rgba(17, 20, 24, 0.15);
}
.bp4-dark .bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-dialog-step-container{
  border-color:rgba(17, 20, 24, 0.4);
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel{
  border-left:none;
}
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel,
.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-footer{
  border-radius:0 0 4px 4px;
}
.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels{
  flex-direction:row-reverse;
}
.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels:first-child .bp4-multistep-dialog-right-panel{
  border-radius:4px 0 0 4px;
}
.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:first-child{
  border-radius:0 4px 0 0;
}
.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-multistep-dialog-left-panel{
  border-radius:0 0 4px 0;
}
.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel{
  border-left:none;
  border-radius:4px 0 0 4px;
  border-right:1px solid rgba(17, 20, 24, 0.15);
}
.bp4-dark .bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel{
  border-color:rgba(17, 20, 24, 0.4);
}
.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-dialog-footer{
  border-bottom-left-radius:0;
}

.bp4-multistep-dialog-left-panel{
  display:flex;
  flex:1 1;
  flex-direction:column;
}
.bp4-dark .bp4-multistep-dialog-left-panel{
  background:#252a31;
  border-bottom:1px solid rgba(255, 255, 255, 0.2);
  border-bottom-left-radius:4px;
  border-left:1px solid rgba(255, 255, 255, 0.2);
}

.bp4-multistep-dialog-right-panel{
  background-color:#f6f7f9;
  border-left:1px solid rgba(17, 20, 24, 0.15);
  border-radius:0 0 4px 0;
  flex:3 1;
  min-width:0;
}
.bp4-dark .bp4-multistep-dialog-right-panel{
  background-color:#2f343c;
  border-bottom:1px solid rgba(255, 255, 255, 0.2);
  border-bottom-right-radius:4px;
  border-left:1px solid rgba(255, 255, 255, 0.2);
  border-right:1px solid rgba(255, 255, 255, 0.2);
}

.bp4-dialog-step-container{
  background-color:#f6f7f9;
  border-bottom:1px solid rgba(17, 20, 24, 0.15);
}
.bp4-dark .bp4-dialog-step-container{
  background:#2f343c;
  border-bottom:1px solid rgba(255, 255, 255, 0.2);
}
.bp4-dialog-step-container.bp4-dialog-step-viewed{
  background-color:#ffffff;
}
.bp4-dark .bp4-dialog-step-container.bp4-dialog-step-viewed{
  background:#383e47;
}

.bp4-dialog-step{
  align-items:center;
  border-radius:4px;
  cursor:not-allowed;
  display:flex;
  margin:4px;
  padding:6px 14px;
}
.bp4-dark .bp4-dialog-step{
  background:#2f343c;
}
.bp4-dialog-step-viewed .bp4-dialog-step{
  background-color:#ffffff;
  cursor:pointer;
}
.bp4-dark .bp4-dialog-step-viewed .bp4-dialog-step{
  background:#383e47;
}
.bp4-dialog-step:hover{
  background-color:#f6f7f9;
}
.bp4-dark .bp4-dialog-step:hover{
  background:#2f343c;
}

.bp4-dialog-step-icon{
  align-items:center;
  background-color:rgba(95, 107, 124, 0.6);
  border-radius:50%;
  color:#ffffff;
  display:flex;
  height:25px;
  justify-content:center;
  width:25px;
}
.bp4-dark .bp4-dialog-step-icon{
  background-color:rgba(171, 179, 191, 0.6);
}
.bp4-active.bp4-dialog-step-viewed .bp4-dialog-step-icon{
  background-color:#4c90f0;
}
.bp4-dialog-step-viewed .bp4-dialog-step-icon{
  background-color:#8f99a8;
}

.bp4-dialog-step-title{
  color:rgba(95, 107, 124, 0.6);
  flex:1 1;
  padding-left:10px;
}
.bp4-dark .bp4-dialog-step-title{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-active.bp4-dialog-step-viewed .bp4-dialog-step-title{
  color:#4c90f0;
}
.bp4-dialog-step-viewed:not(.bp4-active) .bp4-dialog-step-title{
  color:#1c2127;
}
.bp4-dark .bp4-dialog-step-viewed:not(.bp4-active) .bp4-dialog-step-title{
  color:#f6f7f9;
}
.bp4-drawer{
  background:#ffffff;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 4px 8px rgba(17, 20, 24, 0.2), 0 18px 46px 6px rgba(17, 20, 24, 0.2);
  display:flex;
  flex-direction:column;
  margin:0;
  padding:0;
}
.bp4-drawer:focus{
  outline:0;
}
.bp4-drawer.bp4-position-top{
  height:50%;
  left:0;
  right:0;
  top:0;
}
.bp4-drawer.bp4-position-top.bp4-overlay-enter, .bp4-drawer.bp4-position-top.bp4-overlay-appear{
  transform:translateY(-100%);
}
.bp4-drawer.bp4-position-top.bp4-overlay-enter-active, .bp4-drawer.bp4-position-top.bp4-overlay-appear-active{
  transform:translateY(0);
  transition-delay:0;
  transition-duration:200ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-drawer.bp4-position-top.bp4-overlay-exit{
  transform:translateY(0);
}
.bp4-drawer.bp4-position-top.bp4-overlay-exit-active{
  transform:translateY(-100%);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-drawer.bp4-position-top{
    border-bottom:1px solid buttonborder;
  }
}
.bp4-drawer.bp4-position-bottom{
  bottom:0;
  height:50%;
  left:0;
  right:0;
}
.bp4-drawer.bp4-position-bottom.bp4-overlay-enter, .bp4-drawer.bp4-position-bottom.bp4-overlay-appear{
  transform:translateY(100%);
}
.bp4-drawer.bp4-position-bottom.bp4-overlay-enter-active, .bp4-drawer.bp4-position-bottom.bp4-overlay-appear-active{
  transform:translateY(0);
  transition-delay:0;
  transition-duration:200ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-drawer.bp4-position-bottom.bp4-overlay-exit{
  transform:translateY(0);
}
.bp4-drawer.bp4-position-bottom.bp4-overlay-exit-active{
  transform:translateY(100%);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-drawer.bp4-position-bottom{
    border-top:1px solid buttonborder;
  }
}
.bp4-drawer.bp4-position-left{
  bottom:0;
  left:0;
  top:0;
  width:50%;
}
.bp4-drawer.bp4-position-left.bp4-overlay-enter, .bp4-drawer.bp4-position-left.bp4-overlay-appear{
  transform:translateX(-100%);
}
.bp4-drawer.bp4-position-left.bp4-overlay-enter-active, .bp4-drawer.bp4-position-left.bp4-overlay-appear-active{
  transform:translateX(0);
  transition-delay:0;
  transition-duration:200ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-drawer.bp4-position-left.bp4-overlay-exit{
  transform:translateX(0);
}
.bp4-drawer.bp4-position-left.bp4-overlay-exit-active{
  transform:translateX(-100%);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-drawer.bp4-position-left{
    border-right:1px solid buttonborder;
  }
}
.bp4-drawer.bp4-position-right{
  bottom:0;
  right:0;
  top:0;
  width:50%;
}
.bp4-drawer.bp4-position-right.bp4-overlay-enter, .bp4-drawer.bp4-position-right.bp4-overlay-appear{
  transform:translateX(100%);
}
.bp4-drawer.bp4-position-right.bp4-overlay-enter-active, .bp4-drawer.bp4-position-right.bp4-overlay-appear-active{
  transform:translateX(0);
  transition-delay:0;
  transition-duration:200ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-drawer.bp4-position-right.bp4-overlay-exit{
  transform:translateX(0);
}
.bp4-drawer.bp4-position-right.bp4-overlay-exit-active{
  transform:translateX(100%);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-drawer.bp4-position-right{
    border-left:1px solid buttonborder;
  }
}
.bp4-drawer.bp4-dark, .bp4-dark .bp4-drawer{
  background:#383e47;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
  color:#f6f7f9;
}

.bp4-drawer-header{
  align-items:center;
  border-radius:0;
  box-shadow:0 1px 0 rgba(17, 20, 24, 0.15);
  display:flex;
  flex:0 0 auto;
  min-height:40px;
  padding:5px;
  padding-left:20px;
  position:relative;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-drawer-header{
    border-bottom:1px solid buttonborder;
  }
}
.bp4-drawer-header .bp4-icon-large,
.bp4-drawer-header .bp4-icon{
  color:#5f6b7c;
  flex:0 0 auto;
  margin-right:10px;
}
.bp4-drawer-header .bp4-heading{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  flex:1 1 auto;
  line-height:inherit;
  margin:0;
}
.bp4-drawer-header .bp4-heading:last-child{
  margin-right:20px;
}
.bp4-dark .bp4-drawer-header{
  box-shadow:0 1px 0 rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-drawer-header .bp4-icon-large,
.bp4-dark .bp4-drawer-header .bp4-icon{
  color:#abb3bf;
}

.bp4-drawer-body{
  flex:1 1 auto;
  line-height:18px;
  overflow:auto;
}

.bp4-drawer-footer{
  box-shadow:inset 0 1px 0 rgba(17, 20, 24, 0.15);
  flex:0 0 auto;
  padding:10px 20px;
  position:relative;
}
.bp4-dark .bp4-drawer-footer{
  box-shadow:inset 0 1px 0 rgba(17, 20, 24, 0.4);
}
.bp4-editable-text{
  cursor:text;
  display:inline-block;
  max-width:100%;
  position:relative;
  vertical-align:top;
  white-space:nowrap;
}
.bp4-editable-text::before{
  bottom:-2px;
  left:-2px;
  position:absolute;
  right:-2px;
  top:-2px;
  border-radius:2px;
  content:"";
  transition:background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-editable-text:hover::before{
  box-shadow:0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(17, 20, 24, 0.15);
}
.bp4-editable-text.bp4-editable-text-editing::before{
  background-color:#ffffff;
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-editable-text:not(.bp4-disabled)::before{
    border:1px solid buttonborder;
  }
}
.bp4-editable-text.bp4-intent-primary .bp4-editable-text-content,
.bp4-editable-text.bp4-intent-primary .bp4-editable-text-input,
.bp4-editable-text.bp4-intent-primary .bp4-editable-text-input::placeholder{
  color:#2d72d2;
}
.bp4-editable-text.bp4-intent-primary:hover::before{
  box-shadow:0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(45, 114, 210, 0.4);
}
.bp4-editable-text.bp4-intent-primary.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-editable-text.bp4-intent-success .bp4-editable-text-content,
.bp4-editable-text.bp4-intent-success .bp4-editable-text-input,
.bp4-editable-text.bp4-intent-success .bp4-editable-text-input::placeholder{
  color:#238551;
}
.bp4-editable-text.bp4-intent-success:hover::before{
  box-shadow:0 0 0 0 rgba(35, 133, 81, 0), 0 0 0 0 rgba(35, 133, 81, 0), inset 0 0 0 1px rgba(35, 133, 81, 0.4);
}
.bp4-editable-text.bp4-intent-success.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-editable-text.bp4-intent-warning .bp4-editable-text-content,
.bp4-editable-text.bp4-intent-warning .bp4-editable-text-input,
.bp4-editable-text.bp4-intent-warning .bp4-editable-text-input::placeholder{
  color:#c87619;
}
.bp4-editable-text.bp4-intent-warning:hover::before{
  box-shadow:0 0 0 0 rgba(200, 118, 25, 0), 0 0 0 0 rgba(200, 118, 25, 0), inset 0 0 0 1px rgba(200, 118, 25, 0.4);
}
.bp4-editable-text.bp4-intent-warning.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-editable-text.bp4-intent-danger .bp4-editable-text-content,
.bp4-editable-text.bp4-intent-danger .bp4-editable-text-input,
.bp4-editable-text.bp4-intent-danger .bp4-editable-text-input::placeholder{
  color:#cd4246;
}
.bp4-editable-text.bp4-intent-danger:hover::before{
  box-shadow:0 0 0 0 rgba(205, 66, 70, 0), 0 0 0 0 rgba(205, 66, 70, 0), inset 0 0 0 1px rgba(205, 66, 70, 0.4);
}
.bp4-editable-text.bp4-intent-danger.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-dark .bp4-editable-text:hover::before{
  box-shadow:0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
.bp4-dark .bp4-editable-text.bp4-editable-text-editing::before{
  background-color:rgba(17, 20, 24, 0.3);
  box-shadow:inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-editable-text.bp4-disabled::before{
  box-shadow:none;
}
.bp4-dark .bp4-editable-text.bp4-intent-primary .bp4-editable-text-content,
.bp4-dark .bp4-editable-text.bp4-intent-primary .bp4-editable-text-input,
.bp4-dark .bp4-editable-text.bp4-intent-primary .bp4-editable-text-input::placeholder{
  color:#8abbff;
}
.bp4-dark .bp4-editable-text.bp4-intent-primary:hover::before{
  box-shadow:0 0 0 0 rgba(138, 187, 255, 0), 0 0 0 0 rgba(138, 187, 255, 0), inset 0 0 0 1px rgba(138, 187, 255, 0.4);
}
.bp4-dark .bp4-editable-text.bp4-intent-primary.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #8abbff, 0 0 0 2px rgba(138, 187, 255, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-editable-text.bp4-intent-success .bp4-editable-text-content,
.bp4-dark .bp4-editable-text.bp4-intent-success .bp4-editable-text-input,
.bp4-dark .bp4-editable-text.bp4-intent-success .bp4-editable-text-input::placeholder{
  color:#72ca9b;
}
.bp4-dark .bp4-editable-text.bp4-intent-success:hover::before{
  box-shadow:0 0 0 0 rgba(114, 202, 155, 0), 0 0 0 0 rgba(114, 202, 155, 0), inset 0 0 0 1px rgba(114, 202, 155, 0.4);
}
.bp4-dark .bp4-editable-text.bp4-intent-success.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #72ca9b, 0 0 0 2px rgba(114, 202, 155, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-editable-text.bp4-intent-warning .bp4-editable-text-content,
.bp4-dark .bp4-editable-text.bp4-intent-warning .bp4-editable-text-input,
.bp4-dark .bp4-editable-text.bp4-intent-warning .bp4-editable-text-input::placeholder{
  color:#fbb360;
}
.bp4-dark .bp4-editable-text.bp4-intent-warning:hover::before{
  box-shadow:0 0 0 0 rgba(251, 179, 96, 0), 0 0 0 0 rgba(251, 179, 96, 0), inset 0 0 0 1px rgba(251, 179, 96, 0.4);
}
.bp4-dark .bp4-editable-text.bp4-intent-warning.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #fbb360, 0 0 0 2px rgba(251, 179, 96, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-editable-text.bp4-intent-danger .bp4-editable-text-content,
.bp4-dark .bp4-editable-text.bp4-intent-danger .bp4-editable-text-input,
.bp4-dark .bp4-editable-text.bp4-intent-danger .bp4-editable-text-input::placeholder{
  color:#fa999c;
}
.bp4-dark .bp4-editable-text.bp4-intent-danger:hover::before{
  box-shadow:0 0 0 0 rgba(250, 153, 156, 0), 0 0 0 0 rgba(250, 153, 156, 0), inset 0 0 0 1px rgba(250, 153, 156, 0.4);
}
.bp4-dark .bp4-editable-text.bp4-intent-danger.bp4-editable-text-editing::before{
  box-shadow:inset 0 0 0 1px #fa999c, 0 0 0 2px rgba(250, 153, 156, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-editable-text.bp4-disabled::before{
  box-shadow:none !important;
}

.bp4-editable-text-input,
.bp4-editable-text-content{
  color:inherit;
  display:inherit;
  font:inherit;
  letter-spacing:inherit;
  max-width:inherit;
  min-width:inherit;
  position:relative;
  resize:none;
  text-transform:inherit;
  vertical-align:top;
}

.bp4-editable-text-input{
  background:none;
  border:none;
  box-shadow:none;
  padding:0;
  white-space:pre-wrap;
  width:100%;
}
.bp4-editable-text-input::placeholder{
  color:#5f6b7c;
  opacity:1;
}
.bp4-editable-text-input:focus{
  outline:none;
}
.bp4-editable-text-input::-ms-clear{
  display:none;
}

.bp4-editable-text-content{
  overflow:hidden;
  padding-right:2px;
  text-overflow:ellipsis;
  white-space:pre;
}
.bp4-editable-text-editing > .bp4-editable-text-content{
  left:0;
  position:absolute;
  visibility:hidden;
}
.bp4-editable-text-placeholder > .bp4-editable-text-content{
  color:#5f6b7c;
}
.bp4-dark .bp4-editable-text-placeholder > .bp4-editable-text-content{
  color:#abb3bf;
}

.bp4-editable-text.bp4-multiline{
  display:block;
}
.bp4-editable-text.bp4-multiline .bp4-editable-text-content{
  overflow:auto;
  white-space:pre-wrap;
  word-wrap:break-word;
}
.bp4-divider{
  border-bottom:1px solid rgba(17, 20, 24, 0.15);
  border-right:1px solid rgba(17, 20, 24, 0.15);
  margin:5px;
}
.bp4-dark .bp4-divider{
  border-color:rgba(255, 255, 255, 0.2);
}
.bp4-control-group{
  transform:translateZ(0);
  display:flex;
  flex-direction:row;
  align-items:stretch;
}
.bp4-control-group > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-control-group > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-control-group .bp4-button,
.bp4-control-group .bp4-html-select,
.bp4-control-group .bp4-input,
.bp4-control-group .bp4-select{
  position:relative;
}
.bp4-control-group .bp4-input{
  z-index:2;
}
.bp4-control-group .bp4-input:focus{
  z-index:14;
}
.bp4-control-group .bp4-input[class*=bp4-intent]{
  z-index:13;
}
.bp4-control-group .bp4-input[class*=bp4-intent]:focus{
  z-index:15;
}
.bp4-control-group .bp4-input[readonly], .bp4-control-group .bp4-input:disabled, .bp4-control-group .bp4-input.bp4-disabled{
  z-index:1;
}
.bp4-control-group .bp4-input-group[class*=bp4-intent] .bp4-input{
  z-index:13;
}
.bp4-control-group .bp4-input-group[class*=bp4-intent] .bp4-input:focus{
  z-index:15;
}
.bp4-control-group .bp4-button,
.bp4-control-group .bp4-html-select select,
.bp4-control-group .bp4-select select{
  transform:translateZ(0);
  z-index:4;
}
.bp4-control-group .bp4-button:focus,
.bp4-control-group .bp4-html-select select:focus,
.bp4-control-group .bp4-select select:focus{
  z-index:5;
}
.bp4-control-group .bp4-button:hover,
.bp4-control-group .bp4-html-select select:hover,
.bp4-control-group .bp4-select select:hover{
  z-index:6;
}
.bp4-control-group .bp4-button:active,
.bp4-control-group .bp4-html-select select:active,
.bp4-control-group .bp4-select select:active{
  z-index:7;
}
.bp4-control-group .bp4-button[readonly], .bp4-control-group .bp4-button:disabled, .bp4-control-group .bp4-button.bp4-disabled,
.bp4-control-group .bp4-html-select select[readonly],
.bp4-control-group .bp4-html-select select:disabled,
.bp4-control-group .bp4-html-select select.bp4-disabled,
.bp4-control-group .bp4-select select[readonly],
.bp4-control-group .bp4-select select:disabled,
.bp4-control-group .bp4-select select.bp4-disabled{
  z-index:3;
}
.bp4-control-group .bp4-button[class*=bp4-intent],
.bp4-control-group .bp4-html-select select[class*=bp4-intent],
.bp4-control-group .bp4-select select[class*=bp4-intent]{
  z-index:9;
}
.bp4-control-group .bp4-button[class*=bp4-intent]:focus,
.bp4-control-group .bp4-html-select select[class*=bp4-intent]:focus,
.bp4-control-group .bp4-select select[class*=bp4-intent]:focus{
  z-index:10;
}
.bp4-control-group .bp4-button[class*=bp4-intent]:hover,
.bp4-control-group .bp4-html-select select[class*=bp4-intent]:hover,
.bp4-control-group .bp4-select select[class*=bp4-intent]:hover{
  z-index:11;
}
.bp4-control-group .bp4-button[class*=bp4-intent]:active,
.bp4-control-group .bp4-html-select select[class*=bp4-intent]:active,
.bp4-control-group .bp4-select select[class*=bp4-intent]:active{
  z-index:12;
}
.bp4-control-group .bp4-button[class*=bp4-intent][readonly], .bp4-control-group .bp4-button[class*=bp4-intent]:disabled, .bp4-control-group .bp4-button[class*=bp4-intent].bp4-disabled,
.bp4-control-group .bp4-html-select select[class*=bp4-intent][readonly],
.bp4-control-group .bp4-html-select select[class*=bp4-intent]:disabled,
.bp4-control-group .bp4-html-select select[class*=bp4-intent].bp4-disabled,
.bp4-control-group .bp4-select select[class*=bp4-intent][readonly],
.bp4-control-group .bp4-select select[class*=bp4-intent]:disabled,
.bp4-control-group .bp4-select select[class*=bp4-intent].bp4-disabled{
  z-index:8;
}
.bp4-control-group .bp4-input-group > .bp4-icon,
.bp4-control-group .bp4-input-group > .bp4-button,
.bp4-control-group .bp4-input-group > .bp4-input-left-container,
.bp4-control-group .bp4-input-group > .bp4-input-action{
  z-index:16;
}
.bp4-control-group .bp4-select::after,
.bp4-control-group .bp4-html-select::after,
.bp4-control-group .bp4-select > .bp4-icon,
.bp4-control-group .bp4-html-select > .bp4-icon{
  z-index:17;
}
.bp4-control-group .bp4-select:focus-within{
  z-index:5;
}
.bp4-control-group:not(.bp4-vertical) > :not(:last-child){
  margin-right:2px;
}
.bp4-control-group .bp4-numeric-input:not(:first-child) .bp4-input-group{
  border-bottom-left-radius:0;
  border-top-left-radius:0;
}
.bp4-control-group.bp4-fill{
  width:100%;
}
.bp4-control-group > .bp4-fill{
  flex:1 1 auto;
}
.bp4-control-group.bp4-fill > *:not(.bp4-fixed){
  flex:1 1 auto;
}
.bp4-control-group.bp4-vertical{
  flex-direction:column;
}
.bp4-control-group.bp4-vertical > :not(:last-child){
  margin-bottom:2px;
}
.bp4-control{
  cursor:pointer;
  display:block;
  margin-bottom:10px;
  position:relative;
  text-transform:none;
}
.bp4-control input:checked ~ .bp4-control-indicator{
  background-color:#2d72d2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2);
  color:#ffffff;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control input:checked ~ .bp4-control-indicator{
    background-color:highlight;
    border:1px solid highlight;
  }
}
.bp4-control:hover input:checked ~ .bp4-control-indicator{
  background-color:#215db0;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control:hover input:checked ~ .bp4-control-indicator{
    background-color:highlight;
  }
}
.bp4-control input:not(:disabled):active:checked ~ .bp4-control-indicator{
  background:#184a90;
}
.bp4-control input:disabled:checked ~ .bp4-control-indicator{
  background:rgba(45, 114, 210, 0.5);
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control input:disabled:checked ~ .bp4-control-indicator{
    background-color:graytext;
    border-color:graytext;
  }
}
.bp4-dark .bp4-control input:checked ~ .bp4-control-indicator{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-control input:checked ~ .bp4-control-indicator{
    border:1px solid buttonborder;
  }
}
.bp4-dark .bp4-control:hover input:checked ~ .bp4-control-indicator{
  background-color:#215db0;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}
.bp4-dark .bp4-control input:not(:disabled):active:checked ~ .bp4-control-indicator{
  background-color:#184a90;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}
.bp4-dark .bp4-control input:disabled:checked ~ .bp4-control-indicator{
  background:rgba(45, 114, 210, 0.5);
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
.bp4-control:not(.bp4-align-right){
  padding-left:26px;
}
.bp4-control:not(.bp4-align-right) .bp4-control-indicator{
  margin-left:-26px;
}
.bp4-control.bp4-align-right{
  padding-right:26px;
}
.bp4-control.bp4-align-right .bp4-control-indicator{
  margin-right:-26px;
}
.bp4-control.bp4-disabled{
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
.bp4-control.bp4-inline{
  display:inline-block;
  margin-right:20px;
}
.bp4-control input{
  left:0;
  opacity:0;
  position:absolute;
  top:0;
  z-index:-1;
}
.bp4-control .bp4-control-indicator{
  background-clip:padding-box;
  background-color:transparent;
  border:none;
  box-shadow:inset 0 0 0 1px #738091;
  cursor:pointer;
  display:inline-block;
  font-size:16px;
  height:1em;
  margin-right:10px;
  margin-top:-3px;
  position:relative;
  -webkit-user-select:none;
          user-select:none;
  vertical-align:middle;
  width:1em;
}
.bp4-control .bp4-control-indicator::before{
  content:"";
  display:block;
  height:1em;
  width:1em;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control .bp4-control-indicator{
    border:1px solid buttonborder;
  }
  .bp4-control .bp4-control-indicator::before{
    margin-left:-1px;
    margin-top:-1px;
  }
}
.bp4-control:hover .bp4-control-indicator{
  background-color:rgba(143, 153, 168, 0.15);
}
.bp4-control input:not(:disabled):active ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.3);
  box-shadow:inset 0 0 0 1px #738091;
}
.bp4-control input:disabled ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.15);
  box-shadow:none;
  cursor:not-allowed;
}
.bp4-control input:focus ~ .bp4-control-indicator{
  outline:rgba(45, 114, 210, 0.6) solid 2px;
  outline-offset:2px;
  -moz-outline-radius:6px;
  outline:#2d72d2 solid 2px;
}
.bp4-control.bp4-align-right .bp4-control-indicator{
  float:right;
  margin-left:10px;
  margin-top:1px;
}
.bp4-control.bp4-large{
  font-size:16px;
}
.bp4-control.bp4-large:not(.bp4-align-right){
  padding-left:30px;
}
.bp4-control.bp4-large:not(.bp4-align-right) .bp4-control-indicator{
  margin-left:-30px;
}
.bp4-control.bp4-large.bp4-align-right{
  padding-right:30px;
}
.bp4-control.bp4-large.bp4-align-right .bp4-control-indicator{
  margin-right:-30px;
}
.bp4-control.bp4-large .bp4-control-indicator{
  font-size:20px;
}
.bp4-control.bp4-large.bp4-align-right .bp4-control-indicator{
  margin-top:0;
}
.bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator{
  background-color:#2d72d2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2);
  color:#ffffff;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator{
    background-color:highlight;
    border:1px solid highlight;
  }
}
.bp4-control.bp4-checkbox:hover input:indeterminate ~ .bp4-control-indicator{
  background-color:#215db0;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-checkbox:hover input:indeterminate ~ .bp4-control-indicator{
    background-color:highlight;
  }
}
.bp4-control.bp4-checkbox input:not(:disabled):active:indeterminate ~ .bp4-control-indicator{
  background:#184a90;
}
.bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator{
  background:rgba(45, 114, 210, 0.5);
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator{
    background-color:graytext;
    border-color:graytext;
  }
}
.bp4-dark .bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator{
    border:1px solid buttonborder;
  }
}
.bp4-dark .bp4-control.bp4-checkbox:hover input:indeterminate ~ .bp4-control-indicator{
  background-color:#215db0;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}
.bp4-dark .bp4-control.bp4-checkbox input:not(:disabled):active:indeterminate ~ .bp4-control-indicator{
  background-color:#184a90;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}
.bp4-dark .bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator{
  background:rgba(45, 114, 210, 0.5);
  box-shadow:none;
  color:rgba(255, 255, 255, 0.6);
}
.bp4-control.bp4-checkbox .bp4-control-indicator{
  border-radius:2px;
}
.bp4-control.bp4-checkbox input:checked ~ .bp4-control-indicator::before{
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator::before{
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-checkbox input:checked:not(:disabled) ~ .bp4-control-indicator::before{
    background-image:url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
  .bp4-control.bp4-checkbox input:indeterminate:not(:disabled) ~ .bp4-control-indicator::before{
    background-image:url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
  .bp4-control.bp4-checkbox input:disabled ~ .bp4-control-indicator{
    border-color:graytext;
  }
}
.bp4-control.bp4-radio .bp4-control-indicator{
  border-radius:50%;
}
.bp4-control.bp4-radio input:checked ~ .bp4-control-indicator::before{
  background-image:radial-gradient(#ffffff, #ffffff 28%, transparent 32%);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-radio input:checked ~ .bp4-control-indicator::before{
    background:highlight;
    height:12px;
    margin-left:1px;
    margin-top:1px;
    width:12px;
  }
}
.bp4-control.bp4-radio input:checked:disabled ~ .bp4-control-indicator::before{
  opacity:0.5;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-radio input:checked:disabled ~ .bp4-control-indicator::before{
    background:graytext;
  }
}
.bp4-control.bp4-radio input:focus ~ .bp4-control-indicator{
  -moz-outline-radius:16px;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-radio input:disabled ~ .bp4-control-indicator{
    border-color:graytext;
  }
}
.bp4-control.bp4-switch input ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.3);
  color:#1c2127;
}
.bp4-control.bp4-switch:hover input ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.4);
}
.bp4-control.bp4-switch input:not(:disabled):active ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.5);
}
.bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.15);
  color:rgba(95, 107, 124, 0.6);
}
.bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator::before{
  background:rgba(255, 255, 255, 0.8);
  box-shadow:none;
}
.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator{
  background:#2d72d2;
  color:#ffffff;
}
.bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator{
  background:#215db0;
}
.bp4-control.bp4-switch input:checked:not(:disabled):active ~ .bp4-control-indicator{
  background:#184a90;
}
.bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator{
  background:rgba(45, 114, 210, 0.5);
  color:rgba(255, 255, 255, 0.6);
}
.bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator::before{
  background:rgba(255, 255, 255, 0.5);
  box-shadow:none;
}
.bp4-control.bp4-switch:not(.bp4-align-right){
  padding-left:38px;
}
.bp4-control.bp4-switch:not(.bp4-align-right) .bp4-control-indicator{
  margin-left:-38px;
}
.bp4-control.bp4-switch.bp4-align-right{
  padding-right:38px;
}
.bp4-control.bp4-switch.bp4-align-right .bp4-control-indicator{
  margin-right:-38px;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator{
    background:highlight;
    border:1px solid buttonborder;
  }
  .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator{
    background-color:graytext;
  }
  .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator{
    border-color:graytext;
  }
  .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator::before{
    border-color:graytext;
  }
  .bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator{
    background:highlight;
  }
}
.bp4-control.bp4-switch .bp4-control-indicator{
  border:none;
  border-radius:1.75em;
  box-shadow:none !important;
  min-width:1.75em;
  transition:background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9);
  width:auto;
}
.bp4-control.bp4-switch .bp4-control-indicator::before{
  background:#ffffff;
  border-radius:50%;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.5);
  height:calc(1em - 4px);
  left:0;
  margin:2px;
  position:absolute;
  transition:left 100ms cubic-bezier(0.4, 1, 0.75, 0.9);
  width:calc(1em - 4px);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-switch .bp4-control-indicator::before{
    border:1px solid buttonborder;
    margin-top:1px;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-control.bp4-switch .bp4-control-indicator{
    border:1px solid buttonborder;
  }
}
.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator::before{
  left:calc(100% - 1em);
}
.bp4-control.bp4-switch.bp4-large:not(.bp4-align-right){
  padding-left:45px;
}
.bp4-control.bp4-switch.bp4-large:not(.bp4-align-right) .bp4-control-indicator{
  margin-left:-45px;
}
.bp4-control.bp4-switch.bp4-large.bp4-align-right{
  padding-right:45px;
}
.bp4-control.bp4-switch.bp4-large.bp4-align-right .bp4-control-indicator{
  margin-right:-45px;
}
.bp4-dark .bp4-control.bp4-switch input ~ .bp4-control-indicator{
  background:rgba(17, 20, 24, 0.5);
  color:#f6f7f9;
}
.bp4-dark .bp4-control.bp4-switch:hover input ~ .bp4-control-indicator{
  background:rgba(17, 20, 24, 0.8);
}
.bp4-dark .bp4-control.bp4-switch input:not(:disabled):active ~ .bp4-control-indicator{
  background:rgba(17, 20, 24, 0.9);
}
.bp4-dark .bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.15);
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator::before{
  background:rgba(171, 179, 191, 0.5);
  box-shadow:none;
}
.bp4-dark .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator{
  background:#2d72d2;
  color:#ffffff;
}
.bp4-dark .bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator{
  background:#215db0;
}
.bp4-dark .bp4-control.bp4-switch input:checked:not(:disabled):active ~ .bp4-control-indicator{
  background:#184a90;
}
.bp4-dark .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator{
  background:rgba(45, 114, 210, 0.5);
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator::before{
  background:rgba(255, 255, 255, 0.3);
  box-shadow:none;
}
.bp4-dark .bp4-control.bp4-switch .bp4-control-indicator::before{
  background:#abb3bf;
}
.bp4-dark .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator::before{
  background:#ffffff;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator{
    background:highlight;
    border:1px solid buttonborder;
  }
  .bp4-dark .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator{
    background-color:graytext;
  }
  .bp4-dark .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator{
    border-color:graytext;
  }
  .bp4-dark .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator::before{
    border-color:graytext;
  }
  .bp4-dark .bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator{
    background:highlight;
  }
}
.bp4-control.bp4-switch .bp4-switch-inner-text{
  font-size:0.7em;
  text-align:center;
}
.bp4-control.bp4-switch .bp4-control-indicator-child:first-child{
  line-height:0;
  margin-left:0.5em;
  margin-right:1.2em;
  visibility:hidden;
}
.bp4-control.bp4-switch .bp4-control-indicator-child:last-child{
  line-height:1em;
  margin-left:1.2em;
  margin-right:0.5em;
  visibility:visible;
}
.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator .bp4-control-indicator-child:first-child{
  line-height:1em;
  visibility:visible;
}
.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator .bp4-control-indicator-child:last-child{
  line-height:0;
  visibility:hidden;
}
.bp4-dark .bp4-control{
  color:#f6f7f9;
}
.bp4-dark .bp4-control.bp4-disabled{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-control .bp4-control-indicator{
  background-color:transparent;
  box-shadow:inset 0 0 0 1px #8f99a8;
}
.bp4-dark .bp4-control:hover .bp4-control-indicator{
  background-color:rgba(143, 153, 168, 0.15);
}
.bp4-dark .bp4-control input:focus ~ .bp4-control-indicator{
  outline:#8abbff solid 2px;
}
.bp4-dark .bp4-control input:not(:disabled):active ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.3);
  box-shadow:inset 0 0 0 1px #8f99a8;
}
.bp4-dark .bp4-control input:disabled ~ .bp4-control-indicator{
  background:rgba(143, 153, 168, 0.15);
  box-shadow:none;
  cursor:not-allowed;
}
.bp4-dark .bp4-control.bp4-checkbox input:disabled:checked ~ .bp4-control-indicator, .bp4-dark .bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator{
  background:rgba(45, 114, 210, 0.5);
}
.bp4-file-input{
  cursor:pointer;
  display:inline-block;
  height:30px;
  position:relative;
}
.bp4-file-input input{
  margin:0;
  min-width:200px;
  opacity:0;
}
.bp4-file-input input:disabled + .bp4-file-upload-input, .bp4-file-input input.bp4-disabled + .bp4-file-upload-input{
  background:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
  resize:none;
}
.bp4-file-input input:disabled + .bp4-file-upload-input::placeholder, .bp4-file-input input.bp4-disabled + .bp4-file-upload-input::placeholder{
  color:rgba(95, 107, 124, 0.6);
}
.bp4-file-input input:disabled + .bp4-file-upload-input::after, .bp4-file-input input.bp4-disabled + .bp4-file-upload-input::after{
  background-color:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
  outline:none;
}
.bp4-dark .bp4-file-input input:disabled + .bp4-file-upload-input, .bp4-dark .bp4-file-input input.bp4-disabled + .bp4-file-upload-input{
  background:rgba(64, 72, 84, 0.5);
  box-shadow:none;
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-file-input input:disabled + .bp4-file-upload-input::after, .bp4-dark .bp4-file-input input.bp4-disabled + .bp4-file-upload-input::after{
  background-color:rgba(64, 72, 84, 0.5);
  box-shadow:none;
  color:rgba(171, 179, 191, 0.6);
}
.bp4-file-input.bp4-file-input-has-selection .bp4-file-upload-input{
  color:#1c2127;
}
.bp4-dark .bp4-file-input.bp4-file-input-has-selection .bp4-file-upload-input{
  color:#f6f7f9;
}
.bp4-file-input.bp4-fill{
  width:100%;
}
.bp4-file-input.bp4-large, .bp4-large .bp4-file-input{
  height:40px;
}
.bp4-file-input.bp4-small, .bp4-small .bp4-file-input{
  height:24px;
}
.bp4-file-input .bp4-file-upload-input-custom-text::after{
  content:attr(bp4-button-text);
}

.bp4-file-upload-input{
  appearance:none;
  background:#ffffff;
  border:none;
  border-radius:2px;
  box-shadow:0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
  color:#1c2127;
  font-size:14px;
  font-weight:400;
  height:30px;
  line-height:30px;
  outline:none;
  padding:0 10px;
  transition:box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);
  vertical-align:middle;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  color:rgba(95, 107, 124, 0.6);
  left:0;
  padding-right:80px;
  position:absolute;
  right:0;
  top:0;
  -webkit-user-select:none;
          user-select:none;
}
.bp4-file-upload-input::placeholder{
  color:#5f6b7c;
  opacity:1;
}
.bp4-file-upload-input:focus, .bp4-file-upload-input.bp4-active{
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-file-upload-input[type=search], .bp4-file-upload-input.bp4-round{
  border-radius:30px;
  box-sizing:border-box;
  padding-left:10px;
}
.bp4-file-upload-input[readonly]{
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.15);
}
.bp4-file-upload-input:disabled, .bp4-file-upload-input.bp4-disabled{
  background:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
  resize:none;
}
.bp4-file-upload-input:disabled::placeholder, .bp4-file-upload-input.bp4-disabled::placeholder{
  color:rgba(95, 107, 124, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-file-upload-input{
    border:1px solid buttonborder;
  }
}
.bp4-file-upload-input::after{
  background-color:#f6f7f9;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#1c2127;
  min-height:24px;
  min-width:24px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  border-radius:2px;
  content:"Browse";
  line-height:24px;
  margin:3px;
  position:absolute;
  right:0;
  text-align:center;
  top:0;
  width:70px;
}
.bp4-file-upload-input:hover::after{
  background-clip:padding-box;
  background-color:#edeff2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-file-upload-input:active::after{
  background-color:#dce0e5;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-file-upload-input:active::after{
    background:highlight;
  }
}
.bp4-large .bp4-file-upload-input{
  font-size:16px;
  height:40px;
  line-height:40px;
  padding-right:95px;
}
.bp4-large .bp4-file-upload-input[type=search], .bp4-large .bp4-file-upload-input.bp4-round{
  padding:0 15px;
}
.bp4-large .bp4-file-upload-input::after{
  min-height:30px;
  min-width:30px;
  line-height:30px;
  margin:5px;
  width:85px;
}
.bp4-small .bp4-file-upload-input{
  font-size:12px;
  height:24px;
  line-height:24px;
  padding-left:8px;
  padding-right:8px;
  padding-right:65px;
}
.bp4-small .bp4-file-upload-input[type=search], .bp4-small .bp4-file-upload-input.bp4-round{
  padding:0 12px;
}
.bp4-small .bp4-file-upload-input::after{
  min-height:20px;
  min-width:20px;
  line-height:20px;
  margin:2px;
  width:55px;
}
.bp4-dark .bp4-file-upload-input{
  background:rgba(17, 20, 24, 0.3);
  box-shadow:0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
  color:#f6f7f9;
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-file-upload-input::placeholder{
  color:#abb3bf;
}
.bp4-dark .bp4-file-upload-input:focus{
  box-shadow:inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3);
}
.bp4-dark .bp4-file-upload-input[readonly]{
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-file-upload-input:disabled, .bp4-dark .bp4-file-upload-input.bp4-disabled{
  background:rgba(64, 72, 84, 0.5);
  box-shadow:none;
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-file-upload-input::after{
  background-color:#383e47;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);
  color:#f6f7f9;
}
.bp4-dark .bp4-file-upload-input:hover::after{
  background-color:#2f343c;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-file-upload-input:active::after{
  background-color:#1c2127;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-file-upload-input::after{
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
}
.bp4-form-group{
  display:flex;
  flex-direction:column;
  margin:0 0 15px;
}
.bp4-form-group label.bp4-label{
  margin-bottom:5px;
}
.bp4-form-group .bp4-control{
  margin-top:7px;
}
.bp4-form-group .bp4-form-group-sub-label,
.bp4-form-group .bp4-form-helper-text{
  color:#5f6b7c;
  font-size:12px;
}
.bp4-form-group .bp4-form-group-sub-label{
  margin-bottom:5px;
}
.bp4-form-group .bp4-form-helper-text{
  margin-top:5px;
}
.bp4-form-group.bp4-intent-primary .bp4-form-group-sub-label,
.bp4-form-group.bp4-intent-primary .bp4-form-helper-text{
  color:#215db0;
}
.bp4-form-group.bp4-intent-success .bp4-form-group-sub-label,
.bp4-form-group.bp4-intent-success .bp4-form-helper-text{
  color:#1c6e42;
}
.bp4-form-group.bp4-intent-warning .bp4-form-group-sub-label,
.bp4-form-group.bp4-intent-warning .bp4-form-helper-text{
  color:#935610;
}
.bp4-form-group.bp4-intent-danger .bp4-form-group-sub-label,
.bp4-form-group.bp4-intent-danger .bp4-form-helper-text{
  color:#ac2f33;
}
.bp4-form-group.bp4-inline{
  align-items:flex-start;
  flex-direction:row;
}
.bp4-form-group.bp4-inline.bp4-large label.bp4-label{
  line-height:40px;
  margin:0 10px 0 0;
}
.bp4-form-group.bp4-inline label.bp4-label{
  line-height:30px;
  margin:0 10px 0 0;
}
.bp4-form-group.bp4-disabled .bp4-label,
.bp4-form-group.bp4-disabled .bp4-text-muted,
.bp4-form-group.bp4-disabled .bp4-form-group-sub-label,
.bp4-form-group.bp4-disabled .bp4-form-helper-text{
  color:rgba(95, 107, 124, 0.6) !important;
}
.bp4-dark .bp4-form-group.bp4-intent-primary .bp4-form-group-sub-label,
.bp4-dark .bp4-form-group.bp4-intent-primary .bp4-form-helper-text{
  color:#8abbff;
}
.bp4-dark .bp4-form-group.bp4-intent-success .bp4-form-group-sub-label,
.bp4-dark .bp4-form-group.bp4-intent-success .bp4-form-helper-text{
  color:#72ca9b;
}
.bp4-dark .bp4-form-group.bp4-intent-warning .bp4-form-group-sub-label,
.bp4-dark .bp4-form-group.bp4-intent-warning .bp4-form-helper-text{
  color:#fbb360;
}
.bp4-dark .bp4-form-group.bp4-intent-danger .bp4-form-group-sub-label,
.bp4-dark .bp4-form-group.bp4-intent-danger .bp4-form-helper-text{
  color:#fa999c;
}
.bp4-dark .bp4-form-group .bp4-form-helper-text{
  color:#abb3bf;
}
.bp4-dark .bp4-form-group.bp4-disabled .bp4-label,
.bp4-dark .bp4-form-group.bp4-disabled .bp4-text-muted,
.bp4-dark .bp4-form-group.bp4-disabled .bp4-form-group-sub-label,
.bp4-dark .bp4-form-group.bp4-disabled .bp4-form-helper-text{
  color:rgba(171, 179, 191, 0.6) !important;
}
.bp4-input-group{
  display:block;
  position:relative;
}
.bp4-input-group .bp4-input{
  position:relative;
  width:100%;
}
.bp4-input-group .bp4-input:not(:first-child){
  padding-left:30px;
}
.bp4-input-group .bp4-input:not(:last-child){
  padding-right:30px;
}
.bp4-input-group .bp4-input-action,
.bp4-input-group > .bp4-input-left-container,
.bp4-input-group > .bp4-button,
.bp4-input-group > .bp4-icon{
  position:absolute;
  top:0;
}
.bp4-input-group .bp4-input-action:first-child,
.bp4-input-group > .bp4-input-left-container:first-child,
.bp4-input-group > .bp4-button:first-child,
.bp4-input-group > .bp4-icon:first-child{
  left:0;
}
.bp4-input-group .bp4-input-action:last-child,
.bp4-input-group > .bp4-input-left-container:last-child,
.bp4-input-group > .bp4-button:last-child,
.bp4-input-group > .bp4-icon:last-child{
  right:0;
}
.bp4-input-group .bp4-button{
  min-height:24px;
  min-width:24px;
  margin:3px;
  padding:0 7px;
}
.bp4-input-group .bp4-button:empty{
  padding:0;
}
.bp4-input-group > .bp4-input-left-container,
.bp4-input-group > .bp4-icon{
  z-index:1;
}
.bp4-input-group > .bp4-input-left-container > .bp4-icon,
.bp4-input-group > .bp4-icon{
  color:#5f6b7c;
}
.bp4-input-group > .bp4-input-left-container > .bp4-icon:empty,
.bp4-input-group > .bp4-icon:empty{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
}
.bp4-input-group > .bp4-input-left-container > .bp4-icon,
.bp4-input-group > .bp4-icon,
.bp4-input-group .bp4-input-action > .bp4-spinner{
  margin:7px;
}
.bp4-input-group .bp4-tag{
  margin:5px;
}
.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus),
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus){
  color:#5f6b7c;
}
.bp4-dark .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus),
.bp4-dark .bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus){
  color:#abb3bf;
}
.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-standard, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-large,
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon,
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-standard,
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-large{
  color:#5f6b7c;
}
.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled,
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled{
  color:rgba(95, 107, 124, 0.6) !important;
}
.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled .bp4-icon, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled .bp4-icon-standard, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled .bp4-icon-large,
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled .bp4-icon,
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled .bp4-icon-standard,
.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled .bp4-icon-large{
  color:rgba(95, 107, 124, 0.6) !important;
}
.bp4-input-group.bp4-disabled{
  cursor:not-allowed;
}
.bp4-input-group.bp4-disabled .bp4-icon{
  color:rgba(95, 107, 124, 0.6);
}
.bp4-input-group.bp4-large .bp4-button{
  min-height:30px;
  min-width:30px;
  margin:5px;
}
.bp4-input-group.bp4-large > .bp4-input-left-container > .bp4-icon,
.bp4-input-group.bp4-large > .bp4-icon,
.bp4-input-group.bp4-large .bp4-input-action > .bp4-spinner{
  margin:12px;
}
.bp4-input-group.bp4-large .bp4-input{
  font-size:16px;
  height:40px;
  line-height:40px;
}
.bp4-input-group.bp4-large .bp4-input[type=search], .bp4-input-group.bp4-large .bp4-input.bp4-round{
  padding:0 15px;
}
.bp4-input-group.bp4-large .bp4-input:not(:first-child){
  padding-left:40px;
}
.bp4-input-group.bp4-large .bp4-input:not(:last-child){
  padding-right:40px;
}
.bp4-input-group.bp4-small .bp4-button{
  min-height:20px;
  min-width:20px;
  margin:2px;
}
.bp4-input-group.bp4-small .bp4-tag{
  min-height:20px;
  min-width:20px;
  margin:2px;
}
.bp4-input-group.bp4-small > .bp4-input-left-container > .bp4-icon,
.bp4-input-group.bp4-small > .bp4-icon,
.bp4-input-group.bp4-small .bp4-input-action > .bp4-spinner{
  margin:4px;
}
.bp4-input-group.bp4-small .bp4-input{
  font-size:12px;
  height:24px;
  line-height:24px;
  padding-left:8px;
  padding-right:8px;
}
.bp4-input-group.bp4-small .bp4-input[type=search], .bp4-input-group.bp4-small .bp4-input.bp4-round{
  padding:0 12px;
}
.bp4-input-group.bp4-small .bp4-input:not(:first-child){
  padding-left:24px;
}
.bp4-input-group.bp4-small .bp4-input:not(:last-child){
  padding-right:24px;
}
.bp4-input-group.bp4-fill{
  flex:1 1 auto;
  width:100%;
}
.bp4-input-group.bp4-round .bp4-button,
.bp4-input-group.bp4-round .bp4-input,
.bp4-input-group.bp4-round .bp4-tag{
  border-radius:30px;
}
.bp4-dark .bp4-input-group .bp4-icon{
  color:#abb3bf;
}
.bp4-dark .bp4-input-group.bp4-disabled .bp4-icon{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-input-group.bp4-intent-primary .bp4-input{
  box-shadow:0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px #2d72d2, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input-group.bp4-intent-primary .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input-group.bp4-intent-primary .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #2d72d2;
}
.bp4-input-group.bp4-intent-primary .bp4-input:disabled, .bp4-input-group.bp4-intent-primary .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input{
  box-shadow:0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px #4c90f0, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #4c90f0;
}
.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-input-group.bp4-intent-primary > .bp4-icon{
  color:#215db0;
}
.bp4-dark .bp4-input-group.bp4-intent-primary > .bp4-icon{
  color:#8abbff;
}
.bp4-input-group.bp4-intent-success .bp4-input{
  box-shadow:0 0 0 0 rgba(35, 133, 81, 0), 0 0 0 0 rgba(35, 133, 81, 0), inset 0 0 0 1px #238551, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input-group.bp4-intent-success .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input-group.bp4-intent-success .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #238551;
}
.bp4-input-group.bp4-intent-success .bp4-input:disabled, .bp4-input-group.bp4-intent-success .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input{
  box-shadow:0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), inset 0 0 0 1px #32a467, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #32a467, inset 0 0 0 1px #32a467, 0 0 0 2px rgba(50, 164, 103, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #32a467;
}
.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-success .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-input-group.bp4-intent-success > .bp4-icon{
  color:#1c6e42;
}
.bp4-dark .bp4-input-group.bp4-intent-success > .bp4-icon{
  color:#72ca9b;
}
.bp4-input-group.bp4-intent-warning .bp4-input{
  box-shadow:0 0 0 0 rgba(200, 118, 25, 0), 0 0 0 0 rgba(200, 118, 25, 0), inset 0 0 0 1px #c87619, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input-group.bp4-intent-warning .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input-group.bp4-intent-warning .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #c87619;
}
.bp4-input-group.bp4-intent-warning .bp4-input:disabled, .bp4-input-group.bp4-intent-warning .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input{
  box-shadow:0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px #ec9a3c, 0 0 0 2px rgba(236, 154, 60, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #ec9a3c;
}
.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-input-group.bp4-intent-warning > .bp4-icon{
  color:#935610;
}
.bp4-dark .bp4-input-group.bp4-intent-warning > .bp4-icon{
  color:#fbb360;
}
.bp4-input-group.bp4-intent-danger .bp4-input{
  box-shadow:0 0 0 0 rgba(205, 66, 70, 0), 0 0 0 0 rgba(205, 66, 70, 0), inset 0 0 0 1px #cd4246, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input-group.bp4-intent-danger .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input-group.bp4-intent-danger .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #cd4246;
}
.bp4-input-group.bp4-intent-danger .bp4-input:disabled, .bp4-input-group.bp4-intent-danger .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input{
  box-shadow:0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), inset 0 0 0 1px #e76a6e, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #e76a6e, inset 0 0 0 1px #e76a6e, 0 0 0 2px rgba(231, 106, 110, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px #e76a6e;
}
.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input.bp4-disabled{
  box-shadow:none;
}
.bp4-input-group.bp4-intent-danger > .bp4-icon{
  color:#ac2f33;
}
.bp4-dark .bp4-input-group.bp4-intent-danger > .bp4-icon{
  color:#fa999c;
}
.bp4-input{
  appearance:none;
  background:#ffffff;
  border:none;
  border-radius:2px;
  box-shadow:0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
  color:#1c2127;
  font-size:14px;
  font-weight:400;
  height:30px;
  line-height:30px;
  outline:none;
  padding:0 10px;
  transition:box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);
  vertical-align:middle;
}
.bp4-input::placeholder{
  color:#5f6b7c;
  opacity:1;
}
.bp4-input:focus, .bp4-input.bp4-active{
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input[type=search], .bp4-input.bp4-round{
  border-radius:30px;
  box-sizing:border-box;
  padding-left:10px;
}
.bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.15);
}
.bp4-input:disabled, .bp4-input.bp4-disabled{
  background:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
  resize:none;
}
.bp4-input:disabled::placeholder, .bp4-input.bp4-disabled::placeholder{
  color:rgba(95, 107, 124, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-input{
    border:1px solid buttonborder;
  }
}
.bp4-input.bp4-large{
  font-size:16px;
  height:40px;
  line-height:40px;
}
.bp4-input.bp4-large[type=search], .bp4-input.bp4-large.bp4-round{
  padding:0 15px;
}
.bp4-input.bp4-small{
  font-size:12px;
  height:24px;
  line-height:24px;
  padding-left:8px;
  padding-right:8px;
}
.bp4-input.bp4-small[type=search], .bp4-input.bp4-small.bp4-round{
  padding:0 12px;
}
.bp4-input.bp4-fill{
  flex:1 1 auto;
  width:100%;
}
.bp4-dark .bp4-input{
  background:rgba(17, 20, 24, 0.3);
  box-shadow:0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
  color:#f6f7f9;
}
.bp4-dark .bp4-input::placeholder{
  color:#abb3bf;
}
.bp4-dark .bp4-input:focus{
  box-shadow:inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3);
}
.bp4-dark .bp4-input[readonly]{
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-input:disabled, .bp4-dark .bp4-input.bp4-disabled{
  background:rgba(64, 72, 84, 0.5);
  box-shadow:none;
  color:rgba(171, 179, 191, 0.6);
}
.bp4-input.bp4-intent-primary{
  box-shadow:0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px #2d72d2, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input.bp4-intent-primary:focus{
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input.bp4-intent-primary[readonly]{
  box-shadow:inset 0 0 0 1px #2d72d2;
}
.bp4-input.bp4-intent-primary:disabled, .bp4-input.bp4-intent-primary.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input.bp4-intent-primary{
  box-shadow:0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px #4c90f0, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-primary:focus{
  box-shadow:inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-primary[readonly]{
  box-shadow:inset 0 0 0 1px #4c90f0;
}
.bp4-dark .bp4-input.bp4-intent-primary:disabled, .bp4-dark .bp4-input.bp4-intent-primary.bp4-disabled{
  box-shadow:none;
}
.bp4-input.bp4-intent-success{
  box-shadow:0 0 0 0 rgba(35, 133, 81, 0), 0 0 0 0 rgba(35, 133, 81, 0), inset 0 0 0 1px #238551, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input.bp4-intent-success:focus{
  box-shadow:inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input.bp4-intent-success[readonly]{
  box-shadow:inset 0 0 0 1px #238551;
}
.bp4-input.bp4-intent-success:disabled, .bp4-input.bp4-intent-success.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input.bp4-intent-success{
  box-shadow:0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), inset 0 0 0 1px #32a467, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-success:focus{
  box-shadow:inset 0 0 0 1px #32a467, inset 0 0 0 1px #32a467, 0 0 0 2px rgba(50, 164, 103, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-success[readonly]{
  box-shadow:inset 0 0 0 1px #32a467;
}
.bp4-dark .bp4-input.bp4-intent-success:disabled, .bp4-dark .bp4-input.bp4-intent-success.bp4-disabled{
  box-shadow:none;
}
.bp4-input.bp4-intent-warning{
  box-shadow:0 0 0 0 rgba(200, 118, 25, 0), 0 0 0 0 rgba(200, 118, 25, 0), inset 0 0 0 1px #c87619, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input.bp4-intent-warning:focus{
  box-shadow:inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input.bp4-intent-warning[readonly]{
  box-shadow:inset 0 0 0 1px #c87619;
}
.bp4-input.bp4-intent-warning:disabled, .bp4-input.bp4-intent-warning.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input.bp4-intent-warning{
  box-shadow:0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-warning:focus{
  box-shadow:inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px #ec9a3c, 0 0 0 2px rgba(236, 154, 60, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-warning[readonly]{
  box-shadow:inset 0 0 0 1px #ec9a3c;
}
.bp4-dark .bp4-input.bp4-intent-warning:disabled, .bp4-dark .bp4-input.bp4-intent-warning.bp4-disabled{
  box-shadow:none;
}
.bp4-input.bp4-intent-danger{
  box-shadow:0 0 0 0 rgba(205, 66, 70, 0), 0 0 0 0 rgba(205, 66, 70, 0), inset 0 0 0 1px #cd4246, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);
}
.bp4-input.bp4-intent-danger:focus{
  box-shadow:inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-input.bp4-intent-danger[readonly]{
  box-shadow:inset 0 0 0 1px #cd4246;
}
.bp4-input.bp4-intent-danger:disabled, .bp4-input.bp4-intent-danger.bp4-disabled{
  box-shadow:none;
}
.bp4-dark .bp4-input.bp4-intent-danger{
  box-shadow:0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), inset 0 0 0 1px #e76a6e, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-danger:focus{
  box-shadow:inset 0 0 0 1px #e76a6e, inset 0 0 0 1px #e76a6e, 0 0 0 2px rgba(231, 106, 110, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-input.bp4-intent-danger[readonly]{
  box-shadow:inset 0 0 0 1px #e76a6e;
}
.bp4-dark .bp4-input.bp4-intent-danger:disabled, .bp4-dark .bp4-input.bp4-intent-danger.bp4-disabled{
  box-shadow:none;
}
.bp4-input::-ms-clear{
  display:none;
}

@supports (-webkit-touch-callout: none){
  input.bp4-input:disabled, input.bp4-input.bp4-disabled{
    opacity:1;
    -webkit-text-fill-color:rgba(95, 107, 124, 0.6);
  }
  .bp4-dark input.bp4-input:disabled, .bp4-dark input.bp4-input.bp4-disabled{
    -webkit-text-fill-color:rgba(171, 179, 191, 0.6);
  }
}
textarea.bp4-input{
  max-width:100%;
  padding:10px;
}
textarea.bp4-input, textarea.bp4-input.bp4-large, textarea.bp4-input.bp4-small{
  height:auto;
  line-height:inherit;
}
textarea.bp4-input.bp4-small{
  padding:8px;
}
label.bp4-label{
  display:block;
  margin-bottom:15px;
  margin-top:0;
}
label.bp4-label .bp4-html-select,
label.bp4-label .bp4-input,
label.bp4-label .bp4-select,
label.bp4-label .bp4-slider,
label.bp4-label .bp4-popover-wrapper{
  display:block;
  margin-top:5px;
  text-transform:none;
}
label.bp4-label .bp4-button-group{
  margin-top:5px;
}
label.bp4-label .bp4-select select,
label.bp4-label .bp4-html-select select{
  font-weight:400;
  vertical-align:top;
  width:100%;
}
label.bp4-label .bp4-control-group{
  margin-top:5px;
}
label.bp4-label .bp4-control-group > .bp4-button-group,
label.bp4-label .bp4-control-group > .bp4-html-select,
label.bp4-label .bp4-control-group > .bp4-input,
label.bp4-label .bp4-control-group > .bp4-select,
label.bp4-label .bp4-control-group > .bp4-slider,
label.bp4-label .bp4-control-group > .bp4-popover-wrapper{
  margin-top:0;
}
label.bp4-label.bp4-disabled,
label.bp4-label.bp4-disabled .bp4-text-muted{
  color:rgba(95, 107, 124, 0.6);
}
label.bp4-label.bp4-inline{
  line-height:30px;
}
label.bp4-label.bp4-inline .bp4-html-select,
label.bp4-label.bp4-inline .bp4-input,
label.bp4-label.bp4-inline .bp4-input-group,
label.bp4-label.bp4-inline .bp4-select,
label.bp4-label.bp4-inline .bp4-popover-wrapper{
  display:inline-block;
  margin:0 0 0 5px;
  vertical-align:top;
}
label.bp4-label.bp4-inline .bp4-button-group{
  margin:0 0 0 5px;
}
label.bp4-label.bp4-inline .bp4-input-group .bp4-input{
  margin-left:0;
}
label.bp4-label.bp4-inline.bp4-large{
  line-height:40px;
}
label.bp4-label.bp4-inline .bp4-control-group{
  margin:0 0 0 5px;
}
label.bp4-label.bp4-inline .bp4-control-group > .bp4-button-group,
label.bp4-label.bp4-inline .bp4-control-group > .bp4-html-select,
label.bp4-label.bp4-inline .bp4-control-group > .bp4-input,
label.bp4-label.bp4-inline .bp4-control-group > .bp4-select,
label.bp4-label.bp4-inline .bp4-control-group > .bp4-slider,
label.bp4-label.bp4-inline .bp4-control-group > .bp4-popover-wrapper{
  margin:0;
}
label.bp4-label:not(.bp4-inline) .bp4-popover-target{
  display:block;
}
.bp4-dark label.bp4-label{
  color:#f6f7f9;
}
.bp4-dark label.bp4-label.bp4-disabled,
.bp4-dark label.bp4-label.bp4-disabled .bp4-text-muted{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-numeric-input .bp4-button-group.bp4-vertical > .bp4-button{
  flex:1 1 11px;
  min-height:0;
  padding:0;
  width:24px;
}
.bp4-numeric-input.bp4-large .bp4-button-group.bp4-vertical > .bp4-button{
  width:40px;
}
.bp4-numeric-input.bp4-small .bp4-button-group.bp4-vertical > .bp4-button{
  width:24px;
}

form{
  display:block;
}
.bp4-html-select select,
.bp4-select select{
  display:inline-flex;
  flex-direction:row;
  align-items:center;
  border:none;
  border-radius:2px;
  cursor:pointer;
  font-size:14px;
  justify-content:center;
  padding:5px 10px;
  text-align:left;
  vertical-align:middle;
  background-color:#f6f7f9;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#1c2127;
  -moz-appearance:none;
  -webkit-appearance:none;
  border-radius:2px;
  height:30px;
  padding:0 25px 0 10px;
  width:100%;
}
.bp4-html-select select > *,
.bp4-select select > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-html-select select > .bp4-fill,
.bp4-select select > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-html-select select::before,
.bp4-select select::before,
.bp4-html-select select > *,
.bp4-select select > *{
  margin-right:7px;
}
.bp4-html-select select:empty::before,
.bp4-select select:empty::before,
.bp4-html-select select > :last-child,
.bp4-select select > :last-child{
  margin-right:0;
}
.bp4-html-select select:hover,
.bp4-select select:hover{
  background-clip:padding-box;
  background-color:#edeff2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-html-select select:active,
.bp4-select select:active, .bp4-html-select select.bp4-active,
.bp4-select select.bp4-active{
  background-color:#dce0e5;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-html-select select:active,
  .bp4-select select:active, .bp4-html-select select.bp4-active,
  .bp4-select select.bp4-active{
    background:highlight;
  }
}
.bp4-html-select select:disabled,
.bp4-select select:disabled, .bp4-html-select select.bp4-disabled,
.bp4-select select.bp4-disabled{
  background-color:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
  outline:none;
}
.bp4-html-select select:disabled.bp4-active,
.bp4-select select:disabled.bp4-active, .bp4-html-select select.bp4-disabled.bp4-active,
.bp4-select select.bp4-disabled.bp4-active{
  background:rgba(211, 216, 222, 0.7);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-html-select select,
  .bp4-select select{
    border:1px solid buttonborder;
  }
}

.bp4-html-select.bp4-minimal select,
.bp4-select.bp4-minimal select{
  background:none;
  box-shadow:none;
}
.bp4-html-select.bp4-minimal select:hover,
.bp4-select.bp4-minimal select:hover{
  background:rgba(143, 153, 168, 0.15);
  box-shadow:none;
  color:#1c2127;
  text-decoration:none;
}
.bp4-html-select.bp4-minimal select:active,
.bp4-select.bp4-minimal select:active, .bp4-html-select.bp4-minimal select.bp4-active,
.bp4-select.bp4-minimal select.bp4-active{
  background:rgba(143, 153, 168, 0.3);
  box-shadow:none;
  color:#1c2127;
}
.bp4-html-select.bp4-minimal select:disabled,
.bp4-select.bp4-minimal select:disabled, .bp4-html-select.bp4-minimal select.bp4-disabled,
.bp4-select.bp4-minimal select.bp4-disabled{
  background:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
.bp4-html-select.bp4-minimal select:disabled.bp4-active,
.bp4-select.bp4-minimal select:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-disabled.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-html-select.bp4-minimal select, .bp4-html-select.bp4-minimal .bp4-dark select,
.bp4-dark .bp4-select.bp4-minimal select,
.bp4-select.bp4-minimal .bp4-dark select{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-html-select.bp4-minimal select:hover, .bp4-html-select.bp4-minimal .bp4-dark select:hover,
.bp4-dark .bp4-select.bp4-minimal select:hover,
.bp4-select.bp4-minimal .bp4-dark select:hover, .bp4-dark .bp4-html-select.bp4-minimal select:active, .bp4-html-select.bp4-minimal .bp4-dark select:active,
.bp4-dark .bp4-select.bp4-minimal select:active,
.bp4-select.bp4-minimal .bp4-dark select:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-active{
  background:none;
  box-shadow:none;
  color:#ffffff;
}
.bp4-dark .bp4-html-select.bp4-minimal select:hover, .bp4-html-select.bp4-minimal .bp4-dark select:hover,
.bp4-dark .bp4-select.bp4-minimal select:hover,
.bp4-select.bp4-minimal .bp4-dark select:hover{
  background:rgba(143, 153, 168, 0.15);
}
.bp4-dark .bp4-html-select.bp4-minimal select:active, .bp4-html-select.bp4-minimal .bp4-dark select:active,
.bp4-dark .bp4-select.bp4-minimal select:active,
.bp4-select.bp4-minimal .bp4-dark select:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-dark .bp4-html-select.bp4-minimal select:disabled, .bp4-html-select.bp4-minimal .bp4-dark select:disabled,
.bp4-dark .bp4-select.bp4-minimal select:disabled,
.bp4-select.bp4-minimal .bp4-dark select:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-disabled{
  background:none;
  color:rgba(171, 179, 191, 0.6);
  cursor:not-allowed;
}
.bp4-dark .bp4-html-select.bp4-minimal select:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select:disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select:disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-disabled.bp4-active{
  background:rgba(143, 153, 168, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-primary,
.bp4-select.bp4-minimal select.bp4-intent-primary{
  color:#215db0;
}
.bp4-html-select.bp4-minimal select.bp4-intent-primary:hover,
.bp4-select.bp4-minimal select.bp4-intent-primary:hover, .bp4-html-select.bp4-minimal select.bp4-intent-primary:active,
.bp4-select.bp4-minimal select.bp4-intent-primary:active, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-active{
  background:none;
  box-shadow:none;
  color:#215db0;
}
.bp4-html-select.bp4-minimal select.bp4-intent-primary:hover,
.bp4-select.bp4-minimal select.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.15);
  color:#215db0;
}
.bp4-html-select.bp4-minimal select.bp4-intent-primary:active,
.bp4-select.bp4-minimal select.bp4-intent-primary:active, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#184a90;
}
.bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled,
.bp4-select.bp4-minimal select.bp4-intent-primary:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled,
.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(33, 93, 176, 0.5);
}
.bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head,
.bp4-select.bp4-minimal select.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head{
  stroke:#215db0;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary{
  color:#8abbff;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:hover,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:hover,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:hover{
  background:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-active{
  background:rgba(45, 114, 210, 0.3);
  color:#99c4ff;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled{
  background:none;
  color:rgba(138, 187, 255, 0.5);
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled.bp4-active{
  background:rgba(45, 114, 210, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-success,
.bp4-select.bp4-minimal select.bp4-intent-success{
  color:#1c6e42;
}
.bp4-html-select.bp4-minimal select.bp4-intent-success:hover,
.bp4-select.bp4-minimal select.bp4-intent-success:hover, .bp4-html-select.bp4-minimal select.bp4-intent-success:active,
.bp4-select.bp4-minimal select.bp4-intent-success:active, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-success.bp4-active{
  background:none;
  box-shadow:none;
  color:#1c6e42;
}
.bp4-html-select.bp4-minimal select.bp4-intent-success:hover,
.bp4-select.bp4-minimal select.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.15);
  color:#1c6e42;
}
.bp4-html-select.bp4-minimal select.bp4-intent-success:active,
.bp4-select.bp4-minimal select.bp4-intent-success:active, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#165a36;
}
.bp4-html-select.bp4-minimal select.bp4-intent-success:disabled,
.bp4-select.bp4-minimal select.bp4-intent-success:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled,
.bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(28, 110, 66, 0.5);
}
.bp4-html-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-success .bp4-button-spinner .bp4-spinner-head,
.bp4-select.bp4-minimal select.bp4-intent-success .bp4-button-spinner .bp4-spinner-head{
  stroke:#1c6e42;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success{
  color:#72ca9b;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:hover,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:hover,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:hover{
  background:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-active{
  background:rgba(35, 133, 81, 0.3);
  color:#7cd7a2;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled{
  background:none;
  color:rgba(114, 202, 155, 0.5);
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled.bp4-active{
  background:rgba(35, 133, 81, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-warning,
.bp4-select.bp4-minimal select.bp4-intent-warning{
  color:#935610;
}
.bp4-html-select.bp4-minimal select.bp4-intent-warning:hover,
.bp4-select.bp4-minimal select.bp4-intent-warning:hover, .bp4-html-select.bp4-minimal select.bp4-intent-warning:active,
.bp4-select.bp4-minimal select.bp4-intent-warning:active, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-active{
  background:none;
  box-shadow:none;
  color:#935610;
}
.bp4-html-select.bp4-minimal select.bp4-intent-warning:hover,
.bp4-select.bp4-minimal select.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.15);
  color:#935610;
}
.bp4-html-select.bp4-minimal select.bp4-intent-warning:active,
.bp4-select.bp4-minimal select.bp4-intent-warning:active, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#77450d;
}
.bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled,
.bp4-select.bp4-minimal select.bp4-intent-warning:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled,
.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(147, 86, 16, 0.5);
}
.bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head,
.bp4-select.bp4-minimal select.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head{
  stroke:#935610;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning{
  color:#fbb360;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:hover,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:hover,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:hover{
  background:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-active{
  background:rgba(200, 118, 25, 0.3);
  color:#f5c186;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled{
  background:none;
  color:rgba(251, 179, 96, 0.5);
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled.bp4-active{
  background:rgba(200, 118, 25, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-danger,
.bp4-select.bp4-minimal select.bp4-intent-danger{
  color:#ac2f33;
}
.bp4-html-select.bp4-minimal select.bp4-intent-danger:hover,
.bp4-select.bp4-minimal select.bp4-intent-danger:hover, .bp4-html-select.bp4-minimal select.bp4-intent-danger:active,
.bp4-select.bp4-minimal select.bp4-intent-danger:active, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-active{
  background:none;
  box-shadow:none;
  color:#ac2f33;
}
.bp4-html-select.bp4-minimal select.bp4-intent-danger:hover,
.bp4-select.bp4-minimal select.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.15);
  color:#ac2f33;
}
.bp4-html-select.bp4-minimal select.bp4-intent-danger:active,
.bp4-select.bp4-minimal select.bp4-intent-danger:active, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#8e292c;
}
.bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled,
.bp4-select.bp4-minimal select.bp4-intent-danger:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled,
.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(172, 47, 51, 0.5);
}
.bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}
.bp4-html-select.bp4-minimal select.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head,
.bp4-select.bp4-minimal select.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head{
  stroke:#ac2f33;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger{
  color:#fa999c;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:hover,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:hover,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:hover{
  background:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-active{
  background:rgba(205, 66, 70, 0.3);
  color:#ffa1a4;
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled{
  background:none;
  color:rgba(250, 153, 156, 0.5);
}
.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled.bp4-active,
.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active,
.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled.bp4-active{
  background:rgba(205, 66, 70, 0.3);
}

.bp4-html-select.bp4-large select,
.bp4-select.bp4-large select{
  font-size:16px;
  height:40px;
  padding-right:35px;
}

.bp4-dark .bp4-html-select select,
.bp4-dark .bp4-select select{
  background-color:#383e47;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);
  color:#f6f7f9;
}
.bp4-dark .bp4-html-select select:hover,
.bp4-dark .bp4-select select:hover, .bp4-dark .bp4-html-select select:active,
.bp4-dark .bp4-select select:active, .bp4-dark .bp4-html-select select.bp4-active,
.bp4-dark .bp4-select select.bp4-active{
  color:#f6f7f9;
}
.bp4-dark .bp4-html-select select:hover,
.bp4-dark .bp4-select select:hover{
  background-color:#2f343c;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-html-select select:active,
.bp4-dark .bp4-select select:active, .bp4-dark .bp4-html-select select.bp4-active,
.bp4-dark .bp4-select select.bp4-active{
  background-color:#1c2127;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-html-select select:disabled,
.bp4-dark .bp4-select select:disabled, .bp4-dark .bp4-html-select select.bp4-disabled,
.bp4-dark .bp4-select select.bp4-disabled{
  background-color:rgba(64, 72, 84, 0.5);
  box-shadow:none;
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-html-select select:disabled.bp4-active,
.bp4-dark .bp4-select select:disabled.bp4-active, .bp4-dark .bp4-html-select select.bp4-disabled.bp4-active,
.bp4-dark .bp4-select select.bp4-disabled.bp4-active{
  background:rgba(64, 72, 84, 0.7);
}
.bp4-dark .bp4-html-select select .bp4-button-spinner .bp4-spinner-head,
.bp4-dark .bp4-select select .bp4-button-spinner .bp4-spinner-head{
  background:rgba(17, 20, 24, 0.5);
  stroke:#8f99a8;
}

.bp4-html-select select:disabled,
.bp4-select select:disabled{
  background-color:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}

.bp4-select::after, .bp4-html-select .bp4-icon,
.bp4-select .bp4-icon{
  color:#5f6b7c;
  pointer-events:none;
  position:absolute;
  right:7px;
  top:7px;
}
.bp4-disabled.bp4-select::after, .bp4-html-select .bp4-disabled.bp4-icon,
.bp4-select .bp4-disabled.bp4-icon{
  color:rgba(95, 107, 124, 0.6);
}
.bp4-html-select,
.bp4-select{
  display:inline-block;
  letter-spacing:normal;
  position:relative;
  vertical-align:middle;
}
.bp4-html-select select::-ms-expand,
.bp4-select select::-ms-expand{
  display:none;
}
.bp4-html-select .bp4-icon,
.bp4-select .bp4-icon{
  color:#5f6b7c;
}
.bp4-html-select .bp4-icon:hover,
.bp4-select .bp4-icon:hover{
  color:#1c2127;
}
.bp4-dark .bp4-html-select .bp4-icon,
.bp4-dark .bp4-select .bp4-icon{
  color:#abb3bf;
}
.bp4-dark .bp4-html-select .bp4-icon:hover,
.bp4-dark .bp4-select .bp4-icon:hover{
  color:#f6f7f9;
}
.bp4-html-select.bp4-large::after,
.bp4-html-select.bp4-large .bp4-icon,
.bp4-select.bp4-large::after,
.bp4-select.bp4-large .bp4-icon{
  right:12px;
  top:12px;
}
.bp4-html-select.bp4-fill,
.bp4-html-select.bp4-fill select,
.bp4-select.bp4-fill,
.bp4-select.bp4-fill select{
  width:100%;
}
.bp4-dark .bp4-html-select option,
.bp4-dark .bp4-select option{
  background-color:#2f343c;
  color:#f6f7f9;
}
.bp4-dark .bp4-html-select option:disabled,
.bp4-dark .bp4-select option:disabled{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-dark .bp4-html-select::after,
.bp4-dark .bp4-select::after{
  color:#abb3bf;
}

.bp4-select::after{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  content:"\\f184";
}
table.bp4-html-table, .bp4-running-text table{
  border-spacing:0;
  font-size:14px;
}
table.bp4-html-table th, .bp4-running-text table th,
table.bp4-html-table td,
.bp4-running-text table td{
  padding:11px;
  text-align:left;
  vertical-align:top;
}
table.bp4-html-table th, .bp4-running-text table th{
  color:#1c2127;
  font-weight:600;
}
table.bp4-html-table td, .bp4-running-text table td{
  color:#1c2127;
}
table.bp4-html-table tbody tr:first-child th, .bp4-running-text table tbody tr:first-child th,
table.bp4-html-table tbody tr:first-child td,
.bp4-running-text table tbody tr:first-child td,
table.bp4-html-table tfoot tr:first-child th,
.bp4-running-text table tfoot tr:first-child th,
table.bp4-html-table tfoot tr:first-child td,
.bp4-running-text table tfoot tr:first-child td{
  box-shadow:inset 0 1px 0 0 rgba(17, 20, 24, 0.15);
}
.bp4-dark table.bp4-html-table th, .bp4-dark .bp4-running-text table th, .bp4-running-text .bp4-dark table th{
  color:#f6f7f9;
}
.bp4-dark table.bp4-html-table td, .bp4-dark .bp4-running-text table td, .bp4-running-text .bp4-dark table td{
  color:#f6f7f9;
}
.bp4-dark table.bp4-html-table tbody tr:first-child th, .bp4-dark .bp4-running-text table tbody tr:first-child th, .bp4-running-text .bp4-dark table tbody tr:first-child th,
.bp4-dark table.bp4-html-table tbody tr:first-child td,
.bp4-dark .bp4-running-text table tbody tr:first-child td,
.bp4-running-text .bp4-dark table tbody tr:first-child td,
.bp4-dark table.bp4-html-table tfoot tr:first-child th,
.bp4-dark .bp4-running-text table tfoot tr:first-child th,
.bp4-running-text .bp4-dark table tfoot tr:first-child th,
.bp4-dark table.bp4-html-table tfoot tr:first-child td,
.bp4-dark .bp4-running-text table tfoot tr:first-child td,
.bp4-running-text .bp4-dark table tfoot tr:first-child td{
  box-shadow:inset 0 1px 0 0 rgba(255, 255, 255, 0.2);
}

table.bp4-html-table.bp4-compact th,
table.bp4-html-table.bp4-compact td, table.bp4-html-table.bp4-html-table-condensed th,
table.bp4-html-table.bp4-html-table-condensed td{
  padding-bottom:6px;
  padding-top:6px;
}
table.bp4-html-table.bp4-html-table-striped tbody tr:nth-child(odd) td{
  background:rgba(143, 153, 168, 0.15);
}
table.bp4-html-table.bp4-html-table-bordered th:not(:first-child){
  box-shadow:inset 1px 0 0 0 rgba(17, 20, 24, 0.15);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  table.bp4-html-table.bp4-html-table-bordered th:not(:first-child){
    border-left:1px solid buttonborder;
  }
}
table.bp4-html-table.bp4-html-table-bordered tbody tr td,
table.bp4-html-table.bp4-html-table-bordered tfoot tr td{
  box-shadow:inset 0 1px 0 0 rgba(17, 20, 24, 0.15);
}
table.bp4-html-table.bp4-html-table-bordered tbody tr td:not(:first-child),
table.bp4-html-table.bp4-html-table-bordered tfoot tr td:not(:first-child){
  box-shadow:inset 1px 1px 0 0 rgba(17, 20, 24, 0.15);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  table.bp4-html-table.bp4-html-table-bordered tbody tr td:not(:first-child),
  table.bp4-html-table.bp4-html-table-bordered tfoot tr td:not(:first-child){
    border-left:1px solid buttonborder;
    border-top:1px solid buttonborder;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  table.bp4-html-table.bp4-html-table-bordered tbody tr td,
  table.bp4-html-table.bp4-html-table-bordered tfoot tr td{
    border-top:1px solid buttonborder;
  }
}
table.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td{
  box-shadow:none;
}
table.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td:not(:first-child){
  box-shadow:inset 1px 0 0 0 rgba(17, 20, 24, 0.15);
}
table.bp4-html-table.bp4-interactive tbody tr:hover td{
  background-color:rgba(143, 153, 168, 0.3);
  cursor:pointer;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  table.bp4-html-table.bp4-interactive tbody tr:hover td{
    background-color:highlight;
  }
}
table.bp4-html-table.bp4-interactive tbody tr:active td{
  background-color:rgba(143, 153, 168, 0.35);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  table.bp4-html-table.bp4-interactive tbody tr:active td{
    background-color:highlight;
  }
}
.bp4-dark table.bp4-html-table{
}
.bp4-dark table.bp4-html-table.bp4-html-table-striped tbody tr:nth-child(odd) td{
  background:rgba(95, 107, 124, 0.15);
}
.bp4-dark table.bp4-html-table.bp4-html-table-bordered th:not(:first-child){
  box-shadow:inset 1px 0 0 0 rgba(255, 255, 255, 0.2);
}
.bp4-dark table.bp4-html-table.bp4-html-table-bordered tbody tr td,
.bp4-dark table.bp4-html-table.bp4-html-table-bordered tfoot tr td{
  box-shadow:inset 0 1px 0 0 rgba(255, 255, 255, 0.2);
}
.bp4-dark table.bp4-html-table.bp4-html-table-bordered tbody tr td:not(:first-child),
.bp4-dark table.bp4-html-table.bp4-html-table-bordered tfoot tr td:not(:first-child){
  box-shadow:inset 1px 1px 0 0 rgba(255, 255, 255, 0.2);
}
.bp4-dark table.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td{
  box-shadow:inset 1px 0 0 0 rgba(255, 255, 255, 0.2);
}
.bp4-dark table.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td:first-child{
  box-shadow:none;
}
.bp4-dark table.bp4-html-table.bp4-interactive tbody tr:hover td{
  background-color:rgba(95, 107, 124, 0.3);
  cursor:pointer;
}
.bp4-dark table.bp4-html-table.bp4-interactive tbody tr:active td{
  background-color:rgba(95, 107, 124, 0.4);
}
.bp4-key-combo{
  display:flex;
  flex-direction:row;
  align-items:center;
}
.bp4-key-combo > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-key-combo > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-key-combo::before,
.bp4-key-combo > *{
  margin-right:5px;
}
.bp4-key-combo:empty::before,
.bp4-key-combo > :last-child{
  margin-right:0;
}

.bp4-hotkey-dialog{
  padding-bottom:0;
  top:40px;
}
.bp4-hotkey-dialog .bp4-dialog-body{
  margin:0;
  padding:0;
}
.bp4-hotkey-dialog .bp4-hotkey-label{
  flex-grow:1;
}

.bp4-hotkey-column{
  margin:auto;
  max-height:80vh;
  overflow-y:auto;
  padding:30px;
}
.bp4-hotkey-column .bp4-heading{
  margin-bottom:20px;
}
.bp4-hotkey-column .bp4-heading:not(:first-child){
  margin-top:40px;
}

.bp4-hotkey{
  align-items:center;
  display:flex;
  justify-content:space-between;
  margin-left:0;
  margin-right:0;
}
.bp4-hotkey:not(:last-child){
  margin-bottom:10px;
}
.bp4-icon{
  display:inline-block;
  flex:0 0 auto;
  vertical-align:text-bottom;
}
.bp4-icon:not(:empty)::before{
  content:"" !important;
  content:unset !important;
}
.bp4-icon > svg{
  display:block;
}
.bp4-icon > svg:not([fill]){
  fill:currentcolor;
}

span.bp4-icon-standard{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  display:inline-block;
}

span.bp4-icon-large{
  font-family:"blueprint-icons-20", sans-serif;
  font-size:20px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  display:inline-block;
}

span.bp4-icon:empty{
  font-family:"blueprint-icons-20";
  font-size:inherit;
  font-style:normal;
  font-weight:400;
  line-height:1;
}
span.bp4-icon:empty::before{
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
}

.bp4-icon-add::before{
  content:"\\f109";
}

.bp4-icon-add-clip::before{
  content:"\\f101";
}

.bp4-icon-add-column-left::before{
  content:"\\f102";
}

.bp4-icon-add-column-right::before{
  content:"\\f103";
}

.bp4-icon-add-location::before{
  content:"\\f104";
}

.bp4-icon-add-row-bottom::before{
  content:"\\f105";
}

.bp4-icon-add-row-top::before{
  content:"\\f106";
}

.bp4-icon-add-to-artifact::before{
  content:"\\f107";
}

.bp4-icon-add-to-folder::before{
  content:"\\f108";
}

.bp4-icon-aimpoints-target::before{
  content:"\\f335";
}

.bp4-icon-airplane::before{
  content:"\\f10a";
}

.bp4-icon-align-center::before{
  content:"\\f10b";
}

.bp4-icon-align-justify::before{
  content:"\\f10c";
}

.bp4-icon-align-left::before{
  content:"\\f10d";
}

.bp4-icon-align-right::before{
  content:"\\f10e";
}

.bp4-icon-alignment-bottom::before{
  content:"\\f10f";
}

.bp4-icon-alignment-horizontal-center::before{
  content:"\\f110";
}

.bp4-icon-alignment-left::before{
  content:"\\f111";
}

.bp4-icon-alignment-right::before{
  content:"\\f112";
}

.bp4-icon-alignment-top::before{
  content:"\\f113";
}

.bp4-icon-alignment-vertical-center::before{
  content:"\\f114";
}

.bp4-icon-ammunition::before{
  content:"\\f342";
}

.bp4-icon-anchor::before{
  content:"\\f330";
}

.bp4-icon-annotation::before{
  content:"\\f115";
}

.bp4-icon-antenna::before{
  content:"\\f116";
}

.bp4-icon-app-header::before{
  content:"\\f117";
}

.bp4-icon-application::before{
  content:"\\f118";
}

.bp4-icon-applications::before{
  content:"\\f119";
}

.bp4-icon-archive::before{
  content:"\\f11a";
}

.bp4-icon-area-of-interest::before{
  content:"\\f11b";
}

.bp4-icon-array::before{
  content:"\\f121";
}

.bp4-icon-array-boolean::before{
  content:"\\f11c";
}

.bp4-icon-array-date::before{
  content:"\\f11d";
}

.bp4-icon-array-floating-point::before{
  content:"\\f32d";
}

.bp4-icon-array-numeric::before{
  content:"\\f11e";
}

.bp4-icon-array-string::before{
  content:"\\f11f";
}

.bp4-icon-array-timestamp::before{
  content:"\\f120";
}

.bp4-icon-arrow-bottom-left::before{
  content:"\\f122";
}

.bp4-icon-arrow-bottom-right::before{
  content:"\\f123";
}

.bp4-icon-arrow-down::before{
  content:"\\f124";
}

.bp4-icon-arrow-left::before{
  content:"\\f125";
}

.bp4-icon-arrow-right::before{
  content:"\\f126";
}

.bp4-icon-arrow-top-left::before{
  content:"\\f127";
}

.bp4-icon-arrow-top-right::before{
  content:"\\f128";
}

.bp4-icon-arrow-up::before{
  content:"\\f129";
}

.bp4-icon-arrows-horizontal::before{
  content:"\\f12a";
}

.bp4-icon-arrows-vertical::before{
  content:"\\f12b";
}

.bp4-icon-asterisk::before{
  content:"\\f12c";
}

.bp4-icon-at::before{
  content:"\\f331";
}

.bp4-icon-automatic-updates::before{
  content:"\\f12d";
}

.bp4-icon-axle::before{
  content:"\\f338";
}

.bp4-icon-backlink::before{
  content:"\\f12e";
}

.bp4-icon-badge::before{
  content:"\\f12f";
}

.bp4-icon-ban-circle::before{
  content:"\\f130";
}

.bp4-icon-bank-account::before{
  content:"\\f131";
}

.bp4-icon-barcode::before{
  content:"\\f132";
}

.bp4-icon-blank::before{
  content:"\\f133";
}

.bp4-icon-blocked-person::before{
  content:"\\f134";
}

.bp4-icon-bold::before{
  content:"\\f135";
}

.bp4-icon-book::before{
  content:"\\f136";
}

.bp4-icon-bookmark::before{
  content:"\\f137";
}

.bp4-icon-box::before{
  content:"\\f138";
}

.bp4-icon-briefcase::before{
  content:"\\f139";
}

.bp4-icon-bring-data::before{
  content:"\\f13a";
}

.bp4-icon-bug::before{
  content:"\\f32e";
}

.bp4-icon-buggy::before{
  content:"\\f13b";
}

.bp4-icon-build::before{
  content:"\\f13c";
}

.bp4-icon-calculator::before{
  content:"\\f13d";
}

.bp4-icon-calendar::before{
  content:"\\f13e";
}

.bp4-icon-camera::before{
  content:"\\f13f";
}

.bp4-icon-caret-down::before{
  content:"\\f140";
}

.bp4-icon-caret-left::before{
  content:"\\f141";
}

.bp4-icon-caret-right::before{
  content:"\\f142";
}

.bp4-icon-caret-up::before{
  content:"\\f143";
}

.bp4-icon-cargo-ship::before{
  content:"\\f144";
}

.bp4-icon-cell-tower::before{
  content:"\\f145";
}

.bp4-icon-changes::before{
  content:"\\f146";
}

.bp4-icon-chart::before{
  content:"\\f147";
}

.bp4-icon-chat::before{
  content:"\\f148";
}

.bp4-icon-chevron-backward::before{
  content:"\\f149";
}

.bp4-icon-chevron-down::before{
  content:"\\f14a";
}

.bp4-icon-chevron-forward::before{
  content:"\\f14b";
}

.bp4-icon-chevron-left::before{
  content:"\\f14c";
}

.bp4-icon-chevron-right::before{
  content:"\\f14d";
}

.bp4-icon-chevron-up::before{
  content:"\\f14e";
}

.bp4-icon-circle::before{
  content:"\\f153";
}

.bp4-icon-circle-arrow-down::before{
  content:"\\f14f";
}

.bp4-icon-circle-arrow-left::before{
  content:"\\f150";
}

.bp4-icon-circle-arrow-right::before{
  content:"\\f151";
}

.bp4-icon-circle-arrow-up::before{
  content:"\\f152";
}

.bp4-icon-citation::before{
  content:"\\f154";
}

.bp4-icon-clean::before{
  content:"\\f155";
}

.bp4-icon-clip::before{
  content:"\\f156";
}

.bp4-icon-clipboard::before{
  content:"\\f157";
}

.bp4-icon-cloud::before{
  content:"\\f15a";
}

.bp4-icon-cloud-download::before{
  content:"\\f158";
}

.bp4-icon-cloud-upload::before{
  content:"\\f159";
}

.bp4-icon-code::before{
  content:"\\f15c";
}

.bp4-icon-code-block::before{
  content:"\\f15b";
}

.bp4-icon-cog::before{
  content:"\\f15d";
}

.bp4-icon-collapse-all::before{
  content:"\\f15e";
}

.bp4-icon-color-fill::before{
  content:"\\f328";
}

.bp4-icon-column-layout::before{
  content:"\\f15f";
}

.bp4-icon-comment::before{
  content:"\\f160";
}

.bp4-icon-comparison::before{
  content:"\\f161";
}

.bp4-icon-compass::before{
  content:"\\f162";
}

.bp4-icon-compressed::before{
  content:"\\f163";
}

.bp4-icon-confirm::before{
  content:"\\f164";
}

.bp4-icon-console::before{
  content:"\\f165";
}

.bp4-icon-contrast::before{
  content:"\\f166";
}

.bp4-icon-control::before{
  content:"\\f167";
}

.bp4-icon-credit-card::before{
  content:"\\f168";
}

.bp4-icon-cross::before{
  content:"\\f169";
}

.bp4-icon-cross-circle::before{
  content:"\\f336";
}

.bp4-icon-crown::before{
  content:"\\f16a";
}

.bp4-icon-cube::before{
  content:"\\f16d";
}

.bp4-icon-cube-add::before{
  content:"\\f16b";
}

.bp4-icon-cube-remove::before{
  content:"\\f16c";
}

.bp4-icon-curved-range-chart::before{
  content:"\\f16e";
}

.bp4-icon-cut::before{
  content:"\\f16f";
}

.bp4-icon-cycle::before{
  content:"\\f170";
}

.bp4-icon-dashboard::before{
  content:"\\f171";
}

.bp4-icon-data-connection::before{
  content:"\\f172";
}

.bp4-icon-data-lineage::before{
  content:"\\f173";
}

.bp4-icon-database::before{
  content:"\\f174";
}

.bp4-icon-delete::before{
  content:"\\f175";
}

.bp4-icon-delta::before{
  content:"\\f176";
}

.bp4-icon-derive-column::before{
  content:"\\f177";
}

.bp4-icon-desktop::before{
  content:"\\f178";
}

.bp4-icon-detection::before{
  content:"\\f341";
}

.bp4-icon-diagnosis::before{
  content:"\\f179";
}

.bp4-icon-diagram-tree::before{
  content:"\\f17a";
}

.bp4-icon-direction-left::before{
  content:"\\f17b";
}

.bp4-icon-direction-right::before{
  content:"\\f17c";
}

.bp4-icon-disable::before{
  content:"\\f17d";
}

.bp4-icon-divide::before{
  content:"\\f327";
}

.bp4-icon-document::before{
  content:"\\f180";
}

.bp4-icon-document-open::before{
  content:"\\f17e";
}

.bp4-icon-document-share::before{
  content:"\\f17f";
}

.bp4-icon-dollar::before{
  content:"\\f181";
}

.bp4-icon-dot::before{
  content:"\\f182";
}

.bp4-icon-double-caret-horizontal::before{
  content:"\\f183";
}

.bp4-icon-double-caret-vertical::before{
  content:"\\f184";
}

.bp4-icon-double-chevron-down::before{
  content:"\\f185";
}

.bp4-icon-double-chevron-left::before{
  content:"\\f186";
}

.bp4-icon-double-chevron-right::before{
  content:"\\f187";
}

.bp4-icon-double-chevron-up::before{
  content:"\\f188";
}

.bp4-icon-doughnut-chart::before{
  content:"\\f189";
}

.bp4-icon-download::before{
  content:"\\f18a";
}

.bp4-icon-drag-handle-horizontal::before{
  content:"\\f18b";
}

.bp4-icon-drag-handle-vertical::before{
  content:"\\f18c";
}

.bp4-icon-draw::before{
  content:"\\f18d";
}

.bp4-icon-drawer-left::before{
  content:"\\f18f";
}

.bp4-icon-drawer-left-filled::before{
  content:"\\f18e";
}

.bp4-icon-drawer-right::before{
  content:"\\f191";
}

.bp4-icon-drawer-right-filled::before{
  content:"\\f190";
}

.bp4-icon-drive-time::before{
  content:"\\f192";
}

.bp4-icon-duplicate::before{
  content:"\\f193";
}

.bp4-icon-edit::before{
  content:"\\f194";
}

.bp4-icon-eject::before{
  content:"\\f195";
}

.bp4-icon-emoji::before{
  content:"\\f196";
}

.bp4-icon-endorsed::before{
  content:"\\f197";
}

.bp4-icon-envelope::before{
  content:"\\f198";
}

.bp4-icon-equals::before{
  content:"\\f199";
}

.bp4-icon-eraser::before{
  content:"\\f19a";
}

.bp4-icon-error::before{
  content:"\\f19b";
}

.bp4-icon-euro::before{
  content:"\\f19c";
}

.bp4-icon-exchange::before{
  content:"\\f19d";
}

.bp4-icon-exclude-row::before{
  content:"\\f19e";
}

.bp4-icon-expand-all::before{
  content:"\\f19f";
}

.bp4-icon-export::before{
  content:"\\f1a0";
}

.bp4-icon-eye-off::before{
  content:"\\f1a1";
}

.bp4-icon-eye-on::before{
  content:"\\f1a2";
}

.bp4-icon-eye-open::before{
  content:"\\f1a3";
}

.bp4-icon-fast-backward::before{
  content:"\\f1a4";
}

.bp4-icon-fast-forward::before{
  content:"\\f1a5";
}

.bp4-icon-feed::before{
  content:"\\f1a7";
}

.bp4-icon-feed-subscribed::before{
  content:"\\f1a6";
}

.bp4-icon-film::before{
  content:"\\f1a8";
}

.bp4-icon-filter::before{
  content:"\\f1ad";
}

.bp4-icon-filter-keep::before{
  content:"\\f1a9";
}

.bp4-icon-filter-list::before{
  content:"\\f1aa";
}

.bp4-icon-filter-open::before{
  content:"\\f1ab";
}

.bp4-icon-filter-remove::before{
  content:"\\f1ac";
}

.bp4-icon-flag::before{
  content:"\\f1ae";
}

.bp4-icon-flame::before{
  content:"\\f1af";
}

.bp4-icon-flash::before{
  content:"\\f1b0";
}

.bp4-icon-floating-point::before{
  content:"\\f32c";
}

.bp4-icon-floppy-disk::before{
  content:"\\f1b1";
}

.bp4-icon-flow-branch::before{
  content:"\\f1b2";
}

.bp4-icon-flow-end::before{
  content:"\\f1b3";
}

.bp4-icon-flow-linear::before{
  content:"\\f1b4";
}

.bp4-icon-flow-review::before{
  content:"\\f1b6";
}

.bp4-icon-flow-review-branch::before{
  content:"\\f1b5";
}

.bp4-icon-flows::before{
  content:"\\f1b7";
}

.bp4-icon-folder-close::before{
  content:"\\f1b8";
}

.bp4-icon-folder-new::before{
  content:"\\f1b9";
}

.bp4-icon-folder-open::before{
  content:"\\f1ba";
}

.bp4-icon-folder-shared::before{
  content:"\\f1bc";
}

.bp4-icon-folder-shared-open::before{
  content:"\\f1bb";
}

.bp4-icon-follower::before{
  content:"\\f1bd";
}

.bp4-icon-following::before{
  content:"\\f1be";
}

.bp4-icon-font::before{
  content:"\\f1bf";
}

.bp4-icon-fork::before{
  content:"\\f1c0";
}

.bp4-icon-form::before{
  content:"\\f1c1";
}

.bp4-icon-fuel::before{
  content:"\\f323";
}

.bp4-icon-full-circle::before{
  content:"\\f1c2";
}

.bp4-icon-full-stacked-chart::before{
  content:"\\f1c3";
}

.bp4-icon-fullscreen::before{
  content:"\\f1c4";
}

.bp4-icon-function::before{
  content:"\\f1c5";
}

.bp4-icon-gantt-chart::before{
  content:"\\f1c6";
}

.bp4-icon-geofence::before{
  content:"\\f1c7";
}

.bp4-icon-geolocation::before{
  content:"\\f1c8";
}

.bp4-icon-geosearch::before{
  content:"\\f1c9";
}

.bp4-icon-git-branch::before{
  content:"\\f1ca";
}

.bp4-icon-git-commit::before{
  content:"\\f1cb";
}

.bp4-icon-git-merge::before{
  content:"\\f1cc";
}

.bp4-icon-git-new-branch::before{
  content:"\\f1cd";
}

.bp4-icon-git-pull::before{
  content:"\\f1ce";
}

.bp4-icon-git-push::before{
  content:"\\f1cf";
}

.bp4-icon-git-repo::before{
  content:"\\f1d0";
}

.bp4-icon-glass::before{
  content:"\\f1d1";
}

.bp4-icon-globe::before{
  content:"\\f1d3";
}

.bp4-icon-globe-network::before{
  content:"\\f1d2";
}

.bp4-icon-graph::before{
  content:"\\f1d5";
}

.bp4-icon-graph-remove::before{
  content:"\\f1d4";
}

.bp4-icon-greater-than::before{
  content:"\\f1d7";
}

.bp4-icon-greater-than-or-equal-to::before{
  content:"\\f1d6";
}

.bp4-icon-grid::before{
  content:"\\f1d9";
}

.bp4-icon-grid-view::before{
  content:"\\f1d8";
}

.bp4-icon-group-objects::before{
  content:"\\f1da";
}

.bp4-icon-grouped-bar-chart::before{
  content:"\\f1db";
}

.bp4-icon-hand::before{
  content:"\\f1e0";
}

.bp4-icon-hand-down::before{
  content:"\\f1dc";
}

.bp4-icon-hand-left::before{
  content:"\\f1dd";
}

.bp4-icon-hand-right::before{
  content:"\\f1de";
}

.bp4-icon-hand-up::before{
  content:"\\f1df";
}

.bp4-icon-hat::before{
  content:"\\f1e1";
}

.bp4-icon-header::before{
  content:"\\f1e5";
}

.bp4-icon-header-one::before{
  content:"\\f1e2";
}

.bp4-icon-header-three::before{
  content:"\\f1e3";
}

.bp4-icon-header-two::before{
  content:"\\f1e4";
}

.bp4-icon-headset::before{
  content:"\\f1e6";
}

.bp4-icon-heart::before{
  content:"\\f1e8";
}

.bp4-icon-heart-broken::before{
  content:"\\f1e7";
}

.bp4-icon-heat-grid::before{
  content:"\\f1e9";
}

.bp4-icon-heatmap::before{
  content:"\\f1ea";
}

.bp4-icon-helicopter::before{
  content:"\\f1eb";
}

.bp4-icon-help::before{
  content:"\\f1ec";
}

.bp4-icon-helper-management::before{
  content:"\\f1ed";
}

.bp4-icon-high-priority::before{
  content:"\\f1ee";
}

.bp4-icon-high-voltage-pole::before{
  content:"\\f333";
}

.bp4-icon-highlight::before{
  content:"\\f1ef";
}

.bp4-icon-history::before{
  content:"\\f1f0";
}

.bp4-icon-home::before{
  content:"\\f1f1";
}

.bp4-icon-horizontal-bar-chart::before{
  content:"\\f1f4";
}

.bp4-icon-horizontal-bar-chart-asc::before{
  content:"\\f1f2";
}

.bp4-icon-horizontal-bar-chart-desc::before{
  content:"\\f1f3";
}

.bp4-icon-horizontal-distribution::before{
  content:"\\f1f5";
}

.bp4-icon-horizontal-inbetween::before{
  content:"\\f329";
}

.bp4-icon-hurricane::before{
  content:"\\f1f6";
}

.bp4-icon-id-number::before{
  content:"\\f1f7";
}

.bp4-icon-image-rotate-left::before{
  content:"\\f1f8";
}

.bp4-icon-image-rotate-right::before{
  content:"\\f1f9";
}

.bp4-icon-import::before{
  content:"\\f1fa";
}

.bp4-icon-inbox::before{
  content:"\\f1ff";
}

.bp4-icon-inbox-filtered::before{
  content:"\\f1fb";
}

.bp4-icon-inbox-geo::before{
  content:"\\f1fc";
}

.bp4-icon-inbox-search::before{
  content:"\\f1fd";
}

.bp4-icon-inbox-update::before{
  content:"\\f1fe";
}

.bp4-icon-info-sign::before{
  content:"\\f200";
}

.bp4-icon-inheritance::before{
  content:"\\f201";
}

.bp4-icon-inherited-group::before{
  content:"\\f202";
}

.bp4-icon-inner-join::before{
  content:"\\f203";
}

.bp4-icon-insert::before{
  content:"\\f204";
}

.bp4-icon-intelligence::before{
  content:"\\f337";
}

.bp4-icon-intersection::before{
  content:"\\f205";
}

.bp4-icon-ip-address::before{
  content:"\\f206";
}

.bp4-icon-issue::before{
  content:"\\f209";
}

.bp4-icon-issue-closed::before{
  content:"\\f207";
}

.bp4-icon-issue-new::before{
  content:"\\f208";
}

.bp4-icon-italic::before{
  content:"\\f20a";
}

.bp4-icon-join-table::before{
  content:"\\f20b";
}

.bp4-icon-key::before{
  content:"\\f215";
}

.bp4-icon-key-backspace::before{
  content:"\\f20c";
}

.bp4-icon-key-command::before{
  content:"\\f20d";
}

.bp4-icon-key-control::before{
  content:"\\f20e";
}

.bp4-icon-key-delete::before{
  content:"\\f20f";
}

.bp4-icon-key-enter::before{
  content:"\\f210";
}

.bp4-icon-key-escape::before{
  content:"\\f211";
}

.bp4-icon-key-option::before{
  content:"\\f212";
}

.bp4-icon-key-shift::before{
  content:"\\f213";
}

.bp4-icon-key-tab::before{
  content:"\\f214";
}

.bp4-icon-known-vehicle::before{
  content:"\\f216";
}

.bp4-icon-lab-test::before{
  content:"\\f217";
}

.bp4-icon-label::before{
  content:"\\f218";
}

.bp4-icon-layer::before{
  content:"\\f21a";
}

.bp4-icon-layer-outline::before{
  content:"\\f219";
}

.bp4-icon-layers::before{
  content:"\\f21b";
}

.bp4-icon-layout::before{
  content:"\\f225";
}

.bp4-icon-layout-auto::before{
  content:"\\f21c";
}

.bp4-icon-layout-balloon::before{
  content:"\\f21d";
}

.bp4-icon-layout-circle::before{
  content:"\\f21e";
}

.bp4-icon-layout-grid::before{
  content:"\\f21f";
}

.bp4-icon-layout-group-by::before{
  content:"\\f220";
}

.bp4-icon-layout-hierarchy::before{
  content:"\\f221";
}

.bp4-icon-layout-linear::before{
  content:"\\f222";
}

.bp4-icon-layout-skew-grid::before{
  content:"\\f223";
}

.bp4-icon-layout-sorted-clusters::before{
  content:"\\f224";
}

.bp4-icon-learning::before{
  content:"\\f226";
}

.bp4-icon-left-join::before{
  content:"\\f227";
}

.bp4-icon-lengthen-text::before{
  content:"\\f33e";
}

.bp4-icon-less-than::before{
  content:"\\f229";
}

.bp4-icon-less-than-or-equal-to::before{
  content:"\\f228";
}

.bp4-icon-lifesaver::before{
  content:"\\f22a";
}

.bp4-icon-lightbulb::before{
  content:"\\f22b";
}

.bp4-icon-lightning::before{
  content:"\\f22c";
}

.bp4-icon-link::before{
  content:"\\f22d";
}

.bp4-icon-list::before{
  content:"\\f230";
}

.bp4-icon-list-columns::before{
  content:"\\f22e";
}

.bp4-icon-list-detail-view::before{
  content:"\\f22f";
}

.bp4-icon-locate::before{
  content:"\\f231";
}

.bp4-icon-lock::before{
  content:"\\f232";
}

.bp4-icon-locomotive::before{
  content:"\\f33b";
}

.bp4-icon-log-in::before{
  content:"\\f233";
}

.bp4-icon-log-out::before{
  content:"\\f234";
}

.bp4-icon-low-voltage-pole::before{
  content:"\\f332";
}

.bp4-icon-manual::before{
  content:"\\f235";
}

.bp4-icon-manually-entered-data::before{
  content:"\\f236";
}

.bp4-icon-many-to-many::before{
  content:"\\f237";
}

.bp4-icon-many-to-one::before{
  content:"\\f238";
}

.bp4-icon-map::before{
  content:"\\f23b";
}

.bp4-icon-map-create::before{
  content:"\\f239";
}

.bp4-icon-map-marker::before{
  content:"\\f23a";
}

.bp4-icon-maximize::before{
  content:"\\f23c";
}

.bp4-icon-media::before{
  content:"\\f23d";
}

.bp4-icon-menu::before{
  content:"\\f240";
}

.bp4-icon-menu-closed::before{
  content:"\\f23e";
}

.bp4-icon-menu-open::before{
  content:"\\f23f";
}

.bp4-icon-merge-columns::before{
  content:"\\f241";
}

.bp4-icon-merge-links::before{
  content:"\\f242";
}

.bp4-icon-minimize::before{
  content:"\\f243";
}

.bp4-icon-minus::before{
  content:"\\f244";
}

.bp4-icon-mobile-phone::before{
  content:"\\f245";
}

.bp4-icon-mobile-video::before{
  content:"\\f246";
}

.bp4-icon-modal::before{
  content:"\\f248";
}

.bp4-icon-modal-filled::before{
  content:"\\f247";
}

.bp4-icon-model::before{
  content:"\\f33d";
}

.bp4-icon-moon::before{
  content:"\\f249";
}

.bp4-icon-more::before{
  content:"\\f24a";
}

.bp4-icon-mountain::before{
  content:"\\f24b";
}

.bp4-icon-move::before{
  content:"\\f24c";
}

.bp4-icon-mugshot::before{
  content:"\\f24d";
}

.bp4-icon-multi-select::before{
  content:"\\f24e";
}

.bp4-icon-music::before{
  content:"\\f24f";
}

.bp4-icon-nest::before{
  content:"\\f250";
}

.bp4-icon-new-drawing::before{
  content:"\\f251";
}

.bp4-icon-new-grid-item::before{
  content:"\\f252";
}

.bp4-icon-new-layer::before{
  content:"\\f253";
}

.bp4-icon-new-layers::before{
  content:"\\f254";
}

.bp4-icon-new-link::before{
  content:"\\f255";
}

.bp4-icon-new-object::before{
  content:"\\f256";
}

.bp4-icon-new-person::before{
  content:"\\f257";
}

.bp4-icon-new-prescription::before{
  content:"\\f258";
}

.bp4-icon-new-text-box::before{
  content:"\\f259";
}

.bp4-icon-ninja::before{
  content:"\\f25a";
}

.bp4-icon-not-equal-to::before{
  content:"\\f25b";
}

.bp4-icon-notifications::before{
  content:"\\f25e";
}

.bp4-icon-notifications-snooze::before{
  content:"\\f25c";
}

.bp4-icon-notifications-updated::before{
  content:"\\f25d";
}

.bp4-icon-numbered-list::before{
  content:"\\f25f";
}

.bp4-icon-numerical::before{
  content:"\\f260";
}

.bp4-icon-office::before{
  content:"\\f261";
}

.bp4-icon-offline::before{
  content:"\\f262";
}

.bp4-icon-oil-field::before{
  content:"\\f263";
}

.bp4-icon-one-column::before{
  content:"\\f264";
}

.bp4-icon-one-to-many::before{
  content:"\\f265";
}

.bp4-icon-one-to-one::before{
  content:"\\f266";
}

.bp4-icon-open-application::before{
  content:"\\f32b";
}

.bp4-icon-outdated::before{
  content:"\\f267";
}

.bp4-icon-page-layout::before{
  content:"\\f268";
}

.bp4-icon-panel-stats::before{
  content:"\\f269";
}

.bp4-icon-panel-table::before{
  content:"\\f26a";
}

.bp4-icon-paperclip::before{
  content:"\\f26b";
}

.bp4-icon-paragraph::before{
  content:"\\f26c";
}

.bp4-icon-path::before{
  content:"\\f26e";
}

.bp4-icon-path-search::before{
  content:"\\f26d";
}

.bp4-icon-pause::before{
  content:"\\f26f";
}

.bp4-icon-people::before{
  content:"\\f270";
}

.bp4-icon-percentage::before{
  content:"\\f271";
}

.bp4-icon-person::before{
  content:"\\f272";
}

.bp4-icon-phone::before{
  content:"\\f273";
}

.bp4-icon-pie-chart::before{
  content:"\\f274";
}

.bp4-icon-pin::before{
  content:"\\f275";
}

.bp4-icon-pivot::before{
  content:"\\f277";
}

.bp4-icon-pivot-table::before{
  content:"\\f276";
}

.bp4-icon-play::before{
  content:"\\f278";
}

.bp4-icon-playbook::before{
  content:"\\f324";
}

.bp4-icon-plus::before{
  content:"\\f279";
}

.bp4-icon-polygon-filter::before{
  content:"\\f27a";
}

.bp4-icon-power::before{
  content:"\\f27b";
}

.bp4-icon-predictive-analysis::before{
  content:"\\f27c";
}

.bp4-icon-prescription::before{
  content:"\\f27d";
}

.bp4-icon-presentation::before{
  content:"\\f27e";
}

.bp4-icon-print::before{
  content:"\\f27f";
}

.bp4-icon-projects::before{
  content:"\\f280";
}

.bp4-icon-properties::before{
  content:"\\f281";
}

.bp4-icon-property::before{
  content:"\\f282";
}

.bp4-icon-publish-function::before{
  content:"\\f283";
}

.bp4-icon-pulse::before{
  content:"\\f284";
}

.bp4-icon-rain::before{
  content:"\\f285";
}

.bp4-icon-random::before{
  content:"\\f286";
}

.bp4-icon-record::before{
  content:"\\f287";
}

.bp4-icon-rect-height::before{
  content:"\\f325";
}

.bp4-icon-rect-width::before{
  content:"\\f326";
}

.bp4-icon-rectangle::before{
  content:"\\f321";
}

.bp4-icon-redo::before{
  content:"\\f288";
}

.bp4-icon-refresh::before{
  content:"\\f289";
}

.bp4-icon-regex::before{
  content:"\\f32f";
}

.bp4-icon-regression-chart::before{
  content:"\\f28a";
}

.bp4-icon-remove::before{
  content:"\\f290";
}

.bp4-icon-remove-column::before{
  content:"\\f28d";
}

.bp4-icon-remove-column-left::before{
  content:"\\f28b";
}

.bp4-icon-remove-column-right::before{
  content:"\\f28c";
}

.bp4-icon-remove-row-bottom::before{
  content:"\\f28e";
}

.bp4-icon-remove-row-top::before{
  content:"\\f28f";
}

.bp4-icon-repeat::before{
  content:"\\f291";
}

.bp4-icon-reset::before{
  content:"\\f292";
}

.bp4-icon-resolve::before{
  content:"\\f293";
}

.bp4-icon-rig::before{
  content:"\\f294";
}

.bp4-icon-right-join::before{
  content:"\\f295";
}

.bp4-icon-ring::before{
  content:"\\f296";
}

.bp4-icon-rocket::before{
  content:"\\f298";
}

.bp4-icon-rocket-slant::before{
  content:"\\f297";
}

.bp4-icon-rotate-document::before{
  content:"\\f299";
}

.bp4-icon-rotate-page::before{
  content:"\\f29a";
}

.bp4-icon-route::before{
  content:"\\f29b";
}

.bp4-icon-satellite::before{
  content:"\\f29c";
}

.bp4-icon-saved::before{
  content:"\\f29d";
}

.bp4-icon-scatter-plot::before{
  content:"\\f29e";
}

.bp4-icon-search::before{
  content:"\\f2a2";
}

.bp4-icon-search-around::before{
  content:"\\f29f";
}

.bp4-icon-search-template::before{
  content:"\\f2a0";
}

.bp4-icon-search-text::before{
  content:"\\f2a1";
}

.bp4-icon-segmented-control::before{
  content:"\\f2a3";
}

.bp4-icon-select::before{
  content:"\\f2a4";
}

.bp4-icon-selection::before{
  content:"\\f2a5";
}

.bp4-icon-send-message::before{
  content:"\\f2a6";
}

.bp4-icon-send-to::before{
  content:"\\f2a9";
}

.bp4-icon-send-to-graph::before{
  content:"\\f2a7";
}

.bp4-icon-send-to-map::before{
  content:"\\f2a8";
}

.bp4-icon-sensor::before{
  content:"\\f33c";
}

.bp4-icon-series-add::before{
  content:"\\f2aa";
}

.bp4-icon-series-configuration::before{
  content:"\\f2ab";
}

.bp4-icon-series-derived::before{
  content:"\\f2ac";
}

.bp4-icon-series-filtered::before{
  content:"\\f2ad";
}

.bp4-icon-series-search::before{
  content:"\\f2ae";
}

.bp4-icon-settings::before{
  content:"\\f2af";
}

.bp4-icon-shapes::before{
  content:"\\f2b0";
}

.bp4-icon-share::before{
  content:"\\f2b1";
}

.bp4-icon-shared-filter::before{
  content:"\\f2b2";
}

.bp4-icon-shield::before{
  content:"\\f2b3";
}

.bp4-icon-ship::before{
  content:"\\f2b4";
}

.bp4-icon-shop::before{
  content:"\\f2b5";
}

.bp4-icon-shopping-cart::before{
  content:"\\f2b6";
}

.bp4-icon-shorten-text::before{
  content:"\\f33f";
}

.bp4-icon-signal-search::before{
  content:"\\f2b7";
}

.bp4-icon-sim-card::before{
  content:"\\f2b8";
}

.bp4-icon-slash::before{
  content:"\\f2b9";
}

.bp4-icon-small-cross::before{
  content:"\\f2ba";
}

.bp4-icon-small-info-sign::before{
  content:"\\f334";
}

.bp4-icon-small-minus::before{
  content:"\\f2bb";
}

.bp4-icon-small-plus::before{
  content:"\\f2bc";
}

.bp4-icon-small-square::before{
  content:"\\f2bd";
}

.bp4-icon-small-tick::before{
  content:"\\f2be";
}

.bp4-icon-snowflake::before{
  content:"\\f2bf";
}

.bp4-icon-social-media::before{
  content:"\\f2c0";
}

.bp4-icon-sort::before{
  content:"\\f2c7";
}

.bp4-icon-sort-alphabetical::before{
  content:"\\f2c2";
}

.bp4-icon-sort-alphabetical-desc::before{
  content:"\\f2c1";
}

.bp4-icon-sort-asc::before{
  content:"\\f2c3";
}

.bp4-icon-sort-desc::before{
  content:"\\f2c4";
}

.bp4-icon-sort-numerical::before{
  content:"\\f2c6";
}

.bp4-icon-sort-numerical-desc::before{
  content:"\\f2c5";
}

.bp4-icon-spell-check::before{
  content:"\\f340";
}

.bp4-icon-split-columns::before{
  content:"\\f2c8";
}

.bp4-icon-square::before{
  content:"\\f2c9";
}

.bp4-icon-stacked-chart::before{
  content:"\\f2ca";
}

.bp4-icon-stadium-geometry::before{
  content:"\\f2cb";
}

.bp4-icon-star::before{
  content:"\\f2cd";
}

.bp4-icon-star-empty::before{
  content:"\\f2cc";
}

.bp4-icon-step-backward::before{
  content:"\\f2ce";
}

.bp4-icon-step-chart::before{
  content:"\\f2cf";
}

.bp4-icon-step-forward::before{
  content:"\\f2d0";
}

.bp4-icon-stop::before{
  content:"\\f2d1";
}

.bp4-icon-stopwatch::before{
  content:"\\f2d2";
}

.bp4-icon-strikethrough::before{
  content:"\\f2d3";
}

.bp4-icon-style::before{
  content:"\\f2d4";
}

.bp4-icon-subscript::before{
  content:"\\f339";
}

.bp4-icon-superscript::before{
  content:"\\f33a";
}

.bp4-icon-swap-horizontal::before{
  content:"\\f2d5";
}

.bp4-icon-swap-vertical::before{
  content:"\\f2d6";
}

.bp4-icon-switch::before{
  content:"\\f2d7";
}

.bp4-icon-symbol-circle::before{
  content:"\\f2d8";
}

.bp4-icon-symbol-cross::before{
  content:"\\f2d9";
}

.bp4-icon-symbol-diamond::before{
  content:"\\f2da";
}

.bp4-icon-symbol-rectangle::before{
  content:"\\f322";
}

.bp4-icon-symbol-square::before{
  content:"\\f2db";
}

.bp4-icon-symbol-triangle-down::before{
  content:"\\f2dc";
}

.bp4-icon-symbol-triangle-up::before{
  content:"\\f2dd";
}

.bp4-icon-syringe::before{
  content:"\\f2de";
}

.bp4-icon-tag::before{
  content:"\\f2df";
}

.bp4-icon-take-action::before{
  content:"\\f2e0";
}

.bp4-icon-tank::before{
  content:"\\f2e1";
}

.bp4-icon-target::before{
  content:"\\f2e2";
}

.bp4-icon-taxi::before{
  content:"\\f2e3";
}

.bp4-icon-temperature::before{
  content:"\\f2e4";
}

.bp4-icon-text-highlight::before{
  content:"\\f2e5";
}

.bp4-icon-th::before{
  content:"\\f2ea";
}

.bp4-icon-th-derived::before{
  content:"\\f2e6";
}

.bp4-icon-th-disconnect::before{
  content:"\\f2e7";
}

.bp4-icon-th-filtered::before{
  content:"\\f2e8";
}

.bp4-icon-th-list::before{
  content:"\\f2e9";
}

.bp4-icon-third-party::before{
  content:"\\f2eb";
}

.bp4-icon-thumbs-down::before{
  content:"\\f2ec";
}

.bp4-icon-thumbs-up::before{
  content:"\\f2ed";
}

.bp4-icon-tick::before{
  content:"\\f2ef";
}

.bp4-icon-tick-circle::before{
  content:"\\f2ee";
}

.bp4-icon-time::before{
  content:"\\f2f0";
}

.bp4-icon-timeline-area-chart::before{
  content:"\\f2f1";
}

.bp4-icon-timeline-bar-chart::before{
  content:"\\f2f2";
}

.bp4-icon-timeline-events::before{
  content:"\\f2f3";
}

.bp4-icon-timeline-line-chart::before{
  content:"\\f2f4";
}

.bp4-icon-tint::before{
  content:"\\f2f5";
}

.bp4-icon-torch::before{
  content:"\\f2f6";
}

.bp4-icon-tractor::before{
  content:"\\f2f7";
}

.bp4-icon-train::before{
  content:"\\f2f8";
}

.bp4-icon-translate::before{
  content:"\\f2f9";
}

.bp4-icon-trash::before{
  content:"\\f2fa";
}

.bp4-icon-tree::before{
  content:"\\f2fb";
}

.bp4-icon-trending-down::before{
  content:"\\f2fc";
}

.bp4-icon-trending-up::before{
  content:"\\f2fd";
}

.bp4-icon-truck::before{
  content:"\\f2fe";
}

.bp4-icon-two-columns::before{
  content:"\\f2ff";
}

.bp4-icon-unarchive::before{
  content:"\\f300";
}

.bp4-icon-underline::before{
  content:"\\f301";
}

.bp4-icon-undo::before{
  content:"\\f302";
}

.bp4-icon-ungroup-objects::before{
  content:"\\f303";
}

.bp4-icon-unknown-vehicle::before{
  content:"\\f304";
}

.bp4-icon-unlock::before{
  content:"\\f305";
}

.bp4-icon-unpin::before{
  content:"\\f306";
}

.bp4-icon-unresolve::before{
  content:"\\f307";
}

.bp4-icon-updated::before{
  content:"\\f308";
}

.bp4-icon-upload::before{
  content:"\\f309";
}

.bp4-icon-user::before{
  content:"\\f30a";
}

.bp4-icon-variable::before{
  content:"\\f30b";
}

.bp4-icon-vertical-bar-chart-asc::before{
  content:"\\f30c";
}

.bp4-icon-vertical-bar-chart-desc::before{
  content:"\\f30d";
}

.bp4-icon-vertical-distribution::before{
  content:"\\f30e";
}

.bp4-icon-vertical-inbetween::before{
  content:"\\f32a";
}

.bp4-icon-video::before{
  content:"\\f30f";
}

.bp4-icon-virus::before{
  content:"\\f310";
}

.bp4-icon-volume-down::before{
  content:"\\f311";
}

.bp4-icon-volume-off::before{
  content:"\\f312";
}

.bp4-icon-volume-up::before{
  content:"\\f313";
}

.bp4-icon-walk::before{
  content:"\\f314";
}

.bp4-icon-warning-sign::before{
  content:"\\f315";
}

.bp4-icon-waterfall-chart::before{
  content:"\\f316";
}

.bp4-icon-waves::before{
  content:"\\f317";
}

.bp4-icon-widget::before{
  content:"\\f31b";
}

.bp4-icon-widget-button::before{
  content:"\\f318";
}

.bp4-icon-widget-footer::before{
  content:"\\f319";
}

.bp4-icon-widget-header::before{
  content:"\\f31a";
}

.bp4-icon-wind::before{
  content:"\\f31c";
}

.bp4-icon-wrench::before{
  content:"\\f31d";
}

.bp4-icon-zoom-in::before{
  content:"\\f31e";
}

.bp4-icon-zoom-out::before{
  content:"\\f31f";
}

.bp4-icon-zoom-to-fit::before{
  content:"\\f320";
}
.bp4-submenu > .bp4-popover-wrapper{
  display:block;
}
.bp4-submenu .bp4-popover-target{
  display:block;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item{
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]){
  background-color:rgba(143, 153, 168, 0.15);
  color:inherit;
  cursor:pointer;
  text-decoration:none;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected{
  background-color:rgba(45, 114, 210, 0.1);
  color:#215db0;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-menu-item-label{
  color:inherit;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-submenu-icon{
  color:#215db0;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.1);
  color:#1c6e42;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.1);
  color:#935610;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.1);
  color:#ac2f33;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected{
    background-color:highlight;
  }
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]){
  color:inherit;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]) .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]) .bp4-submenu-icon{
  color:#abb3bf;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected{
  background-color:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-submenu-icon{
  color:#8abbff;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected{
    background-color:highlight;
  }
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active{
  background-color:rgba(45, 114, 210, 0.1);
  color:#215db0;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-menu-item-label, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-menu-item-label, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-menu-item-label{
  color:inherit;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-submenu-icon{
  color:#215db0;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.1);
  color:#1c6e42;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.1);
  color:#935610;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.1);
  color:#ac2f33;
}
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger::before,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-menu-item-icon,
.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active{
    background-color:highlight;
  }
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active{
  background-color:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-submenu-icon{
  color:#8abbff;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger::before,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active{
    background-color:highlight;
  }
}
.bp4-submenu.bp4-popover{
  box-shadow:none;
  padding:0 5px;
}
.bp4-submenu.bp4-popover > .bp4-popover-content{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
}
.bp4-dark .bp4-submenu.bp4-popover, .bp4-submenu.bp4-popover.bp4-dark{
  box-shadow:none;
}
.bp4-dark .bp4-submenu.bp4-popover > .bp4-popover-content, .bp4-submenu.bp4-popover.bp4-dark > .bp4-popover-content{
  box-shadow:0 0 0 1px hsl(215, 3%, 38%), inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
}
.bp4-menu{
  background:#ffffff;
  border-radius:2px;
  color:#1c2127;
  list-style:none;
  margin:0;
  min-width:180px;
  padding:5px;
  text-align:left;
}

.bp4-menu-divider{
  border-top:1px solid rgba(17, 20, 24, 0.15);
  display:block;
  margin:5px;
}
.bp4-dark .bp4-menu-divider{
  border-top-color:rgba(255, 255, 255, 0.2);
}

.bp4-menu-item{
  display:flex;
  flex-direction:row;
  align-items:flex-start;
  border-radius:2px;
  color:inherit;
  line-height:20px;
  padding:5px 7px;
  text-decoration:none;
  -webkit-user-select:none;
          user-select:none;
}
.bp4-menu-item > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-menu-item > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-menu-item::before,
.bp4-menu-item > *{
  margin-right:7px;
}
.bp4-menu-item:empty::before,
.bp4-menu-item > :last-child{
  margin-right:0;
}
.bp4-menu-item > .bp4-fill{
  word-break:break-word;
}
.bp4-menu-item .bp4-menu-item-icon{
  display:flex;
  flex-direction:column;
  height:20px;
  justify-content:center;
}
.bp4-menu-item .bp4-menu-item-label{
  color:#5f6b7c;
}
.bp4-menu-item::before,
.bp4-menu-item .bp4-menu-item-icon,
.bp4-menu-item .bp4-submenu-icon{
  color:#5f6b7c;
}
.bp4-menu-item::before,
.bp4-menu-item .bp4-submenu-icon{
  margin-top:2px;
}
.bp4-menu-item:hover{
  background-color:rgba(143, 153, 168, 0.15);
  color:inherit;
  cursor:pointer;
  text-decoration:none;
}
.bp4-menu-item:hover.ns-selected{
  background-color:rgba(45, 114, 210, 0.1);
  color:#215db0;
}
.bp4-menu-item:hover.ns-selected .bp4-menu-item-label{
  color:inherit;
}
.bp4-menu-item:hover.ns-selected::before,
.bp4-menu-item:hover.ns-selected .bp4-menu-item-icon,
.bp4-menu-item:hover.ns-selected .bp4-submenu-icon{
  color:#215db0;
}
.bp4-menu-item:hover.ns-selected.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.1);
  color:#1c6e42;
}
.bp4-menu-item:hover.ns-selected.bp4-intent-success::before,
.bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-menu-item-icon,
.bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-menu-item:hover.ns-selected.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.1);
  color:#935610;
}
.bp4-menu-item:hover.ns-selected.bp4-intent-warning::before,
.bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-menu-item-icon,
.bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-menu-item:hover.ns-selected.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.1);
  color:#ac2f33;
}
.bp4-menu-item:hover.ns-selected.bp4-intent-danger::before,
.bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-menu-item-icon,
.bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-menu-item:hover.ns-selected{
    background-color:highlight;
  }
}
.bp4-menu-item:active, .bp4-menu-item.bp4-active{
  background-color:rgba(143, 153, 168, 0.3);
}
.bp4-menu-item:active .bp4-menu-item-label, .bp4-menu-item.bp4-active .bp4-menu-item-label{
  color:#1c2127;
}
.bp4-menu-item.bp4-selected, .bp4-menu-item.bp4-selected:hover, .bp4-menu-item.bp4-selected:active{
  background-color:rgba(45, 114, 210, 0.1);
  color:#215db0;
}
.bp4-menu-item.bp4-selected .bp4-menu-item-label, .bp4-menu-item.bp4-selected:hover .bp4-menu-item-label, .bp4-menu-item.bp4-selected:active .bp4-menu-item-label{
  color:inherit;
}
.bp4-menu-item.bp4-selected::before,
.bp4-menu-item.bp4-selected .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover::before,
.bp4-menu-item.bp4-selected:hover .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:hover .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active::before,
.bp4-menu-item.bp4-selected:active .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:active .bp4-submenu-icon{
  color:#215db0;
}
.bp4-menu-item.bp4-selected.bp4-intent-success, .bp4-menu-item.bp4-selected:hover.bp4-intent-success, .bp4-menu-item.bp4-selected:active.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.1);
  color:#1c6e42;
}
.bp4-menu-item.bp4-selected.bp4-intent-success::before,
.bp4-menu-item.bp4-selected.bp4-intent-success .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected.bp4-intent-success .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover.bp4-intent-success::before,
.bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active.bp4-intent-success::before,
.bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-menu-item.bp4-selected.bp4-intent-warning, .bp4-menu-item.bp4-selected:hover.bp4-intent-warning, .bp4-menu-item.bp4-selected:active.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.1);
  color:#935610;
}
.bp4-menu-item.bp4-selected.bp4-intent-warning::before,
.bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover.bp4-intent-warning::before,
.bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active.bp4-intent-warning::before,
.bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-menu-item.bp4-selected.bp4-intent-danger, .bp4-menu-item.bp4-selected:hover.bp4-intent-danger, .bp4-menu-item.bp4-selected:active.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.1);
  color:#ac2f33;
}
.bp4-menu-item.bp4-selected.bp4-intent-danger::before,
.bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover.bp4-intent-danger::before,
.bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active.bp4-intent-danger::before,
.bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-menu-item-icon,
.bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-menu-item.bp4-selected, .bp4-menu-item.bp4-selected:hover, .bp4-menu-item.bp4-selected:active{
    background-color:highlight;
  }
}
.bp4-menu-item.bp4-disabled{
  background-color:inherit !important;
  color:rgba(95, 107, 124, 0.6) !important;
  cursor:not-allowed !important;
  outline:none !important;
}
.bp4-menu-item.bp4-disabled::before,
.bp4-menu-item.bp4-disabled .bp4-menu-item-icon,
.bp4-menu-item.bp4-disabled .bp4-submenu-icon{
  color:rgba(95, 107, 124, 0.6) !important;
}
.bp4-menu-item.bp4-disabled .bp4-menu-item-label{
  color:rgba(95, 107, 124, 0.6) !important;
}
.bp4-menu-item.bp4-intent-primary{
  color:#215db0;
}
.bp4-menu-item.bp4-intent-primary::before,
.bp4-menu-item.bp4-intent-primary .bp4-menu-item-icon,
.bp4-menu-item.bp4-intent-primary .bp4-submenu-icon,
.bp4-menu-item.bp4-intent-primary .bp4-menu-item-label{
  color:inherit;
}
.bp4-menu-item.bp4-intent-primary:hover{
  background-color:rgba(45, 114, 210, 0.1);
}
.bp4-menu-item.bp4-intent-primary:active, .bp4-menu-item.bp4-intent-primary.bp4-active{
  background-color:rgba(45, 114, 210, 0.2);
  color:#184a90;
}
.bp4-menu-item.bp4-intent-success{
  color:#1c6e42;
}
.bp4-menu-item.bp4-intent-success::before,
.bp4-menu-item.bp4-intent-success .bp4-menu-item-icon,
.bp4-menu-item.bp4-intent-success .bp4-submenu-icon,
.bp4-menu-item.bp4-intent-success .bp4-menu-item-label{
  color:inherit;
}
.bp4-menu-item.bp4-intent-success:hover{
  background-color:rgba(35, 133, 81, 0.1);
}
.bp4-menu-item.bp4-intent-success:active, .bp4-menu-item.bp4-intent-success.bp4-active{
  background-color:rgba(35, 133, 81, 0.2);
  color:#165a36;
}
.bp4-menu-item.bp4-intent-warning{
  color:#935610;
}
.bp4-menu-item.bp4-intent-warning::before,
.bp4-menu-item.bp4-intent-warning .bp4-menu-item-icon,
.bp4-menu-item.bp4-intent-warning .bp4-submenu-icon,
.bp4-menu-item.bp4-intent-warning .bp4-menu-item-label{
  color:inherit;
}
.bp4-menu-item.bp4-intent-warning:hover{
  background-color:rgba(200, 118, 25, 0.1);
}
.bp4-menu-item.bp4-intent-warning:active, .bp4-menu-item.bp4-intent-warning.bp4-active{
  background-color:rgba(200, 118, 25, 0.2);
  color:#77450d;
}
.bp4-menu-item.bp4-intent-danger{
  color:#ac2f33;
}
.bp4-menu-item.bp4-intent-danger::before,
.bp4-menu-item.bp4-intent-danger .bp4-menu-item-icon,
.bp4-menu-item.bp4-intent-danger .bp4-submenu-icon,
.bp4-menu-item.bp4-intent-danger .bp4-menu-item-label{
  color:inherit;
}
.bp4-menu-item.bp4-intent-danger:hover{
  background-color:rgba(205, 66, 70, 0.1);
}
.bp4-menu-item.bp4-intent-danger:active, .bp4-menu-item.bp4-intent-danger.bp4-active{
  background-color:rgba(205, 66, 70, 0.2);
  color:#8e292c;
}
.bp4-menu-item::before{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  margin-right:7px;
}
.bp4-large .bp4-menu-item{
  font-size:16px;
  line-height:22px;
  padding:9px 7px;
}
.bp4-large .bp4-menu-item .bp4-menu-item-icon{
  height:22px;
}
.bp4-large .bp4-menu-item::before,
.bp4-large .bp4-menu-item .bp4-submenu-icon{
  margin-top:3px;
}
.bp4-large .bp4-menu-item::before{
  font-family:"blueprint-icons-20", sans-serif;
  font-size:20px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  margin-right:10px;
}

button.bp4-menu-item{
  background:none;
  border:none;
  text-align:left;
  width:100%;
}
.bp4-menu-header{
  border-top:1px solid rgba(17, 20, 24, 0.15);
  display:block;
  margin:5px;
  cursor:default;
  padding-left:2px;
}
.bp4-dark .bp4-menu-header{
  border-top-color:rgba(255, 255, 255, 0.2);
}
.bp4-menu-header:first-of-type{
  border-top:none;
}
.bp4-menu-header > h6{
  color:#1c2127;
  font-weight:600;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  line-height:17px;
  margin:0;
  padding:10px 7px 0 1px;
}
.bp4-dark .bp4-menu-header > h6{
  color:#f6f7f9;
}
.bp4-menu-header:first-of-type > h6{
  padding-top:0;
}
.bp4-large .bp4-menu-header > h6{
  font-size:18px;
  padding-bottom:5px;
  padding-top:15px;
}
.bp4-large .bp4-menu-header:first-of-type > h6{
  padding-top:0;
}

.bp4-dark .bp4-menu{
  background:#2f343c;
  color:#f6f7f9;
}
.bp4-dark .bp4-menu-item{
  color:inherit;
}
.bp4-dark .bp4-menu-item .bp4-menu-item-label{
  color:#abb3bf;
}
.bp4-dark .bp4-menu-item::before,
.bp4-dark .bp4-menu-item .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item .bp4-submenu-icon{
  color:#abb3bf;
}
.bp4-dark .bp4-menu-item:hover{
  color:inherit;
}
.bp4-dark .bp4-menu-item:hover .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item:hover .bp4-submenu-icon{
  color:#abb3bf;
}
.bp4-dark .bp4-menu-item:hover.ns-selected{
  background-color:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-menu-item:hover.ns-selected::before,
.bp4-dark .bp4-menu-item:hover.ns-selected .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item:hover.ns-selected .bp4-submenu-icon{
  color:#8abbff;
}
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success::before,
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning::before,
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger::before,
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-menu-item:hover.ns-selected{
    background-color:highlight;
  }
}
.bp4-dark .bp4-menu-item:active .bp4-menu-item-label, .bp4-dark .bp4-menu-item.bp4-active .bp4-menu-item-label{
  color:#f6f7f9;
}
.bp4-dark .bp4-menu-item.bp4-selected, .bp4-dark .bp4-menu-item.bp4-selected:hover, .bp4-dark .bp4-menu-item.bp4-selected:active{
  background-color:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-menu-item.bp4-selected::before,
.bp4-dark .bp4-menu-item.bp4-selected .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover::before,
.bp4-dark .bp4-menu-item.bp4-selected:hover .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:hover .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active::before,
.bp4-dark .bp4-menu-item.bp4-selected:active .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:active .bp4-submenu-icon{
  color:#8abbff;
}
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success::before,
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success::before,
.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success::before,
.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning::before,
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning::before,
.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning::before,
.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-submenu-icon{
  color:inherit;
}
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger::before,
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger::before,
.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger::before,
.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-submenu-icon{
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-menu-item.bp4-selected, .bp4-dark .bp4-menu-item.bp4-selected:hover, .bp4-dark .bp4-menu-item.bp4-selected:active{
    background-color:highlight;
  }
}
.bp4-dark .bp4-menu-item.bp4-disabled{
  color:rgba(171, 179, 191, 0.6) !important;
}
.bp4-dark .bp4-menu-item.bp4-disabled::before,
.bp4-dark .bp4-menu-item.bp4-disabled .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-disabled .bp4-submenu-icon{
  color:rgba(171, 179, 191, 0.6) !important;
}
.bp4-dark .bp4-menu-item.bp4-disabled .bp4-menu-item-label{
  color:rgba(171, 179, 191, 0.6) !important;
}
.bp4-dark .bp4-menu-item.bp4-intent-primary{
  color:#8abbff;
}
.bp4-dark .bp4-menu-item.bp4-intent-primary::before,
.bp4-dark .bp4-menu-item.bp4-intent-primary .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-intent-primary .bp4-submenu-icon,
.bp4-dark .bp4-menu-item.bp4-intent-primary .bp4-menu-item-label{
  color:inherit;
}
.bp4-dark .bp4-menu-item.bp4-intent-primary:hover{
  background-color:rgba(45, 114, 210, 0.2);
}
.bp4-dark .bp4-menu-item.bp4-intent-primary:active, .bp4-dark .bp4-menu-item.bp4-intent-primary.bp4-active{
  background-color:rgba(45, 114, 210, 0.3);
  color:#99c4ff;
}
.bp4-dark .bp4-menu-item.bp4-intent-success{
  color:#72ca9b;
}
.bp4-dark .bp4-menu-item.bp4-intent-success::before,
.bp4-dark .bp4-menu-item.bp4-intent-success .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-intent-success .bp4-submenu-icon,
.bp4-dark .bp4-menu-item.bp4-intent-success .bp4-menu-item-label{
  color:inherit;
}
.bp4-dark .bp4-menu-item.bp4-intent-success:hover{
  background-color:rgba(35, 133, 81, 0.2);
}
.bp4-dark .bp4-menu-item.bp4-intent-success:active, .bp4-dark .bp4-menu-item.bp4-intent-success.bp4-active{
  background-color:rgba(35, 133, 81, 0.3);
  color:#7cd7a2;
}
.bp4-dark .bp4-menu-item.bp4-intent-warning{
  color:#fbb360;
}
.bp4-dark .bp4-menu-item.bp4-intent-warning::before,
.bp4-dark .bp4-menu-item.bp4-intent-warning .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-intent-warning .bp4-submenu-icon,
.bp4-dark .bp4-menu-item.bp4-intent-warning .bp4-menu-item-label{
  color:inherit;
}
.bp4-dark .bp4-menu-item.bp4-intent-warning:hover{
  background-color:rgba(200, 118, 25, 0.2);
}
.bp4-dark .bp4-menu-item.bp4-intent-warning:active, .bp4-dark .bp4-menu-item.bp4-intent-warning.bp4-active{
  background-color:rgba(200, 118, 25, 0.3);
  color:#f5c186;
}
.bp4-dark .bp4-menu-item.bp4-intent-danger{
  color:#fa999c;
}
.bp4-dark .bp4-menu-item.bp4-intent-danger::before,
.bp4-dark .bp4-menu-item.bp4-intent-danger .bp4-menu-item-icon,
.bp4-dark .bp4-menu-item.bp4-intent-danger .bp4-submenu-icon,
.bp4-dark .bp4-menu-item.bp4-intent-danger .bp4-menu-item-label{
  color:inherit;
}
.bp4-dark .bp4-menu-item.bp4-intent-danger:hover{
  background-color:rgba(205, 66, 70, 0.2);
}
.bp4-dark .bp4-menu-item.bp4-intent-danger:active, .bp4-dark .bp4-menu-item.bp4-intent-danger.bp4-active{
  background-color:rgba(205, 66, 70, 0.3);
  color:#ffa1a4;
}
.bp4-dark .bp4-menu-divider,
.bp4-dark .bp4-menu-header{
  border-color:rgba(255, 255, 255, 0.2);
}
.bp4-dark .bp4-menu-header > h6{
  color:#f6f7f9;
}

.bp4-label .bp4-menu{
  margin-top:5px;
}
.bp4-navbar{
  background-color:#ffffff;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);
  height:50px;
  padding:0 15px;
  position:relative;
  width:100%;
  z-index:10;
}
.bp4-navbar.bp4-dark, .bp4-dark .bp4-navbar{
  background-color:#383e47;
}
.bp4-navbar.bp4-dark{
  box-shadow:inset inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-navbar{
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);
}
.bp4-navbar.bp4-fixed-top{
  left:0;
  position:fixed;
  right:0;
  top:0;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-navbar{
    border:1px solid buttonborder;
  }
}

.bp4-navbar-heading{
  font-size:16px;
  margin-right:15px;
}

.bp4-navbar-group{
  align-items:center;
  display:flex;
  height:50px;
}
.bp4-navbar-group.bp4-align-left{
  float:left;
}
.bp4-navbar-group.bp4-align-right{
  float:right;
}

.bp4-navbar-divider{
  border-left:1px solid rgba(17, 20, 24, 0.15);
  height:20px;
  margin:0 10px;
}
.bp4-dark .bp4-navbar-divider{
  border-left-color:rgba(255, 255, 255, 0.2);
}
.bp4-non-ideal-state{
  display:flex;
  flex-direction:column;
  align-items:center;
  color:#5f6b7c;
  height:100%;
  justify-content:center;
  text-align:center;
  width:100%;
}
.bp4-non-ideal-state > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-non-ideal-state > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-non-ideal-state::before,
.bp4-non-ideal-state > *{
  margin-bottom:20px;
}
.bp4-non-ideal-state:empty::before,
.bp4-non-ideal-state > :last-child{
  margin-bottom:0;
}
.bp4-non-ideal-state > *{
  max-width:400px;
}
.bp4-non-ideal-state .bp4-heading{
  color:#5f6b7c;
  line-height:20px;
  margin-bottom:10px;
}
.bp4-non-ideal-state .bp4-heading:only-child{
  margin-bottom:0;
}
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal{
  display:flex;
  flex-direction:row;
  text-align:left;
}
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal::before,
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > *{
  margin-right:20px;
}
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal:empty::before,
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > :last-child{
  margin-right:0;
}
.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > *{
  margin-bottom:0;
}
.bp4-dark .bp4-non-ideal-state{
  color:#abb3bf;
}
.bp4-dark .bp4-non-ideal-state .bp4-heading{
  color:#abb3bf;
}

.bp4-non-ideal-state-visual{
  color:#8f99a8;
}
.bp4-non-ideal-state-visual .bp4-icon svg{
  fill-opacity:15%;
  overflow:visible;
}
.bp4-non-ideal-state-visual .bp4-icon svg path{
  stroke:#8f99a8;
  stroke-opacity:50%;
  stroke-width:0.5px;
}
.bp4-dark .bp4-non-ideal-state-visual .bp4-icon svg{
  fill-opacity:20%;
}

.bp4-overflow-list{
  display:flex;
  flex-wrap:nowrap;
  min-width:0;
}

.bp4-overflow-list-spacer{
  flex-shrink:1;
  width:1px;
}
body.bp4-overlay-open{
  overflow:hidden;
}

.bp4-overlay{
  bottom:0;
  left:0;
  position:static;
  right:0;
  top:0;
  z-index:20;
}
.bp4-overlay:not(.bp4-overlay-open){
  pointer-events:none;
}
.bp4-overlay.bp4-overlay-container{
  overflow:hidden;
  position:fixed;
}
.bp4-overlay.bp4-overlay-container.bp4-overlay-inline{
  position:absolute;
}
.bp4-overlay.bp4-overlay-scroll-container{
  overflow:auto;
  position:fixed;
}
.bp4-overlay.bp4-overlay-scroll-container.bp4-overlay-inline{
  position:absolute;
}
.bp4-overlay.bp4-overlay-inline{
  display:inline;
  overflow:visible;
}

.bp4-overlay-content{
  position:fixed;
  z-index:20;
}
.bp4-overlay-inline .bp4-overlay-content, .bp4-overlay-scroll-container .bp4-overlay-content{
  position:absolute;
}

.bp4-overlay-backdrop{
  bottom:0;
  left:0;
  position:fixed;
  right:0;
  top:0;
  opacity:1;
  background-color:rgba(17, 20, 24, 0.7);
  overflow:auto;
  -webkit-user-select:none;
          user-select:none;
  z-index:20;
}
.bp4-overlay-backdrop.bp4-overlay-enter, .bp4-overlay-backdrop.bp4-overlay-appear{
  opacity:0;
}
.bp4-overlay-backdrop.bp4-overlay-enter-active, .bp4-overlay-backdrop.bp4-overlay-appear-active{
  opacity:1;
  transition-delay:0;
  transition-duration:200ms;
  transition-property:opacity;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-overlay-backdrop.bp4-overlay-exit{
  opacity:1;
}
.bp4-overlay-backdrop.bp4-overlay-exit-active{
  opacity:0;
  transition-delay:0;
  transition-duration:200ms;
  transition-property:opacity;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-overlay-backdrop:focus{
  outline:none;
}
.bp4-overlay-inline .bp4-overlay-backdrop{
  position:absolute;
}
.bp4-panel-stack{
  overflow:hidden;
  position:relative;
}

.bp4-panel-stack-header{
  align-items:center;
  box-shadow:0 1px rgba(17, 20, 24, 0.15);
  display:flex;
  flex-shrink:0;
  height:30px;
  z-index:1;
}
.bp4-dark .bp4-panel-stack-header{
  box-shadow:0 1px rgba(255, 255, 255, 0.2);
}
.bp4-panel-stack-header > span{
  align-items:stretch;
  display:flex;
  flex:1 1;
}
.bp4-panel-stack-header .bp4-heading{
  margin:0 5px;
}

.bp4-button.bp4-panel-stack-header-back{
  margin-left:5px;
  padding-left:0;
  white-space:nowrap;
}
.bp4-button.bp4-panel-stack-header-back .bp4-icon{
  margin:0 2px;
}

.bp4-panel-stack-view{
  bottom:0;
  left:0;
  position:absolute;
  right:0;
  top:0;
  background-color:#ffffff;
  border-right:1px solid rgba(17, 20, 24, 0.15);
  display:flex;
  flex-direction:column;
  margin-right:-1px;
  overflow-y:auto;
  z-index:1;
}
.bp4-dark .bp4-panel-stack-view{
  background-color:#383e47;
}
.bp4-panel-stack-view:nth-last-child(n+4){
  display:none;
}

.bp4-panel-stack-push .bp4-panel-stack-enter, .bp4-panel-stack-push .bp4-panel-stack-appear{
  transform:translateX(100%);
  opacity:0;
}
.bp4-panel-stack-push .bp4-panel-stack-enter-active, .bp4-panel-stack-push .bp4-panel-stack-appear-active{
  transform:translate(0%);
  opacity:1;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}
.bp4-panel-stack-push .bp4-panel-stack-exit{
  transform:translate(0%);
  opacity:1;
}
.bp4-panel-stack-push .bp4-panel-stack-exit-active{
  transform:translateX(-50%);
  opacity:0;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}

.bp4-panel-stack-pop .bp4-panel-stack-enter, .bp4-panel-stack-pop .bp4-panel-stack-appear{
  transform:translateX(-50%);
  opacity:0;
}
.bp4-panel-stack-pop .bp4-panel-stack-enter-active, .bp4-panel-stack-pop .bp4-panel-stack-appear-active{
  transform:translate(0%);
  opacity:1;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}
.bp4-panel-stack-pop .bp4-panel-stack-exit{
  transform:translate(0%);
  opacity:1;
}
.bp4-panel-stack-pop .bp4-panel-stack-exit-active{
  transform:translateX(100%);
  opacity:0;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}
.bp4-panel-stack2{
  overflow:hidden;
  position:relative;
}

.bp4-panel-stack2-header{
  align-items:center;
  box-shadow:0 1px rgba(17, 20, 24, 0.15);
  display:flex;
  flex-shrink:0;
  height:30px;
  z-index:1;
}
.bp4-dark .bp4-panel-stack2-header{
  box-shadow:0 1px rgba(255, 255, 255, 0.2);
}
.bp4-panel-stack2-header > span{
  align-items:stretch;
  display:flex;
  flex:1 1;
}
.bp4-panel-stack2-header .bp4-heading{
  margin:0 5px;
}

.bp4-button.bp4-panel-stack2-header-back{
  margin-left:5px;
  padding-left:0;
  white-space:nowrap;
}
.bp4-button.bp4-panel-stack2-header-back .bp4-icon{
  margin:0 2px;
}

.bp4-panel-stack2-view{
  bottom:0;
  left:0;
  position:absolute;
  right:0;
  top:0;
  background-color:#ffffff;
  border-right:1px solid rgba(17, 20, 24, 0.15);
  display:flex;
  flex-direction:column;
  margin-right:-1px;
  overflow-y:auto;
  z-index:1;
}
.bp4-dark .bp4-panel-stack2-view{
  background-color:#383e47;
}
.bp4-panel-stack2-view:nth-last-child(n+4){
  display:none;
}

.bp4-panel-stack2-push .bp4-panel-stack2-enter, .bp4-panel-stack2-push .bp4-panel-stack2-appear{
  transform:translateX(100%);
  opacity:0;
}
.bp4-panel-stack2-push .bp4-panel-stack2-enter-active, .bp4-panel-stack2-push .bp4-panel-stack2-appear-active{
  transform:translate(0%);
  opacity:1;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}
.bp4-panel-stack2-push .bp4-panel-stack2-exit{
  transform:translate(0%);
  opacity:1;
}
.bp4-panel-stack2-push .bp4-panel-stack2-exit-active{
  transform:translateX(-50%);
  opacity:0;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}

.bp4-panel-stack2-pop .bp4-panel-stack2-enter, .bp4-panel-stack2-pop .bp4-panel-stack2-appear{
  transform:translateX(-50%);
  opacity:0;
}
.bp4-panel-stack2-pop .bp4-panel-stack2-enter-active, .bp4-panel-stack2-pop .bp4-panel-stack2-appear-active{
  transform:translate(0%);
  opacity:1;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}
.bp4-panel-stack2-pop .bp4-panel-stack2-exit{
  transform:translate(0%);
  opacity:1;
}
.bp4-panel-stack2-pop .bp4-panel-stack2-exit-active{
  transform:translateX(100%);
  opacity:0;
  transition-delay:0;
  transition-duration:400ms;
  transition-property:transform, opacity;
  transition-timing-function:ease;
}
.bp4-popover{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
  transform:scale(1);
  border-radius:2px;
  display:inline-block;
  z-index:20;
}
.bp4-popover .bp4-popover-arrow{
  height:30px;
  position:absolute;
  width:30px;
}
.bp4-popover .bp4-popover-arrow::before{
  height:20px;
  margin:5px;
  width:20px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-popover{
  margin-bottom:17px;
  margin-top:-17px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-popover > .bp4-popover-arrow{
  bottom:-11px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-popover > .bp4-popover-arrow svg{
  transform:rotate(-90deg);
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-popover{
  margin-left:17px;
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-popover > .bp4-popover-arrow{
  left:-11px;
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-popover > .bp4-popover-arrow svg{
  transform:rotate(0);
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-popover{
  margin-top:17px;
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-popover > .bp4-popover-arrow{
  top:-11px;
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-popover > .bp4-popover-arrow svg{
  transform:rotate(90deg);
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-popover{
  margin-left:-17px;
  margin-right:17px;
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-popover > .bp4-popover-arrow{
  right:-11px;
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-popover > .bp4-popover-arrow svg{
  transform:rotate(180deg);
}
.bp4-tether-element-attached-middle > .bp4-popover > .bp4-popover-arrow{
  top:50%;
  transform:translateY(-50%);
}
.bp4-tether-element-attached-center > .bp4-popover > .bp4-popover-arrow{
  right:50%;
  transform:translateX(50%);
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-top > .bp4-popover > .bp4-popover-arrow{
  top:-0.3933982644px;
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-right > .bp4-popover > .bp4-popover-arrow{
  right:-0.3933982644px;
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-left > .bp4-popover > .bp4-popover-arrow{
  left:-0.3933982644px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-bottom > .bp4-popover > .bp4-popover-arrow{
  bottom:-0.3933982644px;
}
.bp4-tether-element-attached-top.bp4-tether-element-attached-left > .bp4-popover{
  transform-origin:top left;
}
.bp4-tether-element-attached-top.bp4-tether-element-attached-center > .bp4-popover{
  transform-origin:top center;
}
.bp4-tether-element-attached-top.bp4-tether-element-attached-right > .bp4-popover{
  transform-origin:top right;
}
.bp4-tether-element-attached-middle.bp4-tether-element-attached-left > .bp4-popover{
  transform-origin:center left;
}
.bp4-tether-element-attached-middle.bp4-tether-element-attached-center > .bp4-popover{
  transform-origin:center center;
}
.bp4-tether-element-attached-middle.bp4-tether-element-attached-right > .bp4-popover{
  transform-origin:center right;
}
.bp4-tether-element-attached-bottom.bp4-tether-element-attached-left > .bp4-popover{
  transform-origin:bottom left;
}
.bp4-tether-element-attached-bottom.bp4-tether-element-attached-center > .bp4-popover{
  transform-origin:bottom center;
}
.bp4-tether-element-attached-bottom.bp4-tether-element-attached-right > .bp4-popover{
  transform-origin:bottom right;
}
.bp4-popover .bp4-popover-content{
  background:#ffffff;
}
.bp4-popover .bp4-popover-content,
.bp4-popover .bp4-heading{
  color:inherit;
}
.bp4-popover .bp4-popover-arrow::before{
  box-shadow:1px 1px 6px rgba(17, 20, 24, 0.2);
}
.bp4-popover .bp4-popover-arrow-border{
  fill:#111418;
  fill-opacity:0.1;
}
.bp4-popover .bp4-popover-arrow-fill{
  fill:#ffffff;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-popover .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}
.bp4-popover-enter > .bp4-popover, .bp4-popover-appear > .bp4-popover{
  transform:scale(0.3);
}
.bp4-popover-enter-active > .bp4-popover, .bp4-popover-appear-active > .bp4-popover{
  transform:scale(1);
  transition-delay:0;
  transition-duration:300ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.54, 1.12, 0.38, 1.11);
}
.bp4-popover-exit > .bp4-popover{
  transform:scale(1);
}
.bp4-popover-exit-active > .bp4-popover{
  transform:scale(0.3);
  transition-delay:0;
  transition-duration:300ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.54, 1.12, 0.38, 1.11);
}
.bp4-popover .bp4-popover-content{
  border-radius:2px;
  position:relative;
}
.bp4-popover.bp4-popover-content-sizing .bp4-popover-content{
  max-width:350px;
  padding:20px;
}
.bp4-popover-target + .bp4-overlay .bp4-popover.bp4-popover-content-sizing{
  width:350px;
}
.bp4-popover.bp4-minimal{
  margin:0 !important;
}
.bp4-popover.bp4-minimal .bp4-popover-arrow{
  display:none;
}
.bp4-popover.bp4-minimal.bp4-popover{
  transform:scale(1);
}
.bp4-popover-enter > .bp4-popover.bp4-minimal.bp4-popover, .bp4-popover-appear > .bp4-popover.bp4-minimal.bp4-popover{
  transform:scale(1);
}
.bp4-popover-enter-active > .bp4-popover.bp4-minimal.bp4-popover, .bp4-popover-appear-active > .bp4-popover.bp4-minimal.bp4-popover{
  transform:scale(1);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-popover-exit > .bp4-popover.bp4-minimal.bp4-popover{
  transform:scale(1);
}
.bp4-popover-exit-active > .bp4-popover.bp4-minimal.bp4-popover{
  transform:scale(1);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-popover.bp4-dark, .bp4-dark .bp4-popover{
  box-shadow:0 0 0 1px hsl(215, 3%, 38%), inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
}
.bp4-popover.bp4-dark .bp4-popover-content, .bp4-dark .bp4-popover .bp4-popover-content{
  background:#2f343c;
}
.bp4-popover.bp4-dark .bp4-popover-content,
.bp4-popover.bp4-dark .bp4-heading, .bp4-dark .bp4-popover .bp4-popover-content,
.bp4-dark .bp4-popover .bp4-heading{
  color:inherit;
}
.bp4-popover.bp4-dark .bp4-popover-arrow::before, .bp4-dark .bp4-popover .bp4-popover-arrow::before{
  box-shadow:0 0 0 1px #777a7e, 1px 1px 6px rgba(17, 20, 24, 0.4);
}
.bp4-popover.bp4-dark .bp4-popover-arrow-border, .bp4-dark .bp4-popover .bp4-popover-arrow-border{
  fill:#111418;
  fill-opacity:0.2;
}
.bp4-popover.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-popover .bp4-popover-arrow-fill{
  fill:#2f343c;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-popover.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-popover .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-popover{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}

.bp4-popover-arrow::before{
  border-radius:1px;
  content:"";
  display:block;
  position:absolute;
  transform:rotate(45deg);
}

.bp4-tether-pinned .bp4-popover-arrow{
  display:none;
}

.bp4-popover-backdrop{
  background:rgba(255, 255, 255, 0);
}

.bp4-transition-container{
  opacity:1;
  display:flex;
  z-index:20;
}
.bp4-transition-container.bp4-popover-enter, .bp4-transition-container.bp4-popover-appear{
  opacity:0;
}
.bp4-transition-container.bp4-popover-enter-active, .bp4-transition-container.bp4-popover-appear-active{
  opacity:1;
  transition-delay:0;
  transition-duration:100ms;
  transition-property:opacity;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-transition-container.bp4-popover-exit{
  opacity:1;
}
.bp4-transition-container.bp4-popover-exit-active{
  opacity:0;
  transition-delay:0;
  transition-duration:100ms;
  transition-property:opacity;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-transition-container:focus{
  outline:none;
}
.bp4-transition-container.bp4-popover-leave .bp4-popover-content{
  pointer-events:none;
}
.bp4-transition-container[data-x-out-of-boundaries]{
  display:none;
}

span.bp4-popover-target{
  display:inline-block;
}

.bp4-popover-wrapper.bp4-fill{
  width:100%;
}

.bp4-portal{
  left:0;
  position:absolute;
  right:0;
  top:0;
}
@keyframes linear-progress-bar-stripes{
  from{
    background-position:0 0;
  }
  to{
    background-position:30px 0;
  }
}
.bp4-progress-bar{
  background:rgba(95, 107, 124, 0.2);
  border-radius:40px;
  display:block;
  height:8px;
  overflow:hidden;
  position:relative;
  width:100%;
}
.bp4-progress-bar .bp4-progress-meter{
  background:linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%);
  background-color:rgba(95, 107, 124, 0.8);
  background-size:30px 30px;
  border-radius:40px;
  height:100%;
  position:absolute;
  transition:width 200ms cubic-bezier(0.4, 1, 0.75, 0.9);
  width:100%;
}
.bp4-progress-bar:not(.bp4-no-animation):not(.bp4-no-stripes) .bp4-progress-meter{
  animation:linear-progress-bar-stripes 300ms linear infinite reverse;
}
.bp4-progress-bar.bp4-no-stripes .bp4-progress-meter{
  background-image:none;
}

.bp4-dark .bp4-progress-bar{
  background:rgba(17, 20, 24, 0.5);
}
.bp4-dark .bp4-progress-bar .bp4-progress-meter{
  background-color:#8f99a8;
}

.bp4-progress-bar.bp4-intent-primary .bp4-progress-meter{
  background-color:#2d72d2;
}

.bp4-progress-bar.bp4-intent-success .bp4-progress-meter{
  background-color:#238551;
}

.bp4-progress-bar.bp4-intent-warning .bp4-progress-meter{
  background-color:#c87619;
}

.bp4-progress-bar.bp4-intent-danger .bp4-progress-meter{
  background-color:#cd4246;
}
@keyframes skeleton-glow{
  from{
    background:rgba(211, 216, 222, 0.2);
    border-color:rgba(211, 216, 222, 0.2);
  }
  to{
    background:rgba(95, 107, 124, 0.2);
    border-color:rgba(95, 107, 124, 0.2);
  }
}
.bp4-skeleton{
  animation:1000ms linear infinite alternate skeleton-glow;
  background:rgba(211, 216, 222, 0.2);
  background-clip:padding-box !important;
  border-color:rgba(211, 216, 222, 0.2) !important;
  border-radius:2px;
  box-shadow:none !important;
  color:transparent !important;
  cursor:default;
  pointer-events:none;
  -webkit-user-select:none;
          user-select:none;
}
.bp4-skeleton::before, .bp4-skeleton::after,
.bp4-skeleton *{
  visibility:hidden !important;
}
.bp4-slider{
  height:40px;
  min-width:150px;
  width:100%;
  cursor:default;
  outline:none;
  position:relative;
  -webkit-user-select:none;
          user-select:none;
}
.bp4-slider:hover{
  cursor:pointer;
}
.bp4-slider:active{
  cursor:grabbing;
}
.bp4-slider.bp4-disabled{
  cursor:not-allowed;
  opacity:0.5;
}
.bp4-slider.bp4-slider-unlabeled{
  height:16px;
}

.bp4-slider-track,
.bp4-slider-progress{
  height:6px;
  left:0;
  right:0;
  top:5px;
  position:absolute;
}

.bp4-slider-track{
  border-radius:2px;
  overflow:hidden;
}

.bp4-slider-progress{
  background:rgba(95, 107, 124, 0.2);
}
.bp4-dark .bp4-slider-progress{
  background:rgba(17, 20, 24, 0.5);
}
.bp4-slider-progress.bp4-intent-primary{
  background-color:#2d72d2;
}
.bp4-slider-progress.bp4-intent-success{
  background-color:#238551;
}
.bp4-slider-progress.bp4-intent-warning{
  background-color:#c87619;
}
.bp4-slider-progress.bp4-intent-danger{
  background-color:#cd4246;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-slider-progress{
    background:ButtonText;
  }
}

.bp4-slider-handle{
  background-color:#f6f7f9;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);
  color:#1c2127;
  border-radius:2px;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.5), 0 1px 1px rgba(17, 20, 24, 0.5);
  cursor:pointer;
  height:16px;
  left:0;
  position:absolute;
  top:0;
  width:16px;
}
.bp4-slider-handle:hover{
  background-clip:padding-box;
  background-color:#edeff2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-slider-handle:active, .bp4-slider-handle.bp4-active{
  background-color:#dce0e5;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-slider-handle:active, .bp4-slider-handle.bp4-active{
    background:highlight;
  }
}
.bp4-slider-handle:disabled, .bp4-slider-handle.bp4-disabled{
  background-color:rgba(211, 216, 222, 0.5);
  box-shadow:none;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
  outline:none;
}
.bp4-slider-handle:disabled.bp4-active, .bp4-slider-handle:disabled.bp4-active:hover, .bp4-slider-handle.bp4-disabled.bp4-active, .bp4-slider-handle.bp4-disabled.bp4-active:hover{
  background:rgba(211, 216, 222, 0.7);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-slider-handle{
    border:1px solid buttonborder;
  }
}
.bp4-slider-handle:focus{
  z-index:1;
}
.bp4-slider-handle:hover{
  background-clip:padding-box;
  background-color:#edeff2;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.5), 0 1px 2px rgba(17, 20, 24, 0.6);
  cursor:grab;
  z-index:2;
}
.bp4-slider-handle.bp4-active{
  background-color:#dce0e5;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);
  box-shadow:inset 0 1px 1px rgba(17, 20, 24, 0.1), 0 0 0 1px rgba(17, 20, 24, 0.5), 0 1px 2px rgba(17, 20, 24, 0.2);
  cursor:grabbing;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-slider-handle.bp4-active{
    background:highlight;
  }
}
.bp4-disabled .bp4-slider-handle{
  background:#c5cbd3;
  box-shadow:none;
  pointer-events:none;
}
.bp4-dark .bp4-slider-handle{
  background-color:#abb3bf;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);
}
.bp4-dark .bp4-slider-handle:hover{
  background-color:#8f99a8;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-slider-handle.bp4-active{
  background-color:#738091;
  box-shadow:inset 0 1px 1px rgba(17, 20, 24, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);
}
.bp4-dark .bp4-disabled .bp4-slider-handle{
  background:#5f6b7c;
  border-color:#5f6b7c;
  box-shadow:none;
}
.bp4-slider-handle .bp4-slider-label{
  background:#404854;
  border-radius:2px;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
  color:#f6f7f9;
  margin-left:8px;
}
.bp4-dark .bp4-slider-handle .bp4-slider-label{
  background:#e5e8eb;
  box-shadow:0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
  color:#404854;
}
.bp4-disabled .bp4-slider-handle .bp4-slider-label{
  box-shadow:none;
}
.bp4-slider-handle.bp4-start, .bp4-slider-handle.bp4-end{
  width:8px;
}
.bp4-slider-handle.bp4-start{
  border-bottom-right-radius:0;
  border-top-right-radius:0;
}
.bp4-slider-handle.bp4-end{
  border-bottom-left-radius:0;
  border-top-left-radius:0;
  margin-left:8px;
}
.bp4-slider-handle.bp4-end .bp4-slider-label{
  margin-left:0;
}

.bp4-slider-label{
  transform:translate(-50%, 20px);
  display:inline-block;
  font-size:12px;
  line-height:1;
  padding:2px 5px;
  position:absolute;
  vertical-align:top;
}

.bp4-slider.bp4-vertical{
  height:150px;
  min-width:40px;
  width:40px;
}
.bp4-slider.bp4-vertical .bp4-slider-track,
.bp4-slider.bp4-vertical .bp4-slider-progress{
  bottom:0;
  height:auto;
  left:5px;
  top:0;
  width:6px;
}
.bp4-slider.bp4-vertical .bp4-slider-progress{
  top:auto;
}
.bp4-slider.bp4-vertical .bp4-slider-label{
  transform:translate(20px, 50%);
}
.bp4-slider.bp4-vertical .bp4-slider-handle{
  top:auto;
}
.bp4-slider.bp4-vertical .bp4-slider-handle .bp4-slider-label{
  margin-left:0;
  margin-top:-8px;
}
.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-end, .bp4-slider.bp4-vertical .bp4-slider-handle.bp4-start{
  height:8px;
  margin-left:0;
  width:16px;
}
.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-start{
  border-bottom-right-radius:2px;
  border-top-left-radius:0;
}
.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-start .bp4-slider-label{
  transform:translate(20px);
}
.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-end{
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
  border-top-left-radius:2px;
  margin-bottom:8px;
}
@keyframes pt-spinner-animation{
  from{
    transform:rotate(0deg);
  }
  to{
    transform:rotate(360deg);
  }
}
.bp4-spinner{
  align-items:center;
  display:flex;
  justify-content:center;
  overflow:visible;
  vertical-align:middle;
}
.bp4-spinner svg{
  display:block;
}
.bp4-spinner path{
  fill-opacity:0%;
}
.bp4-spinner .bp4-spinner-head{
  stroke:rgba(95, 107, 124, 0.8);
  stroke-linecap:round;
  transform-origin:center;
  transition:stroke-dashoffset 200ms cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-spinner .bp4-spinner-track{
  stroke:rgba(95, 107, 124, 0.2);
}

.bp4-spinner-animation{
  animation:pt-spinner-animation 500ms linear infinite;
}
.bp4-no-spin > .bp4-spinner-animation{
  animation:none;
}

.bp4-dark .bp4-spinner .bp4-spinner-head{
  stroke:#8f99a8;
}
.bp4-dark .bp4-spinner .bp4-spinner-track{
  stroke:rgba(17, 20, 24, 0.5);
}

.bp4-spinner.bp4-intent-primary .bp4-spinner-head{
  stroke:#2d72d2;
}

.bp4-spinner.bp4-intent-success .bp4-spinner-head{
  stroke:#238551;
}

.bp4-spinner.bp4-intent-warning .bp4-spinner-head{
  stroke:#c87619;
}

.bp4-spinner.bp4-intent-danger .bp4-spinner-head{
  stroke:#cd4246;
}
.bp4-tabs:not(.bp4-vertical).bp4-fill{
  height:100%;
}
.bp4-tabs:not(.bp4-vertical).bp4-fill .bp4-tab-list{
  height:100%;
}

.bp4-tabs.bp4-vertical{
  display:flex;
}
.bp4-tabs.bp4-vertical > .bp4-tab-list{
  align-items:flex-start;
  flex-direction:column;
}
.bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab{
  align-items:center;
  border-radius:2px;
  display:flex;
  padding:0 10px;
  width:100%;
}
.bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab[aria-selected=true]{
  background-color:rgba(45, 114, 210, 0.2);
  box-shadow:none;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab[aria-selected=true]{
    background-color:highlight;
    color:#111418;
  }
}
.bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab-indicator-wrapper .bp4-tab-indicator{
  background-color:rgba(45, 114, 210, 0.2);
  border-radius:2px;
  bottom:0;
  height:auto;
  left:0;
  right:0;
  top:0;
}
.bp4-tabs.bp4-vertical > .bp4-tab-panel{
  margin-top:0;
  padding-left:20px;
}

.bp4-tab-list{
  align-items:flex-end;
  border:none;
  display:flex;
  flex:0 0 auto;
  list-style:none;
  margin:0;
  padding:0;
  position:relative;
}
.bp4-tab-list > *:not(:last-child){
  margin-right:20px;
}

.bp4-tab{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  align-items:center;
  align-self:stretch;
  color:#1c2127;
  cursor:pointer;
  display:flex;
  flex:0 0 auto;
  font-size:14px;
  line-height:30px;
  max-width:100%;
  position:relative;
  vertical-align:top;
}
.bp4-tab a{
  color:inherit;
  display:block;
  text-decoration:none;
}
.bp4-tab-indicator-wrapper ~ .bp4-tab{
  background-color:transparent !important;
  box-shadow:none !important;
}
.bp4-tab[aria-disabled=true]{
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tab[aria-disabled=true]{
    color:graytext;
  }
}
.bp4-tab[aria-selected=true]{
  border-radius:0;
  box-shadow:inset 0 -3px 0 #215db0;
}
.bp4-tab[aria-selected=true], .bp4-tab:not([aria-disabled=true]):hover{
  color:#215db0;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tab[aria-selected=true], .bp4-tab:not([aria-disabled=true]):hover{
    color:highlight;
  }
}
.bp4-tab:focus{
  -moz-outline-radius:0;
}
.bp4-large > .bp4-tab{
  font-size:16px;
  line-height:40px;
}

.bp4-tab-panel{
  margin-top:20px;
}
.bp4-tab-panel[aria-hidden=true]{
  display:none;
}

.bp4-tab-icon{
  margin-right:7px;
}

.bp4-tab-tag{
  margin-left:7px;
}

.bp4-tab-indicator-wrapper{
  left:0;
  pointer-events:none;
  position:absolute;
  top:0;
  transform:translateX(0), translateY(0);
  transition:height, transform, width;
  transition-duration:200ms;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-tab-indicator-wrapper .bp4-tab-indicator{
  background-color:#215db0;
  bottom:0;
  height:3px;
  left:0;
  position:absolute;
  right:0;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tab-indicator-wrapper .bp4-tab-indicator{
    background-color:highlight;
  }
}
.bp4-tab-indicator-wrapper.bp4-no-animation{
  transition:none;
}
.bp4-tabs:not(.bp4-vertical) .bp4-tab-indicator-wrapper{
  height:100%;
}

.bp4-dark .bp4-tab{
  color:#f6f7f9;
}
.bp4-dark .bp4-tab[aria-disabled=true]{
  color:rgba(171, 179, 191, 0.6);
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-tab[aria-disabled=true]{
    color:graytext;
  }
}
.bp4-dark .bp4-tab[aria-selected=true]{
  box-shadow:inset 0 -3px 0 #8abbff;
}
.bp4-dark .bp4-tab[aria-selected=true], .bp4-dark .bp4-tab:not([aria-disabled=true]):hover{
  color:#8abbff;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-tab[aria-selected=true], .bp4-dark .bp4-tab:not([aria-disabled=true]):hover{
    color:highlight;
  }
}
.bp4-dark .bp4-tab-indicator{
  background-color:#8abbff;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-dark .bp4-tab-indicator{
    background-color:highlight;
  }
}

.bp4-flex-expander{
  flex:1 1;
}
.bp4-tag{
  display:inline-flex;
  flex-direction:row;
  align-items:center;
  background-color:#5f6b7c;
  border:none;
  border-radius:2px;
  box-shadow:none;
  color:#ffffff;
  font-size:12px;
  line-height:16px;
  max-width:100%;
  min-height:20px;
  min-width:20px;
  padding:2px 6px;
  position:relative;
}
.bp4-tag > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-tag > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-tag::before,
.bp4-tag > *{
  margin-right:4px;
}
.bp4-tag:empty::before,
.bp4-tag > :last-child{
  margin-right:0;
}
.bp4-tag:focus{
  outline:rgba(45, 114, 210, 0.6) solid 2px;
  outline-offset:0;
  -moz-outline-radius:6px;
}
.bp4-tag.bp4-interactive{
  cursor:pointer;
}
.bp4-tag.bp4-interactive:hover{
  background:#404854;
}
.bp4-tag.bp4-interactive:active, .bp4-tag.bp4-interactive.bp4-active{
  background:#383e47;
}
.bp4-tag.bp4-round{
  border-radius:30px;
  padding-left:8px;
  padding-right:8px;
}
.bp4-dark .bp4-tag{
  background-color:#c5cbd3;
  color:#1c2127;
}
.bp4-dark .bp4-tag > .bp4-icon, .bp4-dark .bp4-tag .bp4-icon-standard, .bp4-dark .bp4-tag .bp4-icon-large{
  fill:currentcolor;
}
.bp4-dark .bp4-tag.bp4-interactive:hover{
  background:#abb3bf;
}
.bp4-dark .bp4-tag.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-interactive.bp4-active{
  background:#8f99a8;
}
.bp4-tag > .bp4-icon, .bp4-tag .bp4-icon-standard, .bp4-tag .bp4-icon-large{
  fill:#ffffff;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tag{
    border:1px solid buttonborder;
  }
}
.bp4-tag.bp4-large, .bp4-large .bp4-tag{
  font-size:14px;
  line-height:20px;
  min-height:30px;
  min-width:30px;
  padding:5px 10px;
}
.bp4-tag.bp4-large::before,
.bp4-tag.bp4-large > *, .bp4-large .bp4-tag::before,
.bp4-large .bp4-tag > *{
  margin-right:7px;
}
.bp4-tag.bp4-large:empty::before,
.bp4-tag.bp4-large > :last-child, .bp4-large .bp4-tag:empty::before,
.bp4-large .bp4-tag > :last-child{
  margin-right:0;
}
.bp4-tag.bp4-large.bp4-round, .bp4-large .bp4-tag.bp4-round{
  padding-left:12px;
  padding-right:12px;
}
.bp4-tag.bp4-intent-primary{
  background:#2d72d2;
  color:#ffffff;
}
.bp4-tag.bp4-intent-primary.bp4-interactive:hover{
  background-color:#215db0;
}
.bp4-tag.bp4-intent-primary.bp4-interactive:active, .bp4-tag.bp4-intent-primary.bp4-interactive.bp4-active{
  background-color:#184a90;
}
.bp4-tag.bp4-intent-primary .bp4-tag-remove{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-tag.bp4-intent-primary .bp4-tag-remove:hover, .bp4-tag.bp4-intent-primary .bp4-tag-remove:active{
  color:#ffffff;
}
.bp4-tag.bp4-intent-success{
  background:#238551;
  color:#ffffff;
}
.bp4-tag.bp4-intent-success.bp4-interactive:hover{
  background-color:#1c6e42;
}
.bp4-tag.bp4-intent-success.bp4-interactive:active, .bp4-tag.bp4-intent-success.bp4-interactive.bp4-active{
  background-color:#165a36;
}
.bp4-tag.bp4-intent-success .bp4-tag-remove{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-tag.bp4-intent-success .bp4-tag-remove:hover, .bp4-tag.bp4-intent-success .bp4-tag-remove:active{
  color:#ffffff;
}
.bp4-tag.bp4-intent-warning{
  background:#fbb360;
  color:#1c2127;
}
.bp4-tag.bp4-intent-warning.bp4-interactive:hover{
  background-color:#ec9a3c;
}
.bp4-tag.bp4-intent-warning.bp4-interactive:active, .bp4-tag.bp4-intent-warning.bp4-interactive.bp4-active{
  background-color:#c87619;
}
.bp4-tag.bp4-intent-warning .bp4-tag-remove{
  color:rgba(28, 33, 39, 0.7);
}
.bp4-tag.bp4-intent-warning .bp4-tag-remove:hover, .bp4-tag.bp4-intent-warning .bp4-tag-remove:active{
  color:#1c2127;
}
.bp4-tag.bp4-intent-danger{
  background:#cd4246;
  color:#ffffff;
}
.bp4-tag.bp4-intent-danger.bp4-interactive:hover{
  background-color:#ac2f33;
}
.bp4-tag.bp4-intent-danger.bp4-interactive:active, .bp4-tag.bp4-intent-danger.bp4-interactive.bp4-active{
  background-color:#8e292c;
}
.bp4-tag.bp4-intent-danger .bp4-tag-remove{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-tag.bp4-intent-danger .bp4-tag-remove:hover, .bp4-tag.bp4-intent-danger .bp4-tag-remove:active{
  color:#ffffff;
}
.bp4-tag.bp4-fill{
  display:flex;
  width:100%;
}
.bp4-tag.bp4-minimal > .bp4-icon, .bp4-tag.bp4-minimal .bp4-icon-standard, .bp4-tag.bp4-minimal .bp4-icon-large{
  fill:#5f6b7c;
}
.bp4-tag.bp4-minimal:not([class*=bp4-intent-]){
  background-color:rgba(143, 153, 168, 0.15);
  color:#1c2127;
}
.bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive{
  cursor:pointer;
}
.bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:hover{
  background-color:rgba(143, 153, 168, 0.3);
  color:#111418;
}
.bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive.bp4-active, .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:active{
  background-color:rgba(143, 153, 168, 0.35);
  color:#111418;
}
.bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove{
  color:#5f6b7c;
}
.bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:hover, .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:active{
  color:#404854;
}
.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]){
  background-color:rgba(143, 153, 168, 0.15);
  color:#f6f7f9;
}
.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive{
  cursor:pointer;
}
.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:hover{
  background-color:rgba(143, 153, 168, 0.3);
  color:#ffffff;
}
.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive.bp4-active, .bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:active{
  background-color:rgba(143, 153, 168, 0.35);
  color:#ffffff;
}
.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove{
  color:#abb3bf;
}
.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:active{
  color:#d3d8de;
}
.bp4-tag.bp4-minimal.bp4-intent-primary{
  background-color:rgba(45, 114, 210, 0.1);
  color:#215db0;
}
.bp4-tag.bp4-minimal.bp4-intent-primary > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-icon-large{
  fill:#215db0;
}
.bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:hover{
  background-color:rgba(45, 114, 210, 0.2);
  color:#184a90;
}
.bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive.bp4-active{
  background-color:rgba(45, 114, 210, 0.3);
  color:#184a90;
}
.bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove{
  color:#215db0;
}
.bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:active{
  color:#184a90;
}
.bp4-tag.bp4-minimal.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.1);
  color:#1c6e42;
}
.bp4-tag.bp4-minimal.bp4-intent-success > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-success .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-success .bp4-icon-large{
  fill:#1c6e42;
}
.bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:hover{
  background-color:rgba(35, 133, 81, 0.2);
  color:#165a36;
}
.bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive.bp4-active{
  background-color:rgba(35, 133, 81, 0.3);
  color:#165a36;
}
.bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove{
  color:#1c6e42;
}
.bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:active{
  color:#165a36;
}
.bp4-tag.bp4-minimal.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.1);
  color:#935610;
}
.bp4-tag.bp4-minimal.bp4-intent-warning > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-icon-large{
  fill:#935610;
}
.bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:hover{
  background-color:rgba(200, 118, 25, 0.2);
  color:#77450d;
}
.bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive.bp4-active{
  background-color:rgba(200, 118, 25, 0.3);
  color:#77450d;
}
.bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove{
  color:#935610;
}
.bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:active{
  color:#77450d;
}
.bp4-tag.bp4-minimal.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.1);
  color:#ac2f33;
}
.bp4-tag.bp4-minimal.bp4-intent-danger > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-icon-large{
  fill:#ac2f33;
}
.bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:hover{
  background-color:rgba(205, 66, 70, 0.2);
  color:#8e292c;
}
.bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive.bp4-active{
  background-color:rgba(205, 66, 70, 0.3);
  color:#8e292c;
}
.bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove{
  color:#ac2f33;
}
.bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:active{
  color:#8e292c;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary{
  background-color:rgba(45, 114, 210, 0.2);
  color:#8abbff;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:hover{
  background-color:rgba(45, 114, 210, 0.3);
  color:#99c4ff;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive.bp4-active{
  background-color:rgba(45, 114, 210, 0.35);
  color:#99c4ff;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove{
  color:#8abbff;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:active{
  color:#99c4ff;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success{
  background-color:rgba(35, 133, 81, 0.2);
  color:#72ca9b;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:hover{
  background-color:rgba(35, 133, 81, 0.3);
  color:#7cd7a2;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive.bp4-active{
  background-color:rgba(35, 133, 81, 0.35);
  color:#7cd7a2;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove{
  color:#72ca9b;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:active{
  color:#7cd7a2;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning{
  background-color:rgba(200, 118, 25, 0.2);
  color:#fbb360;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:hover{
  background-color:rgba(200, 118, 25, 0.3);
  color:#f5c186;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive.bp4-active{
  background-color:rgba(200, 118, 25, 0.35);
  color:#f5c186;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove{
  color:#fbb360;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:active{
  color:#f5c186;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger{
  background-color:rgba(205, 66, 70, 0.2);
  color:#fa999c;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:hover{
  background-color:rgba(205, 66, 70, 0.3);
  color:#ffa1a4;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive.bp4-active{
  background-color:rgba(205, 66, 70, 0.35);
  color:#ffa1a4;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove{
  color:#fa999c;
}
.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:active{
  color:#ffa1a4;
}

.bp4-tag-remove{
  background:none;
  border:none;
  color:rgba(255, 255, 255, 0.7);
  cursor:pointer;
  display:flex;
  margin-bottom:-2px;
  margin-right:-6px !important;
  margin-top:-2px;
  padding:2px;
  padding-left:0;
}
.bp4-tag-remove:hover{
  background:none;
  color:inherit;
  text-decoration:none;
}
.bp4-tag-remove .bp4-icon:first-child{
  color:inherit;
}
.bp4-tag-remove:hover, .bp4-tag-remove:active{
  color:#ffffff;
}
.bp4-tag-remove:empty::before{
  font-family:"blueprint-icons-16", sans-serif;
  font-size:16px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
  -moz-osx-font-smoothing:grayscale;
  -webkit-font-smoothing:antialiased;
  content:"\\f2ba";
}
.bp4-large .bp4-tag-remove{
  margin-right:-10px !important;
  padding:0 5px 0 0;
}
.bp4-large .bp4-tag-remove:empty::before{
  font-family:"blueprint-icons-20", sans-serif;
  font-size:20px;
  font-style:normal;
  font-variant:normal;
  font-weight:400;
  line-height:1;
}
.bp4-dark .bp4-tag-remove{
  color:rgba(28, 33, 39, 0.7);
}
.bp4-dark .bp4-tag-remove:hover, .bp4-dark .bp4-tag-remove:active{
  color:#1c2127;
}
.bp4-tag-input{
  display:flex;
  flex-direction:row;
  align-items:flex-start;
  cursor:text;
  height:auto;
  line-height:inherit;
  min-height:30px;
  padding-left:5px;
  padding-right:0;
}
.bp4-tag-input > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-tag-input > .bp4-tag-input-values{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-tag-input .bp4-tag-input-icon{
  color:#5f6b7c;
  margin-left:2px;
  margin-right:7px;
  margin-top:7px;
}
.bp4-tag-input .bp4-tag-input-values{
  display:flex;
  flex-direction:row;
  align-items:center;
  align-self:stretch;
  flex-wrap:wrap;
  margin-right:7px;
  margin-top:5px;
  min-width:0;
  position:relative;
}
.bp4-tag-input .bp4-tag-input-values > *{
  flex-grow:0;
  flex-shrink:0;
}
.bp4-tag-input .bp4-tag-input-values > .bp4-fill{
  flex-grow:1;
  flex-shrink:1;
}
.bp4-tag-input .bp4-tag-input-values::before,
.bp4-tag-input .bp4-tag-input-values > *{
  margin-right:5px;
}
.bp4-tag-input .bp4-tag-input-values:empty::before,
.bp4-tag-input .bp4-tag-input-values > :last-child{
  margin-right:0;
}
.bp4-tag-input .bp4-tag-input-values:first-child .bp4-tag ~ .bp4-input-ghost{
  padding-left:0;
}
.bp4-tag-input .bp4-tag-input-values:first-child .bp4-input-ghost{
  padding-left:5px;
}
.bp4-tag-input .bp4-tag-input-values > *{
  margin-bottom:5px;
}
.bp4-tag-input .bp4-tag{
  overflow-wrap:break-word;
}
.bp4-tag-input .bp4-tag.bp4-active{
  outline:rgba(45, 114, 210, 0.6) solid 2px;
  outline-offset:0;
  -moz-outline-radius:6px;
}
.bp4-tag-input .bp4-input-ghost{
  flex:1 1 auto;
  line-height:20px;
  width:80px;
}
.bp4-tag-input .bp4-input-ghost:disabled, .bp4-tag-input .bp4-input-ghost.bp4-disabled{
  cursor:not-allowed;
}
.bp4-tag-input .bp4-button,
.bp4-tag-input .bp4-spinner{
  margin:3px;
  margin-left:0;
}
.bp4-tag-input .bp4-button{
  min-height:24px;
  min-width:24px;
  padding:0 7px;
}
.bp4-tag-input.bp4-large{
  height:auto;
  min-height:40px;
}
.bp4-tag-input.bp4-large::before,
.bp4-tag-input.bp4-large > *{
  margin-right:10px;
}
.bp4-tag-input.bp4-large:empty::before,
.bp4-tag-input.bp4-large > :last-child{
  margin-right:0;
}
.bp4-tag-input.bp4-large .bp4-tag-input-icon{
  margin-left:5px;
  margin-top:10px;
}
.bp4-tag-input.bp4-large .bp4-input-ghost{
  line-height:30px;
}
.bp4-tag-input.bp4-large .bp4-button{
  min-height:30px;
  min-width:30px;
  padding:5px 10px;
  margin:5px;
  margin-left:0;
}
.bp4-tag-input.bp4-large .bp4-spinner{
  margin:8px;
  margin-left:0;
}
.bp4-tag-input.bp4-active{
  background-color:#ffffff;
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-tag-input.bp4-active.bp4-intent-primary{
  box-shadow:inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-tag-input.bp4-active.bp4-intent-success{
  box-shadow:inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-tag-input.bp4-active.bp4-intent-warning{
  box-shadow:inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-tag-input.bp4-active.bp4-intent-danger{
  box-shadow:inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);
}
.bp4-dark .bp4-tag-input .bp4-tag-input-icon, .bp4-tag-input.bp4-dark .bp4-tag-input-icon{
  color:#abb3bf;
}
.bp4-dark .bp4-tag-input .bp4-input-ghost, .bp4-tag-input.bp4-dark .bp4-input-ghost{
  color:#f6f7f9;
}
.bp4-dark .bp4-tag-input .bp4-input-ghost::placeholder, .bp4-tag-input.bp4-dark .bp4-input-ghost::placeholder{
  color:#abb3bf;
}
.bp4-dark .bp4-tag-input.bp4-active, .bp4-tag-input.bp4-dark.bp4-active{
  background-color:rgba(17, 20, 24, 0.3);
  box-shadow:inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-primary, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-primary{
  box-shadow:inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-success, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-success{
  box-shadow:inset 0 0 0 1px #32a467, 0 0 0 2px rgba(50, 164, 103, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-warning, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-warning{
  box-shadow:inset 0 0 0 1px #ec9a3c, 0 0 0 2px rgba(236, 154, 60, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}
.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-danger, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-danger{
  box-shadow:inset 0 0 0 1px #e76a6e, 0 0 0 2px rgba(231, 106, 110, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;
}

.bp4-input-ghost{
  background:none;
  border:none;
  box-shadow:none;
  padding:0;
}
.bp4-input-ghost::placeholder{
  color:#5f6b7c;
  opacity:1;
}
.bp4-input-ghost:focus{
  outline:none !important;
}
.bp4-resizable-input-span{
  max-height:0;
  max-width:100%;
  min-width:80px;
  opacity:0;
  overflow:hidden;
  position:absolute;
  white-space:nowrap;
  z-index:-1;
}
.bp4-toast{
  align-items:flex-start;
  background-color:#ffffff;
  border-radius:2px;
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
  display:flex;
  margin:20px 0 0;
  max-width:500px;
  min-width:300px;
  pointer-events:all;
  position:relative !important;
}
.bp4-toast.bp4-toast-enter, .bp4-toast.bp4-toast-appear{
  transform:translateY(-40px);
}
.bp4-toast.bp4-toast-enter-active, .bp4-toast.bp4-toast-appear-active{
  transform:translateY(0);
  transition-delay:0;
  transition-duration:300ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.54, 1.12, 0.38, 1.11);
}
.bp4-toast.bp4-toast-enter ~ .bp4-toast, .bp4-toast.bp4-toast-appear ~ .bp4-toast{
  transform:translateY(-40px);
}
.bp4-toast.bp4-toast-enter-active ~ .bp4-toast, .bp4-toast.bp4-toast-appear-active ~ .bp4-toast{
  transform:translateY(0);
  transition-delay:0;
  transition-duration:300ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.54, 1.12, 0.38, 1.11);
}
.bp4-toast.bp4-toast-exit{
  opacity:1;
  filter:blur(0);
}
.bp4-toast.bp4-toast-exit-active{
  opacity:0;
  filter:blur(10px);
  transition-delay:0;
  transition-duration:300ms;
  transition-property:opacity, filter;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-toast.bp4-toast-exit ~ .bp4-toast{
  transform:translateY(0);
}
.bp4-toast.bp4-toast-exit-active ~ .bp4-toast{
  transform:translateY(-40px);
  transition-delay:50ms;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-toast .bp4-button-group{
  flex:0 0 auto;
  padding:5px;
  padding-left:0;
}
.bp4-toast > .bp4-icon{
  color:#5f6b7c;
  margin:12px;
  margin-right:0;
}
.bp4-toast.bp4-dark, .bp4-dark .bp4-toast{
  background-color:#404854;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
}
.bp4-toast.bp4-dark > .bp4-icon, .bp4-dark .bp4-toast > .bp4-icon{
  color:#abb3bf;
}
.bp4-toast.bp4-dark .bp4-button .bp4-icon, .bp4-dark .bp4-toast .bp4-button .bp4-icon{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-toast[class*=bp4-intent-] a{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-toast[class*=bp4-intent-] a:hover{
  color:#ffffff;
}
.bp4-toast[class*=bp4-intent-] > .bp4-icon{
  color:#ffffff;
}
.bp4-toast.bp4-intent-primary{
  background-color:#2d72d2;
  color:#ffffff;
}
.bp4-toast.bp4-intent-primary .bp4-icon:first-child{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-toast.bp4-intent-primary .bp4-button{
  background-color:#2d72d2 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-primary .bp4-button:hover{
  background-color:#215db0 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-primary .bp4-button:active{
  background-color:#184a90 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-primary .bp4-button:focus{
  outline-color:rgba(255, 255, 255, 0.5);
}
.bp4-toast.bp4-intent-primary .bp4-button:last-child > .bp4-icon-cross{
  color:rgba(255, 255, 255, 0.7) !important;
}
.bp4-toast.bp4-intent-success{
  background-color:#238551;
  color:#ffffff;
}
.bp4-toast.bp4-intent-success .bp4-icon:first-child{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-toast.bp4-intent-success .bp4-button{
  background-color:#238551 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-success .bp4-button:hover{
  background-color:#1c6e42 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-success .bp4-button:active{
  background-color:#165a36 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-success .bp4-button:focus{
  outline-color:rgba(255, 255, 255, 0.5);
}
.bp4-toast.bp4-intent-success .bp4-button:last-child > .bp4-icon-cross{
  color:rgba(255, 255, 255, 0.7) !important;
}
.bp4-toast.bp4-intent-warning{
  background-color:#fbb360;
  color:#1c2127;
}
.bp4-toast.bp4-intent-warning .bp4-icon:first-child{
  color:rgba(28, 33, 39, 0.7);
}
.bp4-toast.bp4-intent-warning .bp4-button{
  background-color:#fbb360 !important;
  color:#1c2127 !important;
}
.bp4-toast.bp4-intent-warning .bp4-button:hover{
  background-color:#ec9a3c !important;
  color:#1c2127 !important;
}
.bp4-toast.bp4-intent-warning .bp4-button:active{
  background-color:#c87619 !important;
  color:#1c2127 !important;
}
.bp4-toast.bp4-intent-warning .bp4-button:focus{
  outline-color:rgba(255, 255, 255, 0.5);
}
.bp4-toast.bp4-intent-warning .bp4-button:last-child > .bp4-icon-cross{
  color:rgba(28, 33, 39, 0.7) !important;
}
.bp4-toast.bp4-intent-danger{
  background-color:#cd4246;
  color:#ffffff;
}
.bp4-toast.bp4-intent-danger .bp4-icon:first-child{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-toast.bp4-intent-danger .bp4-button{
  background-color:#cd4246 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-danger .bp4-button:hover{
  background-color:#ac2f33 !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-danger .bp4-button:active{
  background-color:#8e292c !important;
  color:#ffffff !important;
}
.bp4-toast.bp4-intent-danger .bp4-button:focus{
  outline-color:rgba(255, 255, 255, 0.5);
}
.bp4-toast.bp4-intent-danger .bp4-button:last-child > .bp4-icon-cross{
  color:rgba(255, 255, 255, 0.7) !important;
}

.bp4-toast-message{
  flex:1 1 auto;
  padding:11px;
  word-break:break-word;
}

.bp4-toast-container{
  align-items:center;
  display:flex !important;
  flex-direction:column;
  left:0;
  overflow:hidden;
  padding:0 20px 20px;
  pointer-events:none;
  right:0;
  z-index:40;
}
.bp4-toast-container.bp4-toast-container-in-portal{
  position:fixed;
}
.bp4-toast-container.bp4-toast-container-inline{
  position:absolute;
}
.bp4-toast-container.bp4-toast-container-top{
  top:0;
}
.bp4-toast-container.bp4-toast-container-bottom{
  bottom:0;
  flex-direction:column-reverse;
  top:auto;
}
.bp4-toast-container.bp4-toast-container-left{
  align-items:flex-start;
}
.bp4-toast-container.bp4-toast-container-right{
  align-items:flex-end;
}

.bp4-toast-container-bottom .bp4-toast.bp4-toast-enter:not(.bp4-toast-enter-active), .bp4-toast-container-bottom .bp4-toast.bp4-toast-enter:not(.bp4-toast-enter-active) ~ .bp4-toast, .bp4-toast-container-bottom .bp4-toast.bp4-toast-appear:not(.bp4-toast-appear-active), .bp4-toast-container-bottom .bp4-toast.bp4-toast-appear:not(.bp4-toast-appear-active) ~ .bp4-toast, .bp4-toast-container-bottom .bp4-toast.bp4-toast-exit-active ~ .bp4-toast, .bp4-toast-container-bottom .bp4-toast.bp4-toast-leave-active ~ .bp4-toast{
  transform:translateY(60px);
}
.bp4-tooltip{
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);
  transform:scale(1);
  color:#f6f7f9;
}
.bp4-tooltip .bp4-popover-arrow{
  height:22px;
  position:absolute;
  width:22px;
}
.bp4-tooltip .bp4-popover-arrow::before{
  height:14px;
  margin:4px;
  width:14px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-tooltip{
  margin-bottom:11px;
  margin-top:-11px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-tooltip > .bp4-popover-arrow{
  bottom:-8px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-tooltip > .bp4-popover-arrow svg{
  transform:rotate(-90deg);
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-tooltip{
  margin-left:11px;
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-tooltip > .bp4-popover-arrow{
  left:-8px;
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-tooltip > .bp4-popover-arrow svg{
  transform:rotate(0);
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-tooltip{
  margin-top:11px;
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-tooltip > .bp4-popover-arrow{
  top:-8px;
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-tooltip > .bp4-popover-arrow svg{
  transform:rotate(90deg);
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-tooltip{
  margin-left:-11px;
  margin-right:11px;
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-tooltip > .bp4-popover-arrow{
  right:-8px;
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-tooltip > .bp4-popover-arrow svg{
  transform:rotate(180deg);
}
.bp4-tether-element-attached-middle > .bp4-tooltip > .bp4-popover-arrow{
  top:50%;
  transform:translateY(-50%);
}
.bp4-tether-element-attached-center > .bp4-tooltip > .bp4-popover-arrow{
  right:50%;
  transform:translateX(50%);
}
.bp4-tether-element-attached-top.bp4-tether-target-attached-top > .bp4-tooltip > .bp4-popover-arrow{
  top:-0.2218253939px;
}
.bp4-tether-element-attached-right.bp4-tether-target-attached-right > .bp4-tooltip > .bp4-popover-arrow{
  right:-0.2218253939px;
}
.bp4-tether-element-attached-left.bp4-tether-target-attached-left > .bp4-tooltip > .bp4-popover-arrow{
  left:-0.2218253939px;
}
.bp4-tether-element-attached-bottom.bp4-tether-target-attached-bottom > .bp4-tooltip > .bp4-popover-arrow{
  bottom:-0.2218253939px;
}
.bp4-tether-element-attached-top.bp4-tether-element-attached-left > .bp4-tooltip{
  transform-origin:top left;
}
.bp4-tether-element-attached-top.bp4-tether-element-attached-center > .bp4-tooltip{
  transform-origin:top center;
}
.bp4-tether-element-attached-top.bp4-tether-element-attached-right > .bp4-tooltip{
  transform-origin:top right;
}
.bp4-tether-element-attached-middle.bp4-tether-element-attached-left > .bp4-tooltip{
  transform-origin:center left;
}
.bp4-tether-element-attached-middle.bp4-tether-element-attached-center > .bp4-tooltip{
  transform-origin:center center;
}
.bp4-tether-element-attached-middle.bp4-tether-element-attached-right > .bp4-tooltip{
  transform-origin:center right;
}
.bp4-tether-element-attached-bottom.bp4-tether-element-attached-left > .bp4-tooltip{
  transform-origin:bottom left;
}
.bp4-tether-element-attached-bottom.bp4-tether-element-attached-center > .bp4-tooltip{
  transform-origin:bottom center;
}
.bp4-tether-element-attached-bottom.bp4-tether-element-attached-right > .bp4-tooltip{
  transform-origin:bottom right;
}
.bp4-tooltip .bp4-popover-content{
  background:#404854;
}
.bp4-tooltip .bp4-popover-content,
.bp4-tooltip .bp4-heading{
  color:#f6f7f9;
}
.bp4-tooltip .bp4-popover-arrow::before{
  box-shadow:1px 1px 6px rgba(17, 20, 24, 0.2);
}
.bp4-tooltip .bp4-popover-arrow-border{
  fill:#111418;
  fill-opacity:0.1;
}
.bp4-tooltip .bp4-popover-arrow-fill{
  fill:#404854;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tooltip .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}
.bp4-popover-enter > .bp4-tooltip, .bp4-popover-appear > .bp4-tooltip{
  transform:scale(0.8);
}
.bp4-popover-enter-active > .bp4-tooltip, .bp4-popover-appear-active > .bp4-tooltip{
  transform:scale(1);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-popover-exit > .bp4-tooltip{
  transform:scale(1);
}
.bp4-popover-exit-active > .bp4-tooltip{
  transform:scale(0.8);
  transition-delay:0;
  transition-duration:100ms;
  transition-property:transform;
  transition-timing-function:cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-tooltip .bp4-text-muted{
  color:#abb3bf;
}
.bp4-tooltip .bp4-text-disabled{
  color:rgba(171, 179, 191, 0.6);
}
.bp4-tooltip .bp4-running-text hr{
  border-color:rgba(255, 255, 255, 0.2);
}
.bp4-tooltip a{
  color:#8abbff;
}
.bp4-tooltip a:hover{
  color:#8abbff;
}
.bp4-tooltip a .bp4-icon, .bp4-tooltip a .bp4-icon-standard, .bp4-tooltip a .bp4-icon-large{
  color:inherit;
}
.bp4-tooltip a code{
  color:inherit;
}
.bp4-tooltip .bp4-code,
.bp4-tooltip .bp4-running-text code{
  background:rgba(17, 20, 24, 0.3);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.4);
  color:#abb3bf;
}
a > .bp4-tooltip .bp4-code,
a > .bp4-tooltip .bp4-running-text code{
  color:inherit;
}
.bp4-tooltip .bp4-code-block,
.bp4-tooltip .bp4-running-text pre{
  background:rgba(17, 20, 24, 0.3);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.4);
  color:#f6f7f9;
}
.bp4-tooltip .bp4-code-block > code,
.bp4-tooltip .bp4-running-text pre > code{
  background:none;
  box-shadow:none;
  color:inherit;
}
.bp4-tooltip .bp4-key,
.bp4-tooltip .bp4-running-text kbd{
  background:#383e47;
  box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);
  color:#abb3bf;
}
.bp4-tooltip .bp4-icon.bp4-intent-primary, .bp4-tooltip .bp4-icon-standard.bp4-intent-primary, .bp4-tooltip .bp4-icon-large.bp4-intent-primary{
  color:#8abbff;
}
.bp4-tooltip .bp4-icon.bp4-intent-success, .bp4-tooltip .bp4-icon-standard.bp4-intent-success, .bp4-tooltip .bp4-icon-large.bp4-intent-success{
  color:#72ca9b;
}
.bp4-tooltip .bp4-icon.bp4-intent-warning, .bp4-tooltip .bp4-icon-standard.bp4-intent-warning, .bp4-tooltip .bp4-icon-large.bp4-intent-warning{
  color:#fbb360;
}
.bp4-tooltip .bp4-icon.bp4-intent-danger, .bp4-tooltip .bp4-icon-standard.bp4-intent-danger, .bp4-tooltip .bp4-icon-large.bp4-intent-danger{
  color:#fa999c;
}
.bp4-tooltip .bp4-popover-content{
  padding:10px 12px;
}
.bp4-tooltip.bp4-dark, .bp4-dark .bp4-tooltip{
  box-shadow:0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);
}
.bp4-tooltip.bp4-dark .bp4-popover-content, .bp4-dark .bp4-tooltip .bp4-popover-content{
  background:#e5e8eb;
}
.bp4-tooltip.bp4-dark .bp4-popover-content,
.bp4-tooltip.bp4-dark .bp4-heading, .bp4-dark .bp4-tooltip .bp4-popover-content,
.bp4-dark .bp4-tooltip .bp4-heading{
  color:#404854;
}
.bp4-tooltip.bp4-dark .bp4-popover-arrow::before, .bp4-dark .bp4-tooltip .bp4-popover-arrow::before{
  box-shadow:1px 1px 6px rgba(17, 20, 24, 0.4);
}
.bp4-tooltip.bp4-dark .bp4-popover-arrow-border, .bp4-dark .bp4-tooltip .bp4-popover-arrow-border{
  fill:#111418;
  fill-opacity:0.2;
}
.bp4-tooltip.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-tooltip .bp4-popover-arrow-fill{
  fill:#e5e8eb;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tooltip.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-tooltip .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}
.bp4-tooltip.bp4-dark .bp4-text-muted, .bp4-dark .bp4-tooltip .bp4-text-muted{
  color:#5f6b7c;
}
.bp4-tooltip.bp4-dark .bp4-text-disabled, .bp4-dark .bp4-tooltip .bp4-text-disabled{
  color:rgba(95, 107, 124, 0.6);
}
.bp4-tooltip.bp4-dark .bp4-running-text hr, .bp4-dark .bp4-tooltip .bp4-running-text hr{
  border-color:rgba(17, 20, 24, 0.15);
}
.bp4-tooltip.bp4-dark a, .bp4-dark .bp4-tooltip a{
  color:#215db0;
}
.bp4-tooltip.bp4-dark a:hover, .bp4-dark .bp4-tooltip a:hover{
  color:#215db0;
}
.bp4-tooltip.bp4-dark a .bp4-icon, .bp4-tooltip.bp4-dark a .bp4-icon-standard, .bp4-tooltip.bp4-dark a .bp4-icon-large, .bp4-dark .bp4-tooltip a .bp4-icon, .bp4-dark .bp4-tooltip a .bp4-icon-standard, .bp4-dark .bp4-tooltip a .bp4-icon-large{
  color:inherit;
}
.bp4-tooltip.bp4-dark a code, .bp4-dark .bp4-tooltip a code{
  color:inherit;
}
.bp4-tooltip.bp4-dark .bp4-code,
.bp4-tooltip.bp4-dark .bp4-running-text code, .bp4-dark .bp4-tooltip .bp4-code,
.bp4-dark .bp4-tooltip .bp4-running-text code{
  background:rgba(255, 255, 255, 0.7);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.2);
  color:#5f6b7c;
}
a > .bp4-tooltip.bp4-dark .bp4-code,
a > .bp4-tooltip.bp4-dark .bp4-running-text code, a > .bp4-dark .bp4-tooltip .bp4-code,
a > .bp4-dark .bp4-tooltip .bp4-running-text code{
  color:#2d72d2;
}
.bp4-tooltip.bp4-dark .bp4-code-block,
.bp4-tooltip.bp4-dark .bp4-running-text pre, .bp4-dark .bp4-tooltip .bp4-code-block,
.bp4-dark .bp4-tooltip .bp4-running-text pre{
  background:rgba(255, 255, 255, 0.7);
  box-shadow:inset 0 0 0 1px rgba(17, 20, 24, 0.15);
  color:#1c2127;
}
.bp4-tooltip.bp4-dark .bp4-code-block > code,
.bp4-tooltip.bp4-dark .bp4-running-text pre > code, .bp4-dark .bp4-tooltip .bp4-code-block > code,
.bp4-dark .bp4-tooltip .bp4-running-text pre > code{
  background:none;
  box-shadow:none;
  color:inherit;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tooltip.bp4-dark .bp4-code-block,
  .bp4-tooltip.bp4-dark .bp4-running-text pre, .bp4-dark .bp4-tooltip .bp4-code-block,
  .bp4-dark .bp4-tooltip .bp4-running-text pre{
    border:1px solid buttonborder;
    box-shadow:none;
  }
}
.bp4-tooltip.bp4-dark .bp4-key,
.bp4-tooltip.bp4-dark .bp4-running-text kbd, .bp4-dark .bp4-tooltip .bp4-key,
.bp4-dark .bp4-tooltip .bp4-running-text kbd{
  background:#ffffff;
  box-shadow:0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);
  color:#5f6b7c;
}
.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-primary, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-primary, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-primary, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-primary, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-primary, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-primary{
  color:#215db0;
}
.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-success, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-success, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-success, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-success, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-success, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-success{
  color:#1c6e42;
}
.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-warning, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-warning, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-warning, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-warning, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-warning, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-warning{
  color:#935610;
}
.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-danger, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-danger, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-danger, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-danger, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-danger, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-danger{
  color:#ac2f33;
}
.bp4-tooltip.bp4-intent-primary .bp4-popover-content{
  background:#2d72d2;
  color:#ffffff;
}
.bp4-tooltip.bp4-intent-primary .bp4-popover-arrow-fill{
  fill:#2d72d2;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tooltip.bp4-intent-primary .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}
.bp4-tooltip.bp4-intent-success .bp4-popover-content{
  background:#238551;
  color:#ffffff;
}
.bp4-tooltip.bp4-intent-success .bp4-popover-arrow-fill{
  fill:#238551;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tooltip.bp4-intent-success .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}
.bp4-tooltip.bp4-intent-warning .bp4-popover-content{
  background:#c87619;
  color:#ffffff;
}
.bp4-tooltip.bp4-intent-warning .bp4-popover-arrow-fill{
  fill:#c87619;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tooltip.bp4-intent-warning .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}
.bp4-tooltip.bp4-intent-danger .bp4-popover-content{
  background:#cd4246;
  color:#ffffff;
}
.bp4-tooltip.bp4-intent-danger .bp4-popover-arrow-fill{
  fill:#cd4246;
}
@media (forced-colors: active) and (prefers-color-scheme: dark){
  .bp4-tooltip.bp4-intent-danger .bp4-popover-arrow-fill{
    fill:buttonborder;
  }
}

.bp4-tooltip-indicator{
  border-bottom:dotted 1px;
  cursor:help;
}
.bp4-tree .bp4-icon, .bp4-tree .bp4-icon-standard, .bp4-tree .bp4-icon-large{
  color:#5f6b7c;
}
.bp4-tree .bp4-icon.bp4-intent-primary, .bp4-tree .bp4-icon-standard.bp4-intent-primary, .bp4-tree .bp4-icon-large.bp4-intent-primary{
  color:#2d72d2;
}
.bp4-tree .bp4-icon.bp4-intent-success, .bp4-tree .bp4-icon-standard.bp4-intent-success, .bp4-tree .bp4-icon-large.bp4-intent-success{
  color:#238551;
}
.bp4-tree .bp4-icon.bp4-intent-warning, .bp4-tree .bp4-icon-standard.bp4-intent-warning, .bp4-tree .bp4-icon-large.bp4-intent-warning{
  color:#c87619;
}
.bp4-tree .bp4-icon.bp4-intent-danger, .bp4-tree .bp4-icon-standard.bp4-intent-danger, .bp4-tree .bp4-icon-large.bp4-intent-danger{
  color:#cd4246;
}

.bp4-tree-node-list{
  list-style:none;
  margin:0;
  padding-left:0;
}

.bp4-tree-root{
  background-color:transparent;
  cursor:default;
  padding-left:0;
  position:relative;
}

.bp4-tree-node-content-0{
  padding-left:0px;
}

.bp4-tree-node-content-1{
  padding-left:23px;
}

.bp4-tree-node-content-2{
  padding-left:46px;
}

.bp4-tree-node-content-3{
  padding-left:69px;
}

.bp4-tree-node-content-4{
  padding-left:92px;
}

.bp4-tree-node-content-5{
  padding-left:115px;
}

.bp4-tree-node-content-6{
  padding-left:138px;
}

.bp4-tree-node-content-7{
  padding-left:161px;
}

.bp4-tree-node-content-8{
  padding-left:184px;
}

.bp4-tree-node-content-9{
  padding-left:207px;
}

.bp4-tree-node-content-10{
  padding-left:230px;
}

.bp4-tree-node-content-11{
  padding-left:253px;
}

.bp4-tree-node-content-12{
  padding-left:276px;
}

.bp4-tree-node-content-13{
  padding-left:299px;
}

.bp4-tree-node-content-14{
  padding-left:322px;
}

.bp4-tree-node-content-15{
  padding-left:345px;
}

.bp4-tree-node-content-16{
  padding-left:368px;
}

.bp4-tree-node-content-17{
  padding-left:391px;
}

.bp4-tree-node-content-18{
  padding-left:414px;
}

.bp4-tree-node-content-19{
  padding-left:437px;
}

.bp4-tree-node-content-20{
  padding-left:460px;
}

.bp4-tree-node-content{
  align-items:center;
  background:none;
  display:flex;
  height:30px;
  padding-right:5px;
  width:100%;
}
.bp4-tree-node-content:hover{
  background-color:rgba(143, 153, 168, 0.15);
}
.bp4-tree-node-content:active{
  background-color:rgba(143, 153, 168, 0.3);
}

.bp4-tree-node-caret,
.bp4-tree-node-caret-none{
  min-width:30px;
}

.bp4-tree-node-caret{
  color:#5f6b7c;
  cursor:pointer;
  padding:7px;
  transform:rotate(0deg);
  transition:transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);
}
.bp4-tree-node-caret:hover{
  color:#1c2127;
}
.bp4-dark .bp4-tree-node-caret{
  color:#abb3bf;
}
.bp4-dark .bp4-tree-node-caret:hover{
  color:#f6f7f9;
}
.bp4-tree-node-caret.bp4-tree-node-caret-open{
  transform:rotate(90deg);
}
.bp4-tree-node-caret.bp4-icon-standard::before{
  content:"\\f14d";
}

.bp4-tree-node-icon{
  margin-right:7px;
  position:relative;
}

.bp4-tree-node-label{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  flex:1 1 auto;
  position:relative;
  -webkit-user-select:none;
          user-select:none;
}
.bp4-tree-node-label span{
  display:inline;
}

.bp4-tree-node-secondary-label{
  padding:0 5px;
  -webkit-user-select:none;
          user-select:none;
}
.bp4-tree-node-secondary-label .bp4-popover-wrapper,
.bp4-tree-node-secondary-label .bp4-popover-target{
  align-items:center;
  display:flex;
}

.bp4-tree-node.bp4-disabled .bp4-tree-node-content{
  background-color:inherit;
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}
.bp4-tree-node.bp4-disabled .bp4-tree-node-caret,
.bp4-tree-node.bp4-disabled .bp4-tree-node-icon{
  color:rgba(95, 107, 124, 0.6);
  cursor:not-allowed;
}

.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content{
  background-color:#2d72d2;
}
.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content,
.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon, .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-standard, .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-large{
  color:#ffffff;
}
.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-tree-node-caret::before{
  color:rgba(255, 255, 255, 0.7);
}
.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-tree-node-caret:hover::before{
  color:#ffffff;
}

.bp4-dark .bp4-tree-node-content:hover{
  background-color:rgba(95, 107, 124, 0.3);
}
.bp4-dark .bp4-tree .bp4-icon, .bp4-dark .bp4-tree .bp4-icon-standard, .bp4-dark .bp4-tree .bp4-icon-large{
  color:#abb3bf;
}
.bp4-dark .bp4-tree .bp4-icon.bp4-intent-primary, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-primary, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-primary{
  color:#8abbff;
}
.bp4-dark .bp4-tree .bp4-icon.bp4-intent-success, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-success, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-success{
  color:#72ca9b;
}
.bp4-dark .bp4-tree .bp4-icon.bp4-intent-warning, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-warning, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-warning{
  color:#fbb360;
}
.bp4-dark .bp4-tree .bp4-icon.bp4-intent-danger, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-danger, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-danger{
  color:#fa999c;
}
.bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content{
  background-color:#2d72d2;
}
.bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon, .bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-standard, .bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-large{
  color:#ffffff;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@blueprintjs/core/lib/css/blueprint.css"],"names":[],"mappings":"AAAA,gBAAgB;AAyBhB;EACE,qBAAsB;AACxB;;AAEA;;;EAGE,kBAAmB;AACrB;;AAEA;EACE,cAAe;EACf,eAAgB;EAChB,gBAAiB;EACjB,mBAAoB;EACpB,mBAAoB;EACpB,aAAc;EACd,uKAAwK;AAC1K;;AAEA;EACE,kBAAmB;EACnB,YAAa;AACf;;AAEA;EACE,cAAe;AACjB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,mCAAoC;AACtC;AA6BA;EACE,oBAAqB;EACrB,aAAc;EACd,0BAA2B;AAC7B;AACA;EAEE,qBAAsB;EACtB,wBAAyB;AAE3B;AACA;EACE,aAAc;AAChB;AACA;EACE,iBAAkB;AACpB;;AAEA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,oBAAqB;AACvB;;AAEA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,oBAAqB;AACvB;;AAEA;EACE,gCAAiC;EACjC,iBAAkB;EAClB,iBAAkB;EAClB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,kCAAmC;AACrC;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,aAAc;AAChB;;AAEA;EACE,6BAA8B;AAChC;;AAEA;EACE,mCAAoC;AACtC;;AAEA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;;AAEA;;EAEE,mCAAoC;EACpC,gDAAiD;EACjD,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;;AAEA;;EAEE,mCAAoC;EACpC,iDAAkD;EAClD,aAAc;AAChB;AACA;;EAEE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE;;IAEE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAmB;EACnB,2EAA4E;EAC5E,aAAc;AAChB;;AAEA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AAiBA;EACE,aAAc;EACd,eAAgB;EAChB,eAAgB;EAChB,SAAU;AACZ;AACA;EACE,aAAc;AAChB;;AAEA;EACE,cAAe;EACf,gBAAiB;AACnB;;AAEA;EACE,cAAe;EACf,gBAAiB;AACnB;;AAEA;EACE,cAAe;EACf,gBAAiB;AACnB;;AAEA;EACE,cAAe;EACf,gBAAiB;AACnB;;AAEA;EACE,cAAe;EACf,gBAAiB;AACnB;;AAEA;EACE,cAAe;EACf,gBAAiB;AACnB;AAwBA;EACE,cAAe;EACf,eAAgB;EAChB,gBAAiB;EACjB,mBAAoB;EACpB,mBAAoB;AACtB;;AAEA;EACE,qBAAsB;EACtB,mBAAoB;AACtB;;AAEA;EACE,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;AACnB;AA6BA;EACE,cAAe;EACf,eAAgB;AAClB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,WAAY;EACZ,8CAA+C;EAC/C,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,SAAU;AACZ;AACA;EACE,cAAe;AACjB;;AAEA;EACE,cAAe;AACjB;AAYA;EACE,oBAAqB;AACvB;AACA;EACE,cAAe;EACf,yBAA0B;AAC5B;AAuBA;EACE,qBAAsB;EACtB,mBAAoB;EACpB,iBAAkB;EAClB,iBAAkB;EAClB,eAAgB;AAClB;;AAEA;EACE,qBAAsB;EACtB,mBAAoB;EACpB,iBAAkB;EAClB,aAAc;EACd,cAAe;EACf,eAAgB;EAChB,aAAc;EACd,sBAAuB;EACvB,oBAAqB;EACrB,oBAAqB;AACvB;AACA;EACE,iBAAkB;EAClB,SAAU;AACZ;;AAEA;EACE,kBAAmB;EACnB,iBAAkB;EAClB,mBAAoB;EACpB,mBAAoB;EACpB,cAAe;EACf,WAAY;EACZ,sBAAuB;EACvB,gBAAiB;EACjB,cAAe;EACf,eAAgB;EAChB,qBAAsB;AACxB;AACA;EACE,gBAAiB;AACnB;AAeA;EACE,8CAA+C;EAC/C,eAAgB;EAChB,cAAe;AACjB;AACA;EACE,qCAAsC;AACxC;AAuBA;;EAEE,aAAc;EACd,iBAAkB;AACpB;AACA;;EAEE,iBAAkB;AACpB;AACA;;;;;EAKE,cAAe;AACjB;;AAEA;EACE,eAAgB;EAChB,QAAS;EACT,SAAU;AACZ;AACA;EACE,SAAU;AACZ;AAmBA;EACE,gBAAiB;AACnB;AAKA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;EAEE,gCAAiC;EACjC,gDAAiD;EACjD,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,gCAAiC;EACjC,gDAAiD;EACjD,aAAc;AAChB;AACA;;EAEE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;EAEE,kBAAmB;EACnB,sFAAuF;EACvF,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;;AAEA;EACE,yCAA0C;EAC1C,kBAAmB;EACnB,uBAAwB;AAC1B;;AAEA;EAEE,uBAAwB;AAC1B;AACA;EACE,uBAAwB;AAC1B;;AAEA;EACE,iBAAkB;AACpB;AAKA;EACE,eAAgB;EAChB,YAAa;AACf;;AAEA;EACE,YAAa;AACf;AACA;EACE,cAAe;EACf,iBAAkB;EAClB,YAAa;AACf;;AAEA;EACE,qBAAsB;AACxB;;AAEA;EACE,YAAa;EACb,0BAA2B;EAC3B,eAAgB;AAClB;AACA;EACE,gBAAiB;AACnB;AAmBA;EACE,kBAAmB;EACnB,cAAe;EACf,YAAa;EACb,cAAe;EACf,WAAY;EACZ,eAAgB;EAChB,QAAS;EACT,SAAU;AACZ;AACA;EACE,kBAAmB;EACnB,YAAa;AACf;AACA;EACE,kDAAkV;EAClV,UAAW;EACX,aAAc;EACd,WAAY;EACZ,YAAa;EACb,UAAW;AACb;AACA;EACE,YAAa;AACf;;AAEA;;;EAGE,kBAAmB;EACnB,mBAAoB;EACpB,cAAe;AACjB;;AAEA;;EAEE,aAAc;AAChB;;AAEA;EACE,oBAAqB;AACvB;AACA;EACE,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;EACE,gBAAiB;AACnB;;AAEA;EACE,aAAc;EACd,eAAgB;AAClB;AACA;EACE,iBAAkB;EAClB,mBAAoB;EACpB,uBAAwB;AAC1B;;AAEA;EACE,oCAAqC;EACrC,WAAY;EACZ,iBAAkB;EAClB,cAAe;EACf,gBAAiB;EACjB,eAAgB;EAChB,0BAA2B;AAC7B;AACA;EACE,mEAAkR;EAClR,UAAW;EACX,aAAc;EACd,WAAY;EACZ,UAAW;AACb;AACA;EACE,mCAAoC;EACpC,aAAc;EACd,oBAAqB;AACvB;;AAEA;;EAEE,aAAc;AAChB;AACA;EACE,kDAAkV;EAClV,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,mEAAkR;AACpR;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AAmDA;EACE,mBAAoB;EACpB,kBAAmB;EACnB,kBAAmB;EACnB,WAAY;EACZ,iBAAkB;EAClB,cAAe;EACf,cAAe;EACf,sBAAuB;EACvB,gBAAiB;EACjB,eAAgB;EAChB,qBAAsB;EACtB,eAAgB;EAChB,cAAe;AACjB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,gBAAiB;AACnB;AACA;;EAEE,cAAe;AACjB;AACA;EAEE,oBAAqB;AACvB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,YAAa;EACb,UAAW;AACb;AACA;EACE,gBAAiB;AACnB;AACA;EACE,eAAgB;AAClB;AACA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;AAChB;AACA;EACE,2BAA4B;EAC5B,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE;IACE,oBAAqB;EACvB;AACF;AACA;EACE,yCAA0C;EAC1C,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;EACnB,YAAa;AACf;AACA;EACE,mCAAoC;AACtC;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wCAAyC;EACzC,wBAAyB;EACzB,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE;IACE,qBAAsB;IACtB,cAAe;EACjB;AACF;AACA;EACE;IACE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;AACA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,uCAAwC;EACxC,wBAAyB;EACzB,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE;IACE,qBAAsB;IACtB,cAAe;EACjB;AACF;AACA;EACE;IACE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;AACA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wCAAyC;EACzC,wBAAyB;EACzB,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE;IACE,qBAAsB;IACtB,cAAe;EACjB;AACF;AACA;EACE;IACE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;AACA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,uCAAwC;EACxC,wBAAyB;EACzB,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE;IACE,qBAAsB;IACtB,cAAe;EACjB;AACF;AACA;EACE;IACE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;AACA;EACE,cAAe;AACjB;AACA;EACE,eAAgB;EAChB,cAAe;EACf,cAAe;EACf,gBAAiB;AACnB;AACA;;;EAGE,iBAAkB;AACpB;AACA;;;EAGE,cAAe;AACjB;AACA;EACE,eAAgB;EAChB,cAAe;EACf,aAAc;AAChB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,QAAS;EACT,iBAAkB;AACpB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;AAClB;AACA;;EAEE,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,oFAAqF;EACrF,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,oFAAqF;AACvF;AACA;EACE,wBAAyB;EACzB,oFAAqF;AACvF;AACA;EACE,sCAAuC;EACvC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,gCAAiC;AACnC;AACA;EACE,gCAAiC;EACjC,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,oFAAqF;AACvF;AACA;EACE,oFAAqF;AACvF;AACA;EACE,oFAAqF;AACvF;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,cAAe;AACjB;AACA;;;;EAKE,wBAAyB;AAC3B;AACA;EACE,eAAgB;EAChB,eAAgB;AAClB;AACA;EACE,oCAAqC;EACrC,eAAgB;EAChB,aAAc;EACd,oBAAqB;AACvB;AACA;EACE,mCAAoC;EACpC,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,oCAAqC;AACvC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,eAAgB;EAChB,8BAA+B;EAC/B,kBAAmB;AACrB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,kCAAmC;AACrC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,kCAAmC;AACrC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,iCAAkC;AACpC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iCAAkC;AACpC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,kCAAmC;AACrC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,6BAA8B;AAChC;AACA;EACE,kCAAmC;AACrC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,iCAAkC;AACpC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iCAAkC;AACpC;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,sCAAuC;EACvC,qBAAsB;AACxB;AACA;EACE,oCAAqC;EACrC,eAAgB;EAChB,aAAc;EACd,oBAAqB;AACvB;AACA;EACE,mCAAoC;EACpC,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,oCAAqC;AACvC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,eAAgB;EAChB,8BAA+B;EAC/B,kBAAmB;AACrB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,kCAAmC;AACrC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,kCAAmC;AACrC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,iCAAkC;AACpC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iCAAkC;AACpC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,kCAAmC;AACrC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,6BAA8B;AAChC;AACA;EACE,kCAAmC;AACrC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,iCAAkC;AACpC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iCAAkC;AACpC;AACA;EACE,oCAAqC;AACvC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,oCAAqC;AACvC;AACA;EACE,oCAAqC;AACvC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,0BAA2B;AAC7B;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE;IACE,oBAAqB;EACvB;AACF;AACA;EACE,kCAAmC;EACnC,4BAA6B;AAC/B;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,eAAgB;AAClB;AACA;EACE,YAAa;AACf;;AAEA;EACE,iBAAkB;EAClB,oBAAqB;EACrB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,6BAA8B;AAChC;;AAEA;EACE,aAAc;AAChB;;AAEA;;;EAGE,aAAc;AAChB;AAoFA;EACE,mBAAoB;AA6CtB;AACA;EACE,aAAc;EACd,iBAAkB;EAClB,SAAU;AACZ;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;AACZ;AACA;EACE,UAAW;AACb;AACA;EACE,UAAW;AACb;AACA;EACE,UAAW;AACb;AACA;EACE,SAAU;AACZ;AACA;;EAEE,2BAA4B;EAC5B,wBAAyB;AAC3B;AACA;;EAEE,4BAA6B;EAC7B,yBAA0B;EAC1B,iBAAkB;AACpB;AACA;EACE,eAAgB;EAChB,eAAgB;AAClB;AACA;EACE,oCAAqC;EACrC,eAAgB;EAChB,aAAc;EACd,oBAAqB;AACvB;AACA;EACE,mCAAoC;EACpC,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,oCAAqC;AACvC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,eAAgB;EAChB,8BAA+B;EAC/B,kBAAmB;AACrB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,kCAAmC;AACrC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,kCAAmC;AACrC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,iCAAkC;AACpC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iCAAkC;AACpC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,kCAAmC;AACrC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,6BAA8B;AAChC;AACA;EACE,kCAAmC;AACrC;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,kCAAmC;EACnC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;EACE,iCAAkC;AACpC;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iCAAkC;AACpC;AACA;EACE;IACE,2BAA4B;IAC5B,gBAAiB;IACjB,wBAAyB;EAC3B;EACA;IACE,4BAA6B;IAC7B,yBAA0B;IAC1B,iBAAkB;EACpB;AACF;AACA;;EAEE,YAAa;EACb,aAAc;AAChB;AACA;EACE,YAAa;EACb,UAAW;AACb;AACA;EACE,aAAc;AAChB;AACA;EACE,mBAAoB;EACpB,qBAAsB;EACtB,kBAAmB;AACrB;AACA;EACE,WAAY;EACZ,WAAY;AACd;AACA;EACE,yBAA0B;EAC1B,UAAW;AACb;AACA;;EAEE,yBAA0B;AAC5B;AACA;;EAEE,yBAA0B;AAC5B;AACA;;EAEE,kBAAmB;AACrB;AACA;EACE,eAAgB;AAClB;AAsBA;EACE,cAAe;EACf,eAAgB;EAChB,0CAA2C;EAC3C,iBAAkB;EAClB,YAAa;EACb,iBAAkB;EAClB,UAAW;AACb;AACA;EACE,iBAAkB;AACpB;AACA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,aAAc;EACd,SAAU;EACV,iBAAkB;EAClB,QAAS;AACX;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,iBAAkB;AACpB;AACA;EACE,aAAc;EACd,SAAU;EACV,iBAAkB;EAClB,QAAS;AACX;AACA;EACE,gBAAiB;EACjB,iBAAkB;EAClB,cAAe;AACjB;AACA;EACE,eAAgB;AAClB;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,yBAA0B;AAC5B;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AAsBA;EACE,wBAAyB;EACzB,iBAAkB;EAClB,2CAA4C;EAC5C,YAAa;EACb,4GAA6G;AAC/G;AACA;EACE,wBAAyB;EACzB,mDAAoD;AACtD;AACA;EACE;IACE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;;AAEA;EACE,2CAA4C;AAC9C;AACA;EACE,mDAAoD;AACtD;AACA;EACE;IACE,6BAA8B;EAChC;AACF;;AAEA;EACE,2EAA4E;AAC9E;AACA;EACE,sFAAuF;AACzF;AACA;EACE;IACE,6BAA8B;EAChC;AACF;;AAEA;EACE,4GAA6G;AAC/G;AACA;EACE,qHAAsH;AACxH;AACA;EACE;IACE,6BAA8B;EAChC;AACF;;AAEA;EACE,6GAA8G;AAChH;AACA;EACE,sHAAuH;AACzH;AACA;EACE;IACE,6BAA8B;EAChC;AACF;;AAEA;EACE,kHAAmH;AACrH;AACA;EACE,2HAA4H;AAC9H;AACA;EACE;IACE,6BAA8B;EAChC;AACF;;AAEA;EACE,6GAA8G;EAC9G,cAAe;AACjB;AACA;EACE,sHAAuH;AACzH;AACA;EACE,2EAA4E;EAC5E,WAAY;EACZ,qBAAsB;AACxB;AACA;EACE,sFAAuF;AACzF;AAKA;EACE,QAAS;EACT,iBAAkB;EAClB,uDAAwD;AAC1D;AACA;EACE,0DAA2D;AAC7D;AACA;EACE,YAAa;AACf;;AAEA;EACE,aAAc;AAChB;;AAEA;EACE,cAAe;AACjB;AAKA;EACE,8CAA+C;EAC/C,6CAA8C;EAC9C,UAAW;AACb;AACA;EACE,qCAAsC;AACxC;AA6EA;EACE,SAAU;EACV,kBAAmB;EACnB,kBAAmB;EACnB,YAAa;EACb,sBAAuB;EACvB,eAAgB;EAChB,mBAAoB;EACpB,wBAAiB;UAAjB,gBAAiB;EACjB,UAAW;AACb;AACA;EACE,SAAU;EACV,oBAAqB;AACvB;AACA;EACE,SAAU;EACV,kBAAmB;EACnB,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+DAAgE;AAClE;AACA;EACE,SAAU;EACV,kBAAmB;AACrB;AACA;EACE,SAAU;EACV,oBAAqB;EACrB,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+DAAgE;AAClE;;AAEA;EACE,kBAAmB;EACnB,iBAAkB;EAClB,6GAA8G;EAC9G,YAAa;EACb,qBAAsB;EACtB,aAAc;EACd,kBAAmB;EACnB,wBAAiB;UAAjB,gBAAiB;EACjB,WAAY;AACd;AACA;EACE,SAAU;AACZ;AACA;EACE,kBAAmB;EACnB,sHAAuH;EACvH,aAAc;AAChB;AACA;EACE;IACE,6BAA8B;EAChC;AACF;;AAEA;EACE,kBAAmB;EACnB,kBAAmB;EACnB,yBAA0B;EAC1B,yCAA0C;EAC1C,YAAa;EACb,aAAc;EACd,eAAgB;EAChB,WAAY;EACZ,iBAAkB;EAClB,SAAU;AACZ;AACA;;EAEE,aAAc;EACd,aAAc;EACd,gBAAiB;EACjB,kBAAmB;AACrB;AACA;EACE,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;EACjB,aAAc;EACd,mBAAoB;EACpB,QAAS;AACX;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;EACnB,mDAAoD;AACtD;AACA;;EAEE,aAAc;AAChB;AACA;EACE;IACE,oCAAqC;EACvC;AACF;;AAEA;EACE,aAAc;EACd,WAAY;AACd;;AAEA;EACE,QAAS;EACT,eAAgB;EAChB,aAAc;EACd,YAAa;AACf;;AAEA;EACE,aAAc;EACd,WAAY;AACd;;AAEA;EACE,kBAAmB;EACnB,wBAAyB;EACzB,yBAA0B;EAC1B,2CAA4C;EAC5C,YAAa;EACb,QAAS;EACT,6BAA8B;EAC9B,QAAS;EACT,2BAA4B;AAC9B;AACA;EACE,kBAAmB;EACnB,6CAA8C;AAChD;;AAEA;EACE,aAAc;AAChB;;AAEA;EACE,YAAa;EACb,wBAAyB;AAC3B;AACA;EACE,gBAAiB;AACnB;AAkDA;EACE,YAAa;AACf;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,qBAAsB;AACxB;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,kBAAmB;AACrB;AACA;EACE,WAAY;AACd;AACA;EACE,4CAA6C;AAC/C;AACA;EACE,kCAAmC;AACrC;AACA;EACE,gBAAiB;AACnB;AACA;;EAEE,yBAA0B;AAC5B;AACA;EACE,0BAA2B;AAC7B;AACA;EACE,yBAA0B;AAC5B;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,gBAAiB;EACjB,yBAA0B;EAC1B,6CAA8C;AAChD;AACA;EACE,kCAAmC;AACrC;AACA;EACE,2BAA4B;AAC9B;;AAEA;EACE,YAAa;EACb,QAAO;EACP,qBAAsB;AACxB;AACA;EACE,kBAAmB;EACnB,gDAAiD;EACjD,6BAA8B;EAC9B,8CAA+C;AACjD;;AAEA;EACE,wBAAyB;EACzB,4CAA6C;EAC7C,uBAAwB;EACxB,QAAO;EACP,WAAY;AACd;AACA;EACE,wBAAyB;EACzB,gDAAiD;EACjD,8BAA+B;EAC/B,8CAA+C;EAC/C,+CAAgD;AAClD;;AAEA;EACE,wBAAyB;EACzB,8CAA+C;AACjD;AACA;EACE,kBAAmB;EACnB,gDAAiD;AACnD;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;EACnB,iBAAkB;EAClB,kBAAmB;EACnB,YAAa;EACb,UAAW;EACX,gBAAiB;AACnB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,wBAAyB;EACzB,cAAe;AACjB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;EACnB,wCAAyC;EACzC,iBAAkB;EAClB,aAAc;EACd,YAAa;EACb,WAAY;EACZ,sBAAuB;EACvB,UAAW;AACb;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;;AAEA;EACE,6BAA8B;EAC9B,QAAO;EACP,iBAAkB;AACpB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AAkDA;EACE,kBAAmB;EACnB,kHAAmH;EACnH,YAAa;EACb,qBAAsB;EACtB,QAAS;EACT,SAAU;AACZ;AACA;EACE,SAAU;AACZ;AACA;EACE,UAAW;EACX,MAAO;EACP,OAAQ;EACR,KAAM;AACR;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,uBAAwB;EACxB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,2BAA4B;EAC5B,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE;IACE,oCAAqC;EACvC;AACF;AACA;EACE,QAAS;EACT,UAAW;EACX,MAAO;EACP,OAAQ;AACV;AACA;EACE,0BAA2B;AAC7B;AACA;EACE,uBAAwB;EACxB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,0BAA2B;EAC3B,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE;IACE,iCAAkC;EACpC;AACF;AACA;EACE,QAAS;EACT,MAAO;EACP,KAAM;EACN,SAAU;AACZ;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,uBAAwB;EACxB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,2BAA4B;EAC5B,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE;IACE,mCAAoC;EACtC;AACF;AACA;EACE,QAAS;EACT,OAAQ;EACR,KAAM;EACN,SAAU;AACZ;AACA;EACE,0BAA2B;AAC7B;AACA;EACE,uBAAwB;EACxB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,0BAA2B;EAC3B,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE;IACE,kCAAmC;EACrC;AACF;AACA;EACE,kBAAmB;EACnB,sHAAuH;EACvH,aAAc;AAChB;;AAEA;EACE,kBAAmB;EACnB,eAAgB;EAChB,yCAA0C;EAC1C,YAAa;EACb,aAAc;EACd,eAAgB;EAChB,WAAY;EACZ,iBAAkB;EAClB,iBAAkB;AACpB;AACA;EACE;IACE,oCAAqC;EACvC;AACF;AACA;;EAEE,aAAc;EACd,aAAc;EACd,iBAAkB;AACpB;AACA;EACE,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;EACjB,aAAc;EACd,mBAAoB;EACpB,QAAS;AACX;AACA;EACE,iBAAkB;AACpB;AACA;EACE,wCAAyC;AAC3C;AACA;;EAEE,aAAc;AAChB;;AAEA;EACE,aAAc;EACd,gBAAiB;EACjB,aAAc;AAChB;;AAEA;EACE,+CAAgD;EAChD,aAAc;EACd,iBAAkB;EAClB,iBAAkB;AACpB;AACA;EACE,8CAA+C;AACjD;AA6BA;EACE,WAAY;EACZ,oBAAqB;EACrB,cAAe;EACf,iBAAkB;EAClB,kBAAmB;EACnB,kBAAmB;AACrB;AACA;EACE,WAAY;EACZ,SAAU;EACV,iBAAkB;EAClB,UAAW;EACX,QAAS;EACT,iBAAkB;EAClB,UAAW;EACX,mHAAoH;AACtH;AACA;EACE,+GAAgH;AAClH;AACA;EACE,wBAAyB;EACzB,4GAA6G;AAC/G;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,gHAAiH;AACnH;AACA;EACE,4GAA6G;AAC/G;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,6GAA8G;AAChH;AACA;EACE,2GAA4G;AAC9G;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,gHAAiH;AACnH;AACA;EACE,4GAA6G;AAC/G;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,6GAA8G;AAChH;AACA;EACE,2GAA4G;AAC9G;AACA;EACE,iHAAkH;AACpH;AACA;EACE,sCAAuC;EACvC,2IAA4I;AAC9I;AACA;EACE,eAAgB;AAClB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,mHAAoH;AACtH;AACA;EACE,4IAA6I;AAC/I;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,mHAAoH;AACtH;AACA;EACE,4IAA6I;AAC/I;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,gHAAiH;AACnH;AACA;EACE,2IAA4I;AAC9I;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,mHAAoH;AACtH;AACA;EACE,4IAA6I;AAC/I;AACA;EAEE,0BAA2B;AAC7B;;AAEA;;EAEE,aAAc;EACd,eAAgB;EAChB,YAAa;EACb,sBAAuB;EACvB,iBAAkB;EAClB,iBAAkB;EAClB,iBAAkB;EAClB,WAAY;EACZ,sBAAuB;EACvB,kBAAmB;AACrB;;AAEA;EACE,eAAgB;EAChB,WAAY;EACZ,eAAgB;EAChB,SAAU;EACV,oBAAqB;EACrB,UAAW;AACb;AACA;EACE,aAAc;EACd,SAAU;AACZ;AACA;EACE,YAAa;AACf;AACA;EACE,YAAa;AACf;;AAEA;EACE,eAAgB;EAChB,iBAAkB;EAClB,sBAAuB;EACvB,eAAgB;AAClB;AACA;EACE,MAAO;EACP,iBAAkB;EAClB,iBAAkB;AACpB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;;AAEA;EACE,aAAc;AAChB;AACA;EACE,aAAc;EACd,oBAAqB;EACrB,oBAAqB;AACvB;AA6EA;EACE,8CAA+C;EAC/C,6CAA8C;EAC9C,UAAW;AACb;AACA;EACE,qCAAsC;AACxC;AAgEA;EACE,uBAAwB;EACxB,YAAa;EACb,kBAAmB;EACnB,mBAAoB;AAsCtB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;;;EAIE,iBAAkB;AACpB;AACA;EACE,SAAU;AACZ;AACA;EACE,UAAW;AACb;AACA;EACE,UAAW;AACb;AACA;EACE,UAAW;AACb;AACA;EACE,SAAU;AACZ;AACA;EACE,UAAW;AACb;AACA;EACE,UAAW;AACb;AACA;;;EAGE,uBAAwB;EACxB,SAAU;AACZ;AACA;;;EAGE,SAAU;AACZ;AACA;;;EAGE,SAAU;AACZ;AACA;;;EAGE,SAAU;AACZ;AACA;;;;;;;EAOE,SAAU;AACZ;AACA;;;EAGE,SAAU;AACZ;AACA;;;EAGE,UAAW;AACb;AACA;;;EAGE,UAAW;AACb;AACA;;;EAGE,UAAW;AACb;AACA;;;;;;;EAOE,SAAU;AACZ;AACA;;;;EAIE,UAAW;AACb;AACA;;;;EAIE,UAAW;AACb;AACA;EACE,SAAU;AACZ;AACA;EACE,gBAAiB;AACnB;AACA;EACE,2BAA4B;EAC5B,wBAAyB;AAC3B;AACA;EACE,UAAW;AACb;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,qBAAsB;AACxB;AACA;EACE,iBAAkB;AACpB;AA6BA;EACE,cAAe;EACf,aAAc;EACd,kBAAmB;EACnB,iBAAkB;EAClB,mBAAoB;AAgFtB;AACA;EACE,wBAAyB;EACzB,gDAAiD;EACjD,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;IAC3B,0BAA2B;EAC7B;AACF;AACA;EACE,wBAAyB;AAC3B;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kCAAmC;EACnC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE;IACE,yBAA0B;IAC1B,qBAAsB;EACxB;AACF;AACA;EACE,mDAAoD;AACtD;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,wBAAyB;EACzB,mDAAoD;AACtD;AACA;EACE,wBAAyB;EACzB,mDAAoD;AACtD;AACA;EACE,kCAAmC;EACnC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iBAAkB;AACpB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;EACE,oBAAqB;EACrB,iBAAkB;AACpB;AACA;EACE,MAAO;EACP,SAAU;EACV,iBAAkB;EAClB,KAAM;EACN,UAAW;AACb;AACA;EACE,2BAA4B;EAC5B,4BAA6B;EAC7B,WAAY;EACZ,kCAAmC;EACnC,cAAe;EACf,oBAAqB;EACrB,cAAe;EACf,UAAW;EACX,iBAAkB;EAClB,eAAgB;EAChB,iBAAkB;EAClB,wBAAiB;UAAjB,gBAAiB;EACjB,qBAAsB;EACtB,SAAU;AACZ;AACA;EACE,UAAW;EACX,aAAc;EACd,UAAW;EACX,SAAU;AACZ;AACA;EACE;IACE,6BAA8B;EAChC;EACA;IACE,gBAAiB;IACjB,eAAgB;EAClB;AACF;AACA;EACE,0CAA2C;AAC7C;AACA;EACE,mCAAoC;EACpC,kCAAmC;AACrC;AACA;EACE,oCAAqC;EACrC,eAAgB;EAChB,kBAAmB;AACrB;AACA;EACE,yCAA0C;EAC1C,kBAAmB;EACnB,uBAAwB;EACxB,yBAA0B;AAC5B;AACA;EACE,WAAY;EACZ,gBAAiB;EACjB,cAAe;AACjB;AACA;EACE,cAAe;AACjB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,cAAe;AACjB;AACA;EACE,YAAa;AACf;AACA;EACE,wBAAyB;EACzB,gDAAiD;EACjD,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;IAC3B,0BAA2B;EAC7B;AACF;AACA;EACE,wBAAyB;AAC3B;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kCAAmC;EACnC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE;IACE,yBAA0B;IAC1B,qBAAsB;EACxB;AACF;AACA;EACE,mDAAoD;AACtD;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,wBAAyB;EACzB,mDAAoD;AACtD;AACA;EACE,wBAAyB;EACzB,mDAAoD;AACtD;AACA;EACE,kCAAmC;EACnC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,iBAAkB;AACpB;AACA;EACE,wDAAiU;AACnU;AACA;EACE,wDAA2P;AAC7P;AACA;EACE;IACE,wDAAqU;EACvU;EACA;IACE,wDAA+P;EACjQ;EACA;IACE,qBAAsB;EACxB;AACF;AACA;EACE,iBAAkB;AACpB;AACA;EACE,uEAAwE;AAC1E;AACA;EACE;IACE,oBAAqB;IACrB,WAAY;IACZ,eAAgB;IAChB,cAAe;IACf,UAAW;EACb;AACF;AACA;EACE,WAAY;AACd;AACA;EACE;IACE,mBAAoB;EACtB;AACF;AACA;EACE,wBAAyB;AAC3B;AACA;EACE;IACE,qBAAsB;EACxB;AACF;AACA;EACE,mCAAoC;EACpC,aAAc;AAChB;AACA;EACE,mCAAoC;AACtC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,oCAAqC;EACrC,6BAA8B;AAChC;AACA;EACE,mCAAoC;EACpC,eAAgB;AAClB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kCAAmC;EACnC,8BAA+B;AACjC;AACA;EACE,mCAAoC;EACpC,eAAgB;AAClB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE;IACE,oBAAqB;IACrB,6BAA8B;EAChC;EACA;IACE,yBAA0B;EAC5B;EACA;IACE,qBAAsB;EACxB;EACA;IACE,qBAAsB;EACxB;EACA;IACE,oBAAqB;EACvB;AACF;AACA;EACE,WAAY;EACZ,oBAAqB;EAErB,0BAA2B;EAC3B,gBAAiB;EACjB,iEAAkE;EAClE,UAAW;AACb;AACA;EACE,kBAAmB;EACnB,iBAAkB;EAClB,0CAA2C;EAC3C,sBAAuB;EACvB,MAAO;EACP,UAAW;EACX,iBAAkB;EAClB,qDAAsD;EACtD,qBAAsB;AACxB;AACA;EACE;IACE,6BAA8B;IAC9B,cAAe;EACjB;AACF;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,qBAAsB;AACxB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,gCAAiC;EACjC,aAAc;AAChB;AACA;EACE,gCAAiC;AACnC;AACA;EACE,gCAAiC;AACnC;AACA;EACE,oCAAqC;EACrC,8BAA+B;AACjC;AACA;EACE,mCAAoC;EACpC,eAAgB;AAClB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kCAAmC;EACnC,8BAA+B;AACjC;AACA;EACE,mCAAoC;EACpC,eAAgB;AAClB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE;IACE,oBAAqB;IACrB,6BAA8B;EAChC;EACA;IACE,yBAA0B;EAC5B;EACA;IACE,qBAAsB;EACxB;EACA;IACE,qBAAsB;EACxB;EACA;IACE,oBAAqB;EACvB;AACF;AACA;EACE,eAAgB;EAChB,iBAAkB;AACpB;AACA;EACE,aAAc;EACd,iBAAkB;EAClB,kBAAmB;EACnB,iBAAkB;AACpB;AACA;EACE,eAAgB;EAChB,iBAAkB;EAClB,kBAAmB;EACnB,kBAAmB;AACrB;AACA;EACE,eAAgB;EAChB,kBAAmB;AACrB;AACA;EACE,aAAc;EACd,iBAAkB;AACpB;AACA;EACE,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,4BAA6B;EAC7B,kCAAmC;AACrC;AACA;EACE,0CAA2C;AAC7C;AACA;EACE,yBAA0B;AAC5B;AACA;EACE,mCAAoC;EACpC,kCAAmC;AACrC;AACA;EACE,oCAAqC;EACrC,eAAgB;EAChB,kBAAmB;AACrB;AACA;EACE,kCAAmC;AACrC;AA8CA;EACE,cAAe;EACf,oBAAqB;EACrB,WAAY;EACZ,iBAAkB;AACpB;AACA;EACE,QAAS;EACT,eAAgB;EAChB,SAAU;AACZ;AACA;EACE,mCAAoC;EACpC,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;EACnB,WAAY;AACd;AACA;EACE,6BAA8B;AAChC;AACA;EACE,yCAA0C;EAC1C,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;EACnB,YAAa;AACf;AACA;EACE,gCAAiC;EACjC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,sCAAuC;EACvC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,UAAW;AACb;AACA;EACE,WAAY;AACd;AACA;EACE,WAAY;AACd;AACA;EACE,6BAA8B;AAChC;;AAEA;EACE,eAAgB;EAChB,kBAAmB;EACnB,WAAY;EACZ,iBAAkB;EAClB,qJAAsJ;EACtJ,aAAc;EACd,cAAe;EACf,eAAgB;EAChB,WAAY;EACZ,gBAAiB;EACjB,YAAa;EACb,cAAe;EACf,2DAA4D;EAC5D,qBAAsB;EACtB,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;EACjB,6BAA8B;EAC9B,MAAO;EACP,kBAAmB;EACnB,iBAAkB;EAClB,OAAQ;EACR,KAAM;EACN,wBAAiB;UAAjB,gBAAiB;AACnB;AACA;EACE,aAAc;EACd,SAAU;AACZ;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,kBAAmB;EACnB,qBAAsB;EACtB,iBAAkB;AACpB;AACA;EACE,iDAAkD;AACpD;AACA;EACE,mCAAoC;EACpC,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;EACnB,WAAY;AACd;AACA;EACE,6BAA8B;AAChC;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;EACd,eAAgB;EAChB,cAAe;EACf,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;EACjB,iBAAkB;EAClB,gBAAiB;EACjB,gBAAiB;EACjB,UAAW;EACX,iBAAkB;EAClB,OAAQ;EACR,iBAAkB;EAClB,KAAM;EACN,UAAW;AACb;AACA;EACE,2BAA4B;EAC5B,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE;IACE,oBAAqB;EACvB;AACF;AACA;EACE,cAAe;EACf,WAAY;EACZ,gBAAiB;EACjB,kBAAmB;AACrB;AACA;EACE,cAAe;AACjB;AACA;EACE,eAAgB;EAChB,cAAe;EACf,gBAAiB;EACjB,UAAW;EACX,UAAW;AACb;AACA;EACE,cAAe;EACf,WAAY;EACZ,gBAAiB;EACjB,gBAAiB;EACjB,iBAAkB;EAClB,kBAAmB;AACrB;AACA;EACE,cAAe;AACjB;AACA;EACE,eAAgB;EAChB,cAAe;EACf,gBAAiB;EACjB,UAAW;EACX,UAAW;AACb;AACA;EACE,gCAAiC;EACjC,4KAA6K;EAC7K,aAAc;EACd,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,8FAA+F;AACjG;AACA;EACE,gDAAiD;AACnD;AACA;EACE,gCAAiC;EACjC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,wBAAyB;EACzB,oFAAqF;EACrF,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,oFAAqF;AACvF;AACA;EACE,wBAAyB;EACzB,oFAAqF;AACvF;AAGA;EACE,iFAAkF;AACpF;AA0DA;EACE,YAAa;EACb,qBAAsB;EACtB,eAAgB;AAElB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,cAAe;AACjB;AACA;;EAEE,aAAc;EACd,cAAe;AACjB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,cAAe;AACjB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;EACE,sBAAuB;EACvB,kBAAmB;AACrB;AACA;EACE,gBAAiB;EACjB,iBAAkB;AACpB;AACA;EACE,gBAAiB;EACjB,iBAAkB;AACpB;AACA;;;;EAKE,wCAAyC;AAC3C;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;EAKE,yCAA0C;AAC5C;AAwDA;EACE,aAAc;EACd,iBAAkB;AACpB;AACA;EACE,iBAAkB;EAClB,UAAW;AACb;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;;;;EAIE,iBAAkB;EAClB,KAAM;AACR;AACA;;;;EAIE,MAAO;AACT;AACA;;;;EAIE,OAAQ;AACV;AACA;EACE,eAAgB;EAChB,cAAe;EACf,UAAW;EACX,aAAc;AAChB;AACA;EACE,SAAU;AACZ;AACA;;EAEE,SAAU;AACZ;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;AACrC;AACA;;;EAGE,UAAW;AACb;AACA;EACE,UAAW;AACb;AACA;;EAEE,aAAc;AAEhB;AACA;;EAEE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;;EAGE,wCAAyC;AAC3C;AACA;;;;EAIE,wCAAyC;AAC3C;AACA;EACE,kBAAmB;AACrB;AACA;EACE,6BAA8B;AAChC;AACA;EACE,eAAgB;EAChB,cAAe;EACf,UAAW;AACb;AACA;;;EAGE,WAAY;AACd;AACA;EACE,cAAe;EACf,WAAY;EACZ,gBAAiB;AACnB;AACA;EACE,cAAe;AACjB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,eAAgB;EAChB,cAAe;EACf,UAAW;AACb;AACA;EACE,eAAgB;EAChB,cAAe;EACf,UAAW;AACb;AACA;;;EAGE,UAAW;AACb;AACA;EACE,cAAe;EACf,WAAY;EACZ,gBAAiB;EACjB,gBAAiB;EACjB,iBAAkB;AACpB;AACA;EACE,cAAe;AACjB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,aAAc;EACd,UAAW;AACb;AACA;;;EAGE,kBAAmB;AACrB;AACA;EACE,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,8KAA+K;AACjL;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,qMAAsM;AACxM;AACA;EACE,oKAAqK;AACvK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,4KAA6K;AAC/K;AACA;EACE,2GAA4G;AAC9G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,qMAAsM;AACxM;AACA;EACE,oKAAqK;AACvK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,8KAA+K;AACjL;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,qMAAsM;AACxM;AACA;EACE,oKAAqK;AACvK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,4KAA6K;AAC/K;AACA;EACE,2GAA4G;AAC9G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,wMAAyM;AAC3M;AACA;EACE,qKAAsK;AACxK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AAwBA;EACE,eAAgB;EAChB,kBAAmB;EACnB,WAAY;EACZ,iBAAkB;EAClB,qJAAsJ;EACtJ,aAAc;EACd,cAAe;EACf,eAAgB;EAChB,WAAY;EACZ,gBAAiB;EACjB,YAAa;EACb,cAAe;EACf,2DAA4D;EAC5D,qBAAsB;AACxB;AACA;EACE,aAAc;EACd,SAAU;AACZ;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,kBAAmB;EACnB,qBAAsB;EACtB,iBAAkB;AACpB;AACA;EACE,iDAAkD;AACpD;AACA;EACE,mCAAoC;EACpC,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;EACnB,WAAY;AACd;AACA;EACE,6BAA8B;AAChC;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,cAAe;EACf,WAAY;EACZ,gBAAiB;AACnB;AACA;EACE,cAAe;AACjB;AACA;EACE,cAAe;EACf,WAAY;EACZ,gBAAiB;EACjB,gBAAiB;EACjB,iBAAkB;AACpB;AACA;EACE,cAAe;AACjB;AACA;EACE,aAAc;EACd,UAAW;AACb;AACA;EACE,gCAAiC;EACjC,4KAA6K;EAC7K,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,8FAA+F;AACjG;AACA;EACE,gDAAiD;AACnD;AACA;EACE,gCAAiC;EACjC,eAAgB;EAChB,8BAA+B;AACjC;AACA;EACE,8KAA+K;AACjL;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,qMAAsM;AACxM;AACA;EACE,oKAAqK;AACvK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,4KAA6K;AAC/K;AACA;EACE,2GAA4G;AAC9G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,qMAAsM;AACxM;AACA;EACE,oKAAqK;AACvK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,8KAA+K;AACjL;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,qMAAsM;AACxM;AACA;EACE,oKAAqK;AACvK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,4KAA6K;AAC/K;AACA;EACE,2GAA4G;AAC9G;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,wMAAyM;AAC3M;AACA;EACE,qKAAsK;AACxK;AACA;EACE,kCAAmC;AACrC;AACA;EACE,eAAgB;AAClB;AACA;EACE,YAAa;AACf;;AAEA;EACE;IACE,SAAU;IACV,+CAAgD;EAClD;EACA;IACE,gDAAiD;EACnD;AACF;AAiCA;EACE,cAAe;EACf,YAAa;AACf;AACA;EACE,WAAY;EACZ,mBAAoB;AACtB;AACA;EACE,WAAY;AACd;AAuCA;EACE,aAAc;EACd,kBAAmB;EACnB,YAAa;AACf;AACA;;;;;EAKE,aAAc;EACd,cAAe;EACf,mBAAoB;AACtB;AACA;EACE,cAAe;AACjB;AACA;;EAEE,eAAgB;EAChB,kBAAmB;EACnB,UAAW;AACb;AACA;EACE,cAAe;AACjB;AACA;;;;;;EAME,YAAa;AACf;AACA;;EAEE,6BAA8B;AAChC;AACA;EACE,gBAAiB;AACnB;AACA;;;;;EAKE,oBAAqB;EACrB,gBAAiB;EACjB,kBAAmB;AACrB;AACA;EACE,gBAAiB;AACnB;AACA;EACE,aAAc;AAChB;AACA;EACE,gBAAiB;AACnB;AACA;EACE,gBAAiB;AACnB;AACA;;;;;;EAME,QAAS;AACX;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;EAEE,8BAA+B;AACjC;AA6BA;EACE,aAAc;EACd,YAAa;EACb,SAAU;EACV,UAAW;AACb;AACA;EACE,UAAW;AACb;AACA;EACE,UAAW;AACb;;AAEA;EACE,aAAc;AAChB;AA0EA;;EAEE,mBAAoB;EACpB,kBAAmB;EACnB,kBAAmB;EACnB,WAAY;EACZ,iBAAkB;EAClB,cAAe;EACf,cAAe;EACf,sBAAuB;EACvB,gBAAiB;EACjB,eAAgB;EAChB,qBAAsB;EACtB,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;EAEd,oBAAqB;EACrB,uBAAwB;EACxB,iBAAkB;EAClB,WAAY;EACZ,qBAAsB;EACtB,UAAW;AAEb;AACA;;EAEE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,WAAY;EACZ,aAAc;AAChB;AACA;;;;EAIE,gBAAiB;AACnB;AACA;;;;EAIE,cAAe;AACjB;AACA;;EAEE,2BAA4B;EAC5B,wBAAyB;EACzB,iFAAkF;AACpF;AACA;;;EAGE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE;;;IAGE,oBAAqB;EACvB;AACF;AACA;;;EAGE,yCAA0C;EAC1C,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;EACnB,YAAa;AACf;AACA;;;EAGE,mCAAoC;AACtC;AACA;EACE;;IAEE,6BAA8B;EAChC;AACF;;AAEA;;EAEE,eAAgB;EAChB,eAAgB;AAClB;AACA;;EAEE,oCAAqC;EACrC,eAAgB;EAChB,aAAc;EACd,oBAAqB;AACvB;AACA;;;EAGE,mCAAoC;EACpC,eAAgB;EAChB,aAAc;AAChB;AACA;;;EAGE,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;;;EAGE,mCAAoC;AACtC;AACA;;;EAGE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;;;;;;EAOE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;;EAGE,oCAAqC;AACvC;AACA;;;;;EAKE,mCAAoC;AACtC;AACA;;;;;EAKE,eAAgB;EAChB,8BAA+B;EAC/B,kBAAmB;AACrB;AACA;;;;;EAKE,mCAAoC;AACtC;AACA;;EAEE,aAAc;AAChB;AACA;;;;EAIE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;EAEE,mCAAoC;EACpC,aAAc;AAChB;AACA;;;EAGE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;EAGE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;;;EAGE,kCAAmC;AACrC;AACA;;EAEE,cAAe;AACjB;AACA;;;EAGE,aAAc;AAChB;AACA;;;EAGE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;;;EAKE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;;;EAKE,eAAgB;EAChB,8BAA+B;AACjC;AACA;;;;;EAKE,kCAAmC;AACrC;AACA;;EAEE,aAAc;AAChB;AACA;;;;EAIE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;EAEE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;EAGE,iCAAkC;EAClC,aAAc;AAChB;AACA;;;EAGE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;;;EAGE,iCAAkC;AACpC;AACA;;EAEE,cAAe;AACjB;AACA;;;EAGE,aAAc;AAChB;AACA;;;EAGE,iCAAkC;EAClC,aAAc;AAChB;AACA;;;;;EAKE,iCAAkC;EAClC,aAAc;AAChB;AACA;;;;;EAKE,eAAgB;EAChB,8BAA+B;AACjC;AACA;;;;;EAKE,iCAAkC;AACpC;AACA;;EAEE,aAAc;AAChB;AACA;;;;EAIE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;EAEE,mCAAoC;EACpC,aAAc;AAChB;AACA;;;EAGE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;EAGE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;;;EAGE,kCAAmC;AACrC;AACA;;EAEE,cAAe;AACjB;AACA;;;EAGE,aAAc;AAChB;AACA;;;EAGE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;;;EAKE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;;;EAKE,eAAgB;EAChB,6BAA8B;AAChC;AACA;;;;;EAKE,kCAAmC;AACrC;AACA;;EAEE,aAAc;AAChB;AACA;;;;EAIE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;EAEE,kCAAmC;EACnC,aAAc;AAChB;AACA;;;EAGE,iCAAkC;EAClC,aAAc;AAChB;AACA;;;EAGE,eAAgB;EAChB,4BAA6B;AAC/B;AACA;;;EAGE,iCAAkC;AACpC;AACA;;EAEE,cAAe;AACjB;AACA;;;EAGE,aAAc;AAChB;AACA;;;EAGE,iCAAkC;EAClC,aAAc;AAChB;AACA;;;;;EAKE,iCAAkC;EAClC,aAAc;AAChB;AACA;;;;;EAKE,eAAgB;EAChB,8BAA+B;AACjC;AACA;;;;;EAKE,iCAAkC;AACpC;;AAEA;;EAEE,cAAe;EACf,WAAY;EACZ,kBAAmB;AACrB;;AAEA;;EAEE,wBAAyB;EACzB,oFAAqF;EACrF,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;;EAEE,wBAAyB;EACzB,oFAAqF;AACvF;AACA;;;EAGE,wBAAyB;EACzB,oFAAqF;AACvF;AACA;;;EAGE,sCAAuC;EACvC,eAAgB;EAChB,8BAA+B;AACjC;AACA;;;EAGE,gCAAiC;AACnC;AACA;;EAEE,gCAAiC;EACjC,cAAe;AACjB;;AAEA;;EAEE,yCAA0C;EAC1C,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;AACrB;;AAEA;;EAEE,aAAc;EACd,mBAAoB;EACpB,iBAAkB;EAClB,SAAU;EACV,OAAQ;AACV;AACA;;EAEE,6BAA8B;AAChC;AAwBA;;EAEE,oBAAqB;EACrB,qBAAsB;EACtB,iBAAkB;EAClB,qBAAsB;AACxB;AACA;;EAEE,YAAa;AACf;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;;;EAIE,UAAW;EACX,QAAS;AACX;AACA;;;;EAIE,UAAW;AACb;AACA;;EAEE,wBAAyB;EACzB,aAAc;AAChB;AACA;;EAEE,8BAA+B;AACjC;AACA;;EAEE,aAAc;AAChB;;AAEA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,eAAgB;AAClB;AAsDA;EACE,gBAAiB;EACjB,cAAe;AAGjB;AACA;;;EAGE,YAAa;EACb,eAAgB;EAChB,kBAAmB;AACrB;AACA;EACE,aAAc;EACd,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;;;;;;;EAOE,iDAAkD;AACpD;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;;;;;;;EAUE,mDAAoD;AACtD;;AAEA;;;EAGE,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,oCAAqC;AACvC;AACA;EACE,iDAAkD;AACpD;AACA;EACE;IACE,kCAAmC;EACrC;AACF;AACA;;EAEE,iDAAkD;AACpD;AACA;;EAEE,mDAAoD;AACtD;AACA;EACE;;IAEE,kCAAmC;IACnC,iCAAkC;EACpC;AACF;AACA;EACE;;IAEE,iCAAkC;EACpC;AACF;AACA;EACE,eAAgB;AAClB;AACA;EACE,iDAAkD;AACpD;AACA;EACE,yCAA0C;EAC1C,cAAe;AACjB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,0CAA2C;AAC7C;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;AAGA;AACA;EACE,mCAAoC;AACtC;AACA;EACE,mDAAoD;AACtD;AACA;;EAEE,mDAAoD;AACtD;AACA;;EAEE,qDAAsD;AACxD;AACA;EACE,mDAAoD;AAEtD;AACA;EACE,eAAgB;AAClB;AACA;EACE,wCAAyC;EACzC,cAAe;AACjB;AACA;EACE,wCAAyC;AAC3C;AAQA;EACE,YAAa;EACb,kBAAmB;EACnB,kBAAmB;AACrB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,gBAAiB;AACnB;AACA;;EAEE,cAAe;AACjB;;AAEA;EACE,gBAAiB;EACjB,QAAS;AACX;AACA;EACE,QAAS;EACT,SAAU;AACZ;AACA;EACE,WAAY;AACd;;AAEA;EACE,WAAY;EACZ,eAAgB;EAChB,eAAgB;EAChB,YAAa;AACf;AACA;EACE,kBAAmB;AACrB;AACA;EACE,eAAgB;AAClB;;AAEA;EACE,kBAAmB;EACnB,YAAa;EACb,6BAA8B;EAC9B,aAAc;EACd,cAAe;AACjB;AACA;EACE,kBAAmB;AACrB;AAWA;EACE,oBAAqB;EACrB,aAAc;EACd,0BAA2B;AAC7B;AACA;EAEE,qBAAsB;EACtB,wBAAyB;AAE3B;AACA;EACE,aAAc;AAChB;AACA;EACE,iBAAkB;AACpB;;AAEA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,oBAAqB;AACvB;;AAEA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,oBAAqB;AACvB;;AAEA;EACE,gCAAiC;EACjC,iBAAkB;EAClB,iBAAkB;EAClB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,iCAAkC;EAClC,kCAAmC;AACrC;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,eAAgB;AAClB;AA6BA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;AAGA;AACA;EACE,0CAA2C;EAC3C,aAAc;EACd,cAAe;EACf,oBAAqB;AACvB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,6GAA8G;AAChH;AACA;EACE,eAAgB;AAClB;AACA;EACE,mJAAoJ;AACtJ;AA0BA;EACE,kBAAmB;EACnB,iBAAkB;EAClB,aAAc;EACd,eAAgB;EAChB,QAAS;EACT,eAAgB;EAChB,WAAY;EACZ,eAAgB;AAClB;;AAEA;EACE,2CAA4C;EAC5C,aAAc;EACd,UAAW;AACb;AACA;EACE,yCAA0C;AAC5C;;AAEA;EACE,YAAa;EACb,kBAAmB;EACnB,sBAAuB;EACvB,iBAAkB;EAClB,aAAc;EACd,gBAAiB;EACjB,eAAgB;EAChB,oBAAqB;EACrB,wBAAiB;UAAjB,gBAAiB;AAGnB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,gBAAiB;AACnB;AACA;;EAEE,cAAe;AACjB;AACA;EACE,qBAAsB;AACxB;AACA;EACE,YAAa;EACb,qBAAsB;EACtB,WAAY;EACZ,sBAAuB;AACzB;AACA;EACE,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;;EAEE,cAAe;AACjB;AACA;EACE,0CAA2C;EAC3C,aAAc;EACd,cAAe;EACf,oBAAqB;AACvB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,mCAAoC;EACpC,wCAAyC;EACzC,6BAA8B;EAC9B,uBAAwB;AAC1B;AACA;;;EAGE,wCAAyC;AAC3C;AACA;EACE,wCAAyC;AAC3C;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,wCAAyC;AAC3C;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,uCAAwC;AAC1C;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,wCAAyC;AAC3C;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,uCAAwC;AAC1C;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,gBAAiB;AACnB;AACA;EACE,cAAe;EACf,gBAAiB;EACjB,eAAgB;AAClB;AACA;EACE,WAAY;AACd;AACA;;EAEE,cAAe;AACjB;AACA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,iBAAkB;AACpB;;AAEA;EACE,eAAgB;EAChB,WAAY;EACZ,eAAgB;EAChB,UAAW;AACb;AAmBA;EACE,2CAA4C;EAC5C,aAAc;EACd,UAAW;EACX,cAAe;EACf,gBAAiB;AACnB;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,eAAgB;AAClB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;EACjB,gBAAiB;EACjB,QAAS;EACT,sBAAuB;AACzB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,cAAe;EACf,kBAAmB;EACnB,gBAAiB;AACnB;AACA;EACE,aAAc;AAChB;;AAEA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,aAAc;AAGhB;AACA;EACE,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;;;;;;EAOE,aAAc;AAChB;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,yCAA0C;AAC5C;AACA;;;EAGE,yCAA0C;AAC5C;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,wCAAyC;AAC3C;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,uCAAwC;AAC1C;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,wCAAyC;AAC3C;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;;EAIE,aAAc;AAChB;AACA;EACE,uCAAwC;AAC1C;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;;EAEE,qCAAsC;AACxC;AACA;EACE,aAAc;AAChB;;AAEA;EACE,cAAe;AACjB;AA4BA;EACE,wBAAyB;EACzB,2EAA4E;EAC5E,WAAY;EACZ,cAAe;EACf,iBAAkB;EAClB,UAAW;EACX,UAAW;AACb;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,4FAA6F;AAC/F;AACA;EACE,sFAAuF;AACzF;AACA;EACE,MAAO;EACP,cAAe;EACf,OAAQ;EACR,KAAM;AACR;AACA;EACE;IACE,6BAA8B;EAChC;AACF;;AAEA;EACE,cAAe;EACf,iBAAkB;AACpB;;AAEA;EACE,kBAAmB;EACnB,YAAa;EACb,WAAY;AACd;AACA;EACE,UAAW;AACb;AACA;EACE,WAAY;AACd;;AAEA;EACE,4CAA6C;EAC7C,WAAY;EACZ,aAAc;AAChB;AACA;EACE,0CAA2C;AAC7C;AA+CA;EACE,YAAa;EACb,qBAAsB;EACtB,kBAAmB;EACnB,aAAc;EACd,WAAY;EACZ,sBAAuB;EACvB,iBAAkB;EAClB,UAAW;AACb;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,kBAAmB;AACrB;AACA;;EAEE,eAAgB;AAClB;AACA;EACE,eAAgB;AAClB;AACA;EACE,aAAc;EACd,gBAAiB;EACjB,kBAAmB;AACrB;AACA;EACE,eAAgB;AAClB;AACA;EACE,YAAa;EACb,kBAAmB;EACnB,eAAgB;AAClB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,iBAAkB;AACpB;AACA;;EAEE,cAAe;AACjB;AACA;EACE,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;;AAEA;EACE,aAAc;AAChB;AACA;EACE,gBAAiB;EACjB,gBAAiB;AACnB;AACA;EACE,cAAe;EACf,kBAAmB;EACnB,kBAAmB;AACrB;AACA;EACE,gBAAiB;AACnB;;AAEA;EACE,YAAa;EACb,gBAAiB;EACjB,WAAY;AACd;;AAEA;EACE,aAAc;EACd,SAAU;AACZ;AAKA;EACE,eAAgB;AAClB;;AAEA;EACE,QAAS;EACT,MAAO;EACP,eAAgB;EAChB,OAAQ;EACR,KAAM;EACN,UAAW;AACb;AACA;EACE,mBAAoB;AACtB;AACA;EACE,eAAgB;EAChB,cAAe;AACjB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,aAAc;EACd,cAAe;AACjB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,cAAe;EACf,gBAAiB;AACnB;;AAEA;EACE,cAAe;EACf,UAAW;AACb;AACA;EACE,iBAAkB;AACpB;;AAEA;EACE,QAAS;EACT,MAAO;EACP,cAAe;EACf,OAAQ;EACR,KAAM;EACN,SAAU;EACV,sCAAuC;EACvC,aAAc;EACd,wBAAiB;UAAjB,gBAAiB;EACjB,UAAW;AACb;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,2BAA4B;EAE5B,0DAA2D;AAC7D;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,2BAA4B;EAE5B,0DAA2D;AAC7D;AACA;EACE,YAAa;AACf;AACA;EACE,iBAAkB;AACpB;AA+CA;EACE,eAAgB;EAChB,iBAAkB;AACpB;;AAEA;EACE,kBAAmB;EACnB,uCAAwC;EACxC,YAAa;EACb,aAAc;EACd,WAAY;EACZ,SAAU;AACZ;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,mBAAoB;EACpB,YAAa;EACb,QAAO;AACT;AACA;EACE,YAAa;AACf;;AAEA;EACE,eAAgB;EAChB,cAAe;EACf,kBAAmB;AACrB;AACA;EACE,YAAa;AACf;;AAEA;EACE,QAAS;EACT,MAAO;EACP,iBAAkB;EAClB,OAAQ;EACR,KAAM;EACN,wBAAyB;EACzB,6CAA8C;EAC9C,YAAa;EACb,qBAAsB;EACtB,iBAAkB;EAClB,eAAgB;EAChB,SAAU;AACZ;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,YAAa;AACf;;AAEA;EACE,0BAA2B;EAC3B,SAAU;AACZ;AACA;EACE,uBAAwB;EACxB,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;AACA;EACE,uBAAwB;EACxB,SAAU;AACZ;AACA;EACE,0BAA2B;EAC3B,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;;AAEA;EACE,0BAA2B;EAC3B,SAAU;AACZ;AACA;EACE,uBAAwB;EACxB,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;AACA;EACE,uBAAwB;EACxB,SAAU;AACZ;AACA;EACE,0BAA2B;EAC3B,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;AA+CA;EACE,eAAgB;EAChB,iBAAkB;AACpB;;AAEA;EACE,kBAAmB;EACnB,uCAAwC;EACxC,YAAa;EACb,aAAc;EACd,WAAY;EACZ,SAAU;AACZ;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,mBAAoB;EACpB,YAAa;EACb,QAAO;AACT;AACA;EACE,YAAa;AACf;;AAEA;EACE,eAAgB;EAChB,cAAe;EACf,kBAAmB;AACrB;AACA;EACE,YAAa;AACf;;AAEA;EACE,QAAS;EACT,MAAO;EACP,iBAAkB;EAClB,OAAQ;EACR,KAAM;EACN,wBAAyB;EACzB,6CAA8C;EAC9C,YAAa;EACb,qBAAsB;EACtB,iBAAkB;EAClB,eAAgB;EAChB,SAAU;AACZ;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,YAAa;AACf;;AAEA;EACE,0BAA2B;EAC3B,SAAU;AACZ;AACA;EACE,uBAAwB;EACxB,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;AACA;EACE,uBAAwB;EACxB,SAAU;AACZ;AACA;EACE,0BAA2B;EAC3B,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;;AAEA;EACE,0BAA2B;EAC3B,SAAU;AACZ;AACA;EACE,uBAAwB;EACxB,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;AACA;EACE,uBAAwB;EACxB,SAAU;AACZ;AACA;EACE,0BAA2B;EAC3B,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,sCAAuC;EAEvC,+BAAgC;AAClC;AA+CA;EAKE,6GAA8G;EAC9G,kBAAmB;EACnB,iBAAkB;EAClB,oBAAqB;EACrB,UAAW;AACb;AACA;EACE,WAAY;EACZ,iBAAkB;EAClB,UAAW;AACb;AACA;EACE,WAAY;EACZ,UAAW;EACX,UAAW;AACb;AACA;EACE,kBAAmB;EACnB,gBAAiB;AACnB;AACA;EACE,YAAa;AACf;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,gBAAiB;AACnB;AACA;EACE,UAAW;AACb;AACA;EACE,mBAAoB;AACtB;AACA;EACE,eAAgB;AAClB;AACA;EACE,SAAU;AACZ;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,iBAAkB;EAClB,iBAAkB;AACpB;AACA;EACE,WAAY;AACd;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,OAAQ;EACR,0BAA2B;AAC7B;AACA;EACE,SAAU;EACV,yBAA0B;AAC5B;AACA;EACE,mBAAoB;AACtB;AACA;EACE,qBAAsB;AACxB;AACA;EACE,oBAAqB;AACvB;AACA;EACE,sBAAuB;AACzB;AACA;EACE,yBAA0B;AAC5B;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,0BAA2B;AAC7B;AACA;EACE,4BAA6B;AAC/B;AACA;EACE,8BAA+B;AACjC;AACA;EACE,6BAA8B;AAChC;AACA;EACE,4BAA6B;AAC/B;AACA;EACE,8BAA+B;AACjC;AACA;EACE,6BAA8B;AAChC;AACA;EACE,kBAAmB;AACrB;AACA;;EAEE,aAAc;AAChB;AACA;EACE,4CAA6C;AAC/C;AACA;EACE,YAAa;EACb,gBAAiB;AACnB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;AACA;EACE,oBAAqB;AACvB;AACA;EACE,kBAAmB;EACnB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,+DAAgE;AAClE;AACA;EACE,kBAAmB;AACrB;AACA;EACE,oBAAqB;EACrB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,+DAAgE;AAClE;AACA;EACE,iBAAkB;EAClB,iBAAkB;AACpB;AACA;EACE,eAAgB;EAChB,YAAa;AACf;AACA;EACE,WAAY;AACd;AACA;EACE,mBAAoB;AACtB;AACA;EACE,YAAa;AACf;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;EACnB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;EACnB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,mJAAoJ;AACtJ;AACA;EACE,kBAAmB;AACrB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,+DAAgE;AAClE;AACA;EACE,YAAa;EACb,gBAAiB;AACnB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;AACA;EACE;IACE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;;AAEA;EACE,iBAAkB;EAClB,UAAW;EACX,aAAc;EACd,iBAAkB;EAClB,uBAAwB;AAC1B;;AAEA;EACE,YAAa;AACf;;AAEA;EACE,iCAAkC;AACpC;;AAEA;EACE,SAAU;EACV,YAAa;EACb,UAAW;AACb;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,2BAA4B;EAE5B,0DAA2D;AAC7D;AACA;EACE,SAAU;AACZ;AACA;EACE,SAAU;EACV,kBAAmB;EACnB,yBAA0B;EAC1B,2BAA4B;EAE5B,0DAA2D;AAC7D;AACA;EACE,YAAa;AACf;AACA;EACE,mBAAoB;AACtB;AACA;EACE,YAAa;AACf;;AAEA;EACE,oBAAqB;AACvB;;AAEA;EACE,UAAW;AACb;;AAEA;EACE,MAAO;EACP,iBAAkB;EAClB,OAAQ;EACR,KAAM;AACR;AA8BA;EACE;IACE,uBAAwB;EAC1B;EACA;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,kCAAmC;EACnC,kBAAmB;EACnB,aAAc;EACd,UAAW;EACX,eAAgB;EAChB,iBAAkB;EAClB,UAAW;AACb;AACA;EACE,+KAAgL;EAChL,wCAAyC;EACzC,yBAA0B;EAC1B,kBAAmB;EACnB,WAAY;EACZ,iBAAkB;EAClB,sDAAuD;EACvD,UAAW;AACb;AACA;EACE,mEAAoE;AACtE;AACA;EACE,qBAAsB;AACxB;;AAEA;EACE,gCAAiC;AACnC;AACA;EACE,wBAAyB;AAC3B;;AAEA;EACE,wBAAyB;AAC3B;;AAEA;EACE,wBAAyB;AAC3B;;AAEA;EACE,wBAAyB;AAC3B;;AAEA;EACE,wBAAyB;AAC3B;AAsBA;EACE;IACE,mCAAoC;IACpC,qCAAsC;EACxC;EACA;IACE,kCAAmC;IACnC,oCAAqC;EACvC;AACF;AAEA;EACE,wDAAyD;EACzD,mCAAoC;EACpC,sCAAuC;EACvC,gDAAiD;EACjD,iBAAkB;EAClB,0BAA2B;EAC3B,4BAA6B;EAC7B,cAAe;EACf,mBAAoB;EACpB,wBAAiB;UAAjB,gBAAiB;AACnB;AACA;;EAEE,4BAA6B;AAC/B;AA8BA;EACE,WAAY;EACZ,eAAgB;EAChB,UAAW;EACX,cAAe;EACf,YAAa;EACb,iBAAkB;EAClB,wBAAiB;UAAjB,gBAAiB;AACnB;AACA;EACE,cAAe;AACjB;AACA;EACE,eAAgB;AAClB;AACA;EACE,kBAAmB;EACnB,WAAY;AACd;AACA;EACE,WAAY;AACd;;AAEA;;EAEE,UAAW;EACX,MAAO;EACP,OAAQ;EACR,OAAQ;EACR,iBAAkB;AACpB;;AAEA;EACE,iBAAkB;EAClB,eAAgB;AAClB;;AAEA;EACE,kCAAmC;AACrC;AACA;EACE,gCAAiC;AACnC;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;AACA;EACE;IACE,qBAAsB;EACxB;AACF;;AAEA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,aAAc;EACd,iBAAkB;EAClB,2EAA4E;EAC5E,cAAe;EACf,WAAY;EACZ,MAAO;EACP,iBAAkB;EAClB,KAAM;EACN,UAAW;AACb;AACA;EACE,2BAA4B;EAC5B,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE,wBAAyB;EACzB,iFAAkF;AACpF;AACA;EACE;IACE,oBAAqB;EACvB;AACF;AACA;EACE,yCAA0C;EAC1C,eAAgB;EAChB,6BAA8B;EAC9B,kBAAmB;EACnB,YAAa;AACf;AACA;EACE,mCAAoC;AACtC;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,SAAU;AACZ;AACA;EACE,2BAA4B;EAC5B,wBAAyB;EACzB,iFAAkF;EAClF,2EAA4E;EAC5E,WAAY;EACZ,SAAU;AACZ;AACA;EACE,wBAAyB;EACzB,iFAAkF;EAClF,kHAAmH;EACnH,eAAgB;AAClB;AACA;EACE;IACE,oBAAqB;EACvB;AACF;AACA;EACE,kBAAmB;EACnB,eAAgB;EAChB,mBAAoB;AACtB;AACA;EACE,wBAAyB;EACzB,oFAAqF;AACvF;AACA;EACE,wBAAyB;EACzB,oFAAqF;AACvF;AACA;EACE,wBAAyB;EACzB,2HAA4H;AAC9H;AACA;EACE,kBAAmB;EACnB,oBAAqB;EACrB,eAAgB;AAClB;AACA;EACE,kBAAmB;EACnB,iBAAkB;EAClB,6GAA8G;EAC9G,aAAc;EACd,eAAgB;AAClB;AACA;EACE,kBAAmB;EACnB,4EAA6E;EAC7E,aAAc;AAChB;AACA;EACE,eAAgB;AAClB;AACA;EACE,SAAU;AACZ;AACA;EACE,4BAA6B;EAC7B,yBAA0B;AAC5B;AACA;EACE,2BAA4B;EAC5B,wBAAyB;EACzB,eAAgB;AAClB;AACA;EACE,aAAc;AAChB;;AAEA;EACE,+BAAgC;EAChC,oBAAqB;EACrB,cAAe;EACf,aAAc;EACd,eAAgB;EAChB,iBAAkB;EAClB,kBAAmB;AACrB;;AAEA;EACE,YAAa;EACb,cAAe;EACf,UAAW;AACb;AACA;;EAEE,QAAS;EACT,WAAY;EACZ,QAAS;EACT,KAAM;EACN,SAAU;AACZ;AACA;EACE,QAAS;AACX;AACA;EACE,8BAA+B;AACjC;AACA;EACE,QAAS;AACX;AACA;EACE,aAAc;EACd,eAAgB;AAClB;AACA;EACE,UAAW;EACX,aAAc;EACd,UAAW;AACb;AACA;EACE,8BAA+B;EAC/B,wBAAyB;AAC3B;AACA;EACE,yBAA0B;AAC5B;AACA;EACE,2BAA4B;EAC5B,4BAA6B;EAC7B,0BAA2B;EAC3B,iBAAkB;AACpB;AAQA;EACE;IACE,sBAAuB;EACzB;EACA;IACE,wBAAyB;EAC3B;AACF;AACA;EACE,kBAAmB;EACnB,YAAa;EACb,sBAAuB;EACvB,gBAAiB;EACjB,qBAAsB;AACxB;AACA;EACE,aAAc;AAChB;AACA;EACE,eAAgB;AAClB;AACA;EACE,8BAA+B;EAC/B,oBAAqB;EACrB,uBAAwB;EACxB,kEAAmE;AACrE;AACA;EACE,8BAA+B;AACjC;;AAEA;EACE,oDAAqD;AACvD;AACA;EACE,cAAe;AACjB;;AAEA;EACE,cAAe;AACjB;AACA;EACE,4BAA6B;AAC/B;;AAEA;EACE,cAAe;AACjB;;AAEA;EACE,cAAe;AACjB;;AAEA;EACE,cAAe;AACjB;;AAEA;EACE,cAAe;AACjB;AA2BA;EACE,WAAY;AACd;AACA;EACE,WAAY;AACd;;AAEA;EACE,YAAa;AACf;AACA;EACE,sBAAuB;EACvB,qBAAsB;AACxB;AACA;EACE,kBAAmB;EACnB,iBAAkB;EAClB,YAAa;EACb,cAAe;EACf,UAAW;AACb;AACA;EACE,wCAAyC;EACzC,eAAgB;AAClB;AACA;EACE;IACE,0BAA2B;IAC3B,aAAc;EAChB;AACF;AACA;EACE,wCAAyC;EACzC,iBAAkB;EAClB,QAAS;EACT,WAAY;EACZ,MAAO;EACP,OAAQ;EACR,KAAM;AACR;AACA;EACE,YAAa;EACb,iBAAkB;AACpB;;AAEA;EACE,oBAAqB;EACrB,WAAY;EACZ,YAAa;EACb,aAAc;EACd,eAAgB;EAChB,QAAS;EACT,SAAU;EACV,iBAAkB;AAEpB;AACA;EACE,iBAAkB;AACpB;;AAEA;EACE,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,aAAc;EACd,cAAe;EACf,YAAa;EACb,aAAc;EACd,cAAe;EACf,gBAAiB;EACjB,cAAe;EACf,iBAAkB;EAClB,kBAAmB;AACrB;AACA;EACE,aAAc;EACd,aAAc;EACd,oBAAqB;AACvB;AACA;EAEE,uCAAwC;EACxC,0BAA2B;AAE7B;AACA;EACE,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;EACE;IACE,cAAe;EACjB;AACF;AACA;EACE,eAAgB;EAChB,iCAAkC;AACpC;AACA;EACE,aAAc;AAChB;AACA;EACE;IACE,eAAgB;EAClB;AACF;AACA;EACE,qBAAsB;AACxB;AACA;EACE,cAAe;EACf,gBAAiB;AACnB;;AAEA;EACE,eAAgB;AAClB;AACA;EACE,YAAa;AACf;;AAEA;EACE,gBAAiB;AACnB;;AAEA;EACE,eAAgB;AAClB;;AAEA;EACE,MAAO;EACP,mBAAoB;EACpB,iBAAkB;EAClB,KAAM;EACN,sCAAuC;EACvC,mCAAoC;EACpC,yBAA0B;EAC1B,0DAA2D;AAC7D;AACA;EACE,wBAAyB;EACzB,QAAS;EACT,UAAW;EACX,MAAO;EACP,iBAAkB;EAClB,OAAQ;AACV;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;AACA;EACE,eAAgB;AAClB;AACA;EACE,WAAY;AACd;;AAEA;EACE,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE;IACE,cAAe;EACjB;AACF;AACA;EACE,iCAAkC;AACpC;AACA;EACE,aAAc;AAChB;AACA;EACE;IACE,eAAgB;EAClB;AACF;AACA;EACE,wBAAyB;AAC3B;AACA;EACE;IACE,0BAA2B;EAC7B;AACF;;AAEA;EACE,QAAS;AACX;AA6CA;EACE,mBAAoB;EACpB,kBAAmB;EACnB,kBAAmB;EACnB,wBAAyB;EACzB,WAAY;EACZ,iBAAkB;EAClB,eAAgB;EAChB,aAAc;EACd,cAAe;EACf,gBAAiB;EACjB,cAAe;EACf,eAAgB;EAChB,cAAe;EACf,eAAgB;EAChB,iBAAkB;AACpB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,gBAAiB;AACnB;AACA;;EAEE,cAAe;AACjB;AACA;EACE,yCAA0C;EAC1C,gBAAiB;EACjB,uBAAwB;AAC1B;AACA;EACE,cAAe;AACjB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;EACnB,gBAAiB;EACjB,iBAAkB;AACpB;AACA;EACE,wBAAyB;EACzB,aAAc;AAChB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,kBAAmB;AACrB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,6BAA8B;EAChC;AACF;AACA;EACE,cAAe;EACf,gBAAiB;EACjB,eAAgB;EAChB,cAAe;EACf,gBAAiB;AACnB;AACA;;;EAGE,gBAAiB;AACnB;AACA;;;EAGE,cAAe;AACjB;AACA;EACE,iBAAkB;EAClB,kBAAmB;AACrB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,aAAc;AAChB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,YAAa;EACb,UAAW;AACb;AACA;EACE,YAAa;AACf;AACA;EACE,0CAA2C;EAC3C,aAAc;AAChB;AACA;EACE,cAAe;AACjB;AACA;EACE,yCAA0C;EAC1C,aAAc;AAChB;AACA;EACE,0CAA2C;EAC3C,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,0CAA2C;EAC3C,aAAc;AAChB;AACA;EACE,cAAe;AACjB;AACA;EACE,yCAA0C;EAC1C,aAAc;AAChB;AACA;EACE,0CAA2C;EAC3C,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,yCAA0C;EAC1C,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,yCAA0C;EAC1C,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,uCAAwC;EACxC,aAAc;AAChB;AACA;EACE,wCAAyC;EACzC,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;;AAEA;EACE,eAAgB;EAChB,WAAY;EACZ,8BAA+B;EAC/B,cAAe;EACf,YAAa;EACb,kBAAmB;EAEnB,4BAA6B;EAC7B,eAAgB;EAChB,WAAY;EACZ,cAAe;AACjB;AACA;EACE,eAAgB;EAChB,aAAc;EACd,oBAAqB;AACvB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;EACd,iCAAkC;EAClC,kCAAmC;EACnC,eAAgB;AAClB;AACA;EAEE,6BAA8B;EAC9B,iBAAkB;AACpB;AACA;EACE,4CAA6C;EAC7C,cAAe;EACf,iBAAkB;EAClB,mBAAoB;EACpB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,aAAc;AAChB;AAmCA;EACE,YAAa;EACb,kBAAmB;EACnB,sBAAuB;EACvB,WAAY;EACZ,WAAY;EACZ,mBAAoB;EACpB,eAAgB;EAChB,gBAAiB;EACjB,eAAgB;AAClB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,aAAc;EACd,eAAgB;EAChB,gBAAiB;EACjB,cAAe;AACjB;AACA;EACE,YAAa;EACb,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,cAAe;EACf,gBAAiB;EACjB,cAAe;EACf,WAAY;EACZ,iBAAkB;AACpB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;EACE,WAAY;EACZ,aAAc;AAChB;AACA;;EAEE,gBAAiB;AACnB;AACA;;EAEE,cAAe;AACjB;AACA;EACE,cAAe;AACjB;AACA;EACE,gBAAiB;AACnB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,yCAA0C;EAC1C,gBAAiB;EACjB,uBAAwB;AAC1B;AACA;EACE,aAAc;EACd,gBAAiB;EACjB,UAAW;AACb;AACA;EACE,kBAAmB;AACrB;AACA;;EAEE,UAAW;EACX,aAAc;AAChB;AACA;EACE,eAAgB;EAChB,cAAe;EACf,aAAc;AAChB;AACA;EACE,WAAY;EACZ,eAAgB;AAClB;AACA;;EAEE,iBAAkB;AACpB;AACA;;EAEE,cAAe;AACjB;AACA;EACE,eAAgB;EAChB,eAAgB;AAClB;AACA;EACE,gBAAiB;AACnB;AACA;EACE,eAAgB;EAChB,cAAe;EACf,gBAAiB;EACjB,UAAW;EACX,aAAc;AAChB;AACA;EACE,UAAW;EACX,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,4GAA6G;AAC/G;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,2GAA4G;AAC9G;AACA;EACE,4GAA6G;AAC/G;AACA;EACE,2GAA4G;AAC9G;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,sCAAuC;EACvC,oKAAqK;AACvK;AACA;EACE,2IAA4I;AAC9I;AACA;EACE,2IAA4I;AAC9I;AACA;EACE,2IAA4I;AAC9I;AACA;EACE,4IAA6I;AAC/I;;AAEA;EACE,eAAgB;EAChB,WAAY;EACZ,eAAgB;EAChB,SAAU;AACZ;AACA;EACE,aAAc;EACd,SAAU;AACZ;AACA;EAEE,uBAAwB;AAC1B;AAWA;EACE,YAAa;EACb,cAAe;EACf,cAAe;EACf,SAAU;EACV,eAAgB;EAChB,iBAAkB;EAClB,kBAAmB;EACnB,UAAW;AACb;AA+CA;EACE,sBAAuB;EACvB,wBAAyB;EACzB,iBAAkB;EAClB,mHAAoH;EACpH,YAAa;EACb,eAAgB;EAChB,eAAgB;EAChB,eAAgB;EAChB,kBAAmB;EAEnB,4BAA6B;AAC/B;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,uBAAwB;EACxB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,+DAAgE;AAClE;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,uBAAwB;EACxB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,+DAAgE;AAClE;AACA;EACE,SAAU;EACV,cAAe;AACjB;AACA;EACE,SAAU;EACV,iBAAkB;EAClB,kBAAmB;EACnB,yBAA0B;EAC1B,mCAAoC;EAEpC,0DAA2D;AAC7D;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,2BAA4B;EAC5B,qBAAsB;EACtB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,aAAc;EACd,WAAY;EACZ,cAAe;AACjB;AACA;EACE,aAAc;EACd,WAAY;EACZ,cAAe;AACjB;AACA;EACE,wBAAyB;EACzB,sHAAuH;AACzH;AACA;EACE,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wBAAyB;EACzB,aAAc;AAGhB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,sCAAuC;AACzC;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,wBAAyB;EACzB,aAAc;AAGhB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,sCAAuC;AACzC;AACA;EACE,yCAA0C;AAC5C;AACA;EACE,wBAAyB;EACzB,aAAc;AAGhB;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,sCAAuC;AACzC;AACA;EACE,sCAAuC;AACzC;AACA;EACE,wBAAyB;EACzB,aAAc;AAGhB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,mCAAoC;EACpC,wBAAyB;AAC3B;AACA;EACE,sCAAuC;AACzC;AACA;EACE,yCAA0C;AAC5C;;AAEA;EACE,aAAc;EACd,YAAa;EACb,qBAAsB;AACxB;;AAEA;EACE,kBAAmB;EAEnB,uBAAwB;EACxB,qBAAsB;EACtB,MAAO;EACP,eAAgB;EAChB,mBAAoB;EACpB,mBAAoB;EACpB,OAAQ;EACR,UAAW;AACb;AACA;EACE,cAAe;AACjB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,KAAM;AACR;AACA;EACE,QAAS;EACT,6BAA8B;EAC9B,QAAS;AACX;AACA;EACE,sBAAuB;AACzB;AACA;EACE,oBAAqB;AACvB;;AAEA;EACE,0BAA2B;AAC7B;AA2DA;EAKE,6GAA8G;EAC9G,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,WAAY;EACZ,iBAAkB;EAClB,UAAW;AACb;AACA;EACE,WAAY;EACZ,UAAW;EACX,UAAW;AACb;AACA;EACE,kBAAmB;EACnB,gBAAiB;AACnB;AACA;EACE,WAAY;AACd;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,gBAAiB;AACnB;AACA;EACE,SAAU;AACZ;AACA;EACE,mBAAoB;AACtB;AACA;EACE,eAAgB;AAClB;AACA;EACE,QAAS;AACX;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,iBAAkB;EAClB,iBAAkB;AACpB;AACA;EACE,UAAW;AACb;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,OAAQ;EACR,0BAA2B;AAC7B;AACA;EACE,SAAU;EACV,yBAA0B;AAC5B;AACA;EACE,mBAAoB;AACtB;AACA;EACE,qBAAsB;AACxB;AACA;EACE,oBAAqB;AACvB;AACA;EACE,sBAAuB;AACzB;AACA;EACE,yBAA0B;AAC5B;AACA;EACE,2BAA4B;AAC9B;AACA;EACE,0BAA2B;AAC7B;AACA;EACE,4BAA6B;AAC/B;AACA;EACE,8BAA+B;AACjC;AACA;EACE,6BAA8B;AAChC;AACA;EACE,4BAA6B;AAC/B;AACA;EACE,8BAA+B;AACjC;AACA;EACE,6BAA8B;AAChC;AACA;EACE,kBAAmB;AACrB;AACA;;EAEE,aAAc;AAChB;AACA;EACE,4CAA6C;AAC/C;AACA;EACE,YAAa;EACb,gBAAiB;AACnB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;AACA;EACE,oBAAqB;AACvB;AACA;EACE,kBAAmB;EACnB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,kBAAmB;AACrB;AACA;EACE,oBAAqB;EACrB,kBAAmB;EACnB,yBAA0B;EAC1B,6BAA8B;EAE9B,0DAA2D;AAC7D;AACA;EACE,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,qCAAsC;AACxC;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;EAEE,gCAAiC;EACjC,gDAAiD;EACjD,aAAc;AAChB;AACA;;EAEE,aAAc;AAChB;AACA;;EAEE,gCAAiC;EACjC,gDAAiD;EACjD,aAAc;AAChB;AACA;;EAEE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;;EAEE,kBAAmB;EACnB,sFAAuF;EACvF,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,iBAAkB;AACpB;AACA;EACE,4EAA6E;AAC/E;AACA;EACE,kBAAmB;AACrB;AACA;;;EAGE,aAAc;AAChB;AACA;EACE,4CAA6C;AAC/C;AACA;EACE,YAAa;EACb,gBAAiB;AACnB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;AACA;EACE,aAAc;AAChB;AACA;EACE,6BAA8B;AAChC;AACA;EACE,mCAAoC;AACtC;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;;;EAGE,mCAAoC;EACpC,gDAAiD;EACjD,aAAc;AAChB;AACA;;;EAGE,aAAc;AAChB;AACA;;;EAGE,mCAAoC;EACpC,iDAAkD;EAClD,aAAc;AAChB;AACA;;;EAGE,eAAgB;EAChB,eAAgB;EAChB,aAAc;AAChB;AACA;EACE;;;IAGE,6BAA8B;IAC9B,eAAgB;EAClB;AACF;AACA;;;EAGE,kBAAmB;EACnB,2EAA4E;EAC5E,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;AACA;EACE,kBAAmB;EACnB,aAAc;AAChB;AACA;EACE,YAAa;AACf;AACA;EACE;IACE,iBAAkB;EACpB;AACF;;AAEA;EACE,wBAAyB;EACzB,WAAY;AACd;AA8CA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;;AAEA;EACE,eAAgB;EAChB,QAAS;EACT,cAAe;AACjB;;AAEA;EACE,4BAA6B;EAC7B,cAAe;EACf,cAAe;EACf,iBAAkB;AACpB;;AAEA;EACE,gBAAiB;AACnB;;AAEA;EACE,iBAAkB;AACpB;;AAEA;EACE,iBAAkB;AACpB;;AAEA;EACE,iBAAkB;AACpB;;AAEA;EACE,iBAAkB;AACpB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;AACrB;;AAEA;EACE,kBAAmB;EACnB,eAAgB;EAChB,YAAa;EACb,WAAY;EACZ,iBAAkB;EAClB,UAAW;AACb;AACA;EACE,0CAA2C;AAC7C;AACA;EACE,yCAA0C;AAC5C;;AAEA;;EAEE,cAAe;AACjB;;AAEA;EACE,aAAc;EACd,cAAe;EACf,WAAY;EACZ,sBAAuB;EACvB,0DAA2D;AAC7D;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,uBAAwB;AAC1B;AACA;EACE,eAAgB;AAClB;;AAEA;EACE,gBAAiB;EACjB,iBAAkB;AACpB;;AAEA;EACE,eAAgB;EAChB,sBAAuB;EACvB,kBAAmB;EACnB,gBAAiB;EACjB,aAAc;EACd,iBAAkB;EAClB,wBAAiB;UAAjB,gBAAiB;AACnB;AACA;EACE,cAAe;AACjB;;AAEA;EACE,aAAc;EACd,wBAAiB;UAAjB,gBAAiB;AACnB;AACA;;EAEE,kBAAmB;EACnB,YAAa;AACf;;AAEA;EACE,wBAAyB;EACzB,6BAA8B;EAC9B,kBAAmB;AACrB;AACA;;EAEE,6BAA8B;EAC9B,kBAAmB;AACrB;;AAEA;EACE,wBAAyB;AAC3B;AACA;;EAEE,aAAc;AAChB;AACA;EACE,8BAA+B;AACjC;AACA;EACE,aAAc;AAChB;;AAEA;EACE,wCAAyC;AAC3C;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,aAAc;AAChB;AACA;EACE,wBAAyB;AAC3B;AACA;EACE,aAAc;AAChB","sourcesContent":["@charset \"UTF-8\";\n/*\n\nCopyright 2021-present Palantir Technologies, Inc. All rights reserved.\nLicensed under the Apache License, Version 2.0.\n\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\nhtml {\n  box-sizing: border-box;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\nbody {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.28581;\n  text-transform: none;\n  color: #1c2127;\n  font-family: -apple-system, \"BlinkMacSystemFont\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Open Sans\", \"Helvetica Neue\", \"blueprint-icons-16\", sans-serif;\n}\n\np {\n  margin-bottom: 10px;\n  margin-top: 0;\n}\n\nsmall {\n  font-size: 12px;\n}\n\nstrong {\n  font-weight: 600;\n}\n\n::selection {\n  background: rgba(125, 188, 255, 0.6);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-icon {\n  display: inline-block;\n  flex: 0 0 auto;\n  vertical-align: text-bottom;\n}\n.bp4-icon:not(:empty)::before {\n  /* stylelint-disable */\n  content: \"\" !important;\n  content: unset !important;\n  /* stylelint-enable */\n}\n.bp4-icon > svg {\n  display: block;\n}\n.bp4-icon > svg:not([fill]) {\n  fill: currentcolor;\n}\n\nspan.bp4-icon-standard {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n}\n\nspan.bp4-icon-large {\n  font-family: \"blueprint-icons-20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n}\n\nspan.bp4-icon:empty {\n  font-family: \"blueprint-icons-20\";\n  font-size: inherit;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n}\nspan.bp4-icon:empty::before {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\n.bp4-icon-add::before {\n  content: \"\\f109\";\n}\n\n.bp4-icon-add-clip::before {\n  content: \"\\f101\";\n}\n\n.bp4-icon-add-column-left::before {\n  content: \"\\f102\";\n}\n\n.bp4-icon-add-column-right::before {\n  content: \"\\f103\";\n}\n\n.bp4-icon-add-location::before {\n  content: \"\\f104\";\n}\n\n.bp4-icon-add-row-bottom::before {\n  content: \"\\f105\";\n}\n\n.bp4-icon-add-row-top::before {\n  content: \"\\f106\";\n}\n\n.bp4-icon-add-to-artifact::before {\n  content: \"\\f107\";\n}\n\n.bp4-icon-add-to-folder::before {\n  content: \"\\f108\";\n}\n\n.bp4-icon-aimpoints-target::before {\n  content: \"\\f335\";\n}\n\n.bp4-icon-airplane::before {\n  content: \"\\f10a\";\n}\n\n.bp4-icon-align-center::before {\n  content: \"\\f10b\";\n}\n\n.bp4-icon-align-justify::before {\n  content: \"\\f10c\";\n}\n\n.bp4-icon-align-left::before {\n  content: \"\\f10d\";\n}\n\n.bp4-icon-align-right::before {\n  content: \"\\f10e\";\n}\n\n.bp4-icon-alignment-bottom::before {\n  content: \"\\f10f\";\n}\n\n.bp4-icon-alignment-horizontal-center::before {\n  content: \"\\f110\";\n}\n\n.bp4-icon-alignment-left::before {\n  content: \"\\f111\";\n}\n\n.bp4-icon-alignment-right::before {\n  content: \"\\f112\";\n}\n\n.bp4-icon-alignment-top::before {\n  content: \"\\f113\";\n}\n\n.bp4-icon-alignment-vertical-center::before {\n  content: \"\\f114\";\n}\n\n.bp4-icon-ammunition::before {\n  content: \"\\f342\";\n}\n\n.bp4-icon-anchor::before {\n  content: \"\\f330\";\n}\n\n.bp4-icon-annotation::before {\n  content: \"\\f115\";\n}\n\n.bp4-icon-antenna::before {\n  content: \"\\f116\";\n}\n\n.bp4-icon-app-header::before {\n  content: \"\\f117\";\n}\n\n.bp4-icon-application::before {\n  content: \"\\f118\";\n}\n\n.bp4-icon-applications::before {\n  content: \"\\f119\";\n}\n\n.bp4-icon-archive::before {\n  content: \"\\f11a\";\n}\n\n.bp4-icon-area-of-interest::before {\n  content: \"\\f11b\";\n}\n\n.bp4-icon-array::before {\n  content: \"\\f121\";\n}\n\n.bp4-icon-array-boolean::before {\n  content: \"\\f11c\";\n}\n\n.bp4-icon-array-date::before {\n  content: \"\\f11d\";\n}\n\n.bp4-icon-array-floating-point::before {\n  content: \"\\f32d\";\n}\n\n.bp4-icon-array-numeric::before {\n  content: \"\\f11e\";\n}\n\n.bp4-icon-array-string::before {\n  content: \"\\f11f\";\n}\n\n.bp4-icon-array-timestamp::before {\n  content: \"\\f120\";\n}\n\n.bp4-icon-arrow-bottom-left::before {\n  content: \"\\f122\";\n}\n\n.bp4-icon-arrow-bottom-right::before {\n  content: \"\\f123\";\n}\n\n.bp4-icon-arrow-down::before {\n  content: \"\\f124\";\n}\n\n.bp4-icon-arrow-left::before {\n  content: \"\\f125\";\n}\n\n.bp4-icon-arrow-right::before {\n  content: \"\\f126\";\n}\n\n.bp4-icon-arrow-top-left::before {\n  content: \"\\f127\";\n}\n\n.bp4-icon-arrow-top-right::before {\n  content: \"\\f128\";\n}\n\n.bp4-icon-arrow-up::before {\n  content: \"\\f129\";\n}\n\n.bp4-icon-arrows-horizontal::before {\n  content: \"\\f12a\";\n}\n\n.bp4-icon-arrows-vertical::before {\n  content: \"\\f12b\";\n}\n\n.bp4-icon-asterisk::before {\n  content: \"\\f12c\";\n}\n\n.bp4-icon-at::before {\n  content: \"\\f331\";\n}\n\n.bp4-icon-automatic-updates::before {\n  content: \"\\f12d\";\n}\n\n.bp4-icon-axle::before {\n  content: \"\\f338\";\n}\n\n.bp4-icon-backlink::before {\n  content: \"\\f12e\";\n}\n\n.bp4-icon-badge::before {\n  content: \"\\f12f\";\n}\n\n.bp4-icon-ban-circle::before {\n  content: \"\\f130\";\n}\n\n.bp4-icon-bank-account::before {\n  content: \"\\f131\";\n}\n\n.bp4-icon-barcode::before {\n  content: \"\\f132\";\n}\n\n.bp4-icon-blank::before {\n  content: \"\\f133\";\n}\n\n.bp4-icon-blocked-person::before {\n  content: \"\\f134\";\n}\n\n.bp4-icon-bold::before {\n  content: \"\\f135\";\n}\n\n.bp4-icon-book::before {\n  content: \"\\f136\";\n}\n\n.bp4-icon-bookmark::before {\n  content: \"\\f137\";\n}\n\n.bp4-icon-box::before {\n  content: \"\\f138\";\n}\n\n.bp4-icon-briefcase::before {\n  content: \"\\f139\";\n}\n\n.bp4-icon-bring-data::before {\n  content: \"\\f13a\";\n}\n\n.bp4-icon-bug::before {\n  content: \"\\f32e\";\n}\n\n.bp4-icon-buggy::before {\n  content: \"\\f13b\";\n}\n\n.bp4-icon-build::before {\n  content: \"\\f13c\";\n}\n\n.bp4-icon-calculator::before {\n  content: \"\\f13d\";\n}\n\n.bp4-icon-calendar::before {\n  content: \"\\f13e\";\n}\n\n.bp4-icon-camera::before {\n  content: \"\\f13f\";\n}\n\n.bp4-icon-caret-down::before {\n  content: \"\\f140\";\n}\n\n.bp4-icon-caret-left::before {\n  content: \"\\f141\";\n}\n\n.bp4-icon-caret-right::before {\n  content: \"\\f142\";\n}\n\n.bp4-icon-caret-up::before {\n  content: \"\\f143\";\n}\n\n.bp4-icon-cargo-ship::before {\n  content: \"\\f144\";\n}\n\n.bp4-icon-cell-tower::before {\n  content: \"\\f145\";\n}\n\n.bp4-icon-changes::before {\n  content: \"\\f146\";\n}\n\n.bp4-icon-chart::before {\n  content: \"\\f147\";\n}\n\n.bp4-icon-chat::before {\n  content: \"\\f148\";\n}\n\n.bp4-icon-chevron-backward::before {\n  content: \"\\f149\";\n}\n\n.bp4-icon-chevron-down::before {\n  content: \"\\f14a\";\n}\n\n.bp4-icon-chevron-forward::before {\n  content: \"\\f14b\";\n}\n\n.bp4-icon-chevron-left::before {\n  content: \"\\f14c\";\n}\n\n.bp4-icon-chevron-right::before {\n  content: \"\\f14d\";\n}\n\n.bp4-icon-chevron-up::before {\n  content: \"\\f14e\";\n}\n\n.bp4-icon-circle::before {\n  content: \"\\f153\";\n}\n\n.bp4-icon-circle-arrow-down::before {\n  content: \"\\f14f\";\n}\n\n.bp4-icon-circle-arrow-left::before {\n  content: \"\\f150\";\n}\n\n.bp4-icon-circle-arrow-right::before {\n  content: \"\\f151\";\n}\n\n.bp4-icon-circle-arrow-up::before {\n  content: \"\\f152\";\n}\n\n.bp4-icon-citation::before {\n  content: \"\\f154\";\n}\n\n.bp4-icon-clean::before {\n  content: \"\\f155\";\n}\n\n.bp4-icon-clip::before {\n  content: \"\\f156\";\n}\n\n.bp4-icon-clipboard::before {\n  content: \"\\f157\";\n}\n\n.bp4-icon-cloud::before {\n  content: \"\\f15a\";\n}\n\n.bp4-icon-cloud-download::before {\n  content: \"\\f158\";\n}\n\n.bp4-icon-cloud-upload::before {\n  content: \"\\f159\";\n}\n\n.bp4-icon-code::before {\n  content: \"\\f15c\";\n}\n\n.bp4-icon-code-block::before {\n  content: \"\\f15b\";\n}\n\n.bp4-icon-cog::before {\n  content: \"\\f15d\";\n}\n\n.bp4-icon-collapse-all::before {\n  content: \"\\f15e\";\n}\n\n.bp4-icon-color-fill::before {\n  content: \"\\f328\";\n}\n\n.bp4-icon-column-layout::before {\n  content: \"\\f15f\";\n}\n\n.bp4-icon-comment::before {\n  content: \"\\f160\";\n}\n\n.bp4-icon-comparison::before {\n  content: \"\\f161\";\n}\n\n.bp4-icon-compass::before {\n  content: \"\\f162\";\n}\n\n.bp4-icon-compressed::before {\n  content: \"\\f163\";\n}\n\n.bp4-icon-confirm::before {\n  content: \"\\f164\";\n}\n\n.bp4-icon-console::before {\n  content: \"\\f165\";\n}\n\n.bp4-icon-contrast::before {\n  content: \"\\f166\";\n}\n\n.bp4-icon-control::before {\n  content: \"\\f167\";\n}\n\n.bp4-icon-credit-card::before {\n  content: \"\\f168\";\n}\n\n.bp4-icon-cross::before {\n  content: \"\\f169\";\n}\n\n.bp4-icon-cross-circle::before {\n  content: \"\\f336\";\n}\n\n.bp4-icon-crown::before {\n  content: \"\\f16a\";\n}\n\n.bp4-icon-cube::before {\n  content: \"\\f16d\";\n}\n\n.bp4-icon-cube-add::before {\n  content: \"\\f16b\";\n}\n\n.bp4-icon-cube-remove::before {\n  content: \"\\f16c\";\n}\n\n.bp4-icon-curved-range-chart::before {\n  content: \"\\f16e\";\n}\n\n.bp4-icon-cut::before {\n  content: \"\\f16f\";\n}\n\n.bp4-icon-cycle::before {\n  content: \"\\f170\";\n}\n\n.bp4-icon-dashboard::before {\n  content: \"\\f171\";\n}\n\n.bp4-icon-data-connection::before {\n  content: \"\\f172\";\n}\n\n.bp4-icon-data-lineage::before {\n  content: \"\\f173\";\n}\n\n.bp4-icon-database::before {\n  content: \"\\f174\";\n}\n\n.bp4-icon-delete::before {\n  content: \"\\f175\";\n}\n\n.bp4-icon-delta::before {\n  content: \"\\f176\";\n}\n\n.bp4-icon-derive-column::before {\n  content: \"\\f177\";\n}\n\n.bp4-icon-desktop::before {\n  content: \"\\f178\";\n}\n\n.bp4-icon-detection::before {\n  content: \"\\f341\";\n}\n\n.bp4-icon-diagnosis::before {\n  content: \"\\f179\";\n}\n\n.bp4-icon-diagram-tree::before {\n  content: \"\\f17a\";\n}\n\n.bp4-icon-direction-left::before {\n  content: \"\\f17b\";\n}\n\n.bp4-icon-direction-right::before {\n  content: \"\\f17c\";\n}\n\n.bp4-icon-disable::before {\n  content: \"\\f17d\";\n}\n\n.bp4-icon-divide::before {\n  content: \"\\f327\";\n}\n\n.bp4-icon-document::before {\n  content: \"\\f180\";\n}\n\n.bp4-icon-document-open::before {\n  content: \"\\f17e\";\n}\n\n.bp4-icon-document-share::before {\n  content: \"\\f17f\";\n}\n\n.bp4-icon-dollar::before {\n  content: \"\\f181\";\n}\n\n.bp4-icon-dot::before {\n  content: \"\\f182\";\n}\n\n.bp4-icon-double-caret-horizontal::before {\n  content: \"\\f183\";\n}\n\n.bp4-icon-double-caret-vertical::before {\n  content: \"\\f184\";\n}\n\n.bp4-icon-double-chevron-down::before {\n  content: \"\\f185\";\n}\n\n.bp4-icon-double-chevron-left::before {\n  content: \"\\f186\";\n}\n\n.bp4-icon-double-chevron-right::before {\n  content: \"\\f187\";\n}\n\n.bp4-icon-double-chevron-up::before {\n  content: \"\\f188\";\n}\n\n.bp4-icon-doughnut-chart::before {\n  content: \"\\f189\";\n}\n\n.bp4-icon-download::before {\n  content: \"\\f18a\";\n}\n\n.bp4-icon-drag-handle-horizontal::before {\n  content: \"\\f18b\";\n}\n\n.bp4-icon-drag-handle-vertical::before {\n  content: \"\\f18c\";\n}\n\n.bp4-icon-draw::before {\n  content: \"\\f18d\";\n}\n\n.bp4-icon-drawer-left::before {\n  content: \"\\f18f\";\n}\n\n.bp4-icon-drawer-left-filled::before {\n  content: \"\\f18e\";\n}\n\n.bp4-icon-drawer-right::before {\n  content: \"\\f191\";\n}\n\n.bp4-icon-drawer-right-filled::before {\n  content: \"\\f190\";\n}\n\n.bp4-icon-drive-time::before {\n  content: \"\\f192\";\n}\n\n.bp4-icon-duplicate::before {\n  content: \"\\f193\";\n}\n\n.bp4-icon-edit::before {\n  content: \"\\f194\";\n}\n\n.bp4-icon-eject::before {\n  content: \"\\f195\";\n}\n\n.bp4-icon-emoji::before {\n  content: \"\\f196\";\n}\n\n.bp4-icon-endorsed::before {\n  content: \"\\f197\";\n}\n\n.bp4-icon-envelope::before {\n  content: \"\\f198\";\n}\n\n.bp4-icon-equals::before {\n  content: \"\\f199\";\n}\n\n.bp4-icon-eraser::before {\n  content: \"\\f19a\";\n}\n\n.bp4-icon-error::before {\n  content: \"\\f19b\";\n}\n\n.bp4-icon-euro::before {\n  content: \"\\f19c\";\n}\n\n.bp4-icon-exchange::before {\n  content: \"\\f19d\";\n}\n\n.bp4-icon-exclude-row::before {\n  content: \"\\f19e\";\n}\n\n.bp4-icon-expand-all::before {\n  content: \"\\f19f\";\n}\n\n.bp4-icon-export::before {\n  content: \"\\f1a0\";\n}\n\n.bp4-icon-eye-off::before {\n  content: \"\\f1a1\";\n}\n\n.bp4-icon-eye-on::before {\n  content: \"\\f1a2\";\n}\n\n.bp4-icon-eye-open::before {\n  content: \"\\f1a3\";\n}\n\n.bp4-icon-fast-backward::before {\n  content: \"\\f1a4\";\n}\n\n.bp4-icon-fast-forward::before {\n  content: \"\\f1a5\";\n}\n\n.bp4-icon-feed::before {\n  content: \"\\f1a7\";\n}\n\n.bp4-icon-feed-subscribed::before {\n  content: \"\\f1a6\";\n}\n\n.bp4-icon-film::before {\n  content: \"\\f1a8\";\n}\n\n.bp4-icon-filter::before {\n  content: \"\\f1ad\";\n}\n\n.bp4-icon-filter-keep::before {\n  content: \"\\f1a9\";\n}\n\n.bp4-icon-filter-list::before {\n  content: \"\\f1aa\";\n}\n\n.bp4-icon-filter-open::before {\n  content: \"\\f1ab\";\n}\n\n.bp4-icon-filter-remove::before {\n  content: \"\\f1ac\";\n}\n\n.bp4-icon-flag::before {\n  content: \"\\f1ae\";\n}\n\n.bp4-icon-flame::before {\n  content: \"\\f1af\";\n}\n\n.bp4-icon-flash::before {\n  content: \"\\f1b0\";\n}\n\n.bp4-icon-floating-point::before {\n  content: \"\\f32c\";\n}\n\n.bp4-icon-floppy-disk::before {\n  content: \"\\f1b1\";\n}\n\n.bp4-icon-flow-branch::before {\n  content: \"\\f1b2\";\n}\n\n.bp4-icon-flow-end::before {\n  content: \"\\f1b3\";\n}\n\n.bp4-icon-flow-linear::before {\n  content: \"\\f1b4\";\n}\n\n.bp4-icon-flow-review::before {\n  content: \"\\f1b6\";\n}\n\n.bp4-icon-flow-review-branch::before {\n  content: \"\\f1b5\";\n}\n\n.bp4-icon-flows::before {\n  content: \"\\f1b7\";\n}\n\n.bp4-icon-folder-close::before {\n  content: \"\\f1b8\";\n}\n\n.bp4-icon-folder-new::before {\n  content: \"\\f1b9\";\n}\n\n.bp4-icon-folder-open::before {\n  content: \"\\f1ba\";\n}\n\n.bp4-icon-folder-shared::before {\n  content: \"\\f1bc\";\n}\n\n.bp4-icon-folder-shared-open::before {\n  content: \"\\f1bb\";\n}\n\n.bp4-icon-follower::before {\n  content: \"\\f1bd\";\n}\n\n.bp4-icon-following::before {\n  content: \"\\f1be\";\n}\n\n.bp4-icon-font::before {\n  content: \"\\f1bf\";\n}\n\n.bp4-icon-fork::before {\n  content: \"\\f1c0\";\n}\n\n.bp4-icon-form::before {\n  content: \"\\f1c1\";\n}\n\n.bp4-icon-fuel::before {\n  content: \"\\f323\";\n}\n\n.bp4-icon-full-circle::before {\n  content: \"\\f1c2\";\n}\n\n.bp4-icon-full-stacked-chart::before {\n  content: \"\\f1c3\";\n}\n\n.bp4-icon-fullscreen::before {\n  content: \"\\f1c4\";\n}\n\n.bp4-icon-function::before {\n  content: \"\\f1c5\";\n}\n\n.bp4-icon-gantt-chart::before {\n  content: \"\\f1c6\";\n}\n\n.bp4-icon-geofence::before {\n  content: \"\\f1c7\";\n}\n\n.bp4-icon-geolocation::before {\n  content: \"\\f1c8\";\n}\n\n.bp4-icon-geosearch::before {\n  content: \"\\f1c9\";\n}\n\n.bp4-icon-git-branch::before {\n  content: \"\\f1ca\";\n}\n\n.bp4-icon-git-commit::before {\n  content: \"\\f1cb\";\n}\n\n.bp4-icon-git-merge::before {\n  content: \"\\f1cc\";\n}\n\n.bp4-icon-git-new-branch::before {\n  content: \"\\f1cd\";\n}\n\n.bp4-icon-git-pull::before {\n  content: \"\\f1ce\";\n}\n\n.bp4-icon-git-push::before {\n  content: \"\\f1cf\";\n}\n\n.bp4-icon-git-repo::before {\n  content: \"\\f1d0\";\n}\n\n.bp4-icon-glass::before {\n  content: \"\\f1d1\";\n}\n\n.bp4-icon-globe::before {\n  content: \"\\f1d3\";\n}\n\n.bp4-icon-globe-network::before {\n  content: \"\\f1d2\";\n}\n\n.bp4-icon-graph::before {\n  content: \"\\f1d5\";\n}\n\n.bp4-icon-graph-remove::before {\n  content: \"\\f1d4\";\n}\n\n.bp4-icon-greater-than::before {\n  content: \"\\f1d7\";\n}\n\n.bp4-icon-greater-than-or-equal-to::before {\n  content: \"\\f1d6\";\n}\n\n.bp4-icon-grid::before {\n  content: \"\\f1d9\";\n}\n\n.bp4-icon-grid-view::before {\n  content: \"\\f1d8\";\n}\n\n.bp4-icon-group-objects::before {\n  content: \"\\f1da\";\n}\n\n.bp4-icon-grouped-bar-chart::before {\n  content: \"\\f1db\";\n}\n\n.bp4-icon-hand::before {\n  content: \"\\f1e0\";\n}\n\n.bp4-icon-hand-down::before {\n  content: \"\\f1dc\";\n}\n\n.bp4-icon-hand-left::before {\n  content: \"\\f1dd\";\n}\n\n.bp4-icon-hand-right::before {\n  content: \"\\f1de\";\n}\n\n.bp4-icon-hand-up::before {\n  content: \"\\f1df\";\n}\n\n.bp4-icon-hat::before {\n  content: \"\\f1e1\";\n}\n\n.bp4-icon-header::before {\n  content: \"\\f1e5\";\n}\n\n.bp4-icon-header-one::before {\n  content: \"\\f1e2\";\n}\n\n.bp4-icon-header-three::before {\n  content: \"\\f1e3\";\n}\n\n.bp4-icon-header-two::before {\n  content: \"\\f1e4\";\n}\n\n.bp4-icon-headset::before {\n  content: \"\\f1e6\";\n}\n\n.bp4-icon-heart::before {\n  content: \"\\f1e8\";\n}\n\n.bp4-icon-heart-broken::before {\n  content: \"\\f1e7\";\n}\n\n.bp4-icon-heat-grid::before {\n  content: \"\\f1e9\";\n}\n\n.bp4-icon-heatmap::before {\n  content: \"\\f1ea\";\n}\n\n.bp4-icon-helicopter::before {\n  content: \"\\f1eb\";\n}\n\n.bp4-icon-help::before {\n  content: \"\\f1ec\";\n}\n\n.bp4-icon-helper-management::before {\n  content: \"\\f1ed\";\n}\n\n.bp4-icon-high-priority::before {\n  content: \"\\f1ee\";\n}\n\n.bp4-icon-high-voltage-pole::before {\n  content: \"\\f333\";\n}\n\n.bp4-icon-highlight::before {\n  content: \"\\f1ef\";\n}\n\n.bp4-icon-history::before {\n  content: \"\\f1f0\";\n}\n\n.bp4-icon-home::before {\n  content: \"\\f1f1\";\n}\n\n.bp4-icon-horizontal-bar-chart::before {\n  content: \"\\f1f4\";\n}\n\n.bp4-icon-horizontal-bar-chart-asc::before {\n  content: \"\\f1f2\";\n}\n\n.bp4-icon-horizontal-bar-chart-desc::before {\n  content: \"\\f1f3\";\n}\n\n.bp4-icon-horizontal-distribution::before {\n  content: \"\\f1f5\";\n}\n\n.bp4-icon-horizontal-inbetween::before {\n  content: \"\\f329\";\n}\n\n.bp4-icon-hurricane::before {\n  content: \"\\f1f6\";\n}\n\n.bp4-icon-id-number::before {\n  content: \"\\f1f7\";\n}\n\n.bp4-icon-image-rotate-left::before {\n  content: \"\\f1f8\";\n}\n\n.bp4-icon-image-rotate-right::before {\n  content: \"\\f1f9\";\n}\n\n.bp4-icon-import::before {\n  content: \"\\f1fa\";\n}\n\n.bp4-icon-inbox::before {\n  content: \"\\f1ff\";\n}\n\n.bp4-icon-inbox-filtered::before {\n  content: \"\\f1fb\";\n}\n\n.bp4-icon-inbox-geo::before {\n  content: \"\\f1fc\";\n}\n\n.bp4-icon-inbox-search::before {\n  content: \"\\f1fd\";\n}\n\n.bp4-icon-inbox-update::before {\n  content: \"\\f1fe\";\n}\n\n.bp4-icon-info-sign::before {\n  content: \"\\f200\";\n}\n\n.bp4-icon-inheritance::before {\n  content: \"\\f201\";\n}\n\n.bp4-icon-inherited-group::before {\n  content: \"\\f202\";\n}\n\n.bp4-icon-inner-join::before {\n  content: \"\\f203\";\n}\n\n.bp4-icon-insert::before {\n  content: \"\\f204\";\n}\n\n.bp4-icon-intelligence::before {\n  content: \"\\f337\";\n}\n\n.bp4-icon-intersection::before {\n  content: \"\\f205\";\n}\n\n.bp4-icon-ip-address::before {\n  content: \"\\f206\";\n}\n\n.bp4-icon-issue::before {\n  content: \"\\f209\";\n}\n\n.bp4-icon-issue-closed::before {\n  content: \"\\f207\";\n}\n\n.bp4-icon-issue-new::before {\n  content: \"\\f208\";\n}\n\n.bp4-icon-italic::before {\n  content: \"\\f20a\";\n}\n\n.bp4-icon-join-table::before {\n  content: \"\\f20b\";\n}\n\n.bp4-icon-key::before {\n  content: \"\\f215\";\n}\n\n.bp4-icon-key-backspace::before {\n  content: \"\\f20c\";\n}\n\n.bp4-icon-key-command::before {\n  content: \"\\f20d\";\n}\n\n.bp4-icon-key-control::before {\n  content: \"\\f20e\";\n}\n\n.bp4-icon-key-delete::before {\n  content: \"\\f20f\";\n}\n\n.bp4-icon-key-enter::before {\n  content: \"\\f210\";\n}\n\n.bp4-icon-key-escape::before {\n  content: \"\\f211\";\n}\n\n.bp4-icon-key-option::before {\n  content: \"\\f212\";\n}\n\n.bp4-icon-key-shift::before {\n  content: \"\\f213\";\n}\n\n.bp4-icon-key-tab::before {\n  content: \"\\f214\";\n}\n\n.bp4-icon-known-vehicle::before {\n  content: \"\\f216\";\n}\n\n.bp4-icon-lab-test::before {\n  content: \"\\f217\";\n}\n\n.bp4-icon-label::before {\n  content: \"\\f218\";\n}\n\n.bp4-icon-layer::before {\n  content: \"\\f21a\";\n}\n\n.bp4-icon-layer-outline::before {\n  content: \"\\f219\";\n}\n\n.bp4-icon-layers::before {\n  content: \"\\f21b\";\n}\n\n.bp4-icon-layout::before {\n  content: \"\\f225\";\n}\n\n.bp4-icon-layout-auto::before {\n  content: \"\\f21c\";\n}\n\n.bp4-icon-layout-balloon::before {\n  content: \"\\f21d\";\n}\n\n.bp4-icon-layout-circle::before {\n  content: \"\\f21e\";\n}\n\n.bp4-icon-layout-grid::before {\n  content: \"\\f21f\";\n}\n\n.bp4-icon-layout-group-by::before {\n  content: \"\\f220\";\n}\n\n.bp4-icon-layout-hierarchy::before {\n  content: \"\\f221\";\n}\n\n.bp4-icon-layout-linear::before {\n  content: \"\\f222\";\n}\n\n.bp4-icon-layout-skew-grid::before {\n  content: \"\\f223\";\n}\n\n.bp4-icon-layout-sorted-clusters::before {\n  content: \"\\f224\";\n}\n\n.bp4-icon-learning::before {\n  content: \"\\f226\";\n}\n\n.bp4-icon-left-join::before {\n  content: \"\\f227\";\n}\n\n.bp4-icon-lengthen-text::before {\n  content: \"\\f33e\";\n}\n\n.bp4-icon-less-than::before {\n  content: \"\\f229\";\n}\n\n.bp4-icon-less-than-or-equal-to::before {\n  content: \"\\f228\";\n}\n\n.bp4-icon-lifesaver::before {\n  content: \"\\f22a\";\n}\n\n.bp4-icon-lightbulb::before {\n  content: \"\\f22b\";\n}\n\n.bp4-icon-lightning::before {\n  content: \"\\f22c\";\n}\n\n.bp4-icon-link::before {\n  content: \"\\f22d\";\n}\n\n.bp4-icon-list::before {\n  content: \"\\f230\";\n}\n\n.bp4-icon-list-columns::before {\n  content: \"\\f22e\";\n}\n\n.bp4-icon-list-detail-view::before {\n  content: \"\\f22f\";\n}\n\n.bp4-icon-locate::before {\n  content: \"\\f231\";\n}\n\n.bp4-icon-lock::before {\n  content: \"\\f232\";\n}\n\n.bp4-icon-locomotive::before {\n  content: \"\\f33b\";\n}\n\n.bp4-icon-log-in::before {\n  content: \"\\f233\";\n}\n\n.bp4-icon-log-out::before {\n  content: \"\\f234\";\n}\n\n.bp4-icon-low-voltage-pole::before {\n  content: \"\\f332\";\n}\n\n.bp4-icon-manual::before {\n  content: \"\\f235\";\n}\n\n.bp4-icon-manually-entered-data::before {\n  content: \"\\f236\";\n}\n\n.bp4-icon-many-to-many::before {\n  content: \"\\f237\";\n}\n\n.bp4-icon-many-to-one::before {\n  content: \"\\f238\";\n}\n\n.bp4-icon-map::before {\n  content: \"\\f23b\";\n}\n\n.bp4-icon-map-create::before {\n  content: \"\\f239\";\n}\n\n.bp4-icon-map-marker::before {\n  content: \"\\f23a\";\n}\n\n.bp4-icon-maximize::before {\n  content: \"\\f23c\";\n}\n\n.bp4-icon-media::before {\n  content: \"\\f23d\";\n}\n\n.bp4-icon-menu::before {\n  content: \"\\f240\";\n}\n\n.bp4-icon-menu-closed::before {\n  content: \"\\f23e\";\n}\n\n.bp4-icon-menu-open::before {\n  content: \"\\f23f\";\n}\n\n.bp4-icon-merge-columns::before {\n  content: \"\\f241\";\n}\n\n.bp4-icon-merge-links::before {\n  content: \"\\f242\";\n}\n\n.bp4-icon-minimize::before {\n  content: \"\\f243\";\n}\n\n.bp4-icon-minus::before {\n  content: \"\\f244\";\n}\n\n.bp4-icon-mobile-phone::before {\n  content: \"\\f245\";\n}\n\n.bp4-icon-mobile-video::before {\n  content: \"\\f246\";\n}\n\n.bp4-icon-modal::before {\n  content: \"\\f248\";\n}\n\n.bp4-icon-modal-filled::before {\n  content: \"\\f247\";\n}\n\n.bp4-icon-model::before {\n  content: \"\\f33d\";\n}\n\n.bp4-icon-moon::before {\n  content: \"\\f249\";\n}\n\n.bp4-icon-more::before {\n  content: \"\\f24a\";\n}\n\n.bp4-icon-mountain::before {\n  content: \"\\f24b\";\n}\n\n.bp4-icon-move::before {\n  content: \"\\f24c\";\n}\n\n.bp4-icon-mugshot::before {\n  content: \"\\f24d\";\n}\n\n.bp4-icon-multi-select::before {\n  content: \"\\f24e\";\n}\n\n.bp4-icon-music::before {\n  content: \"\\f24f\";\n}\n\n.bp4-icon-nest::before {\n  content: \"\\f250\";\n}\n\n.bp4-icon-new-drawing::before {\n  content: \"\\f251\";\n}\n\n.bp4-icon-new-grid-item::before {\n  content: \"\\f252\";\n}\n\n.bp4-icon-new-layer::before {\n  content: \"\\f253\";\n}\n\n.bp4-icon-new-layers::before {\n  content: \"\\f254\";\n}\n\n.bp4-icon-new-link::before {\n  content: \"\\f255\";\n}\n\n.bp4-icon-new-object::before {\n  content: \"\\f256\";\n}\n\n.bp4-icon-new-person::before {\n  content: \"\\f257\";\n}\n\n.bp4-icon-new-prescription::before {\n  content: \"\\f258\";\n}\n\n.bp4-icon-new-text-box::before {\n  content: \"\\f259\";\n}\n\n.bp4-icon-ninja::before {\n  content: \"\\f25a\";\n}\n\n.bp4-icon-not-equal-to::before {\n  content: \"\\f25b\";\n}\n\n.bp4-icon-notifications::before {\n  content: \"\\f25e\";\n}\n\n.bp4-icon-notifications-snooze::before {\n  content: \"\\f25c\";\n}\n\n.bp4-icon-notifications-updated::before {\n  content: \"\\f25d\";\n}\n\n.bp4-icon-numbered-list::before {\n  content: \"\\f25f\";\n}\n\n.bp4-icon-numerical::before {\n  content: \"\\f260\";\n}\n\n.bp4-icon-office::before {\n  content: \"\\f261\";\n}\n\n.bp4-icon-offline::before {\n  content: \"\\f262\";\n}\n\n.bp4-icon-oil-field::before {\n  content: \"\\f263\";\n}\n\n.bp4-icon-one-column::before {\n  content: \"\\f264\";\n}\n\n.bp4-icon-one-to-many::before {\n  content: \"\\f265\";\n}\n\n.bp4-icon-one-to-one::before {\n  content: \"\\f266\";\n}\n\n.bp4-icon-open-application::before {\n  content: \"\\f32b\";\n}\n\n.bp4-icon-outdated::before {\n  content: \"\\f267\";\n}\n\n.bp4-icon-page-layout::before {\n  content: \"\\f268\";\n}\n\n.bp4-icon-panel-stats::before {\n  content: \"\\f269\";\n}\n\n.bp4-icon-panel-table::before {\n  content: \"\\f26a\";\n}\n\n.bp4-icon-paperclip::before {\n  content: \"\\f26b\";\n}\n\n.bp4-icon-paragraph::before {\n  content: \"\\f26c\";\n}\n\n.bp4-icon-path::before {\n  content: \"\\f26e\";\n}\n\n.bp4-icon-path-search::before {\n  content: \"\\f26d\";\n}\n\n.bp4-icon-pause::before {\n  content: \"\\f26f\";\n}\n\n.bp4-icon-people::before {\n  content: \"\\f270\";\n}\n\n.bp4-icon-percentage::before {\n  content: \"\\f271\";\n}\n\n.bp4-icon-person::before {\n  content: \"\\f272\";\n}\n\n.bp4-icon-phone::before {\n  content: \"\\f273\";\n}\n\n.bp4-icon-pie-chart::before {\n  content: \"\\f274\";\n}\n\n.bp4-icon-pin::before {\n  content: \"\\f275\";\n}\n\n.bp4-icon-pivot::before {\n  content: \"\\f277\";\n}\n\n.bp4-icon-pivot-table::before {\n  content: \"\\f276\";\n}\n\n.bp4-icon-play::before {\n  content: \"\\f278\";\n}\n\n.bp4-icon-playbook::before {\n  content: \"\\f324\";\n}\n\n.bp4-icon-plus::before {\n  content: \"\\f279\";\n}\n\n.bp4-icon-polygon-filter::before {\n  content: \"\\f27a\";\n}\n\n.bp4-icon-power::before {\n  content: \"\\f27b\";\n}\n\n.bp4-icon-predictive-analysis::before {\n  content: \"\\f27c\";\n}\n\n.bp4-icon-prescription::before {\n  content: \"\\f27d\";\n}\n\n.bp4-icon-presentation::before {\n  content: \"\\f27e\";\n}\n\n.bp4-icon-print::before {\n  content: \"\\f27f\";\n}\n\n.bp4-icon-projects::before {\n  content: \"\\f280\";\n}\n\n.bp4-icon-properties::before {\n  content: \"\\f281\";\n}\n\n.bp4-icon-property::before {\n  content: \"\\f282\";\n}\n\n.bp4-icon-publish-function::before {\n  content: \"\\f283\";\n}\n\n.bp4-icon-pulse::before {\n  content: \"\\f284\";\n}\n\n.bp4-icon-rain::before {\n  content: \"\\f285\";\n}\n\n.bp4-icon-random::before {\n  content: \"\\f286\";\n}\n\n.bp4-icon-record::before {\n  content: \"\\f287\";\n}\n\n.bp4-icon-rect-height::before {\n  content: \"\\f325\";\n}\n\n.bp4-icon-rect-width::before {\n  content: \"\\f326\";\n}\n\n.bp4-icon-rectangle::before {\n  content: \"\\f321\";\n}\n\n.bp4-icon-redo::before {\n  content: \"\\f288\";\n}\n\n.bp4-icon-refresh::before {\n  content: \"\\f289\";\n}\n\n.bp4-icon-regex::before {\n  content: \"\\f32f\";\n}\n\n.bp4-icon-regression-chart::before {\n  content: \"\\f28a\";\n}\n\n.bp4-icon-remove::before {\n  content: \"\\f290\";\n}\n\n.bp4-icon-remove-column::before {\n  content: \"\\f28d\";\n}\n\n.bp4-icon-remove-column-left::before {\n  content: \"\\f28b\";\n}\n\n.bp4-icon-remove-column-right::before {\n  content: \"\\f28c\";\n}\n\n.bp4-icon-remove-row-bottom::before {\n  content: \"\\f28e\";\n}\n\n.bp4-icon-remove-row-top::before {\n  content: \"\\f28f\";\n}\n\n.bp4-icon-repeat::before {\n  content: \"\\f291\";\n}\n\n.bp4-icon-reset::before {\n  content: \"\\f292\";\n}\n\n.bp4-icon-resolve::before {\n  content: \"\\f293\";\n}\n\n.bp4-icon-rig::before {\n  content: \"\\f294\";\n}\n\n.bp4-icon-right-join::before {\n  content: \"\\f295\";\n}\n\n.bp4-icon-ring::before {\n  content: \"\\f296\";\n}\n\n.bp4-icon-rocket::before {\n  content: \"\\f298\";\n}\n\n.bp4-icon-rocket-slant::before {\n  content: \"\\f297\";\n}\n\n.bp4-icon-rotate-document::before {\n  content: \"\\f299\";\n}\n\n.bp4-icon-rotate-page::before {\n  content: \"\\f29a\";\n}\n\n.bp4-icon-route::before {\n  content: \"\\f29b\";\n}\n\n.bp4-icon-satellite::before {\n  content: \"\\f29c\";\n}\n\n.bp4-icon-saved::before {\n  content: \"\\f29d\";\n}\n\n.bp4-icon-scatter-plot::before {\n  content: \"\\f29e\";\n}\n\n.bp4-icon-search::before {\n  content: \"\\f2a2\";\n}\n\n.bp4-icon-search-around::before {\n  content: \"\\f29f\";\n}\n\n.bp4-icon-search-template::before {\n  content: \"\\f2a0\";\n}\n\n.bp4-icon-search-text::before {\n  content: \"\\f2a1\";\n}\n\n.bp4-icon-segmented-control::before {\n  content: \"\\f2a3\";\n}\n\n.bp4-icon-select::before {\n  content: \"\\f2a4\";\n}\n\n.bp4-icon-selection::before {\n  content: \"\\f2a5\";\n}\n\n.bp4-icon-send-message::before {\n  content: \"\\f2a6\";\n}\n\n.bp4-icon-send-to::before {\n  content: \"\\f2a9\";\n}\n\n.bp4-icon-send-to-graph::before {\n  content: \"\\f2a7\";\n}\n\n.bp4-icon-send-to-map::before {\n  content: \"\\f2a8\";\n}\n\n.bp4-icon-sensor::before {\n  content: \"\\f33c\";\n}\n\n.bp4-icon-series-add::before {\n  content: \"\\f2aa\";\n}\n\n.bp4-icon-series-configuration::before {\n  content: \"\\f2ab\";\n}\n\n.bp4-icon-series-derived::before {\n  content: \"\\f2ac\";\n}\n\n.bp4-icon-series-filtered::before {\n  content: \"\\f2ad\";\n}\n\n.bp4-icon-series-search::before {\n  content: \"\\f2ae\";\n}\n\n.bp4-icon-settings::before {\n  content: \"\\f2af\";\n}\n\n.bp4-icon-shapes::before {\n  content: \"\\f2b0\";\n}\n\n.bp4-icon-share::before {\n  content: \"\\f2b1\";\n}\n\n.bp4-icon-shared-filter::before {\n  content: \"\\f2b2\";\n}\n\n.bp4-icon-shield::before {\n  content: \"\\f2b3\";\n}\n\n.bp4-icon-ship::before {\n  content: \"\\f2b4\";\n}\n\n.bp4-icon-shop::before {\n  content: \"\\f2b5\";\n}\n\n.bp4-icon-shopping-cart::before {\n  content: \"\\f2b6\";\n}\n\n.bp4-icon-shorten-text::before {\n  content: \"\\f33f\";\n}\n\n.bp4-icon-signal-search::before {\n  content: \"\\f2b7\";\n}\n\n.bp4-icon-sim-card::before {\n  content: \"\\f2b8\";\n}\n\n.bp4-icon-slash::before {\n  content: \"\\f2b9\";\n}\n\n.bp4-icon-small-cross::before {\n  content: \"\\f2ba\";\n}\n\n.bp4-icon-small-info-sign::before {\n  content: \"\\f334\";\n}\n\n.bp4-icon-small-minus::before {\n  content: \"\\f2bb\";\n}\n\n.bp4-icon-small-plus::before {\n  content: \"\\f2bc\";\n}\n\n.bp4-icon-small-square::before {\n  content: \"\\f2bd\";\n}\n\n.bp4-icon-small-tick::before {\n  content: \"\\f2be\";\n}\n\n.bp4-icon-snowflake::before {\n  content: \"\\f2bf\";\n}\n\n.bp4-icon-social-media::before {\n  content: \"\\f2c0\";\n}\n\n.bp4-icon-sort::before {\n  content: \"\\f2c7\";\n}\n\n.bp4-icon-sort-alphabetical::before {\n  content: \"\\f2c2\";\n}\n\n.bp4-icon-sort-alphabetical-desc::before {\n  content: \"\\f2c1\";\n}\n\n.bp4-icon-sort-asc::before {\n  content: \"\\f2c3\";\n}\n\n.bp4-icon-sort-desc::before {\n  content: \"\\f2c4\";\n}\n\n.bp4-icon-sort-numerical::before {\n  content: \"\\f2c6\";\n}\n\n.bp4-icon-sort-numerical-desc::before {\n  content: \"\\f2c5\";\n}\n\n.bp4-icon-spell-check::before {\n  content: \"\\f340\";\n}\n\n.bp4-icon-split-columns::before {\n  content: \"\\f2c8\";\n}\n\n.bp4-icon-square::before {\n  content: \"\\f2c9\";\n}\n\n.bp4-icon-stacked-chart::before {\n  content: \"\\f2ca\";\n}\n\n.bp4-icon-stadium-geometry::before {\n  content: \"\\f2cb\";\n}\n\n.bp4-icon-star::before {\n  content: \"\\f2cd\";\n}\n\n.bp4-icon-star-empty::before {\n  content: \"\\f2cc\";\n}\n\n.bp4-icon-step-backward::before {\n  content: \"\\f2ce\";\n}\n\n.bp4-icon-step-chart::before {\n  content: \"\\f2cf\";\n}\n\n.bp4-icon-step-forward::before {\n  content: \"\\f2d0\";\n}\n\n.bp4-icon-stop::before {\n  content: \"\\f2d1\";\n}\n\n.bp4-icon-stopwatch::before {\n  content: \"\\f2d2\";\n}\n\n.bp4-icon-strikethrough::before {\n  content: \"\\f2d3\";\n}\n\n.bp4-icon-style::before {\n  content: \"\\f2d4\";\n}\n\n.bp4-icon-subscript::before {\n  content: \"\\f339\";\n}\n\n.bp4-icon-superscript::before {\n  content: \"\\f33a\";\n}\n\n.bp4-icon-swap-horizontal::before {\n  content: \"\\f2d5\";\n}\n\n.bp4-icon-swap-vertical::before {\n  content: \"\\f2d6\";\n}\n\n.bp4-icon-switch::before {\n  content: \"\\f2d7\";\n}\n\n.bp4-icon-symbol-circle::before {\n  content: \"\\f2d8\";\n}\n\n.bp4-icon-symbol-cross::before {\n  content: \"\\f2d9\";\n}\n\n.bp4-icon-symbol-diamond::before {\n  content: \"\\f2da\";\n}\n\n.bp4-icon-symbol-rectangle::before {\n  content: \"\\f322\";\n}\n\n.bp4-icon-symbol-square::before {\n  content: \"\\f2db\";\n}\n\n.bp4-icon-symbol-triangle-down::before {\n  content: \"\\f2dc\";\n}\n\n.bp4-icon-symbol-triangle-up::before {\n  content: \"\\f2dd\";\n}\n\n.bp4-icon-syringe::before {\n  content: \"\\f2de\";\n}\n\n.bp4-icon-tag::before {\n  content: \"\\f2df\";\n}\n\n.bp4-icon-take-action::before {\n  content: \"\\f2e0\";\n}\n\n.bp4-icon-tank::before {\n  content: \"\\f2e1\";\n}\n\n.bp4-icon-target::before {\n  content: \"\\f2e2\";\n}\n\n.bp4-icon-taxi::before {\n  content: \"\\f2e3\";\n}\n\n.bp4-icon-temperature::before {\n  content: \"\\f2e4\";\n}\n\n.bp4-icon-text-highlight::before {\n  content: \"\\f2e5\";\n}\n\n.bp4-icon-th::before {\n  content: \"\\f2ea\";\n}\n\n.bp4-icon-th-derived::before {\n  content: \"\\f2e6\";\n}\n\n.bp4-icon-th-disconnect::before {\n  content: \"\\f2e7\";\n}\n\n.bp4-icon-th-filtered::before {\n  content: \"\\f2e8\";\n}\n\n.bp4-icon-th-list::before {\n  content: \"\\f2e9\";\n}\n\n.bp4-icon-third-party::before {\n  content: \"\\f2eb\";\n}\n\n.bp4-icon-thumbs-down::before {\n  content: \"\\f2ec\";\n}\n\n.bp4-icon-thumbs-up::before {\n  content: \"\\f2ed\";\n}\n\n.bp4-icon-tick::before {\n  content: \"\\f2ef\";\n}\n\n.bp4-icon-tick-circle::before {\n  content: \"\\f2ee\";\n}\n\n.bp4-icon-time::before {\n  content: \"\\f2f0\";\n}\n\n.bp4-icon-timeline-area-chart::before {\n  content: \"\\f2f1\";\n}\n\n.bp4-icon-timeline-bar-chart::before {\n  content: \"\\f2f2\";\n}\n\n.bp4-icon-timeline-events::before {\n  content: \"\\f2f3\";\n}\n\n.bp4-icon-timeline-line-chart::before {\n  content: \"\\f2f4\";\n}\n\n.bp4-icon-tint::before {\n  content: \"\\f2f5\";\n}\n\n.bp4-icon-torch::before {\n  content: \"\\f2f6\";\n}\n\n.bp4-icon-tractor::before {\n  content: \"\\f2f7\";\n}\n\n.bp4-icon-train::before {\n  content: \"\\f2f8\";\n}\n\n.bp4-icon-translate::before {\n  content: \"\\f2f9\";\n}\n\n.bp4-icon-trash::before {\n  content: \"\\f2fa\";\n}\n\n.bp4-icon-tree::before {\n  content: \"\\f2fb\";\n}\n\n.bp4-icon-trending-down::before {\n  content: \"\\f2fc\";\n}\n\n.bp4-icon-trending-up::before {\n  content: \"\\f2fd\";\n}\n\n.bp4-icon-truck::before {\n  content: \"\\f2fe\";\n}\n\n.bp4-icon-two-columns::before {\n  content: \"\\f2ff\";\n}\n\n.bp4-icon-unarchive::before {\n  content: \"\\f300\";\n}\n\n.bp4-icon-underline::before {\n  content: \"\\f301\";\n}\n\n.bp4-icon-undo::before {\n  content: \"\\f302\";\n}\n\n.bp4-icon-ungroup-objects::before {\n  content: \"\\f303\";\n}\n\n.bp4-icon-unknown-vehicle::before {\n  content: \"\\f304\";\n}\n\n.bp4-icon-unlock::before {\n  content: \"\\f305\";\n}\n\n.bp4-icon-unpin::before {\n  content: \"\\f306\";\n}\n\n.bp4-icon-unresolve::before {\n  content: \"\\f307\";\n}\n\n.bp4-icon-updated::before {\n  content: \"\\f308\";\n}\n\n.bp4-icon-upload::before {\n  content: \"\\f309\";\n}\n\n.bp4-icon-user::before {\n  content: \"\\f30a\";\n}\n\n.bp4-icon-variable::before {\n  content: \"\\f30b\";\n}\n\n.bp4-icon-vertical-bar-chart-asc::before {\n  content: \"\\f30c\";\n}\n\n.bp4-icon-vertical-bar-chart-desc::before {\n  content: \"\\f30d\";\n}\n\n.bp4-icon-vertical-distribution::before {\n  content: \"\\f30e\";\n}\n\n.bp4-icon-vertical-inbetween::before {\n  content: \"\\f32a\";\n}\n\n.bp4-icon-video::before {\n  content: \"\\f30f\";\n}\n\n.bp4-icon-virus::before {\n  content: \"\\f310\";\n}\n\n.bp4-icon-volume-down::before {\n  content: \"\\f311\";\n}\n\n.bp4-icon-volume-off::before {\n  content: \"\\f312\";\n}\n\n.bp4-icon-volume-up::before {\n  content: \"\\f313\";\n}\n\n.bp4-icon-walk::before {\n  content: \"\\f314\";\n}\n\n.bp4-icon-warning-sign::before {\n  content: \"\\f315\";\n}\n\n.bp4-icon-waterfall-chart::before {\n  content: \"\\f316\";\n}\n\n.bp4-icon-waves::before {\n  content: \"\\f317\";\n}\n\n.bp4-icon-widget::before {\n  content: \"\\f31b\";\n}\n\n.bp4-icon-widget-button::before {\n  content: \"\\f318\";\n}\n\n.bp4-icon-widget-footer::before {\n  content: \"\\f319\";\n}\n\n.bp4-icon-widget-header::before {\n  content: \"\\f31a\";\n}\n\n.bp4-icon-wind::before {\n  content: \"\\f31c\";\n}\n\n.bp4-icon-wrench::before {\n  content: \"\\f31d\";\n}\n\n.bp4-icon-zoom-in::before {\n  content: \"\\f31e\";\n}\n\n.bp4-icon-zoom-out::before {\n  content: \"\\f31f\";\n}\n\n.bp4-icon-zoom-to-fit::before {\n  content: \"\\f320\";\n}\n\n.bp4-text-muted {\n  color: #5f6b7c;\n}\n\n.bp4-text-disabled {\n  color: rgba(95, 107, 124, 0.6);\n}\n\n.bp4-running-text hr {\n  border-color: rgba(17, 20, 24, 0.15);\n}\n\na {\n  color: #215db0;\n}\na:hover {\n  color: #215db0;\n}\na .bp4-icon, a .bp4-icon-standard, a .bp4-icon-large {\n  color: inherit;\n}\na code {\n  color: inherit;\n}\n\n.bp4-code,\n.bp4-running-text code {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2);\n  color: #5f6b7c;\n}\na > .bp4-code,\na > .bp4-running-text code {\n  color: #2d72d2;\n}\n\n.bp4-code-block,\n.bp4-running-text pre {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.15);\n  color: #1c2127;\n}\n.bp4-code-block > code,\n.bp4-running-text pre > code {\n  background: none;\n  box-shadow: none;\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-code-block,\n  .bp4-running-text pre {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n\n.bp4-key,\n.bp4-running-text kbd {\n  background: #ffffff;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);\n  color: #5f6b7c;\n}\n\n.bp4-icon.bp4-intent-primary, .bp4-icon-standard.bp4-intent-primary, .bp4-icon-large.bp4-intent-primary {\n  color: #215db0;\n}\n.bp4-icon.bp4-intent-success, .bp4-icon-standard.bp4-intent-success, .bp4-icon-large.bp4-intent-success {\n  color: #1c6e42;\n}\n.bp4-icon.bp4-intent-warning, .bp4-icon-standard.bp4-intent-warning, .bp4-icon-large.bp4-intent-warning {\n  color: #935610;\n}\n.bp4-icon.bp4-intent-danger, .bp4-icon-standard.bp4-intent-danger, .bp4-icon-large.bp4-intent-danger {\n  color: #ac2f33;\n}\n\n/*\nHeadings\n\nMarkup:\n<div>\n  <h1 class=\"@ns-heading\">H1 heading</h1>\n  <h2 class=\"@ns-heading\">H2 heading</h2>\n  <h3 class=\"@ns-heading\">H3 heading</h3>\n  <h4 class=\"@ns-heading\">H4 heading</h4>\n  <h5 class=\"@ns-heading\">H5 heading</h5>\n  <h6 class=\"@ns-heading\">H6 heading</h6>\n</div>\n\nStyleguide headings\n*/\n.bp4-heading {\n  color: #1c2127;\n  font-weight: 600;\n  margin: 0 0 10px;\n  padding: 0;\n}\n.bp4-dark .bp4-heading {\n  color: #f6f7f9;\n}\n\n.bp4-running-text h1, h1.bp4-heading {\n  font-size: 36px;\n  line-height: 40px;\n}\n\n.bp4-running-text h2, h2.bp4-heading {\n  font-size: 28px;\n  line-height: 32px;\n}\n\n.bp4-running-text h3, h3.bp4-heading {\n  font-size: 22px;\n  line-height: 25px;\n}\n\n.bp4-running-text h4, h4.bp4-heading {\n  font-size: 18px;\n  line-height: 21px;\n}\n\n.bp4-running-text h5, h5.bp4-heading {\n  font-size: 16px;\n  line-height: 19px;\n}\n\n.bp4-running-text h6, h6.bp4-heading {\n  font-size: 14px;\n  line-height: 16px;\n}\n\n/*\nUI text\n\nMarkup:\n<div class=\"{{.modifier}}\">\n  More than a decade ago, we set out to create products that would transform\n  the way organizations use their data. Today, our products are deployed at\n  the most critical government, commercial, and non-profit institutions in\n  the world to solve problems we hadn’t even dreamed of back then.\n</div>\n\n.bp4-ui-text - Default Blueprint font styles, applied to the `<body>` tag and available as a class for nested resets.\n.bp4-monospace-text - Use a monospace font (ideal for code).\n.bp4-running-text - Increase line height ideal for longform text. See [Running text](#core/typography.running-text) below for additional features.\n.bp4-text-large - Use a larger font size.\n.bp4-text-small - Use a smaller font size.\n.bp4-text-muted - Change text color to a gentler gray.\n.bp4-text-disabled - Change text color to a transparent, faded gray.\n.bp4-text-overflow-ellipsis - Truncate a single line of text with an ellipsis if it overflows its container.\n\nStyleguide ui-text\n*/\n.bp4-ui-text {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.28581;\n  text-transform: none;\n}\n\n.bp4-monospace-text {\n  font-family: monospace;\n  text-transform: none;\n}\n\n.bp4-text-overflow-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n}\n\n/*\nRunning text\n\nMarkup:\n<div class=\"@ns-running-text {{.modifier}}\">\n  <p>\n    We build products that make people better at their most important\n    work — the kind of work you read about on the front page of the\n    newspaper, not just the technology section.\n  </p>\n  <ul>\n    <li>Item the <code>first</code>.</li>\n    <li>Item the <strong>second</strong>.</li>\n    <li>Item the <a href=\"#core/typography.running-text\">third</a>.</li>\n  </ul>\n  <h3>Scale, Speed, Agility</h3>\n  <p>\n    A successful data transformation requires the whole organization — users, the IT shop, and\n    leadership — to operate in lockstep. With Foundry, the enterprise comes together to\n    transform the organization and turn data into a competitive advantage.\n  </p>\n</div>\n\n.bp4-text-large - Use larger font size.\n\nStyleguide running-text\n*/\n.bp4-running-text {\n  font-size: 14px;\n  line-height: 1.5;\n}\n.bp4-running-text h1 {\n  color: #1c2127;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n.bp4-dark .bp4-running-text h1 {\n  color: #f6f7f9;\n}\n.bp4-running-text h2 {\n  color: #1c2127;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n.bp4-dark .bp4-running-text h2 {\n  color: #f6f7f9;\n}\n.bp4-running-text h3 {\n  color: #1c2127;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n.bp4-dark .bp4-running-text h3 {\n  color: #f6f7f9;\n}\n.bp4-running-text h4 {\n  color: #1c2127;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n.bp4-dark .bp4-running-text h4 {\n  color: #f6f7f9;\n}\n.bp4-running-text h5 {\n  color: #1c2127;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n.bp4-dark .bp4-running-text h5 {\n  color: #f6f7f9;\n}\n.bp4-running-text h6 {\n  color: #1c2127;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n.bp4-dark .bp4-running-text h6 {\n  color: #f6f7f9;\n}\n.bp4-running-text hr {\n  border: none;\n  border-bottom: 1px solid rgba(17, 20, 24, 0.15);\n  margin: 20px 0;\n}\n.bp4-running-text p {\n  margin: 0 0 10px;\n  padding: 0;\n}\n.bp4-text-large {\n  font-size: 16px;\n}\n\n.bp4-text-small {\n  font-size: 12px;\n}\n\n/*\nLinks\n\nSimply use an `<a href=\"\">` tag as you normally would. No class is necessary for Blueprint styles.\nLinks are underlined only when hovered.\n\nPutting an icon inside a link will cause it to inherit the link's text color.\n\nStyleguide typography.links\n*/\na {\n  text-decoration: none;\n}\na:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n/*\nPreformatted text\n\nMarkup:\n<div>\n  <p>Use the <code class=\"@ns-code\">&lt;code></code> tag for snippets of code.</p>\n  <pre class=\"@ns-code-block\">Use the &lt;pre> tag for blocks of code.</pre>\n  <pre class=\"@ns-code-block\"><code>// code sample\nexport function hasModifier(\n  modifiers: ts.ModifiersArray,\n  ...modifierKinds: ts.SyntaxKind[],\n) {\n  if (modifiers == null || modifierKinds == null) {\n    return false;\n  }\n  return modifiers.some(m => modifierKinds.some(k => m.kind === k));\n}</code></pre>\n</div>\n\nStyleguide preformatted\n*/\n.bp4-code, .bp4-running-text code {\n  font-family: monospace;\n  text-transform: none;\n  border-radius: 2px;\n  font-size: smaller;\n  padding: 2px 5px;\n}\n\n.bp4-code-block, .bp4-running-text pre {\n  font-family: monospace;\n  text-transform: none;\n  border-radius: 2px;\n  display: block;\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 10px 0;\n  padding: 13px 15px 12px;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n.bp4-code-block > code, .bp4-running-text pre > code {\n  font-size: inherit;\n  padding: 0;\n}\n\n.bp4-key, .bp4-running-text kbd {\n  align-items: center;\n  border-radius: 2px;\n  display: inline-flex;\n  font-family: inherit;\n  font-size: 12px;\n  height: 24px;\n  justify-content: center;\n  line-height: 24px;\n  min-width: 24px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n.bp4-key .bp4-icon, .bp4-running-text kbd .bp4-icon, .bp4-key .bp4-icon-standard, .bp4-running-text kbd .bp4-icon-standard, .bp4-key .bp4-icon-large, .bp4-running-text kbd .bp4-icon-large {\n  margin-right: 5px;\n}\n\n/*\nBlock quotes\n\nMarkup:\n<blockquote class=\"@ns-blockquote\">\n  Premium Aerotec is a key supplier for Airbus, producing 30 million parts per year,\n  which is huge complexity. Skywise helps us manage all the production steps.\n  It gives Airbus much better visibility into where the product is in the supply chain,\n  and it lets us immediately see our weak points so we can react on the spot.\n</blockquote>\n\nStyleguide blockquote\n*/\n.bp4-blockquote, .bp4-running-text blockquote {\n  border-left: solid 4px rgba(171, 179, 191, 0.5);\n  margin: 0 0 10px;\n  padding: 0 20px;\n}\n.bp4-dark .bp4-blockquote, .bp4-dark .bp4-running-text blockquote, .bp4-running-text .bp4-dark blockquote {\n  border-color: rgba(115, 128, 145, 0.5);\n}\n\n/*\nLists\n\nMarkup:\n<ol class=\"{{.modifier}}\">\n  <li>Item the first</li>\n  <li>Item the second</li>\n  <li>\n    Item the third\n    <ul class=\"{{.modifier}}\">\n      <li>Item the fourth</li>\n      <li>Item the fifth</li>\n    </ul>\n  </li>\n</ol>\n\n.bp4-list - Add a little spacing between items for readability.\n.bp4-list-unstyled - Remove all list styling (including indicators) so you can add your own.\n\nStyleguide lists\n*/\n.bp4-list, .bp4-running-text ul,\n.bp4-running-text ol {\n  margin: 10px 0;\n  padding-left: 30px;\n}\n.bp4-list li:not(:last-child), .bp4-running-text ul li:not(:last-child),\n.bp4-running-text ol li:not(:last-child) {\n  margin-bottom: 5px;\n}\n.bp4-list ol, .bp4-running-text ul ol,\n.bp4-running-text ol ol,\n.bp4-list ul,\n.bp4-running-text ul ul,\n.bp4-running-text ol ul {\n  margin-top: 5px;\n}\n\n.bp4-list-unstyled {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.bp4-list-unstyled li {\n  padding: 0;\n}\n\n/*\nRight-to-left text\n\nMarkup:\n<h5 class=\"@ns-heading\">Arabic:</h5>\n<p class=\"@ns-rtl\">\n  لكل لأداء بمحاولة من. مدينة الواقعة يبق أي, وإعلان وقوعها، حول كل, حدى عجّل مشروط الخاسرة قد.\n  من الذود تكبّد بين, و لها واحدة الأراضي. عل الصفحة والروسية يتم, أي للحكومة استعملت شيء. أم وصل زهاء اليا\n</p>\n<h5 class=\"@ns-heading\">Hebrew:</h5>\n<p class=\"@ns-rtl\">\n  כדי על עזרה יידיש הבהרה, מלא באגים טכניים דת. תנך או ברית ביולי. כתב בה הטבע למנוע, דת כלים פיסיקה החופשית זכר.\n  מתן החלל מאמרשיחהצפה ב. הספרות אנציקלופדיה אם זכר, על שימושי שימושיים תאולוגיה עזה\n</p>\n\nStyleguide rtl\n*/\n.bp4-rtl {\n  text-align: right;\n}\n\n/*\nDark theme\n*/\n.bp4-dark {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-text-muted {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-text-disabled {\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-running-text hr {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.bp4-dark a {\n  color: #8abbff;\n}\n.bp4-dark a:hover {\n  color: #8abbff;\n}\n.bp4-dark a .bp4-icon, .bp4-dark a .bp4-icon-standard, .bp4-dark a .bp4-icon-large {\n  color: inherit;\n}\n.bp4-dark a code {\n  color: inherit;\n}\n.bp4-dark .bp4-code,\n.bp4-dark .bp4-running-text code {\n  background: rgba(17, 20, 24, 0.3);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.4);\n  color: #abb3bf;\n}\na > .bp4-dark .bp4-code,\na > .bp4-dark .bp4-running-text code {\n  color: inherit;\n}\n.bp4-dark .bp4-code-block,\n.bp4-dark .bp4-running-text pre {\n  background: rgba(17, 20, 24, 0.3);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.4);\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-code-block > code,\n.bp4-dark .bp4-running-text pre > code {\n  background: none;\n  box-shadow: none;\n  color: inherit;\n}\n.bp4-dark .bp4-key,\n.bp4-dark .bp4-running-text kbd {\n  background: #383e47;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);\n  color: #abb3bf;\n}\n.bp4-dark .bp4-icon.bp4-intent-primary, .bp4-dark .bp4-icon-standard.bp4-intent-primary, .bp4-dark .bp4-icon-large.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-dark .bp4-icon.bp4-intent-success, .bp4-dark .bp4-icon-standard.bp4-intent-success, .bp4-dark .bp4-icon-large.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-icon.bp4-intent-warning, .bp4-dark .bp4-icon-standard.bp4-intent-warning, .bp4-dark .bp4-icon-large.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-dark .bp4-icon.bp4-intent-danger, .bp4-dark .bp4-icon-standard.bp4-intent-danger, .bp4-dark .bp4-icon-large.bp4-intent-danger {\n  color: #fa999c;\n}\n\n:focus {\n  outline: rgba(45, 114, 210, 0.6) solid 2px;\n  outline-offset: 2px;\n  -moz-outline-radius: 6px;\n}\n\n.bp4-focus-disabled :focus:not(.bp4-focus-style-manager-ignore *) {\n  /* stylelint-disable declaration-no-important */\n  outline: none !important;\n}\n.bp4-focus-disabled :focus:not(.bp4-focus-style-manager-ignore *) ~ .bp4-control-indicator {\n  outline: none !important;\n}\n\n.bp4-dark {\n  color-scheme: dark;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-alert {\n  max-width: 400px;\n  padding: 20px;\n}\n\n.bp4-alert-body {\n  display: flex;\n}\n.bp4-alert-body .bp4-icon {\n  font-size: 40px;\n  margin-right: 20px;\n  margin-top: 0;\n}\n\n.bp4-alert-contents {\n  word-break: break-word;\n}\n\n.bp4-alert-footer {\n  display: flex;\n  flex-direction: row-reverse;\n  margin-top: 10px;\n}\n.bp4-alert-footer .bp4-button {\n  margin-left: 10px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nBreadcrumbs\n\nMarkup:\n<ul class=\"bp4-breadcrumbs\">\n  <li><a class=\"bp4-breadcrumbs-collapsed\" href=\"#\"></a></li>\n  <li><a class=\"bp4-breadcrumb bp4-disabled\">Folder one</a></li>\n  <li><a class=\"bp4-breadcrumb\" href=\"#\">Folder two</a></li>\n  <li><a class=\"bp4-breadcrumb\" href=\"#\">Folder three</a></li>\n  <li><span class=\"bp4-breadcrumb bp4-breadcrumb-current\">File</span></li>\n</ul>\n\nStyleguide breadcrumbs\n*/\n.bp4-breadcrumbs {\n  align-items: center;\n  cursor: default;\n  display: flex;\n  flex-wrap: wrap;\n  height: 30px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.bp4-breadcrumbs > li {\n  align-items: center;\n  display: flex;\n}\n.bp4-breadcrumbs > li::after {\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z' fill='%235f6b7c'/%3e%3c/svg%3e\");\n  content: \"\";\n  display: block;\n  height: 16px;\n  margin: 0 5px;\n  width: 16px;\n}\n.bp4-breadcrumbs > li:last-of-type::after {\n  display: none;\n}\n\n.bp4-breadcrumb,\n.bp4-breadcrumb-current,\n.bp4-breadcrumbs-collapsed {\n  align-items: center;\n  display: inline-flex;\n  font-size: 16px;\n}\n\n.bp4-breadcrumb,\n.bp4-breadcrumbs-collapsed {\n  color: #5f6b7c;\n}\n\n.bp4-breadcrumb:hover {\n  text-decoration: none;\n}\n.bp4-breadcrumb.bp4-disabled {\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n.bp4-breadcrumb .bp4-icon {\n  margin-right: 5px;\n}\n\n.bp4-breadcrumb-current {\n  color: inherit;\n  font-weight: 600;\n}\n.bp4-breadcrumb-current .bp4-input {\n  font-size: inherit;\n  font-weight: inherit;\n  vertical-align: baseline;\n}\n\n.bp4-breadcrumbs-collapsed {\n  background: rgba(143, 153, 168, 0.15);\n  border: none;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-right: 2px;\n  padding: 1px 5px;\n  vertical-align: text-bottom;\n}\n.bp4-breadcrumbs-collapsed::before {\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cg fill='%235f6b7c'%3e%3cpath d='M2 6.03a2 2 0 100 4 2 2 0 100-4zM14 6.03a2 2 0 100 4 2 2 0 100-4zM8 6.03a2 2 0 100 4 2 2 0 100-4z'/%3e%3c/g%3e%3c/svg%3e\") center no-repeat;\n  content: \"\";\n  display: block;\n  height: 16px;\n  width: 16px;\n}\n.bp4-breadcrumbs-collapsed:hover {\n  background: rgba(143, 153, 168, 0.3);\n  color: #1c2127;\n  text-decoration: none;\n}\n\n.bp4-dark .bp4-breadcrumb,\n.bp4-dark .bp4-breadcrumbs-collapsed {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-breadcrumbs > li::after {\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z' fill='%23abb3bf'/%3e%3c/svg%3e\");\n  color: #abb3bf;\n}\n.bp4-dark .bp4-breadcrumb.bp4-disabled {\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-breadcrumb-current {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-breadcrumbs-collapsed {\n  background: rgba(143, 153, 168, 0.2);\n}\n.bp4-dark .bp4-breadcrumbs-collapsed::before {\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cg fill='%23abb3bf'%3e%3cpath d='M2 6.03a2 2 0 100 4 2 2 0 100-4zM14 6.03a2 2 0 100 4 2 2 0 100-4zM8 6.03a2 2 0 100 4 2 2 0 100-4z'/%3e%3c/g%3e%3c/svg%3e\") center no-repeat;\n}\n.bp4-dark .bp4-breadcrumbs-collapsed:hover {\n  background: rgba(143, 153, 168, 0.3);\n  color: #f6f7f9;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\nButton\n\nMarkup:\n<a role=\"button\" class=\"bp4-button {{.modifier}}\" {{:modifier}} tabindex=\"0\">Anchor</a>\n<button type=\"button\" class=\"bp4-button bp4-icon-add {{.modifier}}\" {{:modifier}}>Button</button>\n\n:disabled - Disabled state\n.bp4-active - Active appearance\n.bp4-disabled - Disabled appearance\n.bp4-intent-primary - Primary intent\n.bp4-intent-success - Success intent\n.bp4-intent-warning - Warning intent\n.bp4-intent-danger - Danger intent\n.bp4-minimal - More subtle appearance\n.bp4-outlined - Subtle yet structured appearance\n.bp4-large - Larger size\n.bp4-small - Smaller size\n.bp4-fill - Fill parent container\n\nStyleguide button\n*/\n.bp4-button {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  border: none;\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 14px;\n  justify-content: center;\n  padding: 5px 10px;\n  text-align: left;\n  vertical-align: middle;\n  min-height: 30px;\n  min-width: 30px;\n}\n.bp4-button > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-button > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-button::before,\n.bp4-button > * {\n  margin-right: 7px;\n}\n.bp4-button:empty::before,\n.bp4-button > :last-child {\n  margin-right: 0;\n}\n.bp4-button:empty {\n  /* stylelint-disable-next-line declaration-no-important */\n  padding: 0 !important;\n}\n.bp4-button:disabled, .bp4-button.bp4-disabled {\n  cursor: not-allowed;\n}\n.bp4-button.bp4-fill {\n  display: flex;\n  width: 100%;\n}\n.bp4-button.bp4-align-right, .bp4-align-right .bp4-button {\n  text-align: right;\n}\n.bp4-button.bp4-align-left, .bp4-align-left .bp4-button {\n  text-align: left;\n}\n.bp4-button:not([class*=bp4-intent-]) {\n  background-color: #f6f7f9;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #1c2127;\n}\n.bp4-button:not([class*=bp4-intent-]):hover {\n  background-clip: padding-box;\n  background-color: #edeff2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button:not([class*=bp4-intent-]):active, .bp4-button:not([class*=bp4-intent-]).bp4-active {\n  background-color: #dce0e5;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button:not([class*=bp4-intent-]):active, .bp4-button:not([class*=bp4-intent-]).bp4-active {\n    background: highlight;\n  }\n}\n.bp4-button:not([class*=bp4-intent-]):disabled, .bp4-button:not([class*=bp4-intent-]).bp4-disabled {\n  background-color: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n  outline: none;\n}\n.bp4-button:not([class*=bp4-intent-]):disabled.bp4-active, .bp4-button:not([class*=bp4-intent-]):disabled.bp4-active:hover, .bp4-button:not([class*=bp4-intent-]).bp4-disabled.bp4-active, .bp4-button:not([class*=bp4-intent-]).bp4-disabled.bp4-active:hover {\n  background: rgba(211, 216, 222, 0.7);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button:not([class*=bp4-intent-]) {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-button.bp4-intent-primary {\n  background-color: #2d72d2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-primary:hover, .bp4-button.bp4-intent-primary:active, .bp4-button.bp4-intent-primary.bp4-active {\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-primary:hover {\n  background-color: #215db0;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-primary:active, .bp4-button.bp4-intent-primary.bp4-active {\n  background-color: #184a90;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-primary:disabled, .bp4-button.bp4-intent-primary.bp4-disabled {\n  background-color: rgba(45, 114, 210, 0.5);\n  border-color: transparent;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-primary:disabled, .bp4-button.bp4-intent-primary.bp4-disabled {\n    border-color: graytext;\n    color: graytext;\n  }\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-primary {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n.bp4-button.bp4-intent-success {\n  background-color: #238551;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-success:hover, .bp4-button.bp4-intent-success:active, .bp4-button.bp4-intent-success.bp4-active {\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-success:hover {\n  background-color: #1c6e42;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-success:active, .bp4-button.bp4-intent-success.bp4-active {\n  background-color: #165a36;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-success:disabled, .bp4-button.bp4-intent-success.bp4-disabled {\n  background-color: rgba(35, 133, 81, 0.5);\n  border-color: transparent;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-success:disabled, .bp4-button.bp4-intent-success.bp4-disabled {\n    border-color: graytext;\n    color: graytext;\n  }\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-success {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n.bp4-button.bp4-intent-warning {\n  background-color: #c87619;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-warning:hover, .bp4-button.bp4-intent-warning:active, .bp4-button.bp4-intent-warning.bp4-active {\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-warning:hover {\n  background-color: #935610;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-warning:active, .bp4-button.bp4-intent-warning.bp4-active {\n  background-color: #77450d;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-warning:disabled, .bp4-button.bp4-intent-warning.bp4-disabled {\n  background-color: rgba(200, 118, 25, 0.5);\n  border-color: transparent;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-warning:disabled, .bp4-button.bp4-intent-warning.bp4-disabled {\n    border-color: graytext;\n    color: graytext;\n  }\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-warning {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n.bp4-button.bp4-intent-danger {\n  background-color: #cd4246;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-danger:hover, .bp4-button.bp4-intent-danger:active, .bp4-button.bp4-intent-danger.bp4-active {\n  color: #ffffff;\n}\n.bp4-button.bp4-intent-danger:hover {\n  background-color: #ac2f33;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-danger:active, .bp4-button.bp4-intent-danger.bp4-active {\n  background-color: #8e292c;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-button.bp4-intent-danger:disabled, .bp4-button.bp4-intent-danger.bp4-disabled {\n  background-color: rgba(205, 66, 70, 0.5);\n  border-color: transparent;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-danger:disabled, .bp4-button.bp4-intent-danger.bp4-disabled {\n    border-color: graytext;\n    color: graytext;\n  }\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-danger {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n.bp4-button[class*=bp4-intent-] .bp4-button-spinner .bp4-spinner-head {\n  stroke: #ffffff;\n}\n.bp4-button.bp4-large, .bp4-large .bp4-button {\n  min-height: 40px;\n  min-width: 40px;\n  font-size: 16px;\n  padding: 5px 15px;\n}\n.bp4-button.bp4-large::before,\n.bp4-button.bp4-large > *, .bp4-large .bp4-button::before,\n.bp4-large .bp4-button > * {\n  margin-right: 10px;\n}\n.bp4-button.bp4-large:empty::before,\n.bp4-button.bp4-large > :last-child, .bp4-large .bp4-button:empty::before,\n.bp4-large .bp4-button > :last-child {\n  margin-right: 0;\n}\n.bp4-button.bp4-small, .bp4-small .bp4-button {\n  min-height: 24px;\n  min-width: 24px;\n  padding: 0 7px;\n}\n.bp4-button.bp4-loading {\n  position: relative;\n}\n.bp4-button.bp4-loading[class*=bp4-icon-]::before {\n  visibility: hidden;\n}\n.bp4-button.bp4-loading .bp4-button-spinner {\n  margin: 0;\n  position: absolute;\n}\n.bp4-button.bp4-loading > :not(.bp4-button-spinner) {\n  visibility: hidden;\n}\n.bp4-button[class*=bp4-icon-]::before {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  color: #5f6b7c;\n}\n.bp4-button .bp4-icon, .bp4-button .bp4-icon-standard, .bp4-button .bp4-icon-large {\n  color: #5f6b7c;\n}\n.bp4-button .bp4-icon.bp4-align-right, .bp4-button .bp4-icon-standard.bp4-align-right, .bp4-button .bp4-icon-large.bp4-align-right {\n  margin-left: 7px;\n}\n.bp4-button .bp4-icon:first-child:last-child,\n.bp4-button .bp4-spinner + .bp4-icon:last-child {\n  margin: 0 -7px;\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]) {\n  background-color: #383e47;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]):hover, .bp4-dark .bp4-button:not([class*=bp4-intent-]):active, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-active {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]):hover {\n  background-color: #2f343c;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]):active, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-active {\n  background-color: #1c2127;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]):disabled, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-disabled {\n  background-color: rgba(64, 72, 84, 0.5);\n  box-shadow: none;\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]):disabled.bp4-active, .bp4-dark .bp4-button:not([class*=bp4-intent-]).bp4-disabled.bp4-active {\n  background: rgba(64, 72, 84, 0.7);\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-button-spinner .bp4-spinner-head {\n  background: rgba(17, 20, 24, 0.5);\n  stroke: #8f99a8;\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-])[class*=bp4-icon-]::before {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-icon:not([class*=bp4-intent-]), .bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-icon-standard:not([class*=bp4-intent-]), .bp4-dark .bp4-button:not([class*=bp4-intent-]) .bp4-icon-large:not([class*=bp4-intent-]) {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-button[class*=bp4-intent-] {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-dark .bp4-button[class*=bp4-intent-]:hover {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-dark .bp4-button[class*=bp4-intent-]:active, .bp4-dark .bp4-button[class*=bp4-intent-].bp4-active {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-button[class*=bp4-intent-]:disabled, .bp4-dark .bp4-button[class*=bp4-intent-].bp4-disabled {\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.3);\n}\n.bp4-dark .bp4-button[class*=bp4-intent-] .bp4-button-spinner .bp4-spinner-head {\n  stroke: #8f99a8;\n}\n.bp4-button:disabled::before,\n.bp4-button:disabled .bp4-icon, .bp4-button:disabled .bp4-icon-standard, .bp4-button:disabled .bp4-icon-large, .bp4-button.bp4-disabled::before,\n.bp4-button.bp4-disabled .bp4-icon, .bp4-button.bp4-disabled .bp4-icon-standard, .bp4-button.bp4-disabled .bp4-icon-large, .bp4-button[class*=bp4-intent-]::before,\n.bp4-button[class*=bp4-intent-] .bp4-icon, .bp4-button[class*=bp4-intent-] .bp4-icon-standard, .bp4-button[class*=bp4-intent-] .bp4-icon-large {\n  /* stylelint-disable-next-line declaration-no-important */\n  color: inherit !important;\n}\n.bp4-button.bp4-minimal {\n  background: none;\n  box-shadow: none;\n}\n.bp4-button.bp4-minimal:hover {\n  background: rgba(143, 153, 168, 0.15);\n  box-shadow: none;\n  color: #1c2127;\n  text-decoration: none;\n}\n.bp4-button.bp4-minimal:active, .bp4-button.bp4-minimal.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n  box-shadow: none;\n  color: #1c2127;\n}\n.bp4-button.bp4-minimal:disabled, .bp4-button.bp4-minimal:disabled:hover, .bp4-button.bp4-minimal.bp4-disabled, .bp4-button.bp4-minimal.bp4-disabled:hover {\n  background: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n.bp4-button.bp4-minimal:disabled.bp4-active, .bp4-button.bp4-minimal:disabled:hover.bp4-active, .bp4-button.bp4-minimal.bp4-disabled.bp4-active, .bp4-button.bp4-minimal.bp4-disabled:hover.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-button.bp4-minimal {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-button.bp4-minimal:hover, .bp4-dark .bp4-button.bp4-minimal:active, .bp4-dark .bp4-button.bp4-minimal.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-button.bp4-minimal:hover {\n  background: rgba(143, 153, 168, 0.15);\n}\n.bp4-dark .bp4-button.bp4-minimal:active, .bp4-dark .bp4-button.bp4-minimal.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-button.bp4-minimal:disabled, .bp4-dark .bp4-button.bp4-minimal:disabled:hover, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled:hover {\n  background: none;\n  color: rgba(171, 179, 191, 0.6);\n  cursor: not-allowed;\n}\n.bp4-dark .bp4-button.bp4-minimal:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal:disabled:hover.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-disabled:hover.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-primary {\n  color: #215db0;\n}\n.bp4-button.bp4-minimal.bp4-intent-primary:hover, .bp4-button.bp4-minimal.bp4-intent-primary:active, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #215db0;\n}\n.bp4-button.bp4-minimal.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.15);\n  color: #215db0;\n}\n.bp4-button.bp4-minimal.bp4-intent-primary:active, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #184a90;\n}\n.bp4-button.bp4-minimal.bp4-intent-primary:disabled, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(33, 93, 176, 0.5);\n}\n.bp4-button.bp4-minimal.bp4-intent-primary:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head {\n  stroke: #215db0;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #99c4ff;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(138, 187, 255, 0.5);\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-success {\n  color: #1c6e42;\n}\n.bp4-button.bp4-minimal.bp4-intent-success:hover, .bp4-button.bp4-minimal.bp4-intent-success:active, .bp4-button.bp4-minimal.bp4-intent-success.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #1c6e42;\n}\n.bp4-button.bp4-minimal.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.15);\n  color: #1c6e42;\n}\n.bp4-button.bp4-minimal.bp4-intent-success:active, .bp4-button.bp4-minimal.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #165a36;\n}\n.bp4-button.bp4-minimal.bp4-intent-success:disabled, .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(28, 110, 66, 0.5);\n}\n.bp4-button.bp4-minimal.bp4-intent-success:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-success .bp4-button-spinner .bp4-spinner-head {\n  stroke: #1c6e42;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(114, 202, 155, 0.5);\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-warning {\n  color: #935610;\n}\n.bp4-button.bp4-minimal.bp4-intent-warning:hover, .bp4-button.bp4-minimal.bp4-intent-warning:active, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #935610;\n}\n.bp4-button.bp4-minimal.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.15);\n  color: #935610;\n}\n.bp4-button.bp4-minimal.bp4-intent-warning:active, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #77450d;\n}\n.bp4-button.bp4-minimal.bp4-intent-warning:disabled, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(147, 86, 16, 0.5);\n}\n.bp4-button.bp4-minimal.bp4-intent-warning:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head {\n  stroke: #935610;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #f5c186;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(251, 179, 96, 0.5);\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-danger {\n  color: #ac2f33;\n}\n.bp4-button.bp4-minimal.bp4-intent-danger:hover, .bp4-button.bp4-minimal.bp4-intent-danger:active, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ac2f33;\n}\n.bp4-button.bp4-minimal.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.15);\n  color: #ac2f33;\n}\n.bp4-button.bp4-minimal.bp4-intent-danger:active, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #8e292c;\n}\n.bp4-button.bp4-minimal.bp4-intent-danger:disabled, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(172, 47, 51, 0.5);\n}\n.bp4-button.bp4-minimal.bp4-intent-danger:disabled.bp4-active, .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n.bp4-button.bp4-minimal.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head {\n  stroke: #ac2f33;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger {\n  color: #fa999c;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #ffa1a4;\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:disabled, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(250, 153, 156, 0.5);\n}\n.bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-button.bp4-minimal.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n.bp4-button.bp4-outlined {\n  background: none;\n  box-shadow: none;\n  border: 1px solid rgba(28, 33, 39, 0.2);\n  box-sizing: border-box;\n}\n.bp4-button.bp4-outlined:hover {\n  background: rgba(143, 153, 168, 0.15);\n  box-shadow: none;\n  color: #1c2127;\n  text-decoration: none;\n}\n.bp4-button.bp4-outlined:active, .bp4-button.bp4-outlined.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n  box-shadow: none;\n  color: #1c2127;\n}\n.bp4-button.bp4-outlined:disabled, .bp4-button.bp4-outlined:disabled:hover, .bp4-button.bp4-outlined.bp4-disabled, .bp4-button.bp4-outlined.bp4-disabled:hover {\n  background: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n.bp4-button.bp4-outlined:disabled.bp4-active, .bp4-button.bp4-outlined:disabled:hover.bp4-active, .bp4-button.bp4-outlined.bp4-disabled.bp4-active, .bp4-button.bp4-outlined.bp4-disabled:hover.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-button.bp4-outlined {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-button.bp4-outlined:hover, .bp4-dark .bp4-button.bp4-outlined:active, .bp4-dark .bp4-button.bp4-outlined.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-button.bp4-outlined:hover {\n  background: rgba(143, 153, 168, 0.15);\n}\n.bp4-dark .bp4-button.bp4-outlined:active, .bp4-dark .bp4-button.bp4-outlined.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-button.bp4-outlined:disabled, .bp4-dark .bp4-button.bp4-outlined:disabled:hover, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled:hover {\n  background: none;\n  color: rgba(171, 179, 191, 0.6);\n  cursor: not-allowed;\n}\n.bp4-dark .bp4-button.bp4-outlined:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined:disabled:hover.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled:hover.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-primary {\n  color: #215db0;\n}\n.bp4-button.bp4-outlined.bp4-intent-primary:hover, .bp4-button.bp4-outlined.bp4-intent-primary:active, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #215db0;\n}\n.bp4-button.bp4-outlined.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.15);\n  color: #215db0;\n}\n.bp4-button.bp4-outlined.bp4-intent-primary:active, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #184a90;\n}\n.bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(33, 93, 176, 0.5);\n}\n.bp4-button.bp4-outlined.bp4-intent-primary:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head {\n  stroke: #215db0;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #99c4ff;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(138, 187, 255, 0.5);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-success {\n  color: #1c6e42;\n}\n.bp4-button.bp4-outlined.bp4-intent-success:hover, .bp4-button.bp4-outlined.bp4-intent-success:active, .bp4-button.bp4-outlined.bp4-intent-success.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #1c6e42;\n}\n.bp4-button.bp4-outlined.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.15);\n  color: #1c6e42;\n}\n.bp4-button.bp4-outlined.bp4-intent-success:active, .bp4-button.bp4-outlined.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #165a36;\n}\n.bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(28, 110, 66, 0.5);\n}\n.bp4-button.bp4-outlined.bp4-intent-success:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-success .bp4-button-spinner .bp4-spinner-head {\n  stroke: #1c6e42;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(114, 202, 155, 0.5);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-warning {\n  color: #935610;\n}\n.bp4-button.bp4-outlined.bp4-intent-warning:hover, .bp4-button.bp4-outlined.bp4-intent-warning:active, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #935610;\n}\n.bp4-button.bp4-outlined.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.15);\n  color: #935610;\n}\n.bp4-button.bp4-outlined.bp4-intent-warning:active, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #77450d;\n}\n.bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(147, 86, 16, 0.5);\n}\n.bp4-button.bp4-outlined.bp4-intent-warning:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head {\n  stroke: #935610;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #f5c186;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(251, 179, 96, 0.5);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-danger {\n  color: #ac2f33;\n}\n.bp4-button.bp4-outlined.bp4-intent-danger:hover, .bp4-button.bp4-outlined.bp4-intent-danger:active, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ac2f33;\n}\n.bp4-button.bp4-outlined.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.15);\n  color: #ac2f33;\n}\n.bp4-button.bp4-outlined.bp4-intent-danger:active, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #8e292c;\n}\n.bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(172, 47, 51, 0.5);\n}\n.bp4-button.bp4-outlined.bp4-intent-danger:disabled.bp4-active, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n.bp4-button.bp4-outlined.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head {\n  stroke: #ac2f33;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger {\n  color: #fa999c;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #ffa1a4;\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(250, 153, 156, 0.5);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n.bp4-button.bp4-outlined:disabled, .bp4-button.bp4-outlined.bp4-disabled, .bp4-button.bp4-outlined:disabled:hover, .bp4-button.bp4-outlined.bp4-disabled:hover {\n  border-color: rgba(95, 107, 124, 0.1);\n}\n.bp4-dark .bp4-button.bp4-outlined {\n  border-color: rgba(255, 255, 255, 0.4);\n}\n.bp4-dark .bp4-button.bp4-outlined:disabled, .bp4-dark .bp4-button.bp4-outlined:disabled:hover, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-disabled:hover {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.bp4-button.bp4-outlined.bp4-intent-primary {\n  border-color: rgba(33, 93, 176, 0.6);\n}\n.bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled {\n  border-color: rgba(33, 93, 176, 0.2);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary {\n  border-color: rgba(138, 187, 255, 0.6);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-primary.bp4-disabled {\n  border-color: rgba(138, 187, 255, 0.2);\n}\n.bp4-button.bp4-outlined.bp4-intent-success {\n  border-color: rgba(28, 110, 66, 0.6);\n}\n.bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled {\n  border-color: rgba(28, 110, 66, 0.2);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success {\n  border-color: rgba(114, 202, 155, 0.6);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-success:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-success.bp4-disabled {\n  border-color: rgba(114, 202, 155, 0.2);\n}\n.bp4-button.bp4-outlined.bp4-intent-warning {\n  border-color: rgba(147, 86, 16, 0.6);\n}\n.bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled {\n  border-color: rgba(147, 86, 16, 0.2);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning {\n  border-color: rgba(251, 179, 96, 0.6);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-warning.bp4-disabled {\n  border-color: rgba(251, 179, 96, 0.2);\n}\n.bp4-button.bp4-outlined.bp4-intent-danger {\n  border-color: rgba(172, 47, 51, 0.6);\n}\n.bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled {\n  border-color: rgba(172, 47, 51, 0.2);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger {\n  border-color: rgba(250, 153, 156, 0.6);\n}\n.bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger:disabled, .bp4-dark .bp4-button.bp4-outlined.bp4-intent-danger.bp4-disabled {\n  border-color: rgba(250, 153, 156, 0.2);\n}\n.bp4-button.bp4-intent-warning {\n  background: #fbb360;\n  color: #1c2127;\n}\n.bp4-button.bp4-intent-warning:not(.bp4-disabled).bp4-icon > svg {\n  fill: rgba(28, 33, 39, 0.7);\n}\n.bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined):hover {\n  background: #ec9a3c;\n  color: #1c2127;\n}\n.bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined):active, .bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined).bp4-active {\n  background: #c87619;\n  color: #1c2127;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined):active, .bp4-button.bp4-intent-warning:not(.bp4-disabled):not(.bp4-minimal):not(.bp4-outlined).bp4-active {\n    background: highlight;\n  }\n}\n.bp4-button.bp4-intent-warning:disabled, .bp4-button.bp4-intent-warning.bp4-disabled {\n  background: rgba(200, 118, 25, 0.5);\n  color: rgba(28, 33, 39, 0.35);\n}\n.bp4-dark .bp4-button.bp4-intent-warning:disabled, .bp4-dark .bp4-button.bp4-intent-warning.bp4-disabled {\n  color: rgba(28, 33, 39, 0.6);\n}\n.bp4-button.bp4-intent-warning.bp4-minimal, .bp4-button.bp4-intent-warning.bp4-outlined {\n  background: none;\n}\n.bp4-dark .bp4-button.bp4-intent-warning.bp4-minimal:not(.bp4-disabled).bp4-icon > svg, .bp4-dark .bp4-button.bp4-intent-warning.bp4-outlined:not(.bp4-disabled).bp4-icon > svg {\n  fill: #fbb360;\n}\n\na.bp4-button {\n  text-align: center;\n  text-decoration: none;\n  transition: none;\n}\na.bp4-button, a.bp4-button:hover, a.bp4-button:active {\n  color: #1c2127;\n}\na.bp4-button.bp4-disabled {\n  color: rgba(95, 107, 124, 0.6);\n}\n\n.bp4-button-text {\n  flex: 0 1 auto;\n}\n\n.bp4-button.bp4-align-left .bp4-button-text, .bp4-button.bp4-align-right .bp4-button-text,\n.bp4-button-group.bp4-align-left .bp4-button-text,\n.bp4-button-group.bp4-align-right .bp4-button-text {\n  flex: 1 1 auto;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\nButton groups\n\nMarkup:\n<div class=\"bp4-button-group {{.modifier}}\">\n  <button type=\"button\" class=\"bp4-button bp4-intent-success\">Save</button>\n  <button type=\"button\" class=\"bp4-button bp4-intent-success bp4-icon-caret-down\"></button>\n</div>\n<div class=\"bp4-button-group {{.modifier}}\">\n  <a class=\"bp4-button bp4-icon-database\" tabindex=\"0\" role=\"button\">Queries</a>\n  <a class=\"bp4-button bp4-icon-function\" tabindex=\"0\" role=\"button\">Functions</a>\n  <a class=\"bp4-button\" tabindex=\"0\" role=\"button\">\n    Options <span class=\"bp4-icon-standard bp4-icon-caret-down bp4-align-right\"></span>\n  </a>\n</div>\n<div class=\"bp4-button-group {{.modifier}}\">\n  <a class=\"bp4-button bp4-icon-chart\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-control\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-graph\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-camera\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-map\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-code\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-th\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-time\" tabindex=\"0\" role=\"button\"></a>\n  <a class=\"bp4-button bp4-icon-compressed\" tabindex=\"0\" role=\"button\"></a>\n</div>\n\n.bp4-fill - Buttons expand equally to fill container\n.bp4-large - Use large buttons\n.bp4-minimal - Use minimal buttons\n.bp4-vertical - Vertical layout\n\nStyleguide button-group\n*/\n.bp4-button-group {\n  display: inline-flex;\n  /*\n  Responsive\n\n  Markup:\n  <div class=\"bp4-button-group bp4-large bp4-fill\">\n    <a class=\"bp4-button bp4-intent-primary bp4-fixed\" tabindex=\"0\" role=\"button\">Start</a>\n    <a class=\"bp4-button bp4-intent-primary\" tabindex=\"0\" role=\"button\">Left</a>\n    <a class=\"bp4-button bp4-intent-primary bp4-active\" tabindex=\"0\" role=\"button\">Middle</a>\n    <a class=\"bp4-button bp4-intent-primary\" tabindex=\"0\" role=\"button\">Right</a>\n    <a class=\"bp4-button bp4-intent-primary bp4-fixed\" tabindex=\"0\" role=\"button\">End</a>\n  </div>\n  <br />\n  <div class=\"bp4-button-group bp4-fill\">\n    <button class=\"bp4-button bp4-icon-arrow-left\"></button>\n    <button class=\"bp4-button bp4-fill\">Middle</button>\n    <button class=\"bp4-button bp4-icon-arrow-right\"></button>\n  </div>\n\n  Styleguide button-group}-fill\n  */\n  /*\n  Vertical button groups\n\n  Markup:\n  <div class=\"bp4-button-group bp4-vertical\">\n    <a class=\"bp4-button bp4-icon-search-template\" role=\"button\" tabindex=\"0\"></a>\n    <a class=\"bp4-button bp4-icon-zoom-in\" role=\"button\" tabindex=\"0\"></a>\n    <a class=\"bp4-button bp4-icon-zoom-out\" role=\"button\" tabindex=\"0\"></a>\n    <a class=\"bp4-button bp4-icon-zoom-to-fit\" role=\"button\" tabindex=\"0\"></a>\n  </div>\n  <div class=\"bp4-button-group bp4-vertical\">\n    <button type=\"button\" class=\"bp4-button bp4-active\">Home</button>\n    <button type=\"button\" class=\"bp4-button\">Pages</button>\n    <button type=\"button\" class=\"bp4-button\">Blog</button>\n    <button type=\"button\" class=\"bp4-button\">Calendar</button>\n  </div>\n  <div class=\"bp4-button-group bp4-vertical bp4-align-left bp4-large\">\n    <button type=\"button\" class=\"bp4-button bp4-intent-primary bp4-icon-document\">Text</button>\n    <button type=\"button\" class=\"bp4-button bp4-intent-primary bp4-icon-media bp4-active\">Media</button>\n    <button type=\"button\" class=\"bp4-button bp4-intent-primary bp4-icon-link\">Sources</button>\n  </div>\n\n  Styleguide button-group-vertical\n  */\n}\n.bp4-button-group .bp4-button {\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 4;\n}\n.bp4-button-group .bp4-button:focus {\n  z-index: 5;\n}\n.bp4-button-group .bp4-button:hover {\n  z-index: 6;\n}\n.bp4-button-group .bp4-button:active, .bp4-button-group .bp4-button.bp4-active {\n  z-index: 7;\n}\n.bp4-button-group .bp4-button:disabled, .bp4-button-group .bp4-button.bp4-disabled {\n  z-index: 3;\n}\n.bp4-button-group .bp4-button[class*=bp4-intent-] {\n  z-index: 9;\n}\n.bp4-button-group .bp4-button[class*=bp4-intent-]:focus {\n  z-index: 10;\n}\n.bp4-button-group .bp4-button[class*=bp4-intent-]:hover {\n  z-index: 11;\n}\n.bp4-button-group .bp4-button[class*=bp4-intent-]:active, .bp4-button-group .bp4-button[class*=bp4-intent-].bp4-active {\n  z-index: 12;\n}\n.bp4-button-group .bp4-button[class*=bp4-intent-]:disabled, .bp4-button-group .bp4-button[class*=bp4-intent-].bp4-disabled {\n  z-index: 8;\n}\n.bp4-button-group:not(.bp4-minimal) > .bp4-popover-wrapper:not(:first-child) .bp4-button,\n.bp4-button-group:not(.bp4-minimal) > .bp4-button:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.bp4-button-group:not(.bp4-minimal) > .bp4-popover-wrapper:not(:last-child) .bp4-button,\n.bp4-button-group:not(.bp4-minimal) > .bp4-button:not(:last-child) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  margin-right: -1px;\n}\n.bp4-button-group.bp4-minimal .bp4-button {\n  background: none;\n  box-shadow: none;\n}\n.bp4-button-group.bp4-minimal .bp4-button:hover {\n  background: rgba(143, 153, 168, 0.15);\n  box-shadow: none;\n  color: #1c2127;\n  text-decoration: none;\n}\n.bp4-button-group.bp4-minimal .bp4-button:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n  box-shadow: none;\n  color: #1c2127;\n}\n.bp4-button-group.bp4-minimal .bp4-button:disabled, .bp4-button-group.bp4-minimal .bp4-button:disabled:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover {\n  background: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n.bp4-button-group.bp4-minimal .bp4-button:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button:disabled:hover.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:hover, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:hover {\n  background: rgba(143, 153, 168, 0.15);\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled:hover, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover {\n  background: none;\n  color: rgba(171, 179, 191, 0.6);\n  cursor: not-allowed;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button:disabled:hover.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-disabled:hover.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary {\n  color: #215db0;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #215db0;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.15);\n  color: #215db0;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #184a90;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(33, 93, 176, 0.5);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head {\n  stroke: #215db0;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #99c4ff;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(138, 187, 255, 0.5);\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success {\n  color: #1c6e42;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #1c6e42;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.15);\n  color: #1c6e42;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #165a36;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(28, 110, 66, 0.5);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success .bp4-button-spinner .bp4-spinner-head {\n  stroke: #1c6e42;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(114, 202, 155, 0.5);\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning {\n  color: #935610;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #935610;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.15);\n  color: #935610;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #77450d;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(147, 86, 16, 0.5);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head {\n  stroke: #935610;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #f5c186;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(251, 179, 96, 0.5);\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger {\n  color: #ac2f33;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:hover, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ac2f33;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.15);\n  color: #ac2f33;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #8e292c;\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(172, 47, 51, 0.5);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled.bp4-active, .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n.bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head {\n  stroke: #ac2f33;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger {\n  color: #fa999c;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #ffa1a4;\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(250, 153, 156, 0.5);\n}\n.bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-button-group.bp4-minimal .bp4-button.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-button-group.bp4-minimal:not(:first-child) {\n    border-bottom-left-radius: 0;\n    border-left: none;\n    border-top-left-radius: 0;\n  }\n  .bp4-button-group.bp4-minimal:not(:last-child) {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n    margin-right: -1px;\n  }\n}\n.bp4-button-group .bp4-popover-wrapper,\n.bp4-button-group .bp4-popover-target {\n  display: flex;\n  flex: 1 1 auto;\n}\n.bp4-button-group.bp4-fill {\n  display: flex;\n  width: 100%;\n}\n.bp4-button-group .bp4-button.bp4-fill, .bp4-button-group.bp4-fill .bp4-button:not(.bp4-fixed) {\n  flex: 1 1 auto;\n}\n.bp4-button-group.bp4-vertical {\n  align-items: stretch;\n  flex-direction: column;\n  vertical-align: top;\n}\n.bp4-button-group.bp4-vertical.bp4-fill {\n  height: 100%;\n  width: unset;\n}\n.bp4-button-group.bp4-vertical .bp4-button {\n  margin-right: 0 !important; /* stylelint-disable-line declaration-no-important */\n  width: 100%;\n}\n.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-popover-wrapper:first-child .bp4-button,\n.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-button:first-child {\n  border-radius: 2px 2px 0 0;\n}\n.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-popover-wrapper:last-child .bp4-button,\n.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-button:last-child {\n  border-radius: 0 0 2px 2px;\n}\n.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-popover-wrapper:not(:last-child) .bp4-button,\n.bp4-button-group.bp4-vertical:not(.bp4-minimal) > .bp4-button:not(:last-child) {\n  margin-bottom: -1px;\n}\n.bp4-button-group.bp4-align-left .bp4-button {\n  text-align: left;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCallout\n\nMarkup:\n<div class=\"bp4-callout {{.modifier}}\">\n  <h5 class=\"bp4-heading\">Callout Heading</h5>\n  It's dangerous to go alone! Take <a href=\"#\">this</a>.\n</div>\n\n.bp4-intent-primary - Primary intent\n.bp4-intent-success - Success intent\n.bp4-intent-warning - Warning intent\n.bp4-intent-danger  - Danger intent\n.bp4-icon-info-sign - With an icon\n\nStyleguide callout\n*/\n.bp4-callout {\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: rgba(143, 153, 168, 0.15);\n  border-radius: 2px;\n  padding: 15px;\n  position: relative;\n  width: 100%;\n}\n.bp4-callout[class*=bp4-icon-] {\n  padding-left: 38px;\n}\n.bp4-callout[class*=bp4-icon-]::before {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  color: #5f6b7c;\n  left: 15px;\n  position: absolute;\n  top: 17px;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-callout {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-callout.bp4-callout-icon {\n  padding-left: 38px;\n}\n.bp4-callout.bp4-callout-icon > .bp4-icon:first-child {\n  color: #5f6b7c;\n  left: 15px;\n  position: absolute;\n  top: 17px;\n}\n.bp4-callout .bp4-heading {\n  line-height: 16px;\n  margin-bottom: 5px;\n  margin-top: 2px;\n}\n.bp4-callout .bp4-heading:last-child {\n  margin-bottom: 0;\n}\n.bp4-dark .bp4-callout {\n  background-color: rgba(143, 153, 168, 0.2);\n}\n.bp4-dark .bp4-callout[class*=bp4-icon-]::before, .bp4-dark .bp4-callout.bp4-callout-icon > .bp4-icon:first-child {\n  color: #abb3bf;\n}\n.bp4-callout.bp4-intent-primary {\n  background-color: rgba(45, 114, 210, 0.1);\n  color: #215db0;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-callout.bp4-intent-primary {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-callout.bp4-intent-primary[class*=bp4-icon-]::before,\n.bp4-callout.bp4-intent-primary > .bp4-icon:first-child,\n.bp4-callout.bp4-intent-primary .bp4-heading {\n  color: #215db0;\n}\n.bp4-dark .bp4-callout.bp4-intent-primary {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-callout.bp4-intent-primary[class*=bp4-icon-]::before,\n.bp4-dark .bp4-callout.bp4-intent-primary > .bp4-icon:first-child,\n.bp4-dark .bp4-callout.bp4-intent-primary .bp4-heading {\n  color: #8abbff;\n}\n.bp4-callout.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.1);\n  color: #1c6e42;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-callout.bp4-intent-success {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-callout.bp4-intent-success[class*=bp4-icon-]::before,\n.bp4-callout.bp4-intent-success > .bp4-icon:first-child,\n.bp4-callout.bp4-intent-success .bp4-heading {\n  color: #1c6e42;\n}\n.bp4-dark .bp4-callout.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-callout.bp4-intent-success[class*=bp4-icon-]::before,\n.bp4-dark .bp4-callout.bp4-intent-success > .bp4-icon:first-child,\n.bp4-dark .bp4-callout.bp4-intent-success .bp4-heading {\n  color: #72ca9b;\n}\n.bp4-callout.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.1);\n  color: #935610;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-callout.bp4-intent-warning {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-callout.bp4-intent-warning[class*=bp4-icon-]::before,\n.bp4-callout.bp4-intent-warning > .bp4-icon:first-child,\n.bp4-callout.bp4-intent-warning .bp4-heading {\n  color: #935610;\n}\n.bp4-dark .bp4-callout.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-callout.bp4-intent-warning[class*=bp4-icon-]::before,\n.bp4-dark .bp4-callout.bp4-intent-warning > .bp4-icon:first-child,\n.bp4-dark .bp4-callout.bp4-intent-warning .bp4-heading {\n  color: #fbb360;\n}\n.bp4-callout.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.1);\n  color: #ac2f33;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-callout.bp4-intent-danger {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-callout.bp4-intent-danger[class*=bp4-icon-]::before,\n.bp4-callout.bp4-intent-danger > .bp4-icon:first-child,\n.bp4-callout.bp4-intent-danger .bp4-heading {\n  color: #ac2f33;\n}\n.bp4-dark .bp4-callout.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-callout.bp4-intent-danger[class*=bp4-icon-]::before,\n.bp4-dark .bp4-callout.bp4-intent-danger > .bp4-icon:first-child,\n.bp4-dark .bp4-callout.bp4-intent-danger .bp4-heading {\n  color: #fa999c;\n}\n.bp4-callout.bp4-intent-primary a {\n  text-decoration: underline;\n}\n.bp4-callout.bp4-intent-primary a:hover {\n  color: #184a90;\n}\n.bp4-dark .bp4-callout.bp4-intent-primary a:hover {\n  color: #99c4ff;\n}\n.bp4-running-text .bp4-callout {\n  margin: 20px 0;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCards\n\nMarkup:\n<div class=\"bp4-card {{.modifier}}\">\n  We build products that make people better at their most important work.\n</div>\n\n.bp4-elevation-0 - Ground floor. This level provides just a gentle border shadow.\n.bp4-elevation-1 - First. Subtle drop shadow intended for static containers.\n.bp4-elevation-2 - Second. An even stronger shadow, moving on up.\n.bp4-elevation-3 - Third. For containers overlaying content temporarily.\n.bp4-elevation-4 - Fourth. The strongest shadow, usually for overlay containers on top of backdrops.\n.bp4-interactive - On hover, increase elevation and use pointer cursor.\n\nStyleguide card\n*/\n.bp4-card {\n  background-color: #ffffff;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15);\n  padding: 20px;\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-card.bp4-dark, .bp4-dark .bp4-card {\n  background-color: #2f343c;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-card {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n\n.bp4-elevation-0 {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15);\n}\n.bp4-elevation-0.bp4-dark, .bp4-dark .bp4-elevation-0 {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-elevation-0 {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-elevation-1 {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-elevation-1.bp4-dark, .bp4-dark .bp4-elevation-1 {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-elevation-1 {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-elevation-2 {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2), 0 2px 6px rgba(17, 20, 24, 0.2);\n}\n.bp4-elevation-2.bp4-dark, .bp4-dark .bp4-elevation-2 {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px rgba(17, 20, 24, 0.4), 0 2px 6px rgba(17, 20, 24, 0.4);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-elevation-2 {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-elevation-3 {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n}\n.bp4-elevation-3.bp4-dark, .bp4-dark .bp4-elevation-3 {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-elevation-3 {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-elevation-4 {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 4px 8px rgba(17, 20, 24, 0.2), 0 18px 46px 6px rgba(17, 20, 24, 0.2);\n}\n.bp4-elevation-4.bp4-dark, .bp4-dark .bp4-elevation-4 {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 4px 8px rgba(17, 20, 24, 0.4), 0 18px 46px 6px rgba(17, 20, 24, 0.4);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-elevation-4 {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-card.bp4-interactive:hover {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n  cursor: pointer;\n}\n.bp4-card.bp4-interactive:hover.bp4-dark, .bp4-dark .bp4-card.bp4-interactive:hover {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n}\n.bp4-card.bp4-interactive:active {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);\n  opacity: 0.9;\n  transition-duration: 0;\n}\n.bp4-card.bp4-interactive:active.bp4-dark, .bp4-dark .bp4-card.bp4-interactive:active {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-collapse {\n  height: 0;\n  overflow-y: hidden;\n  transition: height 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-collapse .bp4-collapse-body {\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-collapse .bp4-collapse-body[aria-hidden=true] {\n  display: none;\n}\n\n.bp4-context-menu .bp4-popover-target {\n  display: block;\n}\n\n.bp4-context-menu-popover-target {\n  position: fixed;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-divider {\n  border-bottom: 1px solid rgba(17, 20, 24, 0.15);\n  border-right: 1px solid rgba(17, 20, 24, 0.15);\n  margin: 5px;\n}\n.bp4-dark .bp4-divider {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nDialog\n\nMarkup:\n<!-- this container element fills its parent and centers the .bp4-dialog within it -->\n<div class=\"bp4-dialog-container\">\n  <div class=\"bp4-dialog\">\n    <div class=\"bp4-dialog-header\">\n      <span class=\"bp4-icon-large bp4-icon-inbox\"></span>\n      <h5 class=\"bp4-heading\">Dialog header</h5>\n      <button aria-label=\"Close\" class=\"bp4-dialog-close-button bp4-button bp4-minimal bp4-icon-cross\"></button>\n    </div>\n    <div class=\"bp4-dialog-body\">\n      This dialog hasn't been wired up with any open or close interactions.\n      It's just an example of markup and styles.\n    </div>\n    <div class=\"bp4-dialog-footer\">\n      <div class=\"bp4-dialog-footer-actions\">\n        <button type=\"button\" class=\"bp4-button\">Secondary button</button>\n        <button type=\"submit\" class=\"bp4-button bp4-intent-primary\">Primary button</button>\n      </div>\n    </div>\n  </div>\n</div>\n\nStyleguide dialog\n*/\n.bp4-dialog-container {\n  opacity: 1;\n  transform: scale(1);\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 100%;\n  pointer-events: none;\n  user-select: none;\n  width: 100%;\n}\n.bp4-dialog-container.bp4-overlay-enter > .bp4-dialog, .bp4-dialog-container.bp4-overlay-appear > .bp4-dialog {\n  opacity: 0;\n  transform: scale(0.5);\n}\n.bp4-dialog-container.bp4-overlay-enter-active > .bp4-dialog, .bp4-dialog-container.bp4-overlay-appear-active > .bp4-dialog {\n  opacity: 1;\n  transform: scale(1);\n  transition-delay: 0;\n  transition-duration: 300ms;\n  transition-property: opacity, transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n}\n.bp4-dialog-container.bp4-overlay-exit > .bp4-dialog {\n  opacity: 1;\n  transform: scale(1);\n}\n.bp4-dialog-container.bp4-overlay-exit-active > .bp4-dialog {\n  opacity: 0;\n  transform: scale(0.5);\n  transition-delay: 0;\n  transition-duration: 300ms;\n  transition-property: opacity, transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n}\n\n.bp4-dialog {\n  background: #f6f7f9;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n  display: flex;\n  flex-direction: column;\n  margin: 30px 0;\n  pointer-events: all;\n  user-select: text;\n  width: 500px;\n}\n.bp4-dialog:focus {\n  outline: 0;\n}\n.bp4-dialog.bp4-dark, .bp4-dark .bp4-dialog {\n  background: #252a31;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n  color: #f6f7f9;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dialog {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-dialog-header {\n  align-items: center;\n  background: #ffffff;\n  border-radius: 4px 4px 0 0;\n  box-shadow: 0 1px 0 rgba(17, 20, 24, 0.15);\n  display: flex;\n  flex: 0 0 auto;\n  min-height: 40px;\n  padding: 5px;\n  padding-left: 15px;\n  z-index: 0;\n}\n.bp4-dialog-header .bp4-icon-large,\n.bp4-dialog-header .bp4-icon {\n  color: #5f6b7c;\n  flex: 0 0 auto;\n  margin-left: -3px;\n  margin-right: 7.5px;\n}\n.bp4-dialog-header .bp4-heading {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  flex: 1 1 auto;\n  line-height: inherit;\n  margin: 0;\n}\n.bp4-dialog-header .bp4-heading:last-child {\n  margin-right: 15px;\n}\n.bp4-dark .bp4-dialog-header {\n  background: #2f343c;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n.bp4-dark .bp4-dialog-header .bp4-icon-large,\n.bp4-dark .bp4-dialog-header .bp4-icon {\n  color: #abb3bf;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dialog-header {\n    border-bottom: 1px solid buttonborder;\n  }\n}\n\n.bp4-dialog-body {\n  flex: 1 1 auto;\n  margin: 15px;\n}\n\n.bp4-dialog-body-scroll-container {\n  margin: 0;\n  max-height: 70vh;\n  overflow: auto;\n  padding: 15px;\n}\n\n.bp4-dialog-footer {\n  flex: 0 0 auto;\n  margin: 15px;\n}\n\n.bp4-dialog-footer-fixed {\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 0 0 4px 4px;\n  border-top: 1px solid rgba(17, 20, 24, 0.15);\n  display: flex;\n  gap: 15px;\n  justify-content: space-between;\n  margin: 0;\n  padding: 10px 10px 10px 15px;\n}\n.bp4-dark .bp4-dialog-footer-fixed {\n  background: #383e47;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.bp4-dialog-footer-main-section {\n  flex: 1 0 auto;\n}\n\n.bp4-dialog-footer-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n.bp4-dialog-footer-actions .bp4-button {\n  margin-left: 10px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-multistep-dialog-panels {\n  display: flex;\n}\n.bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:first-child {\n  border-radius: 4px 0 0 0;\n}\n.bp4-multistep-dialog-panels:first-child .bp4-multistep-dialog-right-panel {\n  border-top-right-radius: 4px;\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels {\n  flex-direction: column;\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:first-child {\n  border-radius: 4px 0 0 0;\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:last-child {\n  border-radius: 0 4px 0 0;\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-left-panel {\n  flex-direction: row;\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-dialog-step-container {\n  flex-grow: 1;\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-dialog-step-container:not(:first-child) {\n  border-left: 1px solid rgba(17, 20, 24, 0.15);\n}\n.bp4-dark .bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-dialog-step-container {\n  border-color: rgba(17, 20, 24, 0.4);\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel {\n  border-left: none;\n}\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel,\n.bp4-multistep-dialog-nav-top .bp4-multistep-dialog-panels .bp4-multistep-dialog-footer {\n  border-radius: 0 0 4px 4px;\n}\n.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels {\n  flex-direction: row-reverse;\n}\n.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels:first-child .bp4-multistep-dialog-right-panel {\n  border-radius: 4px 0 0 4px;\n}\n.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels:first-child .bp4-dialog-step-container:first-child {\n  border-radius: 0 4px 0 0;\n}\n.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-multistep-dialog-left-panel {\n  border-radius: 0 0 4px 0;\n}\n.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel {\n  border-left: none;\n  border-radius: 4px 0 0 4px;\n  border-right: 1px solid rgba(17, 20, 24, 0.15);\n}\n.bp4-dark .bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-multistep-dialog-right-panel {\n  border-color: rgba(17, 20, 24, 0.4);\n}\n.bp4-multistep-dialog-nav-right .bp4-multistep-dialog-panels .bp4-dialog-footer {\n  border-bottom-left-radius: 0;\n}\n\n.bp4-multistep-dialog-left-panel {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.bp4-dark .bp4-multistep-dialog-left-panel {\n  background: #252a31;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  border-bottom-left-radius: 4px;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.bp4-multistep-dialog-right-panel {\n  background-color: #f6f7f9;\n  border-left: 1px solid rgba(17, 20, 24, 0.15);\n  border-radius: 0 0 4px 0;\n  flex: 3;\n  min-width: 0;\n}\n.bp4-dark .bp4-multistep-dialog-right-panel {\n  background-color: #2f343c;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  border-bottom-right-radius: 4px;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.bp4-dialog-step-container {\n  background-color: #f6f7f9;\n  border-bottom: 1px solid rgba(17, 20, 24, 0.15);\n}\n.bp4-dark .bp4-dialog-step-container {\n  background: #2f343c;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n.bp4-dialog-step-container.bp4-dialog-step-viewed {\n  background-color: #ffffff;\n}\n.bp4-dark .bp4-dialog-step-container.bp4-dialog-step-viewed {\n  background: #383e47;\n}\n\n.bp4-dialog-step {\n  align-items: center;\n  border-radius: 4px;\n  cursor: not-allowed;\n  display: flex;\n  margin: 4px;\n  padding: 6px 14px;\n}\n.bp4-dark .bp4-dialog-step {\n  background: #2f343c;\n}\n.bp4-dialog-step-viewed .bp4-dialog-step {\n  background-color: #ffffff;\n  cursor: pointer;\n}\n.bp4-dark .bp4-dialog-step-viewed .bp4-dialog-step {\n  background: #383e47;\n}\n.bp4-dialog-step:hover {\n  background-color: #f6f7f9;\n}\n.bp4-dark .bp4-dialog-step:hover {\n  background: #2f343c;\n}\n\n.bp4-dialog-step-icon {\n  align-items: center;\n  background-color: rgba(95, 107, 124, 0.6);\n  border-radius: 50%;\n  color: #ffffff;\n  display: flex;\n  height: 25px;\n  justify-content: center;\n  width: 25px;\n}\n.bp4-dark .bp4-dialog-step-icon {\n  background-color: rgba(171, 179, 191, 0.6);\n}\n.bp4-active.bp4-dialog-step-viewed .bp4-dialog-step-icon {\n  background-color: #4c90f0;\n}\n.bp4-dialog-step-viewed .bp4-dialog-step-icon {\n  background-color: #8f99a8;\n}\n\n.bp4-dialog-step-title {\n  color: rgba(95, 107, 124, 0.6);\n  flex: 1;\n  padding-left: 10px;\n}\n.bp4-dark .bp4-dialog-step-title {\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-active.bp4-dialog-step-viewed .bp4-dialog-step-title {\n  color: #4c90f0;\n}\n.bp4-dialog-step-viewed:not(.bp4-active) .bp4-dialog-step-title {\n  color: #1c2127;\n}\n.bp4-dark .bp4-dialog-step-viewed:not(.bp4-active) .bp4-dialog-step-title {\n  color: #f6f7f9;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-drawer {\n  background: #ffffff;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 4px 8px rgba(17, 20, 24, 0.2), 0 18px 46px 6px rgba(17, 20, 24, 0.2);\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n}\n.bp4-drawer:focus {\n  outline: 0;\n}\n.bp4-drawer.bp4-position-top {\n  height: 50%;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n.bp4-drawer.bp4-position-top.bp4-overlay-enter, .bp4-drawer.bp4-position-top.bp4-overlay-appear {\n  transform: translateY(-100%);\n}\n.bp4-drawer.bp4-position-top.bp4-overlay-enter-active, .bp4-drawer.bp4-position-top.bp4-overlay-appear-active {\n  transform: translateY(0);\n  transition-delay: 0;\n  transition-duration: 200ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-drawer.bp4-position-top.bp4-overlay-exit {\n  transform: translateY(0);\n}\n.bp4-drawer.bp4-position-top.bp4-overlay-exit-active {\n  transform: translateY(-100%);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-drawer.bp4-position-top {\n    border-bottom: 1px solid buttonborder;\n  }\n}\n.bp4-drawer.bp4-position-bottom {\n  bottom: 0;\n  height: 50%;\n  left: 0;\n  right: 0;\n}\n.bp4-drawer.bp4-position-bottom.bp4-overlay-enter, .bp4-drawer.bp4-position-bottom.bp4-overlay-appear {\n  transform: translateY(100%);\n}\n.bp4-drawer.bp4-position-bottom.bp4-overlay-enter-active, .bp4-drawer.bp4-position-bottom.bp4-overlay-appear-active {\n  transform: translateY(0);\n  transition-delay: 0;\n  transition-duration: 200ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-drawer.bp4-position-bottom.bp4-overlay-exit {\n  transform: translateY(0);\n}\n.bp4-drawer.bp4-position-bottom.bp4-overlay-exit-active {\n  transform: translateY(100%);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-drawer.bp4-position-bottom {\n    border-top: 1px solid buttonborder;\n  }\n}\n.bp4-drawer.bp4-position-left {\n  bottom: 0;\n  left: 0;\n  top: 0;\n  width: 50%;\n}\n.bp4-drawer.bp4-position-left.bp4-overlay-enter, .bp4-drawer.bp4-position-left.bp4-overlay-appear {\n  transform: translateX(-100%);\n}\n.bp4-drawer.bp4-position-left.bp4-overlay-enter-active, .bp4-drawer.bp4-position-left.bp4-overlay-appear-active {\n  transform: translateX(0);\n  transition-delay: 0;\n  transition-duration: 200ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-drawer.bp4-position-left.bp4-overlay-exit {\n  transform: translateX(0);\n}\n.bp4-drawer.bp4-position-left.bp4-overlay-exit-active {\n  transform: translateX(-100%);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-drawer.bp4-position-left {\n    border-right: 1px solid buttonborder;\n  }\n}\n.bp4-drawer.bp4-position-right {\n  bottom: 0;\n  right: 0;\n  top: 0;\n  width: 50%;\n}\n.bp4-drawer.bp4-position-right.bp4-overlay-enter, .bp4-drawer.bp4-position-right.bp4-overlay-appear {\n  transform: translateX(100%);\n}\n.bp4-drawer.bp4-position-right.bp4-overlay-enter-active, .bp4-drawer.bp4-position-right.bp4-overlay-appear-active {\n  transform: translateX(0);\n  transition-delay: 0;\n  transition-duration: 200ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-drawer.bp4-position-right.bp4-overlay-exit {\n  transform: translateX(0);\n}\n.bp4-drawer.bp4-position-right.bp4-overlay-exit-active {\n  transform: translateX(100%);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-drawer.bp4-position-right {\n    border-left: 1px solid buttonborder;\n  }\n}\n.bp4-drawer.bp4-dark, .bp4-dark .bp4-drawer {\n  background: #383e47;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n  color: #f6f7f9;\n}\n\n.bp4-drawer-header {\n  align-items: center;\n  border-radius: 0;\n  box-shadow: 0 1px 0 rgba(17, 20, 24, 0.15);\n  display: flex;\n  flex: 0 0 auto;\n  min-height: 40px;\n  padding: 5px;\n  padding-left: 20px;\n  position: relative;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-drawer-header {\n    border-bottom: 1px solid buttonborder;\n  }\n}\n.bp4-drawer-header .bp4-icon-large,\n.bp4-drawer-header .bp4-icon {\n  color: #5f6b7c;\n  flex: 0 0 auto;\n  margin-right: 10px;\n}\n.bp4-drawer-header .bp4-heading {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  flex: 1 1 auto;\n  line-height: inherit;\n  margin: 0;\n}\n.bp4-drawer-header .bp4-heading:last-child {\n  margin-right: 20px;\n}\n.bp4-dark .bp4-drawer-header {\n  box-shadow: 0 1px 0 rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-drawer-header .bp4-icon-large,\n.bp4-dark .bp4-drawer-header .bp4-icon {\n  color: #abb3bf;\n}\n\n.bp4-drawer-body {\n  flex: 1 1 auto;\n  line-height: 18px;\n  overflow: auto;\n}\n\n.bp4-drawer-footer {\n  box-shadow: inset 0 1px 0 rgba(17, 20, 24, 0.15);\n  flex: 0 0 auto;\n  padding: 10px 20px;\n  position: relative;\n}\n.bp4-dark .bp4-drawer-footer {\n  box-shadow: inset 0 1px 0 rgba(17, 20, 24, 0.4);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n.bp4-editable-text {\n  cursor: text;\n  display: inline-block;\n  max-width: 100%;\n  position: relative;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.bp4-editable-text::before {\n  bottom: -2px;\n  left: -2px;\n  position: absolute;\n  right: -2px;\n  top: -2px;\n  border-radius: 2px;\n  content: \"\";\n  transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9), box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-editable-text:hover::before {\n  box-shadow: 0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(17, 20, 24, 0.15);\n}\n.bp4-editable-text.bp4-editable-text-editing::before {\n  background-color: #ffffff;\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-editable-text:not(.bp4-disabled)::before {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-editable-text.bp4-intent-primary .bp4-editable-text-content,\n.bp4-editable-text.bp4-intent-primary .bp4-editable-text-input,\n.bp4-editable-text.bp4-intent-primary .bp4-editable-text-input::placeholder {\n  color: #2d72d2;\n}\n.bp4-editable-text.bp4-intent-primary:hover::before {\n  box-shadow: 0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(45, 114, 210, 0.4);\n}\n.bp4-editable-text.bp4-intent-primary.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-editable-text.bp4-intent-success .bp4-editable-text-content,\n.bp4-editable-text.bp4-intent-success .bp4-editable-text-input,\n.bp4-editable-text.bp4-intent-success .bp4-editable-text-input::placeholder {\n  color: #238551;\n}\n.bp4-editable-text.bp4-intent-success:hover::before {\n  box-shadow: 0 0 0 0 rgba(35, 133, 81, 0), 0 0 0 0 rgba(35, 133, 81, 0), inset 0 0 0 1px rgba(35, 133, 81, 0.4);\n}\n.bp4-editable-text.bp4-intent-success.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-editable-text.bp4-intent-warning .bp4-editable-text-content,\n.bp4-editable-text.bp4-intent-warning .bp4-editable-text-input,\n.bp4-editable-text.bp4-intent-warning .bp4-editable-text-input::placeholder {\n  color: #c87619;\n}\n.bp4-editable-text.bp4-intent-warning:hover::before {\n  box-shadow: 0 0 0 0 rgba(200, 118, 25, 0), 0 0 0 0 rgba(200, 118, 25, 0), inset 0 0 0 1px rgba(200, 118, 25, 0.4);\n}\n.bp4-editable-text.bp4-intent-warning.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-editable-text.bp4-intent-danger .bp4-editable-text-content,\n.bp4-editable-text.bp4-intent-danger .bp4-editable-text-input,\n.bp4-editable-text.bp4-intent-danger .bp4-editable-text-input::placeholder {\n  color: #cd4246;\n}\n.bp4-editable-text.bp4-intent-danger:hover::before {\n  box-shadow: 0 0 0 0 rgba(205, 66, 70, 0), 0 0 0 0 rgba(205, 66, 70, 0), inset 0 0 0 1px rgba(205, 66, 70, 0.4);\n}\n.bp4-editable-text.bp4-intent-danger.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-dark .bp4-editable-text:hover::before {\n  box-shadow: 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n.bp4-dark .bp4-editable-text.bp4-editable-text-editing::before {\n  background-color: rgba(17, 20, 24, 0.3);\n  box-shadow: inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-editable-text.bp4-disabled::before {\n  box-shadow: none;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-primary .bp4-editable-text-content,\n.bp4-dark .bp4-editable-text.bp4-intent-primary .bp4-editable-text-input,\n.bp4-dark .bp4-editable-text.bp4-intent-primary .bp4-editable-text-input::placeholder {\n  color: #8abbff;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-primary:hover::before {\n  box-shadow: 0 0 0 0 rgba(138, 187, 255, 0), 0 0 0 0 rgba(138, 187, 255, 0), inset 0 0 0 1px rgba(138, 187, 255, 0.4);\n}\n.bp4-dark .bp4-editable-text.bp4-intent-primary.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #8abbff, 0 0 0 2px rgba(138, 187, 255, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-success .bp4-editable-text-content,\n.bp4-dark .bp4-editable-text.bp4-intent-success .bp4-editable-text-input,\n.bp4-dark .bp4-editable-text.bp4-intent-success .bp4-editable-text-input::placeholder {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-success:hover::before {\n  box-shadow: 0 0 0 0 rgba(114, 202, 155, 0), 0 0 0 0 rgba(114, 202, 155, 0), inset 0 0 0 1px rgba(114, 202, 155, 0.4);\n}\n.bp4-dark .bp4-editable-text.bp4-intent-success.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #72ca9b, 0 0 0 2px rgba(114, 202, 155, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-warning .bp4-editable-text-content,\n.bp4-dark .bp4-editable-text.bp4-intent-warning .bp4-editable-text-input,\n.bp4-dark .bp4-editable-text.bp4-intent-warning .bp4-editable-text-input::placeholder {\n  color: #fbb360;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-warning:hover::before {\n  box-shadow: 0 0 0 0 rgba(251, 179, 96, 0), 0 0 0 0 rgba(251, 179, 96, 0), inset 0 0 0 1px rgba(251, 179, 96, 0.4);\n}\n.bp4-dark .bp4-editable-text.bp4-intent-warning.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #fbb360, 0 0 0 2px rgba(251, 179, 96, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-danger .bp4-editable-text-content,\n.bp4-dark .bp4-editable-text.bp4-intent-danger .bp4-editable-text-input,\n.bp4-dark .bp4-editable-text.bp4-intent-danger .bp4-editable-text-input::placeholder {\n  color: #fa999c;\n}\n.bp4-dark .bp4-editable-text.bp4-intent-danger:hover::before {\n  box-shadow: 0 0 0 0 rgba(250, 153, 156, 0), 0 0 0 0 rgba(250, 153, 156, 0), inset 0 0 0 1px rgba(250, 153, 156, 0.4);\n}\n.bp4-dark .bp4-editable-text.bp4-intent-danger.bp4-editable-text-editing::before {\n  box-shadow: inset 0 0 0 1px #fa999c, 0 0 0 2px rgba(250, 153, 156, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-editable-text.bp4-disabled::before {\n  /* stylelint-disable-next-line declaration-no-important */\n  box-shadow: none !important;\n}\n\n.bp4-editable-text-input,\n.bp4-editable-text-content {\n  color: inherit;\n  display: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  max-width: inherit;\n  min-width: inherit;\n  position: relative;\n  resize: none;\n  text-transform: inherit;\n  vertical-align: top;\n}\n\n.bp4-editable-text-input {\n  background: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  white-space: pre-wrap;\n  width: 100%;\n}\n.bp4-editable-text-input::placeholder {\n  color: #5f6b7c;\n  opacity: 1;\n}\n.bp4-editable-text-input:focus {\n  outline: none;\n}\n.bp4-editable-text-input::-ms-clear {\n  display: none;\n}\n\n.bp4-editable-text-content {\n  overflow: hidden;\n  padding-right: 2px;\n  text-overflow: ellipsis;\n  white-space: pre;\n}\n.bp4-editable-text-editing > .bp4-editable-text-content {\n  left: 0;\n  position: absolute;\n  visibility: hidden;\n}\n.bp4-editable-text-placeholder > .bp4-editable-text-content {\n  color: #5f6b7c;\n}\n.bp4-dark .bp4-editable-text-placeholder > .bp4-editable-text-content {\n  color: #abb3bf;\n}\n\n.bp4-editable-text.bp4-multiline {\n  display: block;\n}\n.bp4-editable-text.bp4-multiline .bp4-editable-text-content {\n  overflow: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-divider {\n  border-bottom: 1px solid rgba(17, 20, 24, 0.15);\n  border-right: 1px solid rgba(17, 20, 24, 0.15);\n  margin: 5px;\n}\n.bp4-dark .bp4-divider {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n/*\nControl groups\n\nMarkup:\n<div class=\"bp4-control-group\">\n  <button class=\"bp4-button bp4-icon-filter\">Filter</button>\n  <input type=\"text\" class=\"bp4-input\" placeholder=\"Find filters...\" />\n</div>\n<div class=\"bp4-control-group\">\n  <div class=\"bp4-select\">\n    <select>\n      <option selected>Filter...</option>\n      <option value=\"1\">Issues</option>\n      <option value=\"2\">Requests</option>\n      <option value=\"3\">Projects</option>\n    </select>\n  </div>\n  <div class=\"bp4-input-group\">\n    <span class=\"bp4-icon bp4-icon-search\"></span>\n    <input type=\"text\" class=\"bp4-input\" value=\"from:ggray to:allorca\" />\n  </div>\n</div>\n<div class=\"bp4-control-group\">\n  <div class=\"bp4-input-group\">\n    <span class=\"bp4-icon bp4-icon-people\"></span>\n    <input type=\"text\" class=\"bp4-input\" placeholder=\"Find collaborators...\" style=\"padding-right:94px\" />\n    <div class=\"bp4-input-action\">\n      <button class=\"bp4-button bp4-minimal bp4-intent-primary\">\n        can view<span class=\"bp4-icon-standard bp4-icon-caret-down bp4-align-right\"></span>\n      </button>\n    </div>\n  </div>\n  <button class=\"bp4-button bp4-intent-primary\">Add</button>\n</div>\n<div class=\"bp4-control-group\">\n  <div class=\"bp4-select\">\n    <select>\n      <option selected value=\"dollar\">$</option>\n      <option value=\"euro\">€</option>\n    </select>\n  </div>\n  <div class=\"bp4-control-group bp4-numeric-input\">\n    <div class=\"bp4-input-group\">\n      <input type=\"text\" autocomplete=\"off\" class=\"bp4-input\" style=\"padding-right: 10px;\" value=\"1\">\n    </div>\n    <div class=\"bp4-button-group bp4-vertical bp4-fixed\">\n      <button type=\"button\" class=\"bp4-button\">\n        <span icon=\"chevron-up\" class=\"bp4-icon bp4-icon-chevron-up\">\n          <svg data-icon=\"chevron-up\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><desc>chevron-up</desc><path d=\"M12.71 9.29l-4-4C8.53 5.11 8.28 5 8 5s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 7.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z\" fill-rule=\"evenodd\"></path></svg>\n        </span>\n      </button>\n      <button type=\"button\" class=\"bp4-button\">\n        <span icon=\"chevron-down\" class=\"bp4-icon bp4-icon-chevron-down\">\n          <svg data-icon=\"chevron-down\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><desc>chevron-down</desc><path d=\"M12 5c-.28 0-.53.11-.71.29L8 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 5z\" fill-rule=\"evenodd\"></path></svg>\n        </span>\n      </button>\n    </div>\n  </div>\n</div>\n\nStyleguide control-group\n*/\n.bp4-control-group {\n  transform: translateZ(0);\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  /*\n  Responsive control groups\n\n  Markup:\n  <div class=\"bp4-control-group\">\n    <div class=\"bp4-input-group bp4-fill\">\n      <span class=\"bp4-icon bp4-icon-people\"></span>\n      <input type=\"text\" class=\"bp4-input\" placeholder=\"Find collaborators...\" />\n    </div>\n    <button class=\"bp4-button bp4-intent-primary\">Add</button>\n  </div>\n  <div class=\"bp4-control-group bp4-fill\">\n    <button class=\"bp4-button bp4-icon-minus bp4-fixed\"></button>\n    <input type=\"text\" class=\"bp4-input\" placeholder=\"Enter a value...\" />\n    <button class=\"bp4-button bp4-icon-plus bp4-fixed\"></button>\n  </div>\n\n  Styleguide control-group-fill\n  */\n  /*\n  Vertical control groups\n\n  Markup:\n  <div class=\"bp4-control-group bp4-vertical\" style=\"width: 300px;\">\n    <div class=\"bp4-input-group bp4-large\">\n      <span class=\"bp4-icon bp4-icon-person\"></span>\n      <input type=\"text\" class=\"bp4-input\" placeholder=\"Username\" />\n    </div>\n    <div class=\"bp4-input-group bp4-large\">\n      <span class=\"bp4-icon bp4-icon-lock\"></span>\n      <input type=\"password\" class=\"bp4-input\" placeholder=\"Password\" />\n    </div>\n    <button class=\"bp4-button bp4-large bp4-intent-primary\">Login</button>\n  </div>\n\n  Styleguide control-group-vertical\n  */\n}\n.bp4-control-group > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-control-group > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-control-group .bp4-button,\n.bp4-control-group .bp4-html-select,\n.bp4-control-group .bp4-input,\n.bp4-control-group .bp4-select {\n  position: relative;\n}\n.bp4-control-group .bp4-input {\n  z-index: 2;\n}\n.bp4-control-group .bp4-input:focus {\n  z-index: 14;\n}\n.bp4-control-group .bp4-input[class*=bp4-intent] {\n  z-index: 13;\n}\n.bp4-control-group .bp4-input[class*=bp4-intent]:focus {\n  z-index: 15;\n}\n.bp4-control-group .bp4-input[readonly], .bp4-control-group .bp4-input:disabled, .bp4-control-group .bp4-input.bp4-disabled {\n  z-index: 1;\n}\n.bp4-control-group .bp4-input-group[class*=bp4-intent] .bp4-input {\n  z-index: 13;\n}\n.bp4-control-group .bp4-input-group[class*=bp4-intent] .bp4-input:focus {\n  z-index: 15;\n}\n.bp4-control-group .bp4-button,\n.bp4-control-group .bp4-html-select select,\n.bp4-control-group .bp4-select select {\n  transform: translateZ(0);\n  z-index: 4;\n}\n.bp4-control-group .bp4-button:focus,\n.bp4-control-group .bp4-html-select select:focus,\n.bp4-control-group .bp4-select select:focus {\n  z-index: 5;\n}\n.bp4-control-group .bp4-button:hover,\n.bp4-control-group .bp4-html-select select:hover,\n.bp4-control-group .bp4-select select:hover {\n  z-index: 6;\n}\n.bp4-control-group .bp4-button:active,\n.bp4-control-group .bp4-html-select select:active,\n.bp4-control-group .bp4-select select:active {\n  z-index: 7;\n}\n.bp4-control-group .bp4-button[readonly], .bp4-control-group .bp4-button:disabled, .bp4-control-group .bp4-button.bp4-disabled,\n.bp4-control-group .bp4-html-select select[readonly],\n.bp4-control-group .bp4-html-select select:disabled,\n.bp4-control-group .bp4-html-select select.bp4-disabled,\n.bp4-control-group .bp4-select select[readonly],\n.bp4-control-group .bp4-select select:disabled,\n.bp4-control-group .bp4-select select.bp4-disabled {\n  z-index: 3;\n}\n.bp4-control-group .bp4-button[class*=bp4-intent],\n.bp4-control-group .bp4-html-select select[class*=bp4-intent],\n.bp4-control-group .bp4-select select[class*=bp4-intent] {\n  z-index: 9;\n}\n.bp4-control-group .bp4-button[class*=bp4-intent]:focus,\n.bp4-control-group .bp4-html-select select[class*=bp4-intent]:focus,\n.bp4-control-group .bp4-select select[class*=bp4-intent]:focus {\n  z-index: 10;\n}\n.bp4-control-group .bp4-button[class*=bp4-intent]:hover,\n.bp4-control-group .bp4-html-select select[class*=bp4-intent]:hover,\n.bp4-control-group .bp4-select select[class*=bp4-intent]:hover {\n  z-index: 11;\n}\n.bp4-control-group .bp4-button[class*=bp4-intent]:active,\n.bp4-control-group .bp4-html-select select[class*=bp4-intent]:active,\n.bp4-control-group .bp4-select select[class*=bp4-intent]:active {\n  z-index: 12;\n}\n.bp4-control-group .bp4-button[class*=bp4-intent][readonly], .bp4-control-group .bp4-button[class*=bp4-intent]:disabled, .bp4-control-group .bp4-button[class*=bp4-intent].bp4-disabled,\n.bp4-control-group .bp4-html-select select[class*=bp4-intent][readonly],\n.bp4-control-group .bp4-html-select select[class*=bp4-intent]:disabled,\n.bp4-control-group .bp4-html-select select[class*=bp4-intent].bp4-disabled,\n.bp4-control-group .bp4-select select[class*=bp4-intent][readonly],\n.bp4-control-group .bp4-select select[class*=bp4-intent]:disabled,\n.bp4-control-group .bp4-select select[class*=bp4-intent].bp4-disabled {\n  z-index: 8;\n}\n.bp4-control-group .bp4-input-group > .bp4-icon,\n.bp4-control-group .bp4-input-group > .bp4-button,\n.bp4-control-group .bp4-input-group > .bp4-input-left-container,\n.bp4-control-group .bp4-input-group > .bp4-input-action {\n  z-index: 16;\n}\n.bp4-control-group .bp4-select::after,\n.bp4-control-group .bp4-html-select::after,\n.bp4-control-group .bp4-select > .bp4-icon,\n.bp4-control-group .bp4-html-select > .bp4-icon {\n  z-index: 17;\n}\n.bp4-control-group .bp4-select:focus-within {\n  z-index: 5;\n}\n.bp4-control-group:not(.bp4-vertical) > :not(:last-child) {\n  margin-right: 2px;\n}\n.bp4-control-group .bp4-numeric-input:not(:first-child) .bp4-input-group {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.bp4-control-group.bp4-fill {\n  width: 100%;\n}\n.bp4-control-group > .bp4-fill {\n  flex: 1 1 auto;\n}\n.bp4-control-group.bp4-fill > *:not(.bp4-fixed) {\n  flex: 1 1 auto;\n}\n.bp4-control-group.bp4-vertical {\n  flex-direction: column;\n}\n.bp4-control-group.bp4-vertical > :not(:last-child) {\n  margin-bottom: 2px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n.bp4-control {\n  cursor: pointer;\n  display: block;\n  margin-bottom: 10px;\n  position: relative;\n  text-transform: none;\n  /*\n  Checkbox\n\n  Markup:\n  <label class=\"bp4-control bp4-checkbox {{.modifier}}\">\n    <input type=\"checkbox\" {{:modifier}} />\n    <span class=\"bp4-control-indicator\"></span>\n    Checkbox\n  </label>\n\n  :checked  - Checked\n  :disabled - Disabled. Also add <code>.bp4-disabled</code> to <code>.bp4-control</code> to change text color (not shown below).\n  :indeterminate - Indeterminate. Note that this style can only be achieved via JavaScript\n                   <code>input.indeterminate = true</code>.\n  .bp4-align-right - Right-aligned indicator\n  .bp4-large - Large\n\n  Styleguide checkbox\n  */\n  /*\n  Radio\n\n  Markup:\n  <label class=\"bp4-control bp4-radio {{.modifier}}\">\n    <input type=\"radio\" name=\"docs-radio-regular\" {{:modifier}} />\n    <span class=\"bp4-control-indicator\"></span>\n    Radio\n  </label>\n\n  :checked  - Selected\n  :disabled - Disabled. Also add <code>.bp4-disabled</code> to <code>.bp4-control</code> to change text color (not shown below).\n  .bp4-align-right - Right-aligned indicator\n  .bp4-large - Large\n\n  Styleguide radio\n  */\n  /*\n  Switch\n\n  Markup:\n  <label class=\"bp4-control bp4-switch {{.modifier}}\">\n    <input type=\"checkbox\" {{:modifier}} />\n    <span class=\"bp4-control-indicator\"></span>\n    Switch\n  </label>\n\n  :checked  - Selected\n  :disabled - Disabled. Also add <code>.bp4-disabled</code> to <code>.bp4-control</code> to change text color (not shown below).\n  .bp4-align-right - Right-aligned indicator\n  .bp4-large - Large\n\n  Styleguide switch\n  */\n  /* stylelint-disable-next-line order/order */\n  /*\n  Inline labels\n\n  Markup:\n  <div>\n    <label class=\"bp4-label\">A group of related options</label>\n    <label class=\"bp4-control bp4-checkbox bp4-inline\">\n      <input type=\"checkbox\" />\n      <span class=\"bp4-control-indicator\"></span>\n      First\n    </label>\n    <label class=\"bp4-control bp4-checkbox bp4-inline\">\n      <input type=\"checkbox\" />\n      <span class=\"bp4-control-indicator\"></span>\n      Second\n    </label>\n    <label class=\"bp4-control bp4-checkbox bp4-inline\">\n      <input type=\"checkbox\" />\n      <span class=\"bp4-control-indicator\"></span>\n      Third\n    </label>\n  </div>\n\n  Styleguide checkbox-inline\n  */\n}\n.bp4-control input:checked ~ .bp4-control-indicator {\n  background-color: #2d72d2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2);\n  color: #ffffff;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control input:checked ~ .bp4-control-indicator {\n    background-color: highlight;\n    border: 1px solid highlight;\n  }\n}\n.bp4-control:hover input:checked ~ .bp4-control-indicator {\n  background-color: #215db0;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control:hover input:checked ~ .bp4-control-indicator {\n    background-color: highlight;\n  }\n}\n.bp4-control input:not(:disabled):active:checked ~ .bp4-control-indicator {\n  background: #184a90;\n}\n.bp4-control input:disabled:checked ~ .bp4-control-indicator {\n  background: rgba(45, 114, 210, 0.5);\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control input:disabled:checked ~ .bp4-control-indicator {\n    background-color: graytext;\n    border-color: graytext;\n  }\n}\n.bp4-dark .bp4-control input:checked ~ .bp4-control-indicator {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-control input:checked ~ .bp4-control-indicator {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-dark .bp4-control:hover input:checked ~ .bp4-control-indicator {\n  background-color: #215db0;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n.bp4-dark .bp4-control input:not(:disabled):active:checked ~ .bp4-control-indicator {\n  background-color: #184a90;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n.bp4-dark .bp4-control input:disabled:checked ~ .bp4-control-indicator {\n  background: rgba(45, 114, 210, 0.5);\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n.bp4-control:not(.bp4-align-right) {\n  padding-left: 26px;\n}\n.bp4-control:not(.bp4-align-right) .bp4-control-indicator {\n  margin-left: -26px;\n}\n.bp4-control.bp4-align-right {\n  padding-right: 26px;\n}\n.bp4-control.bp4-align-right .bp4-control-indicator {\n  margin-right: -26px;\n}\n.bp4-control.bp4-disabled {\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n.bp4-control.bp4-inline {\n  display: inline-block;\n  margin-right: 20px;\n}\n.bp4-control input {\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  z-index: -1;\n}\n.bp4-control .bp4-control-indicator {\n  background-clip: padding-box;\n  background-color: transparent;\n  border: none;\n  box-shadow: inset 0 0 0 1px #738091;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 16px;\n  height: 1em;\n  margin-right: 10px;\n  margin-top: -3px;\n  position: relative;\n  user-select: none;\n  vertical-align: middle;\n  width: 1em;\n}\n.bp4-control .bp4-control-indicator::before {\n  content: \"\";\n  display: block;\n  height: 1em;\n  width: 1em;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control .bp4-control-indicator {\n    border: 1px solid buttonborder;\n  }\n  .bp4-control .bp4-control-indicator::before {\n    margin-left: -1px;\n    margin-top: -1px;\n  }\n}\n.bp4-control:hover .bp4-control-indicator {\n  background-color: rgba(143, 153, 168, 0.15);\n}\n.bp4-control input:not(:disabled):active ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.3);\n  box-shadow: inset 0 0 0 1px #738091;\n}\n.bp4-control input:disabled ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.15);\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.bp4-control input:focus ~ .bp4-control-indicator {\n  outline: rgba(45, 114, 210, 0.6) solid 2px;\n  outline-offset: 2px;\n  -moz-outline-radius: 6px;\n  outline: #2d72d2 solid 2px;\n}\n.bp4-control.bp4-align-right .bp4-control-indicator {\n  float: right;\n  margin-left: 10px;\n  margin-top: 1px;\n}\n.bp4-control.bp4-large {\n  font-size: 16px;\n}\n.bp4-control.bp4-large:not(.bp4-align-right) {\n  padding-left: 30px;\n}\n.bp4-control.bp4-large:not(.bp4-align-right) .bp4-control-indicator {\n  margin-left: -30px;\n}\n.bp4-control.bp4-large.bp4-align-right {\n  padding-right: 30px;\n}\n.bp4-control.bp4-large.bp4-align-right .bp4-control-indicator {\n  margin-right: -30px;\n}\n.bp4-control.bp4-large .bp4-control-indicator {\n  font-size: 20px;\n}\n.bp4-control.bp4-large.bp4-align-right .bp4-control-indicator {\n  margin-top: 0;\n}\n.bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator {\n  background-color: #2d72d2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2);\n  color: #ffffff;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator {\n    background-color: highlight;\n    border: 1px solid highlight;\n  }\n}\n.bp4-control.bp4-checkbox:hover input:indeterminate ~ .bp4-control-indicator {\n  background-color: #215db0;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-checkbox:hover input:indeterminate ~ .bp4-control-indicator {\n    background-color: highlight;\n  }\n}\n.bp4-control.bp4-checkbox input:not(:disabled):active:indeterminate ~ .bp4-control-indicator {\n  background: #184a90;\n}\n.bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator {\n  background: rgba(45, 114, 210, 0.5);\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator {\n    background-color: graytext;\n    border-color: graytext;\n  }\n}\n.bp4-dark .bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-dark .bp4-control.bp4-checkbox:hover input:indeterminate ~ .bp4-control-indicator {\n  background-color: #215db0;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n.bp4-dark .bp4-control.bp4-checkbox input:not(:disabled):active:indeterminate ~ .bp4-control-indicator {\n  background-color: #184a90;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n.bp4-dark .bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator {\n  background: rgba(45, 114, 210, 0.5);\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.6);\n}\n.bp4-control.bp4-checkbox .bp4-control-indicator {\n  border-radius: 2px;\n}\n.bp4-control.bp4-checkbox input:checked ~ .bp4-control-indicator::before {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='white'/%3e%3c/svg%3e\");\n}\n.bp4-control.bp4-checkbox input:indeterminate ~ .bp4-control-indicator::before {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z' fill='white'/%3e%3c/svg%3e\");\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-checkbox input:checked:not(:disabled) ~ .bp4-control-indicator::before {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23111418'/%3e%3c/svg%3e\");\n  }\n  .bp4-control.bp4-checkbox input:indeterminate:not(:disabled) ~ .bp4-control-indicator::before {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z' fill='%23111418'/%3e%3c/svg%3e\");\n  }\n  .bp4-control.bp4-checkbox input:disabled ~ .bp4-control-indicator {\n    border-color: graytext;\n  }\n}\n.bp4-control.bp4-radio .bp4-control-indicator {\n  border-radius: 50%;\n}\n.bp4-control.bp4-radio input:checked ~ .bp4-control-indicator::before {\n  background-image: radial-gradient(#ffffff, #ffffff 28%, transparent 32%);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-radio input:checked ~ .bp4-control-indicator::before {\n    background: highlight;\n    height: 12px;\n    margin-left: 1px;\n    margin-top: 1px;\n    width: 12px;\n  }\n}\n.bp4-control.bp4-radio input:checked:disabled ~ .bp4-control-indicator::before {\n  opacity: 0.5;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-radio input:checked:disabled ~ .bp4-control-indicator::before {\n    background: graytext;\n  }\n}\n.bp4-control.bp4-radio input:focus ~ .bp4-control-indicator {\n  -moz-outline-radius: 16px;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-radio input:disabled ~ .bp4-control-indicator {\n    border-color: graytext;\n  }\n}\n.bp4-control.bp4-switch input ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.3);\n  color: #1c2127;\n}\n.bp4-control.bp4-switch:hover input ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.4);\n}\n.bp4-control.bp4-switch input:not(:disabled):active ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.5);\n}\n.bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.15);\n  color: rgba(95, 107, 124, 0.6);\n}\n.bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator::before {\n  background: rgba(255, 255, 255, 0.8);\n  box-shadow: none;\n}\n.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator {\n  background: #2d72d2;\n  color: #ffffff;\n}\n.bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator {\n  background: #215db0;\n}\n.bp4-control.bp4-switch input:checked:not(:disabled):active ~ .bp4-control-indicator {\n  background: #184a90;\n}\n.bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator {\n  background: rgba(45, 114, 210, 0.5);\n  color: rgba(255, 255, 255, 0.6);\n}\n.bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator::before {\n  background: rgba(255, 255, 255, 0.5);\n  box-shadow: none;\n}\n.bp4-control.bp4-switch:not(.bp4-align-right) {\n  padding-left: 38px;\n}\n.bp4-control.bp4-switch:not(.bp4-align-right) .bp4-control-indicator {\n  margin-left: -38px;\n}\n.bp4-control.bp4-switch.bp4-align-right {\n  padding-right: 38px;\n}\n.bp4-control.bp4-switch.bp4-align-right .bp4-control-indicator {\n  margin-right: -38px;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator {\n    background: highlight;\n    border: 1px solid buttonborder;\n  }\n  .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator {\n    background-color: graytext;\n  }\n  .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator {\n    border-color: graytext;\n  }\n  .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator::before {\n    border-color: graytext;\n  }\n  .bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator {\n    background: highlight;\n  }\n}\n.bp4-control.bp4-switch .bp4-control-indicator {\n  border: none;\n  border-radius: 1.75em;\n  /* stylelint-disable-next-line declaration-no-important */\n  box-shadow: none !important;\n  min-width: 1.75em;\n  transition: background-color 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  width: auto;\n}\n.bp4-control.bp4-switch .bp4-control-indicator::before {\n  background: #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.5);\n  height: calc(1em - 4px);\n  left: 0;\n  margin: 2px;\n  position: absolute;\n  transition: left 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  width: calc(1em - 4px);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-switch .bp4-control-indicator::before {\n    border: 1px solid buttonborder;\n    margin-top: 1px;\n  }\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-control.bp4-switch .bp4-control-indicator {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator::before {\n  left: calc(100% - 1em);\n}\n.bp4-control.bp4-switch.bp4-large:not(.bp4-align-right) {\n  padding-left: 45px;\n}\n.bp4-control.bp4-switch.bp4-large:not(.bp4-align-right) .bp4-control-indicator {\n  margin-left: -45px;\n}\n.bp4-control.bp4-switch.bp4-large.bp4-align-right {\n  padding-right: 45px;\n}\n.bp4-control.bp4-switch.bp4-large.bp4-align-right .bp4-control-indicator {\n  margin-right: -45px;\n}\n.bp4-dark .bp4-control.bp4-switch input ~ .bp4-control-indicator {\n  background: rgba(17, 20, 24, 0.5);\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-control.bp4-switch:hover input ~ .bp4-control-indicator {\n  background: rgba(17, 20, 24, 0.8);\n}\n.bp4-dark .bp4-control.bp4-switch input:not(:disabled):active ~ .bp4-control-indicator {\n  background: rgba(17, 20, 24, 0.9);\n}\n.bp4-dark .bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.15);\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-control.bp4-switch input:disabled ~ .bp4-control-indicator::before {\n  background: rgba(171, 179, 191, 0.5);\n  box-shadow: none;\n}\n.bp4-dark .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator {\n  background: #2d72d2;\n  color: #ffffff;\n}\n.bp4-dark .bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator {\n  background: #215db0;\n}\n.bp4-dark .bp4-control.bp4-switch input:checked:not(:disabled):active ~ .bp4-control-indicator {\n  background: #184a90;\n}\n.bp4-dark .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator {\n  background: rgba(45, 114, 210, 0.5);\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator::before {\n  background: rgba(255, 255, 255, 0.3);\n  box-shadow: none;\n}\n.bp4-dark .bp4-control.bp4-switch .bp4-control-indicator::before {\n  background: #abb3bf;\n}\n.bp4-dark .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator::before {\n  background: #ffffff;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-control.bp4-switch input:checked ~ .bp4-control-indicator {\n    background: highlight;\n    border: 1px solid buttonborder;\n  }\n  .bp4-dark .bp4-control.bp4-switch input:checked:disabled ~ .bp4-control-indicator {\n    background-color: graytext;\n  }\n  .bp4-dark .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator {\n    border-color: graytext;\n  }\n  .bp4-dark .bp4-control.bp4-switch input:not(:checked):disabled ~ .bp4-control-indicator::before {\n    border-color: graytext;\n  }\n  .bp4-dark .bp4-control.bp4-switch:hover input:checked ~ .bp4-control-indicator {\n    background: highlight;\n  }\n}\n.bp4-control.bp4-switch .bp4-switch-inner-text {\n  font-size: 0.7em;\n  text-align: center;\n}\n.bp4-control.bp4-switch .bp4-control-indicator-child:first-child {\n  line-height: 0;\n  margin-left: 0.5em;\n  margin-right: 1.2em;\n  visibility: hidden;\n}\n.bp4-control.bp4-switch .bp4-control-indicator-child:last-child {\n  line-height: 1em;\n  margin-left: 1.2em;\n  margin-right: 0.5em;\n  visibility: visible;\n}\n.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator .bp4-control-indicator-child:first-child {\n  line-height: 1em;\n  visibility: visible;\n}\n.bp4-control.bp4-switch input:checked ~ .bp4-control-indicator .bp4-control-indicator-child:last-child {\n  line-height: 0;\n  visibility: hidden;\n}\n.bp4-dark .bp4-control {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-control.bp4-disabled {\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-control .bp4-control-indicator {\n  background-color: transparent;\n  box-shadow: inset 0 0 0 1px #8f99a8;\n}\n.bp4-dark .bp4-control:hover .bp4-control-indicator {\n  background-color: rgba(143, 153, 168, 0.15);\n}\n.bp4-dark .bp4-control input:focus ~ .bp4-control-indicator {\n  outline: #8abbff solid 2px;\n}\n.bp4-dark .bp4-control input:not(:disabled):active ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.3);\n  box-shadow: inset 0 0 0 1px #8f99a8;\n}\n.bp4-dark .bp4-control input:disabled ~ .bp4-control-indicator {\n  background: rgba(143, 153, 168, 0.15);\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.bp4-dark .bp4-control.bp4-checkbox input:disabled:checked ~ .bp4-control-indicator, .bp4-dark .bp4-control.bp4-checkbox input:disabled:indeterminate ~ .bp4-control-indicator {\n  background: rgba(45, 114, 210, 0.5);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nFile input\n\nMarkup:\n<label class=\"bp4-file-input {{.modifier}}\">\n  <input type=\"file\" {{:modifier}}/>\n  <span class=\"bp4-file-upload-input\">Choose file...</span>\n</label>\n\n:disabled - Disabled\n.bp4-large - Larger size\n.bp4-small - Smaller size\n.bp4-fill - Take up full width of parent element\n.bp4-file-input-has-selection - User has made a selection\n\nStyleguide file-input\n*/\n.bp4-file-input {\n  cursor: pointer;\n  display: inline-block;\n  height: 30px;\n  position: relative;\n}\n.bp4-file-input input {\n  margin: 0;\n  min-width: 200px;\n  opacity: 0;\n}\n.bp4-file-input input:disabled + .bp4-file-upload-input, .bp4-file-input input.bp4-disabled + .bp4-file-upload-input {\n  background: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n  resize: none;\n}\n.bp4-file-input input:disabled + .bp4-file-upload-input::placeholder, .bp4-file-input input.bp4-disabled + .bp4-file-upload-input::placeholder {\n  color: rgba(95, 107, 124, 0.6);\n}\n.bp4-file-input input:disabled + .bp4-file-upload-input::after, .bp4-file-input input.bp4-disabled + .bp4-file-upload-input::after {\n  background-color: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n  outline: none;\n}\n.bp4-dark .bp4-file-input input:disabled + .bp4-file-upload-input, .bp4-dark .bp4-file-input input.bp4-disabled + .bp4-file-upload-input {\n  background: rgba(64, 72, 84, 0.5);\n  box-shadow: none;\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-file-input input:disabled + .bp4-file-upload-input::after, .bp4-dark .bp4-file-input input.bp4-disabled + .bp4-file-upload-input::after {\n  background-color: rgba(64, 72, 84, 0.5);\n  box-shadow: none;\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-file-input.bp4-file-input-has-selection .bp4-file-upload-input {\n  color: #1c2127;\n}\n.bp4-dark .bp4-file-input.bp4-file-input-has-selection .bp4-file-upload-input {\n  color: #f6f7f9;\n}\n.bp4-file-input.bp4-fill {\n  width: 100%;\n}\n.bp4-file-input.bp4-large, .bp4-large .bp4-file-input {\n  height: 40px;\n}\n.bp4-file-input.bp4-small, .bp4-small .bp4-file-input {\n  height: 24px;\n}\n.bp4-file-input .bp4-file-upload-input-custom-text::after {\n  content: attr(bp4-button-text);\n}\n\n.bp4-file-upload-input {\n  appearance: none;\n  background: #ffffff;\n  border: none;\n  border-radius: 2px;\n  box-shadow: 0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n  color: #1c2127;\n  font-size: 14px;\n  font-weight: 400;\n  height: 30px;\n  line-height: 30px;\n  outline: none;\n  padding: 0 10px;\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  color: rgba(95, 107, 124, 0.6);\n  left: 0;\n  padding-right: 80px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  user-select: none;\n}\n.bp4-file-upload-input::placeholder {\n  color: #5f6b7c;\n  opacity: 1;\n}\n.bp4-file-upload-input:focus, .bp4-file-upload-input.bp4-active {\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-file-upload-input[type=search], .bp4-file-upload-input.bp4-round {\n  border-radius: 30px;\n  box-sizing: border-box;\n  padding-left: 10px;\n}\n.bp4-file-upload-input[readonly] {\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.15);\n}\n.bp4-file-upload-input:disabled, .bp4-file-upload-input.bp4-disabled {\n  background: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n  resize: none;\n}\n.bp4-file-upload-input:disabled::placeholder, .bp4-file-upload-input.bp4-disabled::placeholder {\n  color: rgba(95, 107, 124, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-file-upload-input {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-file-upload-input::after {\n  background-color: #f6f7f9;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #1c2127;\n  min-height: 24px;\n  min-width: 24px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  border-radius: 2px;\n  content: \"Browse\";\n  line-height: 24px;\n  margin: 3px;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 0;\n  width: 70px;\n}\n.bp4-file-upload-input:hover::after {\n  background-clip: padding-box;\n  background-color: #edeff2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-file-upload-input:active::after {\n  background-color: #dce0e5;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-file-upload-input:active::after {\n    background: highlight;\n  }\n}\n.bp4-large .bp4-file-upload-input {\n  font-size: 16px;\n  height: 40px;\n  line-height: 40px;\n  padding-right: 95px;\n}\n.bp4-large .bp4-file-upload-input[type=search], .bp4-large .bp4-file-upload-input.bp4-round {\n  padding: 0 15px;\n}\n.bp4-large .bp4-file-upload-input::after {\n  min-height: 30px;\n  min-width: 30px;\n  line-height: 30px;\n  margin: 5px;\n  width: 85px;\n}\n.bp4-small .bp4-file-upload-input {\n  font-size: 12px;\n  height: 24px;\n  line-height: 24px;\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-right: 65px;\n}\n.bp4-small .bp4-file-upload-input[type=search], .bp4-small .bp4-file-upload-input.bp4-round {\n  padding: 0 12px;\n}\n.bp4-small .bp4-file-upload-input::after {\n  min-height: 20px;\n  min-width: 20px;\n  line-height: 20px;\n  margin: 2px;\n  width: 55px;\n}\n.bp4-dark .bp4-file-upload-input {\n  background: rgba(17, 20, 24, 0.3);\n  box-shadow: 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n  color: #f6f7f9;\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-file-upload-input::placeholder {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-file-upload-input:focus {\n  box-shadow: inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3);\n}\n.bp4-dark .bp4-file-upload-input[readonly] {\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-file-upload-input:disabled, .bp4-dark .bp4-file-upload-input.bp4-disabled {\n  background: rgba(64, 72, 84, 0.5);\n  box-shadow: none;\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-file-upload-input::after {\n  background-color: #383e47;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-file-upload-input:hover::after {\n  background-color: #2f343c;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-file-upload-input:active::after {\n  background-color: #1c2127;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n\n/* stylelint-disable-next-line no-duplicate-selectors */\n.bp4-file-upload-input::after {\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\nForm groups\n\nMarkup:\n<div class=\"bp4-form-group {{.modifier}}\">\n  <label class=\"bp4-label\" for=\"form-group-input\">\n    Label\n    <span class=\"bp4-text-muted\">(required)</span>\n  </label>\n  <div class=\"bp4-form-content\">\n    <div class=\"bp4-input-group {{.modifier}}\">\n      <span class=\"bp4-icon bp4-icon-calendar\"></span>\n      <input id=\"form-group-input\" type=\"text\" {{:modifier}} class=\"bp4-input\"\n             style=\"width: 200px;\" placeholder=\"Placeholder text\" dir=\"auto\" />\n    </div>\n    <div class=\"bp4-form-helper-text\">Please enter a value</div>\n  </div>\n</div>\n\n:disabled - Disable the input.\n.bp4-disabled - Disabled styles. Input must be disabled separately via attribute.\n.bp4-inline - Label and content appear side by side.\n.bp4-intent-primary - Apply intent to form group and input separately.\n\nStyleguide form-group\n*/\n.bp4-form-group {\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 15px;\n  /* stylelint-disable-next-line order/declaration-block-order */\n}\n.bp4-form-group label.bp4-label {\n  margin-bottom: 5px;\n}\n.bp4-form-group .bp4-control {\n  margin-top: 7px;\n}\n.bp4-form-group .bp4-form-group-sub-label,\n.bp4-form-group .bp4-form-helper-text {\n  color: #5f6b7c;\n  font-size: 12px;\n}\n.bp4-form-group .bp4-form-group-sub-label {\n  margin-bottom: 5px;\n}\n.bp4-form-group .bp4-form-helper-text {\n  margin-top: 5px;\n}\n.bp4-form-group.bp4-intent-primary .bp4-form-group-sub-label,\n.bp4-form-group.bp4-intent-primary .bp4-form-helper-text {\n  color: #215db0;\n}\n.bp4-form-group.bp4-intent-success .bp4-form-group-sub-label,\n.bp4-form-group.bp4-intent-success .bp4-form-helper-text {\n  color: #1c6e42;\n}\n.bp4-form-group.bp4-intent-warning .bp4-form-group-sub-label,\n.bp4-form-group.bp4-intent-warning .bp4-form-helper-text {\n  color: #935610;\n}\n.bp4-form-group.bp4-intent-danger .bp4-form-group-sub-label,\n.bp4-form-group.bp4-intent-danger .bp4-form-helper-text {\n  color: #ac2f33;\n}\n.bp4-form-group.bp4-inline {\n  align-items: flex-start;\n  flex-direction: row;\n}\n.bp4-form-group.bp4-inline.bp4-large label.bp4-label {\n  line-height: 40px;\n  margin: 0 10px 0 0;\n}\n.bp4-form-group.bp4-inline label.bp4-label {\n  line-height: 30px;\n  margin: 0 10px 0 0;\n}\n.bp4-form-group.bp4-disabled .bp4-label,\n.bp4-form-group.bp4-disabled .bp4-text-muted,\n.bp4-form-group.bp4-disabled .bp4-form-group-sub-label,\n.bp4-form-group.bp4-disabled .bp4-form-helper-text {\n  /* stylelint-disable-next-line declaration-no-important */\n  color: rgba(95, 107, 124, 0.6) !important;\n}\n.bp4-dark .bp4-form-group.bp4-intent-primary .bp4-form-group-sub-label,\n.bp4-dark .bp4-form-group.bp4-intent-primary .bp4-form-helper-text {\n  color: #8abbff;\n}\n.bp4-dark .bp4-form-group.bp4-intent-success .bp4-form-group-sub-label,\n.bp4-dark .bp4-form-group.bp4-intent-success .bp4-form-helper-text {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-form-group.bp4-intent-warning .bp4-form-group-sub-label,\n.bp4-dark .bp4-form-group.bp4-intent-warning .bp4-form-helper-text {\n  color: #fbb360;\n}\n.bp4-dark .bp4-form-group.bp4-intent-danger .bp4-form-group-sub-label,\n.bp4-dark .bp4-form-group.bp4-intent-danger .bp4-form-helper-text {\n  color: #fa999c;\n}\n.bp4-dark .bp4-form-group .bp4-form-helper-text {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-form-group.bp4-disabled .bp4-label,\n.bp4-dark .bp4-form-group.bp4-disabled .bp4-text-muted,\n.bp4-dark .bp4-form-group.bp4-disabled .bp4-form-group-sub-label,\n.bp4-dark .bp4-form-group.bp4-disabled .bp4-form-helper-text {\n  /* stylelint-disable-next-line declaration-no-important */\n  color: rgba(171, 179, 191, 0.6) !important;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\nInput groups\n\nMarkup:\n<div class=\"bp4-input-group {{.modifier}}\">\n  <span class=\"bp4-icon bp4-icon-filter\"></span>\n  <input type=\"text\" class=\"bp4-input\" {{:modifier}} placeholder=\"Filter histogram...\" />\n</div>\n<div class=\"bp4-input-group {{.modifier}}\">\n  <input type=\"password\" class=\"bp4-input\" {{:modifier}} placeholder=\"Enter your password...\" />\n  <button class=\"bp4-button bp4-minimal bp4-intent-warning bp4-icon-lock\" {{:modifier}}></button>\n</div>\n<div class=\"bp4-input-group {{.modifier}}\">\n  <span class=\"bp4-icon bp4-icon-search\"></span>\n  <input type=\"text\" class=\"bp4-input\" {{:modifier}} placeholder=\"Search\" />\n  <button class=\"bp4-button bp4-minimal bp4-intent-primary bp4-icon-arrow-right\" {{:modifier}}></button>\n</div>\n\n:disabled - Disabled input. Must be added separately to the <code>&#60;input&#62;</code> and <code>&#60;button&#62;</code>. Also add <code>.bp4-disabled</code> to <code>.bp4-input-group</code> for icon coloring (not shown below).\n.bp4-round - Rounded caps. Button will also be rounded.\n.bp4-large - Large group. Children will adjust size accordingly.\n.bp4-small - Small group. Children will adjust size accordingly.\n.bp4-intent-primary - Primary intent. (All 4 intents are supported.)\n.bp4-fill - Take up full width of parent element.\n\nStyleguide input-group\n*/\n.bp4-input-group {\n  display: block;\n  position: relative;\n}\n.bp4-input-group .bp4-input {\n  position: relative;\n  width: 100%;\n}\n.bp4-input-group .bp4-input:not(:first-child) {\n  padding-left: 30px;\n}\n.bp4-input-group .bp4-input:not(:last-child) {\n  padding-right: 30px;\n}\n.bp4-input-group .bp4-input-action,\n.bp4-input-group > .bp4-input-left-container,\n.bp4-input-group > .bp4-button,\n.bp4-input-group > .bp4-icon {\n  position: absolute;\n  top: 0;\n}\n.bp4-input-group .bp4-input-action:first-child,\n.bp4-input-group > .bp4-input-left-container:first-child,\n.bp4-input-group > .bp4-button:first-child,\n.bp4-input-group > .bp4-icon:first-child {\n  left: 0;\n}\n.bp4-input-group .bp4-input-action:last-child,\n.bp4-input-group > .bp4-input-left-container:last-child,\n.bp4-input-group > .bp4-button:last-child,\n.bp4-input-group > .bp4-icon:last-child {\n  right: 0;\n}\n.bp4-input-group .bp4-button {\n  min-height: 24px;\n  min-width: 24px;\n  margin: 3px;\n  padding: 0 7px;\n}\n.bp4-input-group .bp4-button:empty {\n  padding: 0;\n}\n.bp4-input-group > .bp4-input-left-container,\n.bp4-input-group > .bp4-icon {\n  z-index: 1;\n}\n.bp4-input-group > .bp4-input-left-container > .bp4-icon,\n.bp4-input-group > .bp4-icon {\n  color: #5f6b7c;\n}\n.bp4-input-group > .bp4-input-left-container > .bp4-icon:empty,\n.bp4-input-group > .bp4-icon:empty {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n.bp4-input-group > .bp4-input-left-container > .bp4-icon,\n.bp4-input-group > .bp4-icon,\n.bp4-input-group .bp4-input-action > .bp4-spinner {\n  margin: 7px;\n}\n.bp4-input-group .bp4-tag {\n  margin: 5px;\n}\n.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus),\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) {\n  color: #5f6b7c;\n  /* stylelint-disable-next-line selector-max-compound-selectors */\n}\n.bp4-dark .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus),\n.bp4-dark .bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) {\n  color: #abb3bf;\n}\n.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-standard, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-large,\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon,\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-standard,\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:not(:hover):not(:focus) .bp4-icon-large {\n  color: #5f6b7c;\n}\n.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled,\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled {\n  /* stylelint-disable declaration-no-important */\n  color: rgba(95, 107, 124, 0.6) !important;\n}\n.bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled .bp4-icon, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled .bp4-icon-standard, .bp4-input-group .bp4-input:not(:focus) + .bp4-button.bp4-minimal:disabled .bp4-icon-large,\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled .bp4-icon,\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled .bp4-icon-standard,\n.bp4-input-group .bp4-input:not(:focus) + .bp4-input-action .bp4-button.bp4-minimal:disabled .bp4-icon-large {\n  color: rgba(95, 107, 124, 0.6) !important;\n}\n.bp4-input-group.bp4-disabled {\n  cursor: not-allowed;\n}\n.bp4-input-group.bp4-disabled .bp4-icon {\n  color: rgba(95, 107, 124, 0.6);\n}\n.bp4-input-group.bp4-large .bp4-button {\n  min-height: 30px;\n  min-width: 30px;\n  margin: 5px;\n}\n.bp4-input-group.bp4-large > .bp4-input-left-container > .bp4-icon,\n.bp4-input-group.bp4-large > .bp4-icon,\n.bp4-input-group.bp4-large .bp4-input-action > .bp4-spinner {\n  margin: 12px;\n}\n.bp4-input-group.bp4-large .bp4-input {\n  font-size: 16px;\n  height: 40px;\n  line-height: 40px;\n}\n.bp4-input-group.bp4-large .bp4-input[type=search], .bp4-input-group.bp4-large .bp4-input.bp4-round {\n  padding: 0 15px;\n}\n.bp4-input-group.bp4-large .bp4-input:not(:first-child) {\n  padding-left: 40px;\n}\n.bp4-input-group.bp4-large .bp4-input:not(:last-child) {\n  padding-right: 40px;\n}\n.bp4-input-group.bp4-small .bp4-button {\n  min-height: 20px;\n  min-width: 20px;\n  margin: 2px;\n}\n.bp4-input-group.bp4-small .bp4-tag {\n  min-height: 20px;\n  min-width: 20px;\n  margin: 2px;\n}\n.bp4-input-group.bp4-small > .bp4-input-left-container > .bp4-icon,\n.bp4-input-group.bp4-small > .bp4-icon,\n.bp4-input-group.bp4-small .bp4-input-action > .bp4-spinner {\n  margin: 4px;\n}\n.bp4-input-group.bp4-small .bp4-input {\n  font-size: 12px;\n  height: 24px;\n  line-height: 24px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.bp4-input-group.bp4-small .bp4-input[type=search], .bp4-input-group.bp4-small .bp4-input.bp4-round {\n  padding: 0 12px;\n}\n.bp4-input-group.bp4-small .bp4-input:not(:first-child) {\n  padding-left: 24px;\n}\n.bp4-input-group.bp4-small .bp4-input:not(:last-child) {\n  padding-right: 24px;\n}\n.bp4-input-group.bp4-fill {\n  flex: 1 1 auto;\n  width: 100%;\n}\n.bp4-input-group.bp4-round .bp4-button,\n.bp4-input-group.bp4-round .bp4-input,\n.bp4-input-group.bp4-round .bp4-tag {\n  border-radius: 30px;\n}\n.bp4-dark .bp4-input-group .bp4-icon {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-input-group.bp4-disabled .bp4-icon {\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-input-group.bp4-intent-primary .bp4-input {\n  box-shadow: 0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px #2d72d2, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input-group.bp4-intent-primary .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input-group.bp4-intent-primary .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #2d72d2;\n}\n.bp4-input-group.bp4-intent-primary .bp4-input:disabled, .bp4-input-group.bp4-intent-primary .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input {\n  box-shadow: 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px #4c90f0, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #4c90f0;\n}\n.bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-primary .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input-group.bp4-intent-primary > .bp4-icon {\n  color: #215db0;\n}\n.bp4-dark .bp4-input-group.bp4-intent-primary > .bp4-icon {\n  color: #8abbff;\n}\n.bp4-input-group.bp4-intent-success .bp4-input {\n  box-shadow: 0 0 0 0 rgba(35, 133, 81, 0), 0 0 0 0 rgba(35, 133, 81, 0), inset 0 0 0 1px #238551, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input-group.bp4-intent-success .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input-group.bp4-intent-success .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #238551;\n}\n.bp4-input-group.bp4-intent-success .bp4-input:disabled, .bp4-input-group.bp4-intent-success .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input {\n  box-shadow: 0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), inset 0 0 0 1px #32a467, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #32a467, inset 0 0 0 1px #32a467, 0 0 0 2px rgba(50, 164, 103, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #32a467;\n}\n.bp4-dark .bp4-input-group.bp4-intent-success .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-success .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input-group.bp4-intent-success > .bp4-icon {\n  color: #1c6e42;\n}\n.bp4-dark .bp4-input-group.bp4-intent-success > .bp4-icon {\n  color: #72ca9b;\n}\n.bp4-input-group.bp4-intent-warning .bp4-input {\n  box-shadow: 0 0 0 0 rgba(200, 118, 25, 0), 0 0 0 0 rgba(200, 118, 25, 0), inset 0 0 0 1px #c87619, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input-group.bp4-intent-warning .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input-group.bp4-intent-warning .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #c87619;\n}\n.bp4-input-group.bp4-intent-warning .bp4-input:disabled, .bp4-input-group.bp4-intent-warning .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input {\n  box-shadow: 0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px #ec9a3c, 0 0 0 2px rgba(236, 154, 60, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #ec9a3c;\n}\n.bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-warning .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input-group.bp4-intent-warning > .bp4-icon {\n  color: #935610;\n}\n.bp4-dark .bp4-input-group.bp4-intent-warning > .bp4-icon {\n  color: #fbb360;\n}\n.bp4-input-group.bp4-intent-danger .bp4-input {\n  box-shadow: 0 0 0 0 rgba(205, 66, 70, 0), 0 0 0 0 rgba(205, 66, 70, 0), inset 0 0 0 1px #cd4246, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input-group.bp4-intent-danger .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input-group.bp4-intent-danger .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #cd4246;\n}\n.bp4-input-group.bp4-intent-danger .bp4-input:disabled, .bp4-input-group.bp4-intent-danger .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input {\n  box-shadow: 0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), inset 0 0 0 1px #e76a6e, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #e76a6e, inset 0 0 0 1px #e76a6e, 0 0 0 2px rgba(231, 106, 110, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px #e76a6e;\n}\n.bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input:disabled, .bp4-dark .bp4-input-group.bp4-intent-danger .bp4-input.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input-group.bp4-intent-danger > .bp4-icon {\n  color: #ac2f33;\n}\n.bp4-dark .bp4-input-group.bp4-intent-danger > .bp4-icon {\n  color: #fa999c;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nText inputs\n\nMarkup:\n<input class=\"bp4-input {{.modifier}}\" {{:modifier}} type=\"text\" placeholder=\"Text input\" dir=\"auto\" />\n\n:disabled - Disabled\n:readonly - Readonly\n.bp4-round - Rounded ends\n.bp4-large - Larger size\n.bp4-small - Small size\n.bp4-intent-primary - Primary intent\n.bp4-intent-success - Success intent\n.bp4-intent-warning - Warning intent\n.bp4-intent-danger - Danger intent\n.bp4-fill - Take up full width of parent element\n\nStyleguide input\n*/\n.bp4-input {\n  appearance: none;\n  background: #ffffff;\n  border: none;\n  border-radius: 2px;\n  box-shadow: 0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n  color: #1c2127;\n  font-size: 14px;\n  font-weight: 400;\n  height: 30px;\n  line-height: 30px;\n  outline: none;\n  padding: 0 10px;\n  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  vertical-align: middle;\n}\n.bp4-input::placeholder {\n  color: #5f6b7c;\n  opacity: 1;\n}\n.bp4-input:focus, .bp4-input.bp4-active {\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input[type=search], .bp4-input.bp4-round {\n  border-radius: 30px;\n  box-sizing: border-box;\n  padding-left: 10px;\n}\n.bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.15);\n}\n.bp4-input:disabled, .bp4-input.bp4-disabled {\n  background: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n  resize: none;\n}\n.bp4-input:disabled::placeholder, .bp4-input.bp4-disabled::placeholder {\n  color: rgba(95, 107, 124, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-input {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-input.bp4-large {\n  font-size: 16px;\n  height: 40px;\n  line-height: 40px;\n}\n.bp4-input.bp4-large[type=search], .bp4-input.bp4-large.bp4-round {\n  padding: 0 15px;\n}\n.bp4-input.bp4-small {\n  font-size: 12px;\n  height: 24px;\n  line-height: 24px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.bp4-input.bp4-small[type=search], .bp4-input.bp4-small.bp4-round {\n  padding: 0 12px;\n}\n.bp4-input.bp4-fill {\n  flex: 1 1 auto;\n  width: 100%;\n}\n.bp4-dark .bp4-input {\n  background: rgba(17, 20, 24, 0.3);\n  box-shadow: 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-input::placeholder {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-input:focus {\n  box-shadow: inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3);\n}\n.bp4-dark .bp4-input[readonly] {\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-input:disabled, .bp4-dark .bp4-input.bp4-disabled {\n  background: rgba(64, 72, 84, 0.5);\n  box-shadow: none;\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-input.bp4-intent-primary {\n  box-shadow: 0 0 0 0 rgba(45, 114, 210, 0), 0 0 0 0 rgba(45, 114, 210, 0), inset 0 0 0 1px #2d72d2, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input.bp4-intent-primary:focus {\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input.bp4-intent-primary[readonly] {\n  box-shadow: inset 0 0 0 1px #2d72d2;\n}\n.bp4-input.bp4-intent-primary:disabled, .bp4-input.bp4-intent-primary.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input.bp4-intent-primary {\n  box-shadow: 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), 0 0 0 0 rgba(76, 144, 240, 0), inset 0 0 0 1px #4c90f0, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-primary:focus {\n  box-shadow: inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-primary[readonly] {\n  box-shadow: inset 0 0 0 1px #4c90f0;\n}\n.bp4-dark .bp4-input.bp4-intent-primary:disabled, .bp4-dark .bp4-input.bp4-intent-primary.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input.bp4-intent-success {\n  box-shadow: 0 0 0 0 rgba(35, 133, 81, 0), 0 0 0 0 rgba(35, 133, 81, 0), inset 0 0 0 1px #238551, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input.bp4-intent-success:focus {\n  box-shadow: inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input.bp4-intent-success[readonly] {\n  box-shadow: inset 0 0 0 1px #238551;\n}\n.bp4-input.bp4-intent-success:disabled, .bp4-input.bp4-intent-success.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input.bp4-intent-success {\n  box-shadow: 0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), 0 0 0 0 rgba(50, 164, 103, 0), inset 0 0 0 1px #32a467, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-success:focus {\n  box-shadow: inset 0 0 0 1px #32a467, inset 0 0 0 1px #32a467, 0 0 0 2px rgba(50, 164, 103, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-success[readonly] {\n  box-shadow: inset 0 0 0 1px #32a467;\n}\n.bp4-dark .bp4-input.bp4-intent-success:disabled, .bp4-dark .bp4-input.bp4-intent-success.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input.bp4-intent-warning {\n  box-shadow: 0 0 0 0 rgba(200, 118, 25, 0), 0 0 0 0 rgba(200, 118, 25, 0), inset 0 0 0 1px #c87619, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input.bp4-intent-warning:focus {\n  box-shadow: inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input.bp4-intent-warning[readonly] {\n  box-shadow: inset 0 0 0 1px #c87619;\n}\n.bp4-input.bp4-intent-warning:disabled, .bp4-input.bp4-intent-warning.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input.bp4-intent-warning {\n  box-shadow: 0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), 0 0 0 0 rgba(236, 154, 60, 0), inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-warning:focus {\n  box-shadow: inset 0 0 0 1px #ec9a3c, inset 0 0 0 1px #ec9a3c, 0 0 0 2px rgba(236, 154, 60, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-warning[readonly] {\n  box-shadow: inset 0 0 0 1px #ec9a3c;\n}\n.bp4-dark .bp4-input.bp4-intent-warning:disabled, .bp4-dark .bp4-input.bp4-intent-warning.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input.bp4-intent-danger {\n  box-shadow: 0 0 0 0 rgba(205, 66, 70, 0), 0 0 0 0 rgba(205, 66, 70, 0), inset 0 0 0 1px #cd4246, inset 0 0 0 1px rgba(17, 20, 24, 0.2), inset 0 1px 1px rgba(17, 20, 24, 0.5);\n}\n.bp4-input.bp4-intent-danger:focus {\n  box-shadow: inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-input.bp4-intent-danger[readonly] {\n  box-shadow: inset 0 0 0 1px #cd4246;\n}\n.bp4-input.bp4-intent-danger:disabled, .bp4-input.bp4-intent-danger.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-dark .bp4-input.bp4-intent-danger {\n  box-shadow: 0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), 0 0 0 0 rgba(231, 106, 110, 0), inset 0 0 0 1px #e76a6e, inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-danger:focus {\n  box-shadow: inset 0 0 0 1px #e76a6e, inset 0 0 0 1px #e76a6e, 0 0 0 2px rgba(231, 106, 110, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-input.bp4-intent-danger[readonly] {\n  box-shadow: inset 0 0 0 1px #e76a6e;\n}\n.bp4-dark .bp4-input.bp4-intent-danger:disabled, .bp4-dark .bp4-input.bp4-intent-danger.bp4-disabled {\n  box-shadow: none;\n}\n.bp4-input::-ms-clear {\n  display: none;\n}\n\n@supports (-webkit-touch-callout: none) {\n  input.bp4-input:disabled, input.bp4-input.bp4-disabled {\n    opacity: 1;\n    -webkit-text-fill-color: rgba(95, 107, 124, 0.6);\n  }\n  .bp4-dark input.bp4-input:disabled, .bp4-dark input.bp4-input.bp4-disabled {\n    -webkit-text-fill-color: rgba(171, 179, 191, 0.6);\n  }\n}\n/*\nSearch inputs\n\nMarkup:\n<div class=\"bp4-input-group {{.modifier}}\">\n  <span class=\"bp4-icon bp4-icon-search\"></span>\n  <input class=\"bp4-input\" {{:modifier}} type=\"search\" placeholder=\"Search input\" dir=\"auto\" />\n</div>\n\n:disabled - Disabled. Also add <code>.bp4-disabled</code> to <code>.bp4-input-group</code> for icon coloring (not shown below).\n.bp4-large - Large\n.bp4-small - Small\n\nStyleguide input-search\n*/\n/*\nTextareas\n\nMarkup:\n<textarea class=\"bp4-input {{.modifier}}\" {{:modifier}} dir=\"auto\"></textarea>\n\n:disabled - Disabled\n:readonly - Readonly\n.bp4-large - Larger font size\n.bp4-small - Small font size\n.bp4-intent-primary - Primary intent\n.bp4-intent-danger  - Danger intent\n.bp4-fill  - Take up full width of parent element\n\nStyleguide textarea\n*/\n/* stylelint-disable-next-line selector-no-qualifying-type */\ntextarea.bp4-input {\n  max-width: 100%;\n  padding: 10px;\n}\ntextarea.bp4-input, textarea.bp4-input.bp4-large, textarea.bp4-input.bp4-small {\n  height: auto;\n  line-height: inherit;\n}\ntextarea.bp4-input.bp4-small {\n  padding: 8px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nLabels\n\nMarkup:\n<div>\n  <label class=\"bp4-label {{.modifier}}\">\n    Label A\n    <span class=\"bp4-text-muted\">(optional)</span>\n    <input {{:modifier}} class=\"bp4-input\" style=\"width: 200px;\" type=\"text\" placeholder=\"Text input\" dir=\"auto\" />\n  </label>\n  <label class=\"bp4-label {{.modifier}}\">\n    Label B\n    <div class=\"bp4-input-group {{.modifier}}\">\n      <span class=\"bp4-icon bp4-icon-calendar\"></span>\n      <input {{:modifier}} class=\"bp4-input\" style=\"width: 200px;\" type=\"text\" placeholder=\"Input group\" dir=\"auto\" />\n    </div>\n  </label>\n  <label class=\"bp4-label {{.modifier}}\">\n    Label C\n    <div class=\"bp4-select {{.modifier}}\">\n      <select {{:modifier}}>\n        <option selected>Choose an item...</option>\n        <option value=\"1\">One</option>\n      </select>\n    </div>\n  </label>\n</div>\n\n:disabled - Disable the input.\n.bp4-disabled - Disabled styles. Input must be disabled separately via attribute.\n.bp4-inline - Label and content appear side by side.\n\nStyleguide label\n*/\nlabel.bp4-label {\n  display: block;\n  margin-bottom: 15px;\n  margin-top: 0;\n}\nlabel.bp4-label .bp4-html-select,\nlabel.bp4-label .bp4-input,\nlabel.bp4-label .bp4-select,\nlabel.bp4-label .bp4-slider,\nlabel.bp4-label .bp4-popover-wrapper {\n  display: block;\n  margin-top: 5px;\n  text-transform: none;\n}\nlabel.bp4-label .bp4-button-group {\n  margin-top: 5px;\n}\nlabel.bp4-label .bp4-select select,\nlabel.bp4-label .bp4-html-select select {\n  font-weight: 400;\n  vertical-align: top;\n  width: 100%;\n}\nlabel.bp4-label .bp4-control-group {\n  margin-top: 5px;\n}\nlabel.bp4-label .bp4-control-group > .bp4-button-group,\nlabel.bp4-label .bp4-control-group > .bp4-html-select,\nlabel.bp4-label .bp4-control-group > .bp4-input,\nlabel.bp4-label .bp4-control-group > .bp4-select,\nlabel.bp4-label .bp4-control-group > .bp4-slider,\nlabel.bp4-label .bp4-control-group > .bp4-popover-wrapper {\n  margin-top: 0;\n}\nlabel.bp4-label.bp4-disabled,\nlabel.bp4-label.bp4-disabled .bp4-text-muted {\n  color: rgba(95, 107, 124, 0.6);\n}\nlabel.bp4-label.bp4-inline {\n  line-height: 30px;\n}\nlabel.bp4-label.bp4-inline .bp4-html-select,\nlabel.bp4-label.bp4-inline .bp4-input,\nlabel.bp4-label.bp4-inline .bp4-input-group,\nlabel.bp4-label.bp4-inline .bp4-select,\nlabel.bp4-label.bp4-inline .bp4-popover-wrapper {\n  display: inline-block;\n  margin: 0 0 0 5px;\n  vertical-align: top;\n}\nlabel.bp4-label.bp4-inline .bp4-button-group {\n  margin: 0 0 0 5px;\n}\nlabel.bp4-label.bp4-inline .bp4-input-group .bp4-input {\n  margin-left: 0;\n}\nlabel.bp4-label.bp4-inline.bp4-large {\n  line-height: 40px;\n}\nlabel.bp4-label.bp4-inline .bp4-control-group {\n  margin: 0 0 0 5px;\n}\nlabel.bp4-label.bp4-inline .bp4-control-group > .bp4-button-group,\nlabel.bp4-label.bp4-inline .bp4-control-group > .bp4-html-select,\nlabel.bp4-label.bp4-inline .bp4-control-group > .bp4-input,\nlabel.bp4-label.bp4-inline .bp4-control-group > .bp4-select,\nlabel.bp4-label.bp4-inline .bp4-control-group > .bp4-slider,\nlabel.bp4-label.bp4-inline .bp4-control-group > .bp4-popover-wrapper {\n  margin: 0;\n}\nlabel.bp4-label:not(.bp4-inline) .bp4-popover-target {\n  display: block;\n}\n.bp4-dark label.bp4-label {\n  color: #f6f7f9;\n}\n.bp4-dark label.bp4-label.bp4-disabled,\n.bp4-dark label.bp4-label.bp4-disabled .bp4-text-muted {\n  color: rgba(171, 179, 191, 0.6);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n.bp4-numeric-input .bp4-button-group.bp4-vertical > .bp4-button {\n  flex: 1 1 11px;\n  min-height: 0;\n  padding: 0;\n  width: 24px;\n}\n.bp4-numeric-input.bp4-large .bp4-button-group.bp4-vertical > .bp4-button {\n  width: 40px;\n}\n.bp4-numeric-input.bp4-small .bp4-button-group.bp4-vertical > .bp4-button {\n  width: 24px;\n}\n\nform {\n  display: block;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n.bp4-html-select select,\n.bp4-select select {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  border: none;\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 14px;\n  justify-content: center;\n  padding: 5px 10px;\n  text-align: left;\n  vertical-align: middle;\n  background-color: #f6f7f9;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #1c2127;\n  /* stylelint-disable property-no-vendor-prefix */\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  border-radius: 2px;\n  height: 30px;\n  padding: 0 25px 0 10px;\n  width: 100%;\n  /* stylelint-enable property-no-vendor-prefix */\n}\n.bp4-html-select select > *,\n.bp4-select select > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-html-select select > .bp4-fill,\n.bp4-select select > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-html-select select::before,\n.bp4-select select::before,\n.bp4-html-select select > *,\n.bp4-select select > * {\n  margin-right: 7px;\n}\n.bp4-html-select select:empty::before,\n.bp4-select select:empty::before,\n.bp4-html-select select > :last-child,\n.bp4-select select > :last-child {\n  margin-right: 0;\n}\n.bp4-html-select select:hover,\n.bp4-select select:hover {\n  background-clip: padding-box;\n  background-color: #edeff2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-html-select select:active,\n.bp4-select select:active, .bp4-html-select select.bp4-active,\n.bp4-select select.bp4-active {\n  background-color: #dce0e5;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-html-select select:active,\n  .bp4-select select:active, .bp4-html-select select.bp4-active,\n  .bp4-select select.bp4-active {\n    background: highlight;\n  }\n}\n.bp4-html-select select:disabled,\n.bp4-select select:disabled, .bp4-html-select select.bp4-disabled,\n.bp4-select select.bp4-disabled {\n  background-color: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n  outline: none;\n}\n.bp4-html-select select:disabled.bp4-active,\n.bp4-select select:disabled.bp4-active, .bp4-html-select select.bp4-disabled.bp4-active,\n.bp4-select select.bp4-disabled.bp4-active {\n  background: rgba(211, 216, 222, 0.7);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-html-select select,\n  .bp4-select select {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-html-select.bp4-minimal select,\n.bp4-select.bp4-minimal select {\n  background: none;\n  box-shadow: none;\n}\n.bp4-html-select.bp4-minimal select:hover,\n.bp4-select.bp4-minimal select:hover {\n  background: rgba(143, 153, 168, 0.15);\n  box-shadow: none;\n  color: #1c2127;\n  text-decoration: none;\n}\n.bp4-html-select.bp4-minimal select:active,\n.bp4-select.bp4-minimal select:active, .bp4-html-select.bp4-minimal select.bp4-active,\n.bp4-select.bp4-minimal select.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n  box-shadow: none;\n  color: #1c2127;\n}\n.bp4-html-select.bp4-minimal select:disabled,\n.bp4-select.bp4-minimal select:disabled, .bp4-html-select.bp4-minimal select.bp4-disabled,\n.bp4-select.bp4-minimal select.bp4-disabled {\n  background: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n.bp4-html-select.bp4-minimal select:disabled.bp4-active,\n.bp4-select.bp4-minimal select:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-disabled.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-html-select.bp4-minimal select, .bp4-html-select.bp4-minimal .bp4-dark select,\n.bp4-dark .bp4-select.bp4-minimal select,\n.bp4-select.bp4-minimal .bp4-dark select {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select:hover, .bp4-html-select.bp4-minimal .bp4-dark select:hover,\n.bp4-dark .bp4-select.bp4-minimal select:hover,\n.bp4-select.bp4-minimal .bp4-dark select:hover, .bp4-dark .bp4-html-select.bp4-minimal select:active, .bp4-html-select.bp4-minimal .bp4-dark select:active,\n.bp4-dark .bp4-select.bp4-minimal select:active,\n.bp4-select.bp4-minimal .bp4-dark select:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ffffff;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select:hover, .bp4-html-select.bp4-minimal .bp4-dark select:hover,\n.bp4-dark .bp4-select.bp4-minimal select:hover,\n.bp4-select.bp4-minimal .bp4-dark select:hover {\n  background: rgba(143, 153, 168, 0.15);\n}\n.bp4-dark .bp4-html-select.bp4-minimal select:active, .bp4-html-select.bp4-minimal .bp4-dark select:active,\n.bp4-dark .bp4-select.bp4-minimal select:active,\n.bp4-select.bp4-minimal .bp4-dark select:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-dark .bp4-html-select.bp4-minimal select:disabled, .bp4-html-select.bp4-minimal .bp4-dark select:disabled,\n.bp4-dark .bp4-select.bp4-minimal select:disabled,\n.bp4-select.bp4-minimal .bp4-dark select:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-disabled {\n  background: none;\n  color: rgba(171, 179, 191, 0.6);\n  cursor: not-allowed;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select:disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select:disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-disabled.bp4-active {\n  background: rgba(143, 153, 168, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-primary,\n.bp4-select.bp4-minimal select.bp4-intent-primary {\n  color: #215db0;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-primary:hover,\n.bp4-select.bp4-minimal select.bp4-intent-primary:hover, .bp4-html-select.bp4-minimal select.bp4-intent-primary:active,\n.bp4-select.bp4-minimal select.bp4-intent-primary:active, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #215db0;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-primary:hover,\n.bp4-select.bp4-minimal select.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.15);\n  color: #215db0;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-primary:active,\n.bp4-select.bp4-minimal select.bp4-intent-primary:active, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #184a90;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled,\n.bp4-select.bp4-minimal select.bp4-intent-primary:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled,\n.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(33, 93, 176, 0.5);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head,\n.bp4-select.bp4-minimal select.bp4-intent-primary .bp4-button-spinner .bp4-spinner-head {\n  stroke: #215db0;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:hover,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:hover,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:hover {\n  background: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n  color: #99c4ff;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled {\n  background: none;\n  color: rgba(138, 187, 255, 0.5);\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary:disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-primary.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-primary.bp4-disabled.bp4-active {\n  background: rgba(45, 114, 210, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-success,\n.bp4-select.bp4-minimal select.bp4-intent-success {\n  color: #1c6e42;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-success:hover,\n.bp4-select.bp4-minimal select.bp4-intent-success:hover, .bp4-html-select.bp4-minimal select.bp4-intent-success:active,\n.bp4-select.bp4-minimal select.bp4-intent-success:active, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-success.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #1c6e42;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-success:hover,\n.bp4-select.bp4-minimal select.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.15);\n  color: #1c6e42;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-success:active,\n.bp4-select.bp4-minimal select.bp4-intent-success:active, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #165a36;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-success:disabled,\n.bp4-select.bp4-minimal select.bp4-intent-success:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled,\n.bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(28, 110, 66, 0.5);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-success .bp4-button-spinner .bp4-spinner-head,\n.bp4-select.bp4-minimal select.bp4-intent-success .bp4-button-spinner .bp4-spinner-head {\n  stroke: #1c6e42;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:hover,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:hover,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:hover {\n  background: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled {\n  background: none;\n  color: rgba(114, 202, 155, 0.5);\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success:disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-success.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-success.bp4-disabled.bp4-active {\n  background: rgba(35, 133, 81, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-warning,\n.bp4-select.bp4-minimal select.bp4-intent-warning {\n  color: #935610;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-warning:hover,\n.bp4-select.bp4-minimal select.bp4-intent-warning:hover, .bp4-html-select.bp4-minimal select.bp4-intent-warning:active,\n.bp4-select.bp4-minimal select.bp4-intent-warning:active, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #935610;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-warning:hover,\n.bp4-select.bp4-minimal select.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.15);\n  color: #935610;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-warning:active,\n.bp4-select.bp4-minimal select.bp4-intent-warning:active, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #77450d;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled,\n.bp4-select.bp4-minimal select.bp4-intent-warning:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled,\n.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(147, 86, 16, 0.5);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head,\n.bp4-select.bp4-minimal select.bp4-intent-warning .bp4-button-spinner .bp4-spinner-head {\n  stroke: #935610;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:hover,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:hover,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:hover {\n  background: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n  color: #f5c186;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled {\n  background: none;\n  color: rgba(251, 179, 96, 0.5);\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning:disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-warning.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-warning.bp4-disabled.bp4-active {\n  background: rgba(200, 118, 25, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-danger,\n.bp4-select.bp4-minimal select.bp4-intent-danger {\n  color: #ac2f33;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-danger:hover,\n.bp4-select.bp4-minimal select.bp4-intent-danger:hover, .bp4-html-select.bp4-minimal select.bp4-intent-danger:active,\n.bp4-select.bp4-minimal select.bp4-intent-danger:active, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-active {\n  background: none;\n  box-shadow: none;\n  color: #ac2f33;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-danger:hover,\n.bp4-select.bp4-minimal select.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.15);\n  color: #ac2f33;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-danger:active,\n.bp4-select.bp4-minimal select.bp4-intent-danger:active, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #8e292c;\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled,\n.bp4-select.bp4-minimal select.bp4-intent-danger:disabled, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled,\n.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(172, 47, 51, 0.5);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active, .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n.bp4-html-select.bp4-minimal select.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head,\n.bp4-select.bp4-minimal select.bp4-intent-danger .bp4-button-spinner .bp4-spinner-head {\n  stroke: #ac2f33;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger {\n  color: #fa999c;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:hover, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:hover,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:hover,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:hover {\n  background: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n  color: #ffa1a4;\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled {\n  background: none;\n  color: rgba(250, 153, 156, 0.5);\n}\n.bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger:disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger:disabled.bp4-active, .bp4-dark .bp4-html-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active, .bp4-html-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled.bp4-active,\n.bp4-dark .bp4-select.bp4-minimal select.bp4-intent-danger.bp4-disabled.bp4-active,\n.bp4-select.bp4-minimal .bp4-dark select.bp4-intent-danger.bp4-disabled.bp4-active {\n  background: rgba(205, 66, 70, 0.3);\n}\n\n.bp4-html-select.bp4-large select,\n.bp4-select.bp4-large select {\n  font-size: 16px;\n  height: 40px;\n  padding-right: 35px;\n}\n\n.bp4-dark .bp4-html-select select,\n.bp4-dark .bp4-select select {\n  background-color: #383e47;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-html-select select:hover,\n.bp4-dark .bp4-select select:hover, .bp4-dark .bp4-html-select select:active,\n.bp4-dark .bp4-select select:active, .bp4-dark .bp4-html-select select.bp4-active,\n.bp4-dark .bp4-select select.bp4-active {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-html-select select:hover,\n.bp4-dark .bp4-select select:hover {\n  background-color: #2f343c;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-html-select select:active,\n.bp4-dark .bp4-select select:active, .bp4-dark .bp4-html-select select.bp4-active,\n.bp4-dark .bp4-select select.bp4-active {\n  background-color: #1c2127;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-html-select select:disabled,\n.bp4-dark .bp4-select select:disabled, .bp4-dark .bp4-html-select select.bp4-disabled,\n.bp4-dark .bp4-select select.bp4-disabled {\n  background-color: rgba(64, 72, 84, 0.5);\n  box-shadow: none;\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-html-select select:disabled.bp4-active,\n.bp4-dark .bp4-select select:disabled.bp4-active, .bp4-dark .bp4-html-select select.bp4-disabled.bp4-active,\n.bp4-dark .bp4-select select.bp4-disabled.bp4-active {\n  background: rgba(64, 72, 84, 0.7);\n}\n.bp4-dark .bp4-html-select select .bp4-button-spinner .bp4-spinner-head,\n.bp4-dark .bp4-select select .bp4-button-spinner .bp4-spinner-head {\n  background: rgba(17, 20, 24, 0.5);\n  stroke: #8f99a8;\n}\n\n.bp4-html-select select:disabled,\n.bp4-select select:disabled {\n  background-color: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n\n.bp4-select::after, .bp4-html-select .bp4-icon,\n.bp4-select .bp4-icon {\n  color: #5f6b7c;\n  pointer-events: none;\n  position: absolute;\n  right: 7px;\n  top: 7px;\n}\n.bp4-disabled.bp4-select::after, .bp4-html-select .bp4-disabled.bp4-icon,\n.bp4-select .bp4-disabled.bp4-icon {\n  color: rgba(95, 107, 124, 0.6);\n}\n\n/*\nHTML select\n\nMarkup:\n<div class=\"bp4-html-select {{.modifier}}\">\n  <select {{:modifier}}>\n    <option selected>Choose an item...</option>\n    <option value=\"1\">One</option>\n    <option value=\"2\">Two</option>\n    <option value=\"3\">Three</option>\n    <option value=\"4\">Four</option>\n  </select>\n  <span class=\"bp4-icon bp4-icon-double-caret-vertical\"></span>\n</div>\n\n:disabled - Disabled. Also add <code>.bp4-disabled</code> to <code>.bp4-select</code> for icon coloring (not shown below).\n.bp4-fill - Expand to fill parent container\n.bp4-large - Large size\n.bp4-minimal - Minimal appearance\n\nStyleguide select\n*/\n.bp4-html-select,\n.bp4-select {\n  display: inline-block;\n  letter-spacing: normal;\n  position: relative;\n  vertical-align: middle;\n}\n.bp4-html-select select::-ms-expand,\n.bp4-select select::-ms-expand {\n  display: none;\n}\n.bp4-html-select .bp4-icon,\n.bp4-select .bp4-icon {\n  color: #5f6b7c;\n}\n.bp4-html-select .bp4-icon:hover,\n.bp4-select .bp4-icon:hover {\n  color: #1c2127;\n}\n.bp4-dark .bp4-html-select .bp4-icon,\n.bp4-dark .bp4-select .bp4-icon {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-html-select .bp4-icon:hover,\n.bp4-dark .bp4-select .bp4-icon:hover {\n  color: #f6f7f9;\n}\n.bp4-html-select.bp4-large::after,\n.bp4-html-select.bp4-large .bp4-icon,\n.bp4-select.bp4-large::after,\n.bp4-select.bp4-large .bp4-icon {\n  right: 12px;\n  top: 12px;\n}\n.bp4-html-select.bp4-fill,\n.bp4-html-select.bp4-fill select,\n.bp4-select.bp4-fill,\n.bp4-select.bp4-fill select {\n  width: 100%;\n}\n.bp4-dark .bp4-html-select option,\n.bp4-dark .bp4-select option {\n  background-color: #2f343c;\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-html-select option:disabled,\n.bp4-dark .bp4-select option:disabled {\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-dark .bp4-html-select::after,\n.bp4-dark .bp4-select::after {\n  color: #abb3bf;\n}\n\n.bp4-select::after {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\f184\";\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nTables\n\nMarkup:\n<table class=\"bp4-html-table {{.modifier}}\">\n  <thead>\n    <tr>\n      <th>Project</th>\n      <th>Description</th>\n      <th>Technologies</th>\n      <th>Contributors</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td>Blueprint</td>\n      <td>CSS framework and UI toolkit</td>\n      <td>Sass, TypeScript, React</td>\n      <td>268</td>\n    </tr>\n    <tr>\n      <td>TSLint</td>\n      <td>Static analysis linter for TypeScript</td>\n      <td>TypeScript</td>\n      <td>403</td>\n    </tr>\n    <tr>\n      <td>Plottable</td>\n      <td>Composable charting library built on top of D3</td>\n      <td>SVG, TypeScript, D3</td>\n      <td>737</td>\n    </tr>\n  </tbody>\n  <tfoot>\n    <tr>\n      <td colspan=3>Total</td>\n      <td>1408</td>\n    </tr>\n  </tfoot>\n</table>\n\n.bp4-compact - Compact appearance\n.bp4-html-table-bordered - Bordered appearance\n.bp4-html-table-condensed - Condensed smaller appearance (DEPRECATED, use compact instead)\n.bp4-html-table-striped - Striped appearance\n.bp4-interactive - Enables hover styles on rows\n\nStyleguide html-table\n*/\ntable.bp4-html-table, .bp4-running-text table {\n  border-spacing: 0;\n  font-size: 14px;\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-enable selector-max-compound-selectors */\n}\ntable.bp4-html-table th, .bp4-running-text table th,\ntable.bp4-html-table td,\n.bp4-running-text table td {\n  padding: 11px;\n  text-align: left;\n  vertical-align: top;\n}\ntable.bp4-html-table th, .bp4-running-text table th {\n  color: #1c2127;\n  font-weight: 600;\n}\ntable.bp4-html-table td, .bp4-running-text table td {\n  color: #1c2127;\n}\ntable.bp4-html-table tbody tr:first-child th, .bp4-running-text table tbody tr:first-child th,\ntable.bp4-html-table tbody tr:first-child td,\n.bp4-running-text table tbody tr:first-child td,\ntable.bp4-html-table tfoot tr:first-child th,\n.bp4-running-text table tfoot tr:first-child th,\ntable.bp4-html-table tfoot tr:first-child td,\n.bp4-running-text table tfoot tr:first-child td {\n  box-shadow: inset 0 1px 0 0 rgba(17, 20, 24, 0.15);\n}\n.bp4-dark table.bp4-html-table th, .bp4-dark .bp4-running-text table th, .bp4-running-text .bp4-dark table th {\n  color: #f6f7f9;\n}\n.bp4-dark table.bp4-html-table td, .bp4-dark .bp4-running-text table td, .bp4-running-text .bp4-dark table td {\n  color: #f6f7f9;\n}\n.bp4-dark table.bp4-html-table tbody tr:first-child th, .bp4-dark .bp4-running-text table tbody tr:first-child th, .bp4-running-text .bp4-dark table tbody tr:first-child th,\n.bp4-dark table.bp4-html-table tbody tr:first-child td,\n.bp4-dark .bp4-running-text table tbody tr:first-child td,\n.bp4-running-text .bp4-dark table tbody tr:first-child td,\n.bp4-dark table.bp4-html-table tfoot tr:first-child th,\n.bp4-dark .bp4-running-text table tfoot tr:first-child th,\n.bp4-running-text .bp4-dark table tfoot tr:first-child th,\n.bp4-dark table.bp4-html-table tfoot tr:first-child td,\n.bp4-dark .bp4-running-text table tfoot tr:first-child td,\n.bp4-running-text .bp4-dark table tfoot tr:first-child td {\n  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.2);\n}\n\ntable.bp4-html-table.bp4-compact th,\ntable.bp4-html-table.bp4-compact td, table.bp4-html-table.bp4-html-table-condensed th,\ntable.bp4-html-table.bp4-html-table-condensed td {\n  padding-bottom: 6px;\n  padding-top: 6px;\n}\ntable.bp4-html-table.bp4-html-table-striped tbody tr:nth-child(odd) td {\n  background: rgba(143, 153, 168, 0.15);\n}\ntable.bp4-html-table.bp4-html-table-bordered th:not(:first-child) {\n  box-shadow: inset 1px 0 0 0 rgba(17, 20, 24, 0.15);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  table.bp4-html-table.bp4-html-table-bordered th:not(:first-child) {\n    border-left: 1px solid buttonborder;\n  }\n}\ntable.bp4-html-table.bp4-html-table-bordered tbody tr td,\ntable.bp4-html-table.bp4-html-table-bordered tfoot tr td {\n  box-shadow: inset 0 1px 0 0 rgba(17, 20, 24, 0.15);\n}\ntable.bp4-html-table.bp4-html-table-bordered tbody tr td:not(:first-child),\ntable.bp4-html-table.bp4-html-table-bordered tfoot tr td:not(:first-child) {\n  box-shadow: inset 1px 1px 0 0 rgba(17, 20, 24, 0.15);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  table.bp4-html-table.bp4-html-table-bordered tbody tr td:not(:first-child),\n  table.bp4-html-table.bp4-html-table-bordered tfoot tr td:not(:first-child) {\n    border-left: 1px solid buttonborder;\n    border-top: 1px solid buttonborder;\n  }\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  table.bp4-html-table.bp4-html-table-bordered tbody tr td,\n  table.bp4-html-table.bp4-html-table-bordered tfoot tr td {\n    border-top: 1px solid buttonborder;\n  }\n}\ntable.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td {\n  box-shadow: none;\n}\ntable.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td:not(:first-child) {\n  box-shadow: inset 1px 0 0 0 rgba(17, 20, 24, 0.15);\n}\ntable.bp4-html-table.bp4-interactive tbody tr:hover td {\n  background-color: rgba(143, 153, 168, 0.3);\n  cursor: pointer;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  table.bp4-html-table.bp4-interactive tbody tr:hover td {\n    background-color: highlight;\n  }\n}\ntable.bp4-html-table.bp4-interactive tbody tr:active td {\n  background-color: rgba(143, 153, 168, 0.35);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  table.bp4-html-table.bp4-interactive tbody tr:active td {\n    background-color: highlight;\n  }\n}\n.bp4-dark table.bp4-html-table {\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-enable selector-max-compound-selectors */\n}\n.bp4-dark table.bp4-html-table.bp4-html-table-striped tbody tr:nth-child(odd) td {\n  background: rgba(95, 107, 124, 0.15);\n}\n.bp4-dark table.bp4-html-table.bp4-html-table-bordered th:not(:first-child) {\n  box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.2);\n}\n.bp4-dark table.bp4-html-table.bp4-html-table-bordered tbody tr td,\n.bp4-dark table.bp4-html-table.bp4-html-table-bordered tfoot tr td {\n  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.2);\n}\n.bp4-dark table.bp4-html-table.bp4-html-table-bordered tbody tr td:not(:first-child),\n.bp4-dark table.bp4-html-table.bp4-html-table-bordered tfoot tr td:not(:first-child) {\n  box-shadow: inset 1px 1px 0 0 rgba(255, 255, 255, 0.2);\n}\n.bp4-dark table.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td {\n  box-shadow: inset 1px 0 0 0 rgba(255, 255, 255, 0.2);\n  /* stylelint-disable max-nesting-depth */\n}\n.bp4-dark table.bp4-html-table.bp4-html-table-bordered.bp4-html-table-striped tbody tr:not(:first-child) td:first-child {\n  box-shadow: none;\n}\n.bp4-dark table.bp4-html-table.bp4-interactive tbody tr:hover td {\n  background-color: rgba(95, 107, 124, 0.3);\n  cursor: pointer;\n}\n.bp4-dark table.bp4-html-table.bp4-interactive tbody tr:active td {\n  background-color: rgba(95, 107, 124, 0.4);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-key-combo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.bp4-key-combo > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-key-combo > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-key-combo::before,\n.bp4-key-combo > * {\n  margin-right: 5px;\n}\n.bp4-key-combo:empty::before,\n.bp4-key-combo > :last-child {\n  margin-right: 0;\n}\n\n.bp4-hotkey-dialog {\n  padding-bottom: 0;\n  top: 40px;\n}\n.bp4-hotkey-dialog .bp4-dialog-body {\n  margin: 0;\n  padding: 0;\n}\n.bp4-hotkey-dialog .bp4-hotkey-label {\n  flex-grow: 1;\n}\n\n.bp4-hotkey-column {\n  margin: auto;\n  max-height: 80vh;\n  overflow-y: auto;\n  padding: 30px;\n}\n.bp4-hotkey-column .bp4-heading {\n  margin-bottom: 20px;\n}\n.bp4-hotkey-column .bp4-heading:not(:first-child) {\n  margin-top: 40px;\n}\n\n.bp4-hotkey {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-left: 0;\n  margin-right: 0;\n}\n.bp4-hotkey:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-icon {\n  display: inline-block;\n  flex: 0 0 auto;\n  vertical-align: text-bottom;\n}\n.bp4-icon:not(:empty)::before {\n  /* stylelint-disable */\n  content: \"\" !important;\n  content: unset !important;\n  /* stylelint-enable */\n}\n.bp4-icon > svg {\n  display: block;\n}\n.bp4-icon > svg:not([fill]) {\n  fill: currentcolor;\n}\n\nspan.bp4-icon-standard {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n}\n\nspan.bp4-icon-large {\n  font-family: \"blueprint-icons-20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n}\n\nspan.bp4-icon:empty {\n  font-family: \"blueprint-icons-20\";\n  font-size: inherit;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n}\nspan.bp4-icon:empty::before {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\n.bp4-icon-add::before {\n  content: \"\\f109\";\n}\n\n.bp4-icon-add-clip::before {\n  content: \"\\f101\";\n}\n\n.bp4-icon-add-column-left::before {\n  content: \"\\f102\";\n}\n\n.bp4-icon-add-column-right::before {\n  content: \"\\f103\";\n}\n\n.bp4-icon-add-location::before {\n  content: \"\\f104\";\n}\n\n.bp4-icon-add-row-bottom::before {\n  content: \"\\f105\";\n}\n\n.bp4-icon-add-row-top::before {\n  content: \"\\f106\";\n}\n\n.bp4-icon-add-to-artifact::before {\n  content: \"\\f107\";\n}\n\n.bp4-icon-add-to-folder::before {\n  content: \"\\f108\";\n}\n\n.bp4-icon-aimpoints-target::before {\n  content: \"\\f335\";\n}\n\n.bp4-icon-airplane::before {\n  content: \"\\f10a\";\n}\n\n.bp4-icon-align-center::before {\n  content: \"\\f10b\";\n}\n\n.bp4-icon-align-justify::before {\n  content: \"\\f10c\";\n}\n\n.bp4-icon-align-left::before {\n  content: \"\\f10d\";\n}\n\n.bp4-icon-align-right::before {\n  content: \"\\f10e\";\n}\n\n.bp4-icon-alignment-bottom::before {\n  content: \"\\f10f\";\n}\n\n.bp4-icon-alignment-horizontal-center::before {\n  content: \"\\f110\";\n}\n\n.bp4-icon-alignment-left::before {\n  content: \"\\f111\";\n}\n\n.bp4-icon-alignment-right::before {\n  content: \"\\f112\";\n}\n\n.bp4-icon-alignment-top::before {\n  content: \"\\f113\";\n}\n\n.bp4-icon-alignment-vertical-center::before {\n  content: \"\\f114\";\n}\n\n.bp4-icon-ammunition::before {\n  content: \"\\f342\";\n}\n\n.bp4-icon-anchor::before {\n  content: \"\\f330\";\n}\n\n.bp4-icon-annotation::before {\n  content: \"\\f115\";\n}\n\n.bp4-icon-antenna::before {\n  content: \"\\f116\";\n}\n\n.bp4-icon-app-header::before {\n  content: \"\\f117\";\n}\n\n.bp4-icon-application::before {\n  content: \"\\f118\";\n}\n\n.bp4-icon-applications::before {\n  content: \"\\f119\";\n}\n\n.bp4-icon-archive::before {\n  content: \"\\f11a\";\n}\n\n.bp4-icon-area-of-interest::before {\n  content: \"\\f11b\";\n}\n\n.bp4-icon-array::before {\n  content: \"\\f121\";\n}\n\n.bp4-icon-array-boolean::before {\n  content: \"\\f11c\";\n}\n\n.bp4-icon-array-date::before {\n  content: \"\\f11d\";\n}\n\n.bp4-icon-array-floating-point::before {\n  content: \"\\f32d\";\n}\n\n.bp4-icon-array-numeric::before {\n  content: \"\\f11e\";\n}\n\n.bp4-icon-array-string::before {\n  content: \"\\f11f\";\n}\n\n.bp4-icon-array-timestamp::before {\n  content: \"\\f120\";\n}\n\n.bp4-icon-arrow-bottom-left::before {\n  content: \"\\f122\";\n}\n\n.bp4-icon-arrow-bottom-right::before {\n  content: \"\\f123\";\n}\n\n.bp4-icon-arrow-down::before {\n  content: \"\\f124\";\n}\n\n.bp4-icon-arrow-left::before {\n  content: \"\\f125\";\n}\n\n.bp4-icon-arrow-right::before {\n  content: \"\\f126\";\n}\n\n.bp4-icon-arrow-top-left::before {\n  content: \"\\f127\";\n}\n\n.bp4-icon-arrow-top-right::before {\n  content: \"\\f128\";\n}\n\n.bp4-icon-arrow-up::before {\n  content: \"\\f129\";\n}\n\n.bp4-icon-arrows-horizontal::before {\n  content: \"\\f12a\";\n}\n\n.bp4-icon-arrows-vertical::before {\n  content: \"\\f12b\";\n}\n\n.bp4-icon-asterisk::before {\n  content: \"\\f12c\";\n}\n\n.bp4-icon-at::before {\n  content: \"\\f331\";\n}\n\n.bp4-icon-automatic-updates::before {\n  content: \"\\f12d\";\n}\n\n.bp4-icon-axle::before {\n  content: \"\\f338\";\n}\n\n.bp4-icon-backlink::before {\n  content: \"\\f12e\";\n}\n\n.bp4-icon-badge::before {\n  content: \"\\f12f\";\n}\n\n.bp4-icon-ban-circle::before {\n  content: \"\\f130\";\n}\n\n.bp4-icon-bank-account::before {\n  content: \"\\f131\";\n}\n\n.bp4-icon-barcode::before {\n  content: \"\\f132\";\n}\n\n.bp4-icon-blank::before {\n  content: \"\\f133\";\n}\n\n.bp4-icon-blocked-person::before {\n  content: \"\\f134\";\n}\n\n.bp4-icon-bold::before {\n  content: \"\\f135\";\n}\n\n.bp4-icon-book::before {\n  content: \"\\f136\";\n}\n\n.bp4-icon-bookmark::before {\n  content: \"\\f137\";\n}\n\n.bp4-icon-box::before {\n  content: \"\\f138\";\n}\n\n.bp4-icon-briefcase::before {\n  content: \"\\f139\";\n}\n\n.bp4-icon-bring-data::before {\n  content: \"\\f13a\";\n}\n\n.bp4-icon-bug::before {\n  content: \"\\f32e\";\n}\n\n.bp4-icon-buggy::before {\n  content: \"\\f13b\";\n}\n\n.bp4-icon-build::before {\n  content: \"\\f13c\";\n}\n\n.bp4-icon-calculator::before {\n  content: \"\\f13d\";\n}\n\n.bp4-icon-calendar::before {\n  content: \"\\f13e\";\n}\n\n.bp4-icon-camera::before {\n  content: \"\\f13f\";\n}\n\n.bp4-icon-caret-down::before {\n  content: \"\\f140\";\n}\n\n.bp4-icon-caret-left::before {\n  content: \"\\f141\";\n}\n\n.bp4-icon-caret-right::before {\n  content: \"\\f142\";\n}\n\n.bp4-icon-caret-up::before {\n  content: \"\\f143\";\n}\n\n.bp4-icon-cargo-ship::before {\n  content: \"\\f144\";\n}\n\n.bp4-icon-cell-tower::before {\n  content: \"\\f145\";\n}\n\n.bp4-icon-changes::before {\n  content: \"\\f146\";\n}\n\n.bp4-icon-chart::before {\n  content: \"\\f147\";\n}\n\n.bp4-icon-chat::before {\n  content: \"\\f148\";\n}\n\n.bp4-icon-chevron-backward::before {\n  content: \"\\f149\";\n}\n\n.bp4-icon-chevron-down::before {\n  content: \"\\f14a\";\n}\n\n.bp4-icon-chevron-forward::before {\n  content: \"\\f14b\";\n}\n\n.bp4-icon-chevron-left::before {\n  content: \"\\f14c\";\n}\n\n.bp4-icon-chevron-right::before {\n  content: \"\\f14d\";\n}\n\n.bp4-icon-chevron-up::before {\n  content: \"\\f14e\";\n}\n\n.bp4-icon-circle::before {\n  content: \"\\f153\";\n}\n\n.bp4-icon-circle-arrow-down::before {\n  content: \"\\f14f\";\n}\n\n.bp4-icon-circle-arrow-left::before {\n  content: \"\\f150\";\n}\n\n.bp4-icon-circle-arrow-right::before {\n  content: \"\\f151\";\n}\n\n.bp4-icon-circle-arrow-up::before {\n  content: \"\\f152\";\n}\n\n.bp4-icon-citation::before {\n  content: \"\\f154\";\n}\n\n.bp4-icon-clean::before {\n  content: \"\\f155\";\n}\n\n.bp4-icon-clip::before {\n  content: \"\\f156\";\n}\n\n.bp4-icon-clipboard::before {\n  content: \"\\f157\";\n}\n\n.bp4-icon-cloud::before {\n  content: \"\\f15a\";\n}\n\n.bp4-icon-cloud-download::before {\n  content: \"\\f158\";\n}\n\n.bp4-icon-cloud-upload::before {\n  content: \"\\f159\";\n}\n\n.bp4-icon-code::before {\n  content: \"\\f15c\";\n}\n\n.bp4-icon-code-block::before {\n  content: \"\\f15b\";\n}\n\n.bp4-icon-cog::before {\n  content: \"\\f15d\";\n}\n\n.bp4-icon-collapse-all::before {\n  content: \"\\f15e\";\n}\n\n.bp4-icon-color-fill::before {\n  content: \"\\f328\";\n}\n\n.bp4-icon-column-layout::before {\n  content: \"\\f15f\";\n}\n\n.bp4-icon-comment::before {\n  content: \"\\f160\";\n}\n\n.bp4-icon-comparison::before {\n  content: \"\\f161\";\n}\n\n.bp4-icon-compass::before {\n  content: \"\\f162\";\n}\n\n.bp4-icon-compressed::before {\n  content: \"\\f163\";\n}\n\n.bp4-icon-confirm::before {\n  content: \"\\f164\";\n}\n\n.bp4-icon-console::before {\n  content: \"\\f165\";\n}\n\n.bp4-icon-contrast::before {\n  content: \"\\f166\";\n}\n\n.bp4-icon-control::before {\n  content: \"\\f167\";\n}\n\n.bp4-icon-credit-card::before {\n  content: \"\\f168\";\n}\n\n.bp4-icon-cross::before {\n  content: \"\\f169\";\n}\n\n.bp4-icon-cross-circle::before {\n  content: \"\\f336\";\n}\n\n.bp4-icon-crown::before {\n  content: \"\\f16a\";\n}\n\n.bp4-icon-cube::before {\n  content: \"\\f16d\";\n}\n\n.bp4-icon-cube-add::before {\n  content: \"\\f16b\";\n}\n\n.bp4-icon-cube-remove::before {\n  content: \"\\f16c\";\n}\n\n.bp4-icon-curved-range-chart::before {\n  content: \"\\f16e\";\n}\n\n.bp4-icon-cut::before {\n  content: \"\\f16f\";\n}\n\n.bp4-icon-cycle::before {\n  content: \"\\f170\";\n}\n\n.bp4-icon-dashboard::before {\n  content: \"\\f171\";\n}\n\n.bp4-icon-data-connection::before {\n  content: \"\\f172\";\n}\n\n.bp4-icon-data-lineage::before {\n  content: \"\\f173\";\n}\n\n.bp4-icon-database::before {\n  content: \"\\f174\";\n}\n\n.bp4-icon-delete::before {\n  content: \"\\f175\";\n}\n\n.bp4-icon-delta::before {\n  content: \"\\f176\";\n}\n\n.bp4-icon-derive-column::before {\n  content: \"\\f177\";\n}\n\n.bp4-icon-desktop::before {\n  content: \"\\f178\";\n}\n\n.bp4-icon-detection::before {\n  content: \"\\f341\";\n}\n\n.bp4-icon-diagnosis::before {\n  content: \"\\f179\";\n}\n\n.bp4-icon-diagram-tree::before {\n  content: \"\\f17a\";\n}\n\n.bp4-icon-direction-left::before {\n  content: \"\\f17b\";\n}\n\n.bp4-icon-direction-right::before {\n  content: \"\\f17c\";\n}\n\n.bp4-icon-disable::before {\n  content: \"\\f17d\";\n}\n\n.bp4-icon-divide::before {\n  content: \"\\f327\";\n}\n\n.bp4-icon-document::before {\n  content: \"\\f180\";\n}\n\n.bp4-icon-document-open::before {\n  content: \"\\f17e\";\n}\n\n.bp4-icon-document-share::before {\n  content: \"\\f17f\";\n}\n\n.bp4-icon-dollar::before {\n  content: \"\\f181\";\n}\n\n.bp4-icon-dot::before {\n  content: \"\\f182\";\n}\n\n.bp4-icon-double-caret-horizontal::before {\n  content: \"\\f183\";\n}\n\n.bp4-icon-double-caret-vertical::before {\n  content: \"\\f184\";\n}\n\n.bp4-icon-double-chevron-down::before {\n  content: \"\\f185\";\n}\n\n.bp4-icon-double-chevron-left::before {\n  content: \"\\f186\";\n}\n\n.bp4-icon-double-chevron-right::before {\n  content: \"\\f187\";\n}\n\n.bp4-icon-double-chevron-up::before {\n  content: \"\\f188\";\n}\n\n.bp4-icon-doughnut-chart::before {\n  content: \"\\f189\";\n}\n\n.bp4-icon-download::before {\n  content: \"\\f18a\";\n}\n\n.bp4-icon-drag-handle-horizontal::before {\n  content: \"\\f18b\";\n}\n\n.bp4-icon-drag-handle-vertical::before {\n  content: \"\\f18c\";\n}\n\n.bp4-icon-draw::before {\n  content: \"\\f18d\";\n}\n\n.bp4-icon-drawer-left::before {\n  content: \"\\f18f\";\n}\n\n.bp4-icon-drawer-left-filled::before {\n  content: \"\\f18e\";\n}\n\n.bp4-icon-drawer-right::before {\n  content: \"\\f191\";\n}\n\n.bp4-icon-drawer-right-filled::before {\n  content: \"\\f190\";\n}\n\n.bp4-icon-drive-time::before {\n  content: \"\\f192\";\n}\n\n.bp4-icon-duplicate::before {\n  content: \"\\f193\";\n}\n\n.bp4-icon-edit::before {\n  content: \"\\f194\";\n}\n\n.bp4-icon-eject::before {\n  content: \"\\f195\";\n}\n\n.bp4-icon-emoji::before {\n  content: \"\\f196\";\n}\n\n.bp4-icon-endorsed::before {\n  content: \"\\f197\";\n}\n\n.bp4-icon-envelope::before {\n  content: \"\\f198\";\n}\n\n.bp4-icon-equals::before {\n  content: \"\\f199\";\n}\n\n.bp4-icon-eraser::before {\n  content: \"\\f19a\";\n}\n\n.bp4-icon-error::before {\n  content: \"\\f19b\";\n}\n\n.bp4-icon-euro::before {\n  content: \"\\f19c\";\n}\n\n.bp4-icon-exchange::before {\n  content: \"\\f19d\";\n}\n\n.bp4-icon-exclude-row::before {\n  content: \"\\f19e\";\n}\n\n.bp4-icon-expand-all::before {\n  content: \"\\f19f\";\n}\n\n.bp4-icon-export::before {\n  content: \"\\f1a0\";\n}\n\n.bp4-icon-eye-off::before {\n  content: \"\\f1a1\";\n}\n\n.bp4-icon-eye-on::before {\n  content: \"\\f1a2\";\n}\n\n.bp4-icon-eye-open::before {\n  content: \"\\f1a3\";\n}\n\n.bp4-icon-fast-backward::before {\n  content: \"\\f1a4\";\n}\n\n.bp4-icon-fast-forward::before {\n  content: \"\\f1a5\";\n}\n\n.bp4-icon-feed::before {\n  content: \"\\f1a7\";\n}\n\n.bp4-icon-feed-subscribed::before {\n  content: \"\\f1a6\";\n}\n\n.bp4-icon-film::before {\n  content: \"\\f1a8\";\n}\n\n.bp4-icon-filter::before {\n  content: \"\\f1ad\";\n}\n\n.bp4-icon-filter-keep::before {\n  content: \"\\f1a9\";\n}\n\n.bp4-icon-filter-list::before {\n  content: \"\\f1aa\";\n}\n\n.bp4-icon-filter-open::before {\n  content: \"\\f1ab\";\n}\n\n.bp4-icon-filter-remove::before {\n  content: \"\\f1ac\";\n}\n\n.bp4-icon-flag::before {\n  content: \"\\f1ae\";\n}\n\n.bp4-icon-flame::before {\n  content: \"\\f1af\";\n}\n\n.bp4-icon-flash::before {\n  content: \"\\f1b0\";\n}\n\n.bp4-icon-floating-point::before {\n  content: \"\\f32c\";\n}\n\n.bp4-icon-floppy-disk::before {\n  content: \"\\f1b1\";\n}\n\n.bp4-icon-flow-branch::before {\n  content: \"\\f1b2\";\n}\n\n.bp4-icon-flow-end::before {\n  content: \"\\f1b3\";\n}\n\n.bp4-icon-flow-linear::before {\n  content: \"\\f1b4\";\n}\n\n.bp4-icon-flow-review::before {\n  content: \"\\f1b6\";\n}\n\n.bp4-icon-flow-review-branch::before {\n  content: \"\\f1b5\";\n}\n\n.bp4-icon-flows::before {\n  content: \"\\f1b7\";\n}\n\n.bp4-icon-folder-close::before {\n  content: \"\\f1b8\";\n}\n\n.bp4-icon-folder-new::before {\n  content: \"\\f1b9\";\n}\n\n.bp4-icon-folder-open::before {\n  content: \"\\f1ba\";\n}\n\n.bp4-icon-folder-shared::before {\n  content: \"\\f1bc\";\n}\n\n.bp4-icon-folder-shared-open::before {\n  content: \"\\f1bb\";\n}\n\n.bp4-icon-follower::before {\n  content: \"\\f1bd\";\n}\n\n.bp4-icon-following::before {\n  content: \"\\f1be\";\n}\n\n.bp4-icon-font::before {\n  content: \"\\f1bf\";\n}\n\n.bp4-icon-fork::before {\n  content: \"\\f1c0\";\n}\n\n.bp4-icon-form::before {\n  content: \"\\f1c1\";\n}\n\n.bp4-icon-fuel::before {\n  content: \"\\f323\";\n}\n\n.bp4-icon-full-circle::before {\n  content: \"\\f1c2\";\n}\n\n.bp4-icon-full-stacked-chart::before {\n  content: \"\\f1c3\";\n}\n\n.bp4-icon-fullscreen::before {\n  content: \"\\f1c4\";\n}\n\n.bp4-icon-function::before {\n  content: \"\\f1c5\";\n}\n\n.bp4-icon-gantt-chart::before {\n  content: \"\\f1c6\";\n}\n\n.bp4-icon-geofence::before {\n  content: \"\\f1c7\";\n}\n\n.bp4-icon-geolocation::before {\n  content: \"\\f1c8\";\n}\n\n.bp4-icon-geosearch::before {\n  content: \"\\f1c9\";\n}\n\n.bp4-icon-git-branch::before {\n  content: \"\\f1ca\";\n}\n\n.bp4-icon-git-commit::before {\n  content: \"\\f1cb\";\n}\n\n.bp4-icon-git-merge::before {\n  content: \"\\f1cc\";\n}\n\n.bp4-icon-git-new-branch::before {\n  content: \"\\f1cd\";\n}\n\n.bp4-icon-git-pull::before {\n  content: \"\\f1ce\";\n}\n\n.bp4-icon-git-push::before {\n  content: \"\\f1cf\";\n}\n\n.bp4-icon-git-repo::before {\n  content: \"\\f1d0\";\n}\n\n.bp4-icon-glass::before {\n  content: \"\\f1d1\";\n}\n\n.bp4-icon-globe::before {\n  content: \"\\f1d3\";\n}\n\n.bp4-icon-globe-network::before {\n  content: \"\\f1d2\";\n}\n\n.bp4-icon-graph::before {\n  content: \"\\f1d5\";\n}\n\n.bp4-icon-graph-remove::before {\n  content: \"\\f1d4\";\n}\n\n.bp4-icon-greater-than::before {\n  content: \"\\f1d7\";\n}\n\n.bp4-icon-greater-than-or-equal-to::before {\n  content: \"\\f1d6\";\n}\n\n.bp4-icon-grid::before {\n  content: \"\\f1d9\";\n}\n\n.bp4-icon-grid-view::before {\n  content: \"\\f1d8\";\n}\n\n.bp4-icon-group-objects::before {\n  content: \"\\f1da\";\n}\n\n.bp4-icon-grouped-bar-chart::before {\n  content: \"\\f1db\";\n}\n\n.bp4-icon-hand::before {\n  content: \"\\f1e0\";\n}\n\n.bp4-icon-hand-down::before {\n  content: \"\\f1dc\";\n}\n\n.bp4-icon-hand-left::before {\n  content: \"\\f1dd\";\n}\n\n.bp4-icon-hand-right::before {\n  content: \"\\f1de\";\n}\n\n.bp4-icon-hand-up::before {\n  content: \"\\f1df\";\n}\n\n.bp4-icon-hat::before {\n  content: \"\\f1e1\";\n}\n\n.bp4-icon-header::before {\n  content: \"\\f1e5\";\n}\n\n.bp4-icon-header-one::before {\n  content: \"\\f1e2\";\n}\n\n.bp4-icon-header-three::before {\n  content: \"\\f1e3\";\n}\n\n.bp4-icon-header-two::before {\n  content: \"\\f1e4\";\n}\n\n.bp4-icon-headset::before {\n  content: \"\\f1e6\";\n}\n\n.bp4-icon-heart::before {\n  content: \"\\f1e8\";\n}\n\n.bp4-icon-heart-broken::before {\n  content: \"\\f1e7\";\n}\n\n.bp4-icon-heat-grid::before {\n  content: \"\\f1e9\";\n}\n\n.bp4-icon-heatmap::before {\n  content: \"\\f1ea\";\n}\n\n.bp4-icon-helicopter::before {\n  content: \"\\f1eb\";\n}\n\n.bp4-icon-help::before {\n  content: \"\\f1ec\";\n}\n\n.bp4-icon-helper-management::before {\n  content: \"\\f1ed\";\n}\n\n.bp4-icon-high-priority::before {\n  content: \"\\f1ee\";\n}\n\n.bp4-icon-high-voltage-pole::before {\n  content: \"\\f333\";\n}\n\n.bp4-icon-highlight::before {\n  content: \"\\f1ef\";\n}\n\n.bp4-icon-history::before {\n  content: \"\\f1f0\";\n}\n\n.bp4-icon-home::before {\n  content: \"\\f1f1\";\n}\n\n.bp4-icon-horizontal-bar-chart::before {\n  content: \"\\f1f4\";\n}\n\n.bp4-icon-horizontal-bar-chart-asc::before {\n  content: \"\\f1f2\";\n}\n\n.bp4-icon-horizontal-bar-chart-desc::before {\n  content: \"\\f1f3\";\n}\n\n.bp4-icon-horizontal-distribution::before {\n  content: \"\\f1f5\";\n}\n\n.bp4-icon-horizontal-inbetween::before {\n  content: \"\\f329\";\n}\n\n.bp4-icon-hurricane::before {\n  content: \"\\f1f6\";\n}\n\n.bp4-icon-id-number::before {\n  content: \"\\f1f7\";\n}\n\n.bp4-icon-image-rotate-left::before {\n  content: \"\\f1f8\";\n}\n\n.bp4-icon-image-rotate-right::before {\n  content: \"\\f1f9\";\n}\n\n.bp4-icon-import::before {\n  content: \"\\f1fa\";\n}\n\n.bp4-icon-inbox::before {\n  content: \"\\f1ff\";\n}\n\n.bp4-icon-inbox-filtered::before {\n  content: \"\\f1fb\";\n}\n\n.bp4-icon-inbox-geo::before {\n  content: \"\\f1fc\";\n}\n\n.bp4-icon-inbox-search::before {\n  content: \"\\f1fd\";\n}\n\n.bp4-icon-inbox-update::before {\n  content: \"\\f1fe\";\n}\n\n.bp4-icon-info-sign::before {\n  content: \"\\f200\";\n}\n\n.bp4-icon-inheritance::before {\n  content: \"\\f201\";\n}\n\n.bp4-icon-inherited-group::before {\n  content: \"\\f202\";\n}\n\n.bp4-icon-inner-join::before {\n  content: \"\\f203\";\n}\n\n.bp4-icon-insert::before {\n  content: \"\\f204\";\n}\n\n.bp4-icon-intelligence::before {\n  content: \"\\f337\";\n}\n\n.bp4-icon-intersection::before {\n  content: \"\\f205\";\n}\n\n.bp4-icon-ip-address::before {\n  content: \"\\f206\";\n}\n\n.bp4-icon-issue::before {\n  content: \"\\f209\";\n}\n\n.bp4-icon-issue-closed::before {\n  content: \"\\f207\";\n}\n\n.bp4-icon-issue-new::before {\n  content: \"\\f208\";\n}\n\n.bp4-icon-italic::before {\n  content: \"\\f20a\";\n}\n\n.bp4-icon-join-table::before {\n  content: \"\\f20b\";\n}\n\n.bp4-icon-key::before {\n  content: \"\\f215\";\n}\n\n.bp4-icon-key-backspace::before {\n  content: \"\\f20c\";\n}\n\n.bp4-icon-key-command::before {\n  content: \"\\f20d\";\n}\n\n.bp4-icon-key-control::before {\n  content: \"\\f20e\";\n}\n\n.bp4-icon-key-delete::before {\n  content: \"\\f20f\";\n}\n\n.bp4-icon-key-enter::before {\n  content: \"\\f210\";\n}\n\n.bp4-icon-key-escape::before {\n  content: \"\\f211\";\n}\n\n.bp4-icon-key-option::before {\n  content: \"\\f212\";\n}\n\n.bp4-icon-key-shift::before {\n  content: \"\\f213\";\n}\n\n.bp4-icon-key-tab::before {\n  content: \"\\f214\";\n}\n\n.bp4-icon-known-vehicle::before {\n  content: \"\\f216\";\n}\n\n.bp4-icon-lab-test::before {\n  content: \"\\f217\";\n}\n\n.bp4-icon-label::before {\n  content: \"\\f218\";\n}\n\n.bp4-icon-layer::before {\n  content: \"\\f21a\";\n}\n\n.bp4-icon-layer-outline::before {\n  content: \"\\f219\";\n}\n\n.bp4-icon-layers::before {\n  content: \"\\f21b\";\n}\n\n.bp4-icon-layout::before {\n  content: \"\\f225\";\n}\n\n.bp4-icon-layout-auto::before {\n  content: \"\\f21c\";\n}\n\n.bp4-icon-layout-balloon::before {\n  content: \"\\f21d\";\n}\n\n.bp4-icon-layout-circle::before {\n  content: \"\\f21e\";\n}\n\n.bp4-icon-layout-grid::before {\n  content: \"\\f21f\";\n}\n\n.bp4-icon-layout-group-by::before {\n  content: \"\\f220\";\n}\n\n.bp4-icon-layout-hierarchy::before {\n  content: \"\\f221\";\n}\n\n.bp4-icon-layout-linear::before {\n  content: \"\\f222\";\n}\n\n.bp4-icon-layout-skew-grid::before {\n  content: \"\\f223\";\n}\n\n.bp4-icon-layout-sorted-clusters::before {\n  content: \"\\f224\";\n}\n\n.bp4-icon-learning::before {\n  content: \"\\f226\";\n}\n\n.bp4-icon-left-join::before {\n  content: \"\\f227\";\n}\n\n.bp4-icon-lengthen-text::before {\n  content: \"\\f33e\";\n}\n\n.bp4-icon-less-than::before {\n  content: \"\\f229\";\n}\n\n.bp4-icon-less-than-or-equal-to::before {\n  content: \"\\f228\";\n}\n\n.bp4-icon-lifesaver::before {\n  content: \"\\f22a\";\n}\n\n.bp4-icon-lightbulb::before {\n  content: \"\\f22b\";\n}\n\n.bp4-icon-lightning::before {\n  content: \"\\f22c\";\n}\n\n.bp4-icon-link::before {\n  content: \"\\f22d\";\n}\n\n.bp4-icon-list::before {\n  content: \"\\f230\";\n}\n\n.bp4-icon-list-columns::before {\n  content: \"\\f22e\";\n}\n\n.bp4-icon-list-detail-view::before {\n  content: \"\\f22f\";\n}\n\n.bp4-icon-locate::before {\n  content: \"\\f231\";\n}\n\n.bp4-icon-lock::before {\n  content: \"\\f232\";\n}\n\n.bp4-icon-locomotive::before {\n  content: \"\\f33b\";\n}\n\n.bp4-icon-log-in::before {\n  content: \"\\f233\";\n}\n\n.bp4-icon-log-out::before {\n  content: \"\\f234\";\n}\n\n.bp4-icon-low-voltage-pole::before {\n  content: \"\\f332\";\n}\n\n.bp4-icon-manual::before {\n  content: \"\\f235\";\n}\n\n.bp4-icon-manually-entered-data::before {\n  content: \"\\f236\";\n}\n\n.bp4-icon-many-to-many::before {\n  content: \"\\f237\";\n}\n\n.bp4-icon-many-to-one::before {\n  content: \"\\f238\";\n}\n\n.bp4-icon-map::before {\n  content: \"\\f23b\";\n}\n\n.bp4-icon-map-create::before {\n  content: \"\\f239\";\n}\n\n.bp4-icon-map-marker::before {\n  content: \"\\f23a\";\n}\n\n.bp4-icon-maximize::before {\n  content: \"\\f23c\";\n}\n\n.bp4-icon-media::before {\n  content: \"\\f23d\";\n}\n\n.bp4-icon-menu::before {\n  content: \"\\f240\";\n}\n\n.bp4-icon-menu-closed::before {\n  content: \"\\f23e\";\n}\n\n.bp4-icon-menu-open::before {\n  content: \"\\f23f\";\n}\n\n.bp4-icon-merge-columns::before {\n  content: \"\\f241\";\n}\n\n.bp4-icon-merge-links::before {\n  content: \"\\f242\";\n}\n\n.bp4-icon-minimize::before {\n  content: \"\\f243\";\n}\n\n.bp4-icon-minus::before {\n  content: \"\\f244\";\n}\n\n.bp4-icon-mobile-phone::before {\n  content: \"\\f245\";\n}\n\n.bp4-icon-mobile-video::before {\n  content: \"\\f246\";\n}\n\n.bp4-icon-modal::before {\n  content: \"\\f248\";\n}\n\n.bp4-icon-modal-filled::before {\n  content: \"\\f247\";\n}\n\n.bp4-icon-model::before {\n  content: \"\\f33d\";\n}\n\n.bp4-icon-moon::before {\n  content: \"\\f249\";\n}\n\n.bp4-icon-more::before {\n  content: \"\\f24a\";\n}\n\n.bp4-icon-mountain::before {\n  content: \"\\f24b\";\n}\n\n.bp4-icon-move::before {\n  content: \"\\f24c\";\n}\n\n.bp4-icon-mugshot::before {\n  content: \"\\f24d\";\n}\n\n.bp4-icon-multi-select::before {\n  content: \"\\f24e\";\n}\n\n.bp4-icon-music::before {\n  content: \"\\f24f\";\n}\n\n.bp4-icon-nest::before {\n  content: \"\\f250\";\n}\n\n.bp4-icon-new-drawing::before {\n  content: \"\\f251\";\n}\n\n.bp4-icon-new-grid-item::before {\n  content: \"\\f252\";\n}\n\n.bp4-icon-new-layer::before {\n  content: \"\\f253\";\n}\n\n.bp4-icon-new-layers::before {\n  content: \"\\f254\";\n}\n\n.bp4-icon-new-link::before {\n  content: \"\\f255\";\n}\n\n.bp4-icon-new-object::before {\n  content: \"\\f256\";\n}\n\n.bp4-icon-new-person::before {\n  content: \"\\f257\";\n}\n\n.bp4-icon-new-prescription::before {\n  content: \"\\f258\";\n}\n\n.bp4-icon-new-text-box::before {\n  content: \"\\f259\";\n}\n\n.bp4-icon-ninja::before {\n  content: \"\\f25a\";\n}\n\n.bp4-icon-not-equal-to::before {\n  content: \"\\f25b\";\n}\n\n.bp4-icon-notifications::before {\n  content: \"\\f25e\";\n}\n\n.bp4-icon-notifications-snooze::before {\n  content: \"\\f25c\";\n}\n\n.bp4-icon-notifications-updated::before {\n  content: \"\\f25d\";\n}\n\n.bp4-icon-numbered-list::before {\n  content: \"\\f25f\";\n}\n\n.bp4-icon-numerical::before {\n  content: \"\\f260\";\n}\n\n.bp4-icon-office::before {\n  content: \"\\f261\";\n}\n\n.bp4-icon-offline::before {\n  content: \"\\f262\";\n}\n\n.bp4-icon-oil-field::before {\n  content: \"\\f263\";\n}\n\n.bp4-icon-one-column::before {\n  content: \"\\f264\";\n}\n\n.bp4-icon-one-to-many::before {\n  content: \"\\f265\";\n}\n\n.bp4-icon-one-to-one::before {\n  content: \"\\f266\";\n}\n\n.bp4-icon-open-application::before {\n  content: \"\\f32b\";\n}\n\n.bp4-icon-outdated::before {\n  content: \"\\f267\";\n}\n\n.bp4-icon-page-layout::before {\n  content: \"\\f268\";\n}\n\n.bp4-icon-panel-stats::before {\n  content: \"\\f269\";\n}\n\n.bp4-icon-panel-table::before {\n  content: \"\\f26a\";\n}\n\n.bp4-icon-paperclip::before {\n  content: \"\\f26b\";\n}\n\n.bp4-icon-paragraph::before {\n  content: \"\\f26c\";\n}\n\n.bp4-icon-path::before {\n  content: \"\\f26e\";\n}\n\n.bp4-icon-path-search::before {\n  content: \"\\f26d\";\n}\n\n.bp4-icon-pause::before {\n  content: \"\\f26f\";\n}\n\n.bp4-icon-people::before {\n  content: \"\\f270\";\n}\n\n.bp4-icon-percentage::before {\n  content: \"\\f271\";\n}\n\n.bp4-icon-person::before {\n  content: \"\\f272\";\n}\n\n.bp4-icon-phone::before {\n  content: \"\\f273\";\n}\n\n.bp4-icon-pie-chart::before {\n  content: \"\\f274\";\n}\n\n.bp4-icon-pin::before {\n  content: \"\\f275\";\n}\n\n.bp4-icon-pivot::before {\n  content: \"\\f277\";\n}\n\n.bp4-icon-pivot-table::before {\n  content: \"\\f276\";\n}\n\n.bp4-icon-play::before {\n  content: \"\\f278\";\n}\n\n.bp4-icon-playbook::before {\n  content: \"\\f324\";\n}\n\n.bp4-icon-plus::before {\n  content: \"\\f279\";\n}\n\n.bp4-icon-polygon-filter::before {\n  content: \"\\f27a\";\n}\n\n.bp4-icon-power::before {\n  content: \"\\f27b\";\n}\n\n.bp4-icon-predictive-analysis::before {\n  content: \"\\f27c\";\n}\n\n.bp4-icon-prescription::before {\n  content: \"\\f27d\";\n}\n\n.bp4-icon-presentation::before {\n  content: \"\\f27e\";\n}\n\n.bp4-icon-print::before {\n  content: \"\\f27f\";\n}\n\n.bp4-icon-projects::before {\n  content: \"\\f280\";\n}\n\n.bp4-icon-properties::before {\n  content: \"\\f281\";\n}\n\n.bp4-icon-property::before {\n  content: \"\\f282\";\n}\n\n.bp4-icon-publish-function::before {\n  content: \"\\f283\";\n}\n\n.bp4-icon-pulse::before {\n  content: \"\\f284\";\n}\n\n.bp4-icon-rain::before {\n  content: \"\\f285\";\n}\n\n.bp4-icon-random::before {\n  content: \"\\f286\";\n}\n\n.bp4-icon-record::before {\n  content: \"\\f287\";\n}\n\n.bp4-icon-rect-height::before {\n  content: \"\\f325\";\n}\n\n.bp4-icon-rect-width::before {\n  content: \"\\f326\";\n}\n\n.bp4-icon-rectangle::before {\n  content: \"\\f321\";\n}\n\n.bp4-icon-redo::before {\n  content: \"\\f288\";\n}\n\n.bp4-icon-refresh::before {\n  content: \"\\f289\";\n}\n\n.bp4-icon-regex::before {\n  content: \"\\f32f\";\n}\n\n.bp4-icon-regression-chart::before {\n  content: \"\\f28a\";\n}\n\n.bp4-icon-remove::before {\n  content: \"\\f290\";\n}\n\n.bp4-icon-remove-column::before {\n  content: \"\\f28d\";\n}\n\n.bp4-icon-remove-column-left::before {\n  content: \"\\f28b\";\n}\n\n.bp4-icon-remove-column-right::before {\n  content: \"\\f28c\";\n}\n\n.bp4-icon-remove-row-bottom::before {\n  content: \"\\f28e\";\n}\n\n.bp4-icon-remove-row-top::before {\n  content: \"\\f28f\";\n}\n\n.bp4-icon-repeat::before {\n  content: \"\\f291\";\n}\n\n.bp4-icon-reset::before {\n  content: \"\\f292\";\n}\n\n.bp4-icon-resolve::before {\n  content: \"\\f293\";\n}\n\n.bp4-icon-rig::before {\n  content: \"\\f294\";\n}\n\n.bp4-icon-right-join::before {\n  content: \"\\f295\";\n}\n\n.bp4-icon-ring::before {\n  content: \"\\f296\";\n}\n\n.bp4-icon-rocket::before {\n  content: \"\\f298\";\n}\n\n.bp4-icon-rocket-slant::before {\n  content: \"\\f297\";\n}\n\n.bp4-icon-rotate-document::before {\n  content: \"\\f299\";\n}\n\n.bp4-icon-rotate-page::before {\n  content: \"\\f29a\";\n}\n\n.bp4-icon-route::before {\n  content: \"\\f29b\";\n}\n\n.bp4-icon-satellite::before {\n  content: \"\\f29c\";\n}\n\n.bp4-icon-saved::before {\n  content: \"\\f29d\";\n}\n\n.bp4-icon-scatter-plot::before {\n  content: \"\\f29e\";\n}\n\n.bp4-icon-search::before {\n  content: \"\\f2a2\";\n}\n\n.bp4-icon-search-around::before {\n  content: \"\\f29f\";\n}\n\n.bp4-icon-search-template::before {\n  content: \"\\f2a0\";\n}\n\n.bp4-icon-search-text::before {\n  content: \"\\f2a1\";\n}\n\n.bp4-icon-segmented-control::before {\n  content: \"\\f2a3\";\n}\n\n.bp4-icon-select::before {\n  content: \"\\f2a4\";\n}\n\n.bp4-icon-selection::before {\n  content: \"\\f2a5\";\n}\n\n.bp4-icon-send-message::before {\n  content: \"\\f2a6\";\n}\n\n.bp4-icon-send-to::before {\n  content: \"\\f2a9\";\n}\n\n.bp4-icon-send-to-graph::before {\n  content: \"\\f2a7\";\n}\n\n.bp4-icon-send-to-map::before {\n  content: \"\\f2a8\";\n}\n\n.bp4-icon-sensor::before {\n  content: \"\\f33c\";\n}\n\n.bp4-icon-series-add::before {\n  content: \"\\f2aa\";\n}\n\n.bp4-icon-series-configuration::before {\n  content: \"\\f2ab\";\n}\n\n.bp4-icon-series-derived::before {\n  content: \"\\f2ac\";\n}\n\n.bp4-icon-series-filtered::before {\n  content: \"\\f2ad\";\n}\n\n.bp4-icon-series-search::before {\n  content: \"\\f2ae\";\n}\n\n.bp4-icon-settings::before {\n  content: \"\\f2af\";\n}\n\n.bp4-icon-shapes::before {\n  content: \"\\f2b0\";\n}\n\n.bp4-icon-share::before {\n  content: \"\\f2b1\";\n}\n\n.bp4-icon-shared-filter::before {\n  content: \"\\f2b2\";\n}\n\n.bp4-icon-shield::before {\n  content: \"\\f2b3\";\n}\n\n.bp4-icon-ship::before {\n  content: \"\\f2b4\";\n}\n\n.bp4-icon-shop::before {\n  content: \"\\f2b5\";\n}\n\n.bp4-icon-shopping-cart::before {\n  content: \"\\f2b6\";\n}\n\n.bp4-icon-shorten-text::before {\n  content: \"\\f33f\";\n}\n\n.bp4-icon-signal-search::before {\n  content: \"\\f2b7\";\n}\n\n.bp4-icon-sim-card::before {\n  content: \"\\f2b8\";\n}\n\n.bp4-icon-slash::before {\n  content: \"\\f2b9\";\n}\n\n.bp4-icon-small-cross::before {\n  content: \"\\f2ba\";\n}\n\n.bp4-icon-small-info-sign::before {\n  content: \"\\f334\";\n}\n\n.bp4-icon-small-minus::before {\n  content: \"\\f2bb\";\n}\n\n.bp4-icon-small-plus::before {\n  content: \"\\f2bc\";\n}\n\n.bp4-icon-small-square::before {\n  content: \"\\f2bd\";\n}\n\n.bp4-icon-small-tick::before {\n  content: \"\\f2be\";\n}\n\n.bp4-icon-snowflake::before {\n  content: \"\\f2bf\";\n}\n\n.bp4-icon-social-media::before {\n  content: \"\\f2c0\";\n}\n\n.bp4-icon-sort::before {\n  content: \"\\f2c7\";\n}\n\n.bp4-icon-sort-alphabetical::before {\n  content: \"\\f2c2\";\n}\n\n.bp4-icon-sort-alphabetical-desc::before {\n  content: \"\\f2c1\";\n}\n\n.bp4-icon-sort-asc::before {\n  content: \"\\f2c3\";\n}\n\n.bp4-icon-sort-desc::before {\n  content: \"\\f2c4\";\n}\n\n.bp4-icon-sort-numerical::before {\n  content: \"\\f2c6\";\n}\n\n.bp4-icon-sort-numerical-desc::before {\n  content: \"\\f2c5\";\n}\n\n.bp4-icon-spell-check::before {\n  content: \"\\f340\";\n}\n\n.bp4-icon-split-columns::before {\n  content: \"\\f2c8\";\n}\n\n.bp4-icon-square::before {\n  content: \"\\f2c9\";\n}\n\n.bp4-icon-stacked-chart::before {\n  content: \"\\f2ca\";\n}\n\n.bp4-icon-stadium-geometry::before {\n  content: \"\\f2cb\";\n}\n\n.bp4-icon-star::before {\n  content: \"\\f2cd\";\n}\n\n.bp4-icon-star-empty::before {\n  content: \"\\f2cc\";\n}\n\n.bp4-icon-step-backward::before {\n  content: \"\\f2ce\";\n}\n\n.bp4-icon-step-chart::before {\n  content: \"\\f2cf\";\n}\n\n.bp4-icon-step-forward::before {\n  content: \"\\f2d0\";\n}\n\n.bp4-icon-stop::before {\n  content: \"\\f2d1\";\n}\n\n.bp4-icon-stopwatch::before {\n  content: \"\\f2d2\";\n}\n\n.bp4-icon-strikethrough::before {\n  content: \"\\f2d3\";\n}\n\n.bp4-icon-style::before {\n  content: \"\\f2d4\";\n}\n\n.bp4-icon-subscript::before {\n  content: \"\\f339\";\n}\n\n.bp4-icon-superscript::before {\n  content: \"\\f33a\";\n}\n\n.bp4-icon-swap-horizontal::before {\n  content: \"\\f2d5\";\n}\n\n.bp4-icon-swap-vertical::before {\n  content: \"\\f2d6\";\n}\n\n.bp4-icon-switch::before {\n  content: \"\\f2d7\";\n}\n\n.bp4-icon-symbol-circle::before {\n  content: \"\\f2d8\";\n}\n\n.bp4-icon-symbol-cross::before {\n  content: \"\\f2d9\";\n}\n\n.bp4-icon-symbol-diamond::before {\n  content: \"\\f2da\";\n}\n\n.bp4-icon-symbol-rectangle::before {\n  content: \"\\f322\";\n}\n\n.bp4-icon-symbol-square::before {\n  content: \"\\f2db\";\n}\n\n.bp4-icon-symbol-triangle-down::before {\n  content: \"\\f2dc\";\n}\n\n.bp4-icon-symbol-triangle-up::before {\n  content: \"\\f2dd\";\n}\n\n.bp4-icon-syringe::before {\n  content: \"\\f2de\";\n}\n\n.bp4-icon-tag::before {\n  content: \"\\f2df\";\n}\n\n.bp4-icon-take-action::before {\n  content: \"\\f2e0\";\n}\n\n.bp4-icon-tank::before {\n  content: \"\\f2e1\";\n}\n\n.bp4-icon-target::before {\n  content: \"\\f2e2\";\n}\n\n.bp4-icon-taxi::before {\n  content: \"\\f2e3\";\n}\n\n.bp4-icon-temperature::before {\n  content: \"\\f2e4\";\n}\n\n.bp4-icon-text-highlight::before {\n  content: \"\\f2e5\";\n}\n\n.bp4-icon-th::before {\n  content: \"\\f2ea\";\n}\n\n.bp4-icon-th-derived::before {\n  content: \"\\f2e6\";\n}\n\n.bp4-icon-th-disconnect::before {\n  content: \"\\f2e7\";\n}\n\n.bp4-icon-th-filtered::before {\n  content: \"\\f2e8\";\n}\n\n.bp4-icon-th-list::before {\n  content: \"\\f2e9\";\n}\n\n.bp4-icon-third-party::before {\n  content: \"\\f2eb\";\n}\n\n.bp4-icon-thumbs-down::before {\n  content: \"\\f2ec\";\n}\n\n.bp4-icon-thumbs-up::before {\n  content: \"\\f2ed\";\n}\n\n.bp4-icon-tick::before {\n  content: \"\\f2ef\";\n}\n\n.bp4-icon-tick-circle::before {\n  content: \"\\f2ee\";\n}\n\n.bp4-icon-time::before {\n  content: \"\\f2f0\";\n}\n\n.bp4-icon-timeline-area-chart::before {\n  content: \"\\f2f1\";\n}\n\n.bp4-icon-timeline-bar-chart::before {\n  content: \"\\f2f2\";\n}\n\n.bp4-icon-timeline-events::before {\n  content: \"\\f2f3\";\n}\n\n.bp4-icon-timeline-line-chart::before {\n  content: \"\\f2f4\";\n}\n\n.bp4-icon-tint::before {\n  content: \"\\f2f5\";\n}\n\n.bp4-icon-torch::before {\n  content: \"\\f2f6\";\n}\n\n.bp4-icon-tractor::before {\n  content: \"\\f2f7\";\n}\n\n.bp4-icon-train::before {\n  content: \"\\f2f8\";\n}\n\n.bp4-icon-translate::before {\n  content: \"\\f2f9\";\n}\n\n.bp4-icon-trash::before {\n  content: \"\\f2fa\";\n}\n\n.bp4-icon-tree::before {\n  content: \"\\f2fb\";\n}\n\n.bp4-icon-trending-down::before {\n  content: \"\\f2fc\";\n}\n\n.bp4-icon-trending-up::before {\n  content: \"\\f2fd\";\n}\n\n.bp4-icon-truck::before {\n  content: \"\\f2fe\";\n}\n\n.bp4-icon-two-columns::before {\n  content: \"\\f2ff\";\n}\n\n.bp4-icon-unarchive::before {\n  content: \"\\f300\";\n}\n\n.bp4-icon-underline::before {\n  content: \"\\f301\";\n}\n\n.bp4-icon-undo::before {\n  content: \"\\f302\";\n}\n\n.bp4-icon-ungroup-objects::before {\n  content: \"\\f303\";\n}\n\n.bp4-icon-unknown-vehicle::before {\n  content: \"\\f304\";\n}\n\n.bp4-icon-unlock::before {\n  content: \"\\f305\";\n}\n\n.bp4-icon-unpin::before {\n  content: \"\\f306\";\n}\n\n.bp4-icon-unresolve::before {\n  content: \"\\f307\";\n}\n\n.bp4-icon-updated::before {\n  content: \"\\f308\";\n}\n\n.bp4-icon-upload::before {\n  content: \"\\f309\";\n}\n\n.bp4-icon-user::before {\n  content: \"\\f30a\";\n}\n\n.bp4-icon-variable::before {\n  content: \"\\f30b\";\n}\n\n.bp4-icon-vertical-bar-chart-asc::before {\n  content: \"\\f30c\";\n}\n\n.bp4-icon-vertical-bar-chart-desc::before {\n  content: \"\\f30d\";\n}\n\n.bp4-icon-vertical-distribution::before {\n  content: \"\\f30e\";\n}\n\n.bp4-icon-vertical-inbetween::before {\n  content: \"\\f32a\";\n}\n\n.bp4-icon-video::before {\n  content: \"\\f30f\";\n}\n\n.bp4-icon-virus::before {\n  content: \"\\f310\";\n}\n\n.bp4-icon-volume-down::before {\n  content: \"\\f311\";\n}\n\n.bp4-icon-volume-off::before {\n  content: \"\\f312\";\n}\n\n.bp4-icon-volume-up::before {\n  content: \"\\f313\";\n}\n\n.bp4-icon-walk::before {\n  content: \"\\f314\";\n}\n\n.bp4-icon-warning-sign::before {\n  content: \"\\f315\";\n}\n\n.bp4-icon-waterfall-chart::before {\n  content: \"\\f316\";\n}\n\n.bp4-icon-waves::before {\n  content: \"\\f317\";\n}\n\n.bp4-icon-widget::before {\n  content: \"\\f31b\";\n}\n\n.bp4-icon-widget-button::before {\n  content: \"\\f318\";\n}\n\n.bp4-icon-widget-footer::before {\n  content: \"\\f319\";\n}\n\n.bp4-icon-widget-header::before {\n  content: \"\\f31a\";\n}\n\n.bp4-icon-wind::before {\n  content: \"\\f31c\";\n}\n\n.bp4-icon-wrench::before {\n  content: \"\\f31d\";\n}\n\n.bp4-icon-zoom-in::before {\n  content: \"\\f31e\";\n}\n\n.bp4-icon-zoom-out::before {\n  content: \"\\f31f\";\n}\n\n.bp4-icon-zoom-to-fit::before {\n  content: \"\\f320\";\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-submenu > .bp4-popover-wrapper {\n  display: block;\n}\n.bp4-submenu .bp4-popover-target {\n  display: block;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item {\n  /* stylelint-disable scss/at-extend-no-missing-placeholder */\n  /* stylelint-enable scss/at-extend-no-missing-placeholder */\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]) {\n  background-color: rgba(143, 153, 168, 0.15);\n  color: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected {\n  background-color: rgba(45, 114, 210, 0.1);\n  color: #215db0;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-submenu-icon {\n  color: #215db0;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.1);\n  color: #1c6e42;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.1);\n  color: #935610;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.1);\n  color: #ac2f33;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected {\n    background-color: highlight;\n  }\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]) {\n  color: inherit;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]) .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]) .bp4-submenu-icon {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected .bp4-submenu-icon {\n  color: #8abbff;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item:not([class*=bp4-intent-]).ns-selected {\n    background-color: highlight;\n  }\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active {\n  background-color: rgba(45, 114, 210, 0.1);\n  color: #215db0;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-menu-item-label, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-menu-item-label, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-submenu-icon {\n  color: #215db0;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.1);\n  color: #1c6e42;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.1);\n  color: #935610;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.1);\n  color: #ac2f33;\n}\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger::before,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active {\n    background-color: highlight;\n  }\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-] .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active .bp4-submenu-icon {\n  color: #8abbff;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-].bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger::before,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-], .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:hover, .bp4-dark .bp4-submenu .bp4-popover-target.bp4-popover-open > .bp4-menu-item[class*=bp4-intent-]:active {\n    background-color: highlight;\n  }\n}\n.bp4-submenu.bp4-popover {\n  box-shadow: none;\n  padding: 0 5px;\n}\n.bp4-submenu.bp4-popover > .bp4-popover-content {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n}\n.bp4-dark .bp4-submenu.bp4-popover, .bp4-submenu.bp4-popover.bp4-dark {\n  box-shadow: none;\n}\n.bp4-dark .bp4-submenu.bp4-popover > .bp4-popover-content, .bp4-submenu.bp4-popover.bp4-dark > .bp4-popover-content {\n  box-shadow: 0 0 0 1px hsl(215, 3%, 38%), inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n}\n\n/*\nMenus\n\nMarkup:\n<ul class=\"bp4-menu {{.modifier}} bp4-elevation-1\">\n  <li>\n    <a class=\"bp4-menu-item bp4-icon-people\" tabindex=\"0\">Share...</a>\n  </li>\n  <li>\n    <a class=\"bp4-menu-item bp4-icon-circle-arrow-right\" tabindex=\"0\">Move...</a>\n  </li>\n  <li>\n    <a class=\"bp4-menu-item bp4-icon-edit\" tabindex=\"0\">Rename</a>\n  </li>\n  <li class=\"bp4-menu-divider\"></li>\n  <li>\n    <a class=\"bp4-menu-item bp4-icon-trash bp4-intent-danger\" tabindex=\"0\">Delete</a>\n  </li>\n</ul>\n\n.bp4-large - Large size (only supported on <code>.bp4-menu</code>)\n\nStyleguide menu\n*/\n.bp4-menu {\n  background: #ffffff;\n  border-radius: 2px;\n  color: #1c2127;\n  list-style: none;\n  margin: 0;\n  min-width: 180px;\n  padding: 5px;\n  text-align: left;\n}\n\n.bp4-menu-divider {\n  border-top: 1px solid rgba(17, 20, 24, 0.15);\n  display: block;\n  margin: 5px;\n}\n.bp4-dark .bp4-menu-divider {\n  border-top-color: rgba(255, 255, 255, 0.2);\n}\n\n.bp4-menu-item {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  border-radius: 2px;\n  color: inherit;\n  line-height: 20px;\n  padding: 5px 7px;\n  text-decoration: none;\n  user-select: none;\n  /* stylelint-disable declaration-no-important */\n  /* stylelint-enable declaration-no-important */\n}\n.bp4-menu-item > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-menu-item > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-menu-item::before,\n.bp4-menu-item > * {\n  margin-right: 7px;\n}\n.bp4-menu-item:empty::before,\n.bp4-menu-item > :last-child {\n  margin-right: 0;\n}\n.bp4-menu-item > .bp4-fill {\n  word-break: break-word;\n}\n.bp4-menu-item .bp4-menu-item-icon {\n  display: flex;\n  flex-direction: column;\n  height: 20px;\n  justify-content: center;\n}\n.bp4-menu-item .bp4-menu-item-label {\n  color: #5f6b7c;\n}\n.bp4-menu-item::before,\n.bp4-menu-item .bp4-menu-item-icon,\n.bp4-menu-item .bp4-submenu-icon {\n  color: #5f6b7c;\n}\n.bp4-menu-item::before,\n.bp4-menu-item .bp4-submenu-icon {\n  margin-top: 2px;\n}\n.bp4-menu-item:hover {\n  background-color: rgba(143, 153, 168, 0.15);\n  color: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n.bp4-menu-item:hover.ns-selected {\n  background-color: rgba(45, 114, 210, 0.1);\n  color: #215db0;\n}\n.bp4-menu-item:hover.ns-selected .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-menu-item:hover.ns-selected::before,\n.bp4-menu-item:hover.ns-selected .bp4-menu-item-icon,\n.bp4-menu-item:hover.ns-selected .bp4-submenu-icon {\n  color: #215db0;\n}\n.bp4-menu-item:hover.ns-selected.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.1);\n  color: #1c6e42;\n}\n.bp4-menu-item:hover.ns-selected.bp4-intent-success::before,\n.bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-menu-item-icon,\n.bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-menu-item:hover.ns-selected.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.1);\n  color: #935610;\n}\n.bp4-menu-item:hover.ns-selected.bp4-intent-warning::before,\n.bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-menu-item:hover.ns-selected.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.1);\n  color: #ac2f33;\n}\n.bp4-menu-item:hover.ns-selected.bp4-intent-danger::before,\n.bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-menu-item:hover.ns-selected {\n    background-color: highlight;\n  }\n}\n.bp4-menu-item:active, .bp4-menu-item.bp4-active {\n  background-color: rgba(143, 153, 168, 0.3);\n}\n.bp4-menu-item:active .bp4-menu-item-label, .bp4-menu-item.bp4-active .bp4-menu-item-label {\n  color: #1c2127;\n}\n.bp4-menu-item.bp4-selected, .bp4-menu-item.bp4-selected:hover, .bp4-menu-item.bp4-selected:active {\n  background-color: rgba(45, 114, 210, 0.1);\n  color: #215db0;\n}\n.bp4-menu-item.bp4-selected .bp4-menu-item-label, .bp4-menu-item.bp4-selected:hover .bp4-menu-item-label, .bp4-menu-item.bp4-selected:active .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-menu-item.bp4-selected::before,\n.bp4-menu-item.bp4-selected .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover::before,\n.bp4-menu-item.bp4-selected:hover .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:hover .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active::before,\n.bp4-menu-item.bp4-selected:active .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:active .bp4-submenu-icon {\n  color: #215db0;\n}\n.bp4-menu-item.bp4-selected.bp4-intent-success, .bp4-menu-item.bp4-selected:hover.bp4-intent-success, .bp4-menu-item.bp4-selected:active.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.1);\n  color: #1c6e42;\n}\n.bp4-menu-item.bp4-selected.bp4-intent-success::before,\n.bp4-menu-item.bp4-selected.bp4-intent-success .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected.bp4-intent-success .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover.bp4-intent-success::before,\n.bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active.bp4-intent-success::before,\n.bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-menu-item.bp4-selected.bp4-intent-warning, .bp4-menu-item.bp4-selected:hover.bp4-intent-warning, .bp4-menu-item.bp4-selected:active.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.1);\n  color: #935610;\n}\n.bp4-menu-item.bp4-selected.bp4-intent-warning::before,\n.bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover.bp4-intent-warning::before,\n.bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active.bp4-intent-warning::before,\n.bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-menu-item.bp4-selected.bp4-intent-danger, .bp4-menu-item.bp4-selected:hover.bp4-intent-danger, .bp4-menu-item.bp4-selected:active.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.1);\n  color: #ac2f33;\n}\n.bp4-menu-item.bp4-selected.bp4-intent-danger::before,\n.bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-submenu-icon, .bp4-menu-item.bp4-selected:hover.bp4-intent-danger::before,\n.bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-menu-item.bp4-selected:active.bp4-intent-danger::before,\n.bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-menu-item.bp4-selected, .bp4-menu-item.bp4-selected:hover, .bp4-menu-item.bp4-selected:active {\n    background-color: highlight;\n  }\n}\n.bp4-menu-item.bp4-disabled {\n  background-color: inherit !important;\n  color: rgba(95, 107, 124, 0.6) !important;\n  cursor: not-allowed !important;\n  outline: none !important;\n}\n.bp4-menu-item.bp4-disabled::before,\n.bp4-menu-item.bp4-disabled .bp4-menu-item-icon,\n.bp4-menu-item.bp4-disabled .bp4-submenu-icon {\n  color: rgba(95, 107, 124, 0.6) !important;\n}\n.bp4-menu-item.bp4-disabled .bp4-menu-item-label {\n  color: rgba(95, 107, 124, 0.6) !important;\n}\n.bp4-menu-item.bp4-intent-primary {\n  color: #215db0;\n}\n.bp4-menu-item.bp4-intent-primary::before,\n.bp4-menu-item.bp4-intent-primary .bp4-menu-item-icon,\n.bp4-menu-item.bp4-intent-primary .bp4-submenu-icon,\n.bp4-menu-item.bp4-intent-primary .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-menu-item.bp4-intent-primary:hover {\n  background-color: rgba(45, 114, 210, 0.1);\n}\n.bp4-menu-item.bp4-intent-primary:active, .bp4-menu-item.bp4-intent-primary.bp4-active {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #184a90;\n}\n.bp4-menu-item.bp4-intent-success {\n  color: #1c6e42;\n}\n.bp4-menu-item.bp4-intent-success::before,\n.bp4-menu-item.bp4-intent-success .bp4-menu-item-icon,\n.bp4-menu-item.bp4-intent-success .bp4-submenu-icon,\n.bp4-menu-item.bp4-intent-success .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-menu-item.bp4-intent-success:hover {\n  background-color: rgba(35, 133, 81, 0.1);\n}\n.bp4-menu-item.bp4-intent-success:active, .bp4-menu-item.bp4-intent-success.bp4-active {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #165a36;\n}\n.bp4-menu-item.bp4-intent-warning {\n  color: #935610;\n}\n.bp4-menu-item.bp4-intent-warning::before,\n.bp4-menu-item.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-menu-item.bp4-intent-warning .bp4-submenu-icon,\n.bp4-menu-item.bp4-intent-warning .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-menu-item.bp4-intent-warning:hover {\n  background-color: rgba(200, 118, 25, 0.1);\n}\n.bp4-menu-item.bp4-intent-warning:active, .bp4-menu-item.bp4-intent-warning.bp4-active {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #77450d;\n}\n.bp4-menu-item.bp4-intent-danger {\n  color: #ac2f33;\n}\n.bp4-menu-item.bp4-intent-danger::before,\n.bp4-menu-item.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-menu-item.bp4-intent-danger .bp4-submenu-icon,\n.bp4-menu-item.bp4-intent-danger .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-menu-item.bp4-intent-danger:hover {\n  background-color: rgba(205, 66, 70, 0.1);\n}\n.bp4-menu-item.bp4-intent-danger:active, .bp4-menu-item.bp4-intent-danger.bp4-active {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #8e292c;\n}\n.bp4-menu-item::before {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  margin-right: 7px;\n}\n.bp4-large .bp4-menu-item {\n  font-size: 16px;\n  line-height: 22px;\n  padding: 9px 7px;\n}\n.bp4-large .bp4-menu-item .bp4-menu-item-icon {\n  height: 22px;\n}\n.bp4-large .bp4-menu-item::before,\n.bp4-large .bp4-menu-item .bp4-submenu-icon {\n  margin-top: 3px;\n}\n.bp4-large .bp4-menu-item::before {\n  font-family: \"blueprint-icons-20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  margin-right: 10px;\n}\n\nbutton.bp4-menu-item {\n  background: none;\n  border: none;\n  text-align: left;\n  width: 100%;\n}\n\n/*\nMenu headers\n\nMarkup:\n<ul class=\"bp4-menu bp4-elevation-1\">\n  <li class=\"bp4-menu-header\"><h6 class=\"bp4-heading\">Layouts</h6></li>\n  <li><button type=\"button\" class=\"bp4-menu-item bp4-icon-layout-auto\">Auto</button></li>\n  <li><button type=\"button\" class=\"bp4-menu-item bp4-icon-layout-circle\">Circle</button></li>\n  <li><button type=\"button\" class=\"bp4-menu-item bp4-icon-layout-grid\">Grid</button></li>\n  <li class=\"bp4-menu-header\"><h6 class=\"bp4-heading\">Views</h6></li>\n  <li><button type=\"button\" class=\"bp4-menu-item bp4-icon-history\">History</button></li>\n  <li><button type=\"button\" class=\"bp4-menu-item bp4-icon-star\">Favorites</button></li>\n  <li><button type=\"button\" class=\"bp4-menu-item bp4-icon-envelope\">Messages</button></li>\n</ul>\n\nStyleguide menu-header\n*/\n.bp4-menu-header {\n  border-top: 1px solid rgba(17, 20, 24, 0.15);\n  display: block;\n  margin: 5px;\n  cursor: default;\n  padding-left: 2px;\n}\n.bp4-dark .bp4-menu-header {\n  border-top-color: rgba(255, 255, 255, 0.2);\n}\n.bp4-menu-header:first-of-type {\n  border-top: none;\n}\n.bp4-menu-header > h6 {\n  color: #1c2127;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  line-height: 17px;\n  margin: 0;\n  padding: 10px 7px 0 1px;\n}\n.bp4-dark .bp4-menu-header > h6 {\n  color: #f6f7f9;\n}\n.bp4-menu-header:first-of-type > h6 {\n  padding-top: 0;\n}\n.bp4-large .bp4-menu-header > h6 {\n  font-size: 18px;\n  padding-bottom: 5px;\n  padding-top: 15px;\n}\n.bp4-large .bp4-menu-header:first-of-type > h6 {\n  padding-top: 0;\n}\n\n.bp4-dark .bp4-menu {\n  background: #2f343c;\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-menu-item {\n  color: inherit;\n  /* stylelint-disable declaration-no-important */\n  /* stylelint-enable declaration-no-important */\n}\n.bp4-dark .bp4-menu-item .bp4-menu-item-label {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-menu-item::before,\n.bp4-dark .bp4-menu-item .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item .bp4-submenu-icon {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-menu-item:hover {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item:hover .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item:hover .bp4-submenu-icon {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected::before,\n.bp4-dark .bp4-menu-item:hover.ns-selected .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item:hover.ns-selected .bp4-submenu-icon {\n  color: #8abbff;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success::before,\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning::before,\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger::before,\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item:hover.ns-selected.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-menu-item:hover.ns-selected {\n    background-color: highlight;\n  }\n}\n.bp4-dark .bp4-menu-item:active .bp4-menu-item-label, .bp4-dark .bp4-menu-item.bp4-active .bp4-menu-item-label {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-menu-item.bp4-selected, .bp4-dark .bp4-menu-item.bp4-selected:hover, .bp4-dark .bp4-menu-item.bp4-selected:active {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-menu-item.bp4-selected::before,\n.bp4-dark .bp4-menu-item.bp4-selected .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover::before,\n.bp4-dark .bp4-menu-item.bp4-selected:hover .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:hover .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active::before,\n.bp4-dark .bp4-menu-item.bp4-selected:active .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:active .bp4-submenu-icon {\n  color: #8abbff;\n}\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success::before,\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success::before,\n.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-success .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success::before,\n.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-success .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning::before,\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning::before,\n.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-warning .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning::before,\n.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-warning .bp4-submenu-icon {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger::before,\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected.bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger::before,\n.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:hover.bp4-intent-danger .bp4-submenu-icon, .bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger::before,\n.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-selected:active.bp4-intent-danger .bp4-submenu-icon {\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-menu-item.bp4-selected, .bp4-dark .bp4-menu-item.bp4-selected:hover, .bp4-dark .bp4-menu-item.bp4-selected:active {\n    background-color: highlight;\n  }\n}\n.bp4-dark .bp4-menu-item.bp4-disabled {\n  color: rgba(171, 179, 191, 0.6) !important;\n}\n.bp4-dark .bp4-menu-item.bp4-disabled::before,\n.bp4-dark .bp4-menu-item.bp4-disabled .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-disabled .bp4-submenu-icon {\n  color: rgba(171, 179, 191, 0.6) !important;\n}\n.bp4-dark .bp4-menu-item.bp4-disabled .bp4-menu-item-label {\n  color: rgba(171, 179, 191, 0.6) !important;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-primary::before,\n.bp4-dark .bp4-menu-item.bp4-intent-primary .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-primary .bp4-submenu-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-primary .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-primary:hover {\n  background-color: rgba(45, 114, 210, 0.2);\n}\n.bp4-dark .bp4-menu-item.bp4-intent-primary:active, .bp4-dark .bp4-menu-item.bp4-intent-primary.bp4-active {\n  background-color: rgba(45, 114, 210, 0.3);\n  color: #99c4ff;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-success::before,\n.bp4-dark .bp4-menu-item.bp4-intent-success .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-success .bp4-submenu-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-success .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-success:hover {\n  background-color: rgba(35, 133, 81, 0.2);\n}\n.bp4-dark .bp4-menu-item.bp4-intent-success:active, .bp4-dark .bp4-menu-item.bp4-intent-success.bp4-active {\n  background-color: rgba(35, 133, 81, 0.3);\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-warning::before,\n.bp4-dark .bp4-menu-item.bp4-intent-warning .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-warning .bp4-submenu-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-warning .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-warning:hover {\n  background-color: rgba(200, 118, 25, 0.2);\n}\n.bp4-dark .bp4-menu-item.bp4-intent-warning:active, .bp4-dark .bp4-menu-item.bp4-intent-warning.bp4-active {\n  background-color: rgba(200, 118, 25, 0.3);\n  color: #f5c186;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-danger {\n  color: #fa999c;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-danger::before,\n.bp4-dark .bp4-menu-item.bp4-intent-danger .bp4-menu-item-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-danger .bp4-submenu-icon,\n.bp4-dark .bp4-menu-item.bp4-intent-danger .bp4-menu-item-label {\n  color: inherit;\n}\n.bp4-dark .bp4-menu-item.bp4-intent-danger:hover {\n  background-color: rgba(205, 66, 70, 0.2);\n}\n.bp4-dark .bp4-menu-item.bp4-intent-danger:active, .bp4-dark .bp4-menu-item.bp4-intent-danger.bp4-active {\n  background-color: rgba(205, 66, 70, 0.3);\n  color: #ffa1a4;\n}\n.bp4-dark .bp4-menu-divider,\n.bp4-dark .bp4-menu-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.bp4-dark .bp4-menu-header > h6 {\n  color: #f6f7f9;\n}\n\n.bp4-label .bp4-menu {\n  margin-top: 5px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nNavbars\n\nMarkup:\n<nav class=\"bp4-navbar {{.modifier}}\">\n  <div class=\"bp4-navbar-group bp4-align-left\">\n    <div class=\"bp4-navbar-heading\">Blueprint</div>\n    <input class=\"bp4-input\" placeholder=\"Search files...\" type=\"text\" />\n  </div>\n  <div class=\"bp4-navbar-group bp4-align-right\">\n    <button class=\"bp4-button bp4-minimal bp4-icon-home\">Home</button>\n    <button class=\"bp4-button bp4-minimal bp4-icon-document\">Files</button>\n    <span class=\"bp4-navbar-divider\"></span>\n    <button class=\"bp4-button bp4-minimal bp4-icon-user\"></button>\n    <button class=\"bp4-button bp4-minimal bp4-icon-notifications\"></button>\n    <button class=\"bp4-button bp4-minimal bp4-icon-cog\"></button>\n  </div>\n</nav>\n\n.bp4-dark - Dark theme\n\nStyleguide navbar\n*/\n.bp4-navbar {\n  background-color: #ffffff;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);\n  height: 50px;\n  padding: 0 15px;\n  position: relative;\n  width: 100%;\n  z-index: 10;\n}\n.bp4-navbar.bp4-dark, .bp4-dark .bp4-navbar {\n  background-color: #383e47;\n}\n.bp4-navbar.bp4-dark {\n  box-shadow: inset inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-navbar {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);\n}\n.bp4-navbar.bp4-fixed-top {\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-navbar {\n    border: 1px solid buttonborder;\n  }\n}\n\n.bp4-navbar-heading {\n  font-size: 16px;\n  margin-right: 15px;\n}\n\n.bp4-navbar-group {\n  align-items: center;\n  display: flex;\n  height: 50px;\n}\n.bp4-navbar-group.bp4-align-left {\n  float: left;\n}\n.bp4-navbar-group.bp4-align-right {\n  float: right;\n}\n\n.bp4-navbar-divider {\n  border-left: 1px solid rgba(17, 20, 24, 0.15);\n  height: 20px;\n  margin: 0 10px;\n}\n.bp4-dark .bp4-navbar-divider {\n  border-left-color: rgba(255, 255, 255, 0.2);\n}\n\n/*\nFixed width\n\nMarkup:\n<nav class=\"bp4-navbar bp4-dark\">\n  <div style=\"margin: 0 auto; width: 480px;\"> <!-- ADD ME -->\n    <div class=\"bp4-navbar-group bp4-align-left\">\n      <div class=\"bp4-navbar-heading\">Blueprint</div>\n    </div>\n    <div class=\"bp4-navbar-group bp4-align-right\">\n      <button class=\"bp4-button bp4-minimal bp4-icon-home\">Home</button>\n      <button class=\"bp4-button bp4-minimal bp4-icon-document\">Files</button>\n      <span class=\"bp4-navbar-divider\"></span>\n      <button class=\"bp4-button bp4-minimal bp4-icon-user\"></button>\n      <button class=\"bp4-button bp4-minimal bp4-icon-notifications\"></button>\n      <button class=\"bp4-button bp4-minimal bp4-icon-cog\"></button>\n    </div>\n  </div>\n</nav>\n\nStyleguide navbar-container\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nNon-ideal state\n\nMarkup:\n<div class=\"bp4-non-ideal-state\">\n  <div class=\"bp4-non-ideal-state-visual\" style=\"font-size: 48px; line-height: 48px;\">\n    <span class=\"bp4-icon bp4-icon-folder-open\"></span>\n  </div>\n  <div class=\"bp4-non-ideal-state-text\">\n    <h4 class=\"bp4-heading\">This folder is empty</h4>\n    <div>Create a new file to populate the folder.</div>\n  </div>\n  <button class=\"bp4-button bp4-intent-primary\">Create</button>\n</div>\n\nStyleguide non-ideal-state\n*/\n.bp4-non-ideal-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #5f6b7c;\n  height: 100%;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n}\n.bp4-non-ideal-state > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-non-ideal-state > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-non-ideal-state::before,\n.bp4-non-ideal-state > * {\n  margin-bottom: 20px;\n}\n.bp4-non-ideal-state:empty::before,\n.bp4-non-ideal-state > :last-child {\n  margin-bottom: 0;\n}\n.bp4-non-ideal-state > * {\n  max-width: 400px;\n}\n.bp4-non-ideal-state .bp4-heading {\n  color: #5f6b7c;\n  line-height: 20px;\n  margin-bottom: 10px;\n}\n.bp4-non-ideal-state .bp4-heading:only-child {\n  margin-bottom: 0;\n}\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal {\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n}\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal::before,\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > * {\n  margin-right: 20px;\n}\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal:empty::before,\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > :last-child {\n  margin-right: 0;\n}\n.bp4-non-ideal-state.bp4-non-ideal-state-horizontal > * {\n  margin-bottom: 0;\n}\n.bp4-dark .bp4-non-ideal-state {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-non-ideal-state .bp4-heading {\n  color: #abb3bf;\n}\n\n.bp4-non-ideal-state-visual {\n  color: #8f99a8;\n}\n.bp4-non-ideal-state-visual .bp4-icon svg {\n  fill-opacity: 15%;\n  overflow: visible;\n}\n.bp4-non-ideal-state-visual .bp4-icon svg path {\n  stroke: #8f99a8;\n  stroke-opacity: 50%;\n  stroke-width: 0.5px;\n}\n.bp4-dark .bp4-non-ideal-state-visual .bp4-icon svg {\n  fill-opacity: 20%;\n}\n\n.bp4-overflow-list {\n  display: flex;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.bp4-overflow-list-spacer {\n  flex-shrink: 1;\n  width: 1px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\nbody.bp4-overlay-open {\n  overflow: hidden;\n}\n\n.bp4-overlay {\n  bottom: 0;\n  left: 0;\n  position: static;\n  right: 0;\n  top: 0;\n  z-index: 20;\n}\n.bp4-overlay:not(.bp4-overlay-open) {\n  pointer-events: none;\n}\n.bp4-overlay.bp4-overlay-container {\n  overflow: hidden;\n  position: fixed;\n}\n.bp4-overlay.bp4-overlay-container.bp4-overlay-inline {\n  position: absolute;\n}\n.bp4-overlay.bp4-overlay-scroll-container {\n  overflow: auto;\n  position: fixed;\n}\n.bp4-overlay.bp4-overlay-scroll-container.bp4-overlay-inline {\n  position: absolute;\n}\n.bp4-overlay.bp4-overlay-inline {\n  display: inline;\n  overflow: visible;\n}\n\n.bp4-overlay-content {\n  position: fixed;\n  z-index: 20;\n}\n.bp4-overlay-inline .bp4-overlay-content, .bp4-overlay-scroll-container .bp4-overlay-content {\n  position: absolute;\n}\n\n.bp4-overlay-backdrop {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  opacity: 1;\n  background-color: rgba(17, 20, 24, 0.7);\n  overflow: auto;\n  user-select: none;\n  z-index: 20;\n}\n.bp4-overlay-backdrop.bp4-overlay-enter, .bp4-overlay-backdrop.bp4-overlay-appear {\n  opacity: 0;\n}\n.bp4-overlay-backdrop.bp4-overlay-enter-active, .bp4-overlay-backdrop.bp4-overlay-appear-active {\n  opacity: 1;\n  transition-delay: 0;\n  transition-duration: 200ms;\n  transition-property: opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-overlay-backdrop.bp4-overlay-exit {\n  opacity: 1;\n}\n.bp4-overlay-backdrop.bp4-overlay-exit-active {\n  opacity: 0;\n  transition-delay: 0;\n  transition-duration: 200ms;\n  transition-property: opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-overlay-backdrop:focus {\n  outline: none;\n}\n.bp4-overlay-inline .bp4-overlay-backdrop {\n  position: absolute;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n.bp4-panel-stack {\n  overflow: hidden;\n  position: relative;\n}\n\n.bp4-panel-stack-header {\n  align-items: center;\n  box-shadow: 0 1px rgba(17, 20, 24, 0.15);\n  display: flex;\n  flex-shrink: 0;\n  height: 30px;\n  z-index: 1;\n}\n.bp4-dark .bp4-panel-stack-header {\n  box-shadow: 0 1px rgba(255, 255, 255, 0.2);\n}\n.bp4-panel-stack-header > span {\n  align-items: stretch;\n  display: flex;\n  flex: 1;\n}\n.bp4-panel-stack-header .bp4-heading {\n  margin: 0 5px;\n}\n\n.bp4-button.bp4-panel-stack-header-back {\n  margin-left: 5px;\n  padding-left: 0;\n  white-space: nowrap;\n}\n.bp4-button.bp4-panel-stack-header-back .bp4-icon {\n  margin: 0 2px;\n}\n\n.bp4-panel-stack-view {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background-color: #ffffff;\n  border-right: 1px solid rgba(17, 20, 24, 0.15);\n  display: flex;\n  flex-direction: column;\n  margin-right: -1px;\n  overflow-y: auto;\n  z-index: 1;\n}\n.bp4-dark .bp4-panel-stack-view {\n  background-color: #383e47;\n}\n.bp4-panel-stack-view:nth-last-child(n+4) {\n  display: none;\n}\n\n.bp4-panel-stack-push .bp4-panel-stack-enter, .bp4-panel-stack-push .bp4-panel-stack-appear {\n  transform: translateX(100%);\n  opacity: 0;\n}\n.bp4-panel-stack-push .bp4-panel-stack-enter-active, .bp4-panel-stack-push .bp4-panel-stack-appear-active {\n  transform: translate(0%);\n  opacity: 1;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n.bp4-panel-stack-push .bp4-panel-stack-exit {\n  transform: translate(0%);\n  opacity: 1;\n}\n.bp4-panel-stack-push .bp4-panel-stack-exit-active {\n  transform: translateX(-50%);\n  opacity: 0;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n\n.bp4-panel-stack-pop .bp4-panel-stack-enter, .bp4-panel-stack-pop .bp4-panel-stack-appear {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.bp4-panel-stack-pop .bp4-panel-stack-enter-active, .bp4-panel-stack-pop .bp4-panel-stack-appear-active {\n  transform: translate(0%);\n  opacity: 1;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n.bp4-panel-stack-pop .bp4-panel-stack-exit {\n  transform: translate(0%);\n  opacity: 1;\n}\n.bp4-panel-stack-pop .bp4-panel-stack-exit-active {\n  transform: translateX(100%);\n  opacity: 0;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n.bp4-panel-stack2 {\n  overflow: hidden;\n  position: relative;\n}\n\n.bp4-panel-stack2-header {\n  align-items: center;\n  box-shadow: 0 1px rgba(17, 20, 24, 0.15);\n  display: flex;\n  flex-shrink: 0;\n  height: 30px;\n  z-index: 1;\n}\n.bp4-dark .bp4-panel-stack2-header {\n  box-shadow: 0 1px rgba(255, 255, 255, 0.2);\n}\n.bp4-panel-stack2-header > span {\n  align-items: stretch;\n  display: flex;\n  flex: 1;\n}\n.bp4-panel-stack2-header .bp4-heading {\n  margin: 0 5px;\n}\n\n.bp4-button.bp4-panel-stack2-header-back {\n  margin-left: 5px;\n  padding-left: 0;\n  white-space: nowrap;\n}\n.bp4-button.bp4-panel-stack2-header-back .bp4-icon {\n  margin: 0 2px;\n}\n\n.bp4-panel-stack2-view {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background-color: #ffffff;\n  border-right: 1px solid rgba(17, 20, 24, 0.15);\n  display: flex;\n  flex-direction: column;\n  margin-right: -1px;\n  overflow-y: auto;\n  z-index: 1;\n}\n.bp4-dark .bp4-panel-stack2-view {\n  background-color: #383e47;\n}\n.bp4-panel-stack2-view:nth-last-child(n+4) {\n  display: none;\n}\n\n.bp4-panel-stack2-push .bp4-panel-stack2-enter, .bp4-panel-stack2-push .bp4-panel-stack2-appear {\n  transform: translateX(100%);\n  opacity: 0;\n}\n.bp4-panel-stack2-push .bp4-panel-stack2-enter-active, .bp4-panel-stack2-push .bp4-panel-stack2-appear-active {\n  transform: translate(0%);\n  opacity: 1;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n.bp4-panel-stack2-push .bp4-panel-stack2-exit {\n  transform: translate(0%);\n  opacity: 1;\n}\n.bp4-panel-stack2-push .bp4-panel-stack2-exit-active {\n  transform: translateX(-50%);\n  opacity: 0;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n\n.bp4-panel-stack2-pop .bp4-panel-stack2-enter, .bp4-panel-stack2-pop .bp4-panel-stack2-appear {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.bp4-panel-stack2-pop .bp4-panel-stack2-enter-active, .bp4-panel-stack2-pop .bp4-panel-stack2-appear-active {\n  transform: translate(0%);\n  opacity: 1;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n.bp4-panel-stack2-pop .bp4-panel-stack2-exit {\n  transform: translate(0%);\n  opacity: 1;\n}\n.bp4-panel-stack2-pop .bp4-panel-stack2-exit-active {\n  transform: translateX(100%);\n  opacity: 0;\n  transition-delay: 0;\n  transition-duration: 400ms;\n  transition-property: transform, opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: ease;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n.bp4-popover {\n  /* stylelint-disable-next-line max-line-length */\n  /* stylelint-disable-next-line max-line-length */\n  /* stylelint-disable-next-line max-line-length */\n  /* stylelint-disable-next-line max-line-length */\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n  transform: scale(1);\n  border-radius: 2px;\n  display: inline-block;\n  z-index: 20;\n}\n.bp4-popover .bp4-popover-arrow {\n  height: 30px;\n  position: absolute;\n  width: 30px;\n}\n.bp4-popover .bp4-popover-arrow::before {\n  height: 20px;\n  margin: 5px;\n  width: 20px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-popover {\n  margin-bottom: 17px;\n  margin-top: -17px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-popover > .bp4-popover-arrow {\n  bottom: -11px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-popover > .bp4-popover-arrow svg {\n  transform: rotate(-90deg);\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-popover {\n  margin-left: 17px;\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-popover > .bp4-popover-arrow {\n  left: -11px;\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-popover > .bp4-popover-arrow svg {\n  transform: rotate(0);\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-popover {\n  margin-top: 17px;\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-popover > .bp4-popover-arrow {\n  top: -11px;\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-popover > .bp4-popover-arrow svg {\n  transform: rotate(90deg);\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-popover {\n  margin-left: -17px;\n  margin-right: 17px;\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-popover > .bp4-popover-arrow {\n  right: -11px;\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-popover > .bp4-popover-arrow svg {\n  transform: rotate(180deg);\n}\n.bp4-tether-element-attached-middle > .bp4-popover > .bp4-popover-arrow {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.bp4-tether-element-attached-center > .bp4-popover > .bp4-popover-arrow {\n  right: 50%;\n  transform: translateX(50%);\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-top > .bp4-popover > .bp4-popover-arrow {\n  top: -0.3933982644px;\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-right > .bp4-popover > .bp4-popover-arrow {\n  right: -0.3933982644px;\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-left > .bp4-popover > .bp4-popover-arrow {\n  left: -0.3933982644px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-bottom > .bp4-popover > .bp4-popover-arrow {\n  bottom: -0.3933982644px;\n}\n.bp4-tether-element-attached-top.bp4-tether-element-attached-left > .bp4-popover {\n  transform-origin: top left;\n}\n.bp4-tether-element-attached-top.bp4-tether-element-attached-center > .bp4-popover {\n  transform-origin: top center;\n}\n.bp4-tether-element-attached-top.bp4-tether-element-attached-right > .bp4-popover {\n  transform-origin: top right;\n}\n.bp4-tether-element-attached-middle.bp4-tether-element-attached-left > .bp4-popover {\n  transform-origin: center left;\n}\n.bp4-tether-element-attached-middle.bp4-tether-element-attached-center > .bp4-popover {\n  transform-origin: center center;\n}\n.bp4-tether-element-attached-middle.bp4-tether-element-attached-right > .bp4-popover {\n  transform-origin: center right;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-element-attached-left > .bp4-popover {\n  transform-origin: bottom left;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-element-attached-center > .bp4-popover {\n  transform-origin: bottom center;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-element-attached-right > .bp4-popover {\n  transform-origin: bottom right;\n}\n.bp4-popover .bp4-popover-content {\n  background: #ffffff;\n}\n.bp4-popover .bp4-popover-content,\n.bp4-popover .bp4-heading {\n  color: inherit;\n}\n.bp4-popover .bp4-popover-arrow::before {\n  box-shadow: 1px 1px 6px rgba(17, 20, 24, 0.2);\n}\n.bp4-popover .bp4-popover-arrow-border {\n  fill: #111418;\n  fill-opacity: 0.1;\n}\n.bp4-popover .bp4-popover-arrow-fill {\n  fill: #ffffff;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-popover .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n.bp4-popover-enter > .bp4-popover, .bp4-popover-appear > .bp4-popover {\n  transform: scale(0.3);\n}\n.bp4-popover-enter-active > .bp4-popover, .bp4-popover-appear-active > .bp4-popover {\n  transform: scale(1);\n  transition-delay: 0;\n  transition-duration: 300ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n}\n.bp4-popover-exit > .bp4-popover {\n  transform: scale(1);\n}\n.bp4-popover-exit-active > .bp4-popover {\n  transform: scale(0.3);\n  transition-delay: 0;\n  transition-duration: 300ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n}\n.bp4-popover .bp4-popover-content {\n  border-radius: 2px;\n  position: relative;\n}\n.bp4-popover.bp4-popover-content-sizing .bp4-popover-content {\n  max-width: 350px;\n  padding: 20px;\n}\n.bp4-popover-target + .bp4-overlay .bp4-popover.bp4-popover-content-sizing {\n  width: 350px;\n}\n.bp4-popover.bp4-minimal {\n  margin: 0 !important; /* stylelint-disable-line declaration-no-important */\n}\n.bp4-popover.bp4-minimal .bp4-popover-arrow {\n  display: none;\n}\n.bp4-popover.bp4-minimal.bp4-popover {\n  transform: scale(1);\n}\n.bp4-popover-enter > .bp4-popover.bp4-minimal.bp4-popover, .bp4-popover-appear > .bp4-popover.bp4-minimal.bp4-popover {\n  transform: scale(1);\n}\n.bp4-popover-enter-active > .bp4-popover.bp4-minimal.bp4-popover, .bp4-popover-appear-active > .bp4-popover.bp4-minimal.bp4-popover {\n  transform: scale(1);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-popover-exit > .bp4-popover.bp4-minimal.bp4-popover {\n  transform: scale(1);\n}\n.bp4-popover-exit-active > .bp4-popover.bp4-minimal.bp4-popover {\n  transform: scale(1);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-popover.bp4-dark, .bp4-dark .bp4-popover {\n  box-shadow: 0 0 0 1px hsl(215, 3%, 38%), inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n}\n.bp4-popover.bp4-dark .bp4-popover-content, .bp4-dark .bp4-popover .bp4-popover-content {\n  background: #2f343c;\n}\n.bp4-popover.bp4-dark .bp4-popover-content,\n.bp4-popover.bp4-dark .bp4-heading, .bp4-dark .bp4-popover .bp4-popover-content,\n.bp4-dark .bp4-popover .bp4-heading {\n  color: inherit;\n}\n.bp4-popover.bp4-dark .bp4-popover-arrow::before, .bp4-dark .bp4-popover .bp4-popover-arrow::before {\n  box-shadow: 0 0 0 1px #777a7e, 1px 1px 6px rgba(17, 20, 24, 0.4);\n}\n.bp4-popover.bp4-dark .bp4-popover-arrow-border, .bp4-dark .bp4-popover .bp4-popover-arrow-border {\n  fill: #111418;\n  fill-opacity: 0.2;\n}\n.bp4-popover.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-popover .bp4-popover-arrow-fill {\n  fill: #2f343c;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-popover.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-popover .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-popover {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n\n.bp4-popover-arrow::before {\n  border-radius: 1px;\n  content: \"\";\n  display: block;\n  position: absolute;\n  transform: rotate(45deg);\n}\n\n.bp4-tether-pinned .bp4-popover-arrow {\n  display: none;\n}\n\n.bp4-popover-backdrop {\n  background: rgba(255, 255, 255, 0);\n}\n\n.bp4-transition-container {\n  opacity: 1;\n  display: flex;\n  z-index: 20;\n}\n.bp4-transition-container.bp4-popover-enter, .bp4-transition-container.bp4-popover-appear {\n  opacity: 0;\n}\n.bp4-transition-container.bp4-popover-enter-active, .bp4-transition-container.bp4-popover-appear-active {\n  opacity: 1;\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-transition-container.bp4-popover-exit {\n  opacity: 1;\n}\n.bp4-transition-container.bp4-popover-exit-active {\n  opacity: 0;\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: opacity;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-transition-container:focus {\n  outline: none;\n}\n.bp4-transition-container.bp4-popover-leave .bp4-popover-content {\n  pointer-events: none;\n}\n.bp4-transition-container[data-x-out-of-boundaries] {\n  display: none;\n}\n\nspan.bp4-popover-target {\n  display: inline-block;\n}\n\n.bp4-popover-wrapper.bp4-fill {\n  width: 100%;\n}\n\n.bp4-portal {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nProgress bars\n\nMarkup:\n<div class=\"bp4-progress-bar {{.modifier}}\">\n  <div class=\"bp4-progress-meter\" style=\"width: 25%\"></div>\n</div>\n<div class=\"bp4-progress-bar bp4-intent-primary {{.modifier}}\">\n  <div class=\"bp4-progress-meter\" style=\"width: 50%\"></div>\n</div>\n<div class=\"bp4-progress-bar bp4-intent-success {{.modifier}}\">\n  <div class=\"bp4-progress-meter\" style=\"width: 75%\"></div>\n</div>\n<div class=\"bp4-progress-bar bp4-intent-danger {{.modifier}}\">\n  <div class=\"bp4-progress-meter\" style=\"width: 100%\"></div>\n</div>\n\n.bp4-no-stripes   - No stripes\n.bp4-no-animation - No animation\n\nStyleguide progress-bar\n*/\n@keyframes linear-progress-bar-stripes {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 30px 0;\n  }\n}\n.bp4-progress-bar {\n  background: rgba(95, 107, 124, 0.2);\n  border-radius: 40px;\n  display: block;\n  height: 8px;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.bp4-progress-bar .bp4-progress-meter {\n  background: linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%);\n  background-color: rgba(95, 107, 124, 0.8);\n  background-size: 30px 30px;\n  border-radius: 40px;\n  height: 100%;\n  position: absolute;\n  transition: width 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n  width: 100%;\n}\n.bp4-progress-bar:not(.bp4-no-animation):not(.bp4-no-stripes) .bp4-progress-meter {\n  animation: linear-progress-bar-stripes 300ms linear infinite reverse;\n}\n.bp4-progress-bar.bp4-no-stripes .bp4-progress-meter {\n  background-image: none;\n}\n\n.bp4-dark .bp4-progress-bar {\n  background: rgba(17, 20, 24, 0.5);\n}\n.bp4-dark .bp4-progress-bar .bp4-progress-meter {\n  background-color: #8f99a8;\n}\n\n.bp4-progress-bar.bp4-intent-primary .bp4-progress-meter {\n  background-color: #2d72d2;\n}\n\n.bp4-progress-bar.bp4-intent-success .bp4-progress-meter {\n  background-color: #238551;\n}\n\n.bp4-progress-bar.bp4-intent-warning .bp4-progress-meter {\n  background-color: #c87619;\n}\n\n.bp4-progress-bar.bp4-intent-danger .bp4-progress-meter {\n  background-color: #cd4246;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nSkeletons\n\nMarkup:\n<div class=\"bp4-card\">\n  <h5 class=\"bp4-heading\"><a class=\"{{.modifier}}\" href=\"#\" tabindex=\"-1\">Card heading</a></h5>\n  <p class=\"{{.modifier}}\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eget tortor felis.\n    Fusce dapibus metus in dapibus mollis. Quisque eget ex diam.\n  </p>\n  <button type=\"button\" class=\"bp4-button bp4-icon-add {{.modifier}}\" tabindex=\"-1\">Submit</button>\n</div>\n\n.bp4-skeleton - Render this element as a skeleton, an outline of its true self.\n\nStyleguide skeleton\n*/\n@keyframes skeleton-glow {\n  from {\n    background: rgba(211, 216, 222, 0.2);\n    border-color: rgba(211, 216, 222, 0.2);\n  }\n  to {\n    background: rgba(95, 107, 124, 0.2);\n    border-color: rgba(95, 107, 124, 0.2);\n  }\n}\n/* stylelint-disable declaration-no-important */\n.bp4-skeleton {\n  animation: 1000ms linear infinite alternate skeleton-glow;\n  background: rgba(211, 216, 222, 0.2);\n  background-clip: padding-box !important;\n  border-color: rgba(211, 216, 222, 0.2) !important;\n  border-radius: 2px;\n  box-shadow: none !important;\n  color: transparent !important;\n  cursor: default;\n  pointer-events: none;\n  user-select: none;\n}\n.bp4-skeleton::before, .bp4-skeleton::after,\n.bp4-skeleton * {\n  visibility: hidden !important;\n}\n\n/* stylelint-enable declaration-no-important */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n.bp4-slider {\n  height: 40px;\n  min-width: 150px;\n  width: 100%;\n  cursor: default;\n  outline: none;\n  position: relative;\n  user-select: none;\n}\n.bp4-slider:hover {\n  cursor: pointer;\n}\n.bp4-slider:active {\n  cursor: grabbing;\n}\n.bp4-slider.bp4-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.bp4-slider.bp4-slider-unlabeled {\n  height: 16px;\n}\n\n.bp4-slider-track,\n.bp4-slider-progress {\n  height: 6px;\n  left: 0;\n  right: 0;\n  top: 5px;\n  position: absolute;\n}\n\n.bp4-slider-track {\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.bp4-slider-progress {\n  background: rgba(95, 107, 124, 0.2);\n}\n.bp4-dark .bp4-slider-progress {\n  background: rgba(17, 20, 24, 0.5);\n}\n.bp4-slider-progress.bp4-intent-primary {\n  background-color: #2d72d2;\n}\n.bp4-slider-progress.bp4-intent-success {\n  background-color: #238551;\n}\n.bp4-slider-progress.bp4-intent-warning {\n  background-color: #c87619;\n}\n.bp4-slider-progress.bp4-intent-danger {\n  background-color: #cd4246;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-slider-progress {\n    background: ButtonText;\n  }\n}\n\n.bp4-slider-handle {\n  background-color: #f6f7f9;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.1);\n  color: #1c2127;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.5), 0 1px 1px rgba(17, 20, 24, 0.5);\n  cursor: pointer;\n  height: 16px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 16px;\n}\n.bp4-slider-handle:hover {\n  background-clip: padding-box;\n  background-color: #edeff2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-slider-handle:active, .bp4-slider-handle.bp4-active {\n  background-color: #dce0e5;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-slider-handle:active, .bp4-slider-handle.bp4-active {\n    background: highlight;\n  }\n}\n.bp4-slider-handle:disabled, .bp4-slider-handle.bp4-disabled {\n  background-color: rgba(211, 216, 222, 0.5);\n  box-shadow: none;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n  outline: none;\n}\n.bp4-slider-handle:disabled.bp4-active, .bp4-slider-handle:disabled.bp4-active:hover, .bp4-slider-handle.bp4-disabled.bp4-active, .bp4-slider-handle.bp4-disabled.bp4-active:hover {\n  background: rgba(211, 216, 222, 0.7);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-slider-handle {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-slider-handle:focus {\n  z-index: 1;\n}\n.bp4-slider-handle:hover {\n  background-clip: padding-box;\n  background-color: #edeff2;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.5), 0 1px 2px rgba(17, 20, 24, 0.6);\n  cursor: grab;\n  z-index: 2;\n}\n.bp4-slider-handle.bp4-active {\n  background-color: #dce0e5;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 1px 2px rgba(17, 20, 24, 0.2);\n  box-shadow: inset 0 1px 1px rgba(17, 20, 24, 0.1), 0 0 0 1px rgba(17, 20, 24, 0.5), 0 1px 2px rgba(17, 20, 24, 0.2);\n  cursor: grabbing;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-slider-handle.bp4-active {\n    background: highlight;\n  }\n}\n.bp4-disabled .bp4-slider-handle {\n  background: #c5cbd3;\n  box-shadow: none;\n  pointer-events: none;\n}\n.bp4-dark .bp4-slider-handle {\n  background-color: #abb3bf;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2);\n}\n.bp4-dark .bp4-slider-handle:hover {\n  background-color: #8f99a8;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-slider-handle.bp4-active {\n  background-color: #738091;\n  box-shadow: inset 0 1px 1px rgba(17, 20, 24, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.4);\n}\n.bp4-dark .bp4-disabled .bp4-slider-handle {\n  background: #5f6b7c;\n  border-color: #5f6b7c;\n  box-shadow: none;\n}\n.bp4-slider-handle .bp4-slider-label {\n  background: #404854;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n  color: #f6f7f9;\n  margin-left: 8px;\n}\n.bp4-dark .bp4-slider-handle .bp4-slider-label {\n  background: #e5e8eb;\n  box-shadow: 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n  color: #404854;\n}\n.bp4-disabled .bp4-slider-handle .bp4-slider-label {\n  box-shadow: none;\n}\n.bp4-slider-handle.bp4-start, .bp4-slider-handle.bp4-end {\n  width: 8px;\n}\n.bp4-slider-handle.bp4-start {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.bp4-slider-handle.bp4-end {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  margin-left: 8px;\n}\n.bp4-slider-handle.bp4-end .bp4-slider-label {\n  margin-left: 0;\n}\n\n.bp4-slider-label {\n  transform: translate(-50%, 20px);\n  display: inline-block;\n  font-size: 12px;\n  line-height: 1;\n  padding: 2px 5px;\n  position: absolute;\n  vertical-align: top;\n}\n\n.bp4-slider.bp4-vertical {\n  height: 150px;\n  min-width: 40px;\n  width: 40px;\n}\n.bp4-slider.bp4-vertical .bp4-slider-track,\n.bp4-slider.bp4-vertical .bp4-slider-progress {\n  bottom: 0;\n  height: auto;\n  left: 5px;\n  top: 0;\n  width: 6px;\n}\n.bp4-slider.bp4-vertical .bp4-slider-progress {\n  top: auto;\n}\n.bp4-slider.bp4-vertical .bp4-slider-label {\n  transform: translate(20px, 50%);\n}\n.bp4-slider.bp4-vertical .bp4-slider-handle {\n  top: auto;\n}\n.bp4-slider.bp4-vertical .bp4-slider-handle .bp4-slider-label {\n  margin-left: 0;\n  margin-top: -8px;\n}\n.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-end, .bp4-slider.bp4-vertical .bp4-slider-handle.bp4-start {\n  height: 8px;\n  margin-left: 0;\n  width: 16px;\n}\n.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-start {\n  border-bottom-right-radius: 2px;\n  border-top-left-radius: 0;\n}\n.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-start .bp4-slider-label {\n  transform: translate(20px);\n}\n.bp4-slider.bp4-vertical .bp4-slider-handle.bp4-end {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 2px;\n  margin-bottom: 8px;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n@keyframes pt-spinner-animation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.bp4-spinner {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  overflow: visible;\n  vertical-align: middle;\n}\n.bp4-spinner svg {\n  display: block;\n}\n.bp4-spinner path {\n  fill-opacity: 0%;\n}\n.bp4-spinner .bp4-spinner-head {\n  stroke: rgba(95, 107, 124, 0.8);\n  stroke-linecap: round;\n  transform-origin: center;\n  transition: stroke-dashoffset 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-spinner .bp4-spinner-track {\n  stroke: rgba(95, 107, 124, 0.2);\n}\n\n.bp4-spinner-animation {\n  animation: pt-spinner-animation 500ms linear infinite;\n}\n.bp4-no-spin > .bp4-spinner-animation {\n  animation: none;\n}\n\n.bp4-dark .bp4-spinner .bp4-spinner-head {\n  stroke: #8f99a8;\n}\n.bp4-dark .bp4-spinner .bp4-spinner-track {\n  stroke: rgba(17, 20, 24, 0.5);\n}\n\n.bp4-spinner.bp4-intent-primary .bp4-spinner-head {\n  stroke: #2d72d2;\n}\n\n.bp4-spinner.bp4-intent-success .bp4-spinner-head {\n  stroke: #238551;\n}\n\n.bp4-spinner.bp4-intent-warning .bp4-spinner-head {\n  stroke: #c87619;\n}\n\n.bp4-spinner.bp4-intent-danger .bp4-spinner-head {\n  stroke: #cd4246;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nTabs\n\nMarkup:\n<div class=\"bp4-tabs\">\n    <ul class=\"bp4-tab-list {{.modifier}}\" role=\"tablist\">\n        <li class=\"bp4-tab\" role=\"tab\" aria-selected=\"true\">Selected tab</li>\n        <li class=\"bp4-tab\" role=\"tab\">Another tab</li>\n        <li class=\"bp4-tab\" role=\"tab\" aria-disabled=\"true\">Disabled tab</li>\n    </ul>\n    <div class=\"bp4-tab-panel\" role=\"tabpanel\">Selected panel</div>\n    <div class=\"bp4-tab-panel\" role=\"tabpanel\" aria-hidden=\"true\">Another panel</div>\n    <div class=\"bp4-tab-panel\" role=\"tabpanel\" aria-hidden=\"true\">Disabled panel</div>\n</div>\n\n.bp4-large - Large tabs\n\nStyleguide tabs\n*/\n.bp4-tabs:not(.bp4-vertical).bp4-fill {\n  height: 100%;\n}\n.bp4-tabs:not(.bp4-vertical).bp4-fill .bp4-tab-list {\n  height: 100%;\n}\n\n.bp4-tabs.bp4-vertical {\n  display: flex;\n}\n.bp4-tabs.bp4-vertical > .bp4-tab-list {\n  align-items: flex-start;\n  flex-direction: column;\n}\n.bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab {\n  align-items: center;\n  border-radius: 2px;\n  display: flex;\n  padding: 0 10px;\n  width: 100%;\n}\n.bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab[aria-selected=true] {\n  background-color: rgba(45, 114, 210, 0.2);\n  box-shadow: none;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab[aria-selected=true] {\n    background-color: highlight;\n    color: #111418;\n  }\n}\n.bp4-tabs.bp4-vertical > .bp4-tab-list .bp4-tab-indicator-wrapper .bp4-tab-indicator {\n  background-color: rgba(45, 114, 210, 0.2);\n  border-radius: 2px;\n  bottom: 0;\n  height: auto;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n.bp4-tabs.bp4-vertical > .bp4-tab-panel {\n  margin-top: 0;\n  padding-left: 20px;\n}\n\n.bp4-tab-list {\n  align-items: flex-end;\n  border: none;\n  display: flex;\n  flex: 0 0 auto;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  /* stylelint-disable-next-line selector-no-universal */\n}\n.bp4-tab-list > *:not(:last-child) {\n  margin-right: 20px;\n}\n\n.bp4-tab {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  align-items: center;\n  align-self: stretch;\n  color: #1c2127;\n  cursor: pointer;\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  line-height: 30px;\n  max-width: 100%;\n  position: relative;\n  vertical-align: top;\n}\n.bp4-tab a {\n  color: inherit;\n  display: block;\n  text-decoration: none;\n}\n.bp4-tab-indicator-wrapper ~ .bp4-tab {\n  /* stylelint-disable declaration-no-important */\n  background-color: transparent !important;\n  box-shadow: none !important;\n  /* stylelint-enable declaration-no-important */\n}\n.bp4-tab[aria-disabled=true] {\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tab[aria-disabled=true] {\n    color: graytext;\n  }\n}\n.bp4-tab[aria-selected=true] {\n  border-radius: 0;\n  box-shadow: inset 0 -3px 0 #215db0;\n}\n.bp4-tab[aria-selected=true], .bp4-tab:not([aria-disabled=true]):hover {\n  color: #215db0;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tab[aria-selected=true], .bp4-tab:not([aria-disabled=true]):hover {\n    color: highlight;\n  }\n}\n.bp4-tab:focus {\n  -moz-outline-radius: 0;\n}\n.bp4-large > .bp4-tab {\n  font-size: 16px;\n  line-height: 40px;\n}\n\n.bp4-tab-panel {\n  margin-top: 20px;\n}\n.bp4-tab-panel[aria-hidden=true] {\n  display: none;\n}\n\n.bp4-tab-icon {\n  margin-right: 7px;\n}\n\n.bp4-tab-tag {\n  margin-left: 7px;\n}\n\n.bp4-tab-indicator-wrapper {\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  transform: translateX(0), translateY(0);\n  transition: height, transform, width;\n  transition-duration: 200ms;\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-tab-indicator-wrapper .bp4-tab-indicator {\n  background-color: #215db0;\n  bottom: 0;\n  height: 3px;\n  left: 0;\n  position: absolute;\n  right: 0;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tab-indicator-wrapper .bp4-tab-indicator {\n    background-color: highlight;\n  }\n}\n.bp4-tab-indicator-wrapper.bp4-no-animation {\n  transition: none;\n}\n.bp4-tabs:not(.bp4-vertical) .bp4-tab-indicator-wrapper {\n  height: 100%;\n}\n\n.bp4-dark .bp4-tab {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-tab[aria-disabled=true] {\n  color: rgba(171, 179, 191, 0.6);\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-tab[aria-disabled=true] {\n    color: graytext;\n  }\n}\n.bp4-dark .bp4-tab[aria-selected=true] {\n  box-shadow: inset 0 -3px 0 #8abbff;\n}\n.bp4-dark .bp4-tab[aria-selected=true], .bp4-dark .bp4-tab:not([aria-disabled=true]):hover {\n  color: #8abbff;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-tab[aria-selected=true], .bp4-dark .bp4-tab:not([aria-disabled=true]):hover {\n    color: highlight;\n  }\n}\n.bp4-dark .bp4-tab-indicator {\n  background-color: #8abbff;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-dark .bp4-tab-indicator {\n    background-color: highlight;\n  }\n}\n\n.bp4-flex-expander {\n  flex: 1 1;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nTags\n\nMarkup:\n<span class=\"bp4-tag {{.modifier}}\">125</span>\n<span class=\"bp4-tag {{.modifier}}\">Done</span>\n<span class=\"bp4-tag {{.modifier}}\">\n  Tracking\n  <button class=\"bp4-tag-remove\"></button>\n</span>\n<span class=\"bp4-tag {{.modifier}}\">\n  Crushed\n  <button class=\"bp4-tag-remove\"></button>\n</span>\n<span class=\"bp4-tag {{.modifier}}\">\n  A rather long string of text that wraps to multiple lines\n  demonstrates the position of the remove button.\n  <button class=\"bp4-tag-remove\"></button>\n</span>\n\n.bp4-large - Large\n.bp4-minimal - Minimal appearance\n.bp4-round - Rounded corners, ideal for badges\n.bp4-interactive - Hover and active effects\n.bp4-intent-primary - Primary intent\n.bp4-intent-success - Success intent\n.bp4-intent-warning - Warning intent\n.bp4-intent-danger  - Danger intent\n\nStyleguide tag\n*/\n.bp4-tag {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: #5f6b7c;\n  border: none;\n  border-radius: 2px;\n  box-shadow: none;\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 16px;\n  max-width: 100%;\n  min-height: 20px;\n  min-width: 20px;\n  padding: 2px 6px;\n  position: relative;\n}\n.bp4-tag > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-tag > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-tag::before,\n.bp4-tag > * {\n  margin-right: 4px;\n}\n.bp4-tag:empty::before,\n.bp4-tag > :last-child {\n  margin-right: 0;\n}\n.bp4-tag:focus {\n  outline: rgba(45, 114, 210, 0.6) solid 2px;\n  outline-offset: 0;\n  -moz-outline-radius: 6px;\n}\n.bp4-tag.bp4-interactive {\n  cursor: pointer;\n}\n.bp4-tag.bp4-interactive:hover {\n  background: #404854;\n}\n.bp4-tag.bp4-interactive:active, .bp4-tag.bp4-interactive.bp4-active {\n  background: #383e47;\n}\n.bp4-tag.bp4-round {\n  border-radius: 30px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.bp4-dark .bp4-tag {\n  background-color: #c5cbd3;\n  color: #1c2127;\n}\n.bp4-dark .bp4-tag > .bp4-icon, .bp4-dark .bp4-tag .bp4-icon-standard, .bp4-dark .bp4-tag .bp4-icon-large {\n  fill: currentcolor;\n}\n.bp4-dark .bp4-tag.bp4-interactive:hover {\n  background: #abb3bf;\n}\n.bp4-dark .bp4-tag.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-interactive.bp4-active {\n  background: #8f99a8;\n}\n.bp4-tag > .bp4-icon, .bp4-tag .bp4-icon-standard, .bp4-tag .bp4-icon-large {\n  fill: #ffffff;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tag {\n    border: 1px solid buttonborder;\n  }\n}\n.bp4-tag.bp4-large, .bp4-large .bp4-tag {\n  font-size: 14px;\n  line-height: 20px;\n  min-height: 30px;\n  min-width: 30px;\n  padding: 5px 10px;\n}\n.bp4-tag.bp4-large::before,\n.bp4-tag.bp4-large > *, .bp4-large .bp4-tag::before,\n.bp4-large .bp4-tag > * {\n  margin-right: 7px;\n}\n.bp4-tag.bp4-large:empty::before,\n.bp4-tag.bp4-large > :last-child, .bp4-large .bp4-tag:empty::before,\n.bp4-large .bp4-tag > :last-child {\n  margin-right: 0;\n}\n.bp4-tag.bp4-large.bp4-round, .bp4-large .bp4-tag.bp4-round {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.bp4-tag.bp4-intent-primary {\n  background: #2d72d2;\n  color: #ffffff;\n}\n.bp4-tag.bp4-intent-primary.bp4-interactive:hover {\n  background-color: #215db0;\n}\n.bp4-tag.bp4-intent-primary.bp4-interactive:active, .bp4-tag.bp4-intent-primary.bp4-interactive.bp4-active {\n  background-color: #184a90;\n}\n.bp4-tag.bp4-intent-primary .bp4-tag-remove {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-tag.bp4-intent-primary .bp4-tag-remove:hover, .bp4-tag.bp4-intent-primary .bp4-tag-remove:active {\n  color: #ffffff;\n}\n.bp4-tag.bp4-intent-success {\n  background: #238551;\n  color: #ffffff;\n}\n.bp4-tag.bp4-intent-success.bp4-interactive:hover {\n  background-color: #1c6e42;\n}\n.bp4-tag.bp4-intent-success.bp4-interactive:active, .bp4-tag.bp4-intent-success.bp4-interactive.bp4-active {\n  background-color: #165a36;\n}\n.bp4-tag.bp4-intent-success .bp4-tag-remove {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-tag.bp4-intent-success .bp4-tag-remove:hover, .bp4-tag.bp4-intent-success .bp4-tag-remove:active {\n  color: #ffffff;\n}\n.bp4-tag.bp4-intent-warning {\n  background: #fbb360;\n  color: #1c2127;\n}\n.bp4-tag.bp4-intent-warning.bp4-interactive:hover {\n  background-color: #ec9a3c;\n}\n.bp4-tag.bp4-intent-warning.bp4-interactive:active, .bp4-tag.bp4-intent-warning.bp4-interactive.bp4-active {\n  background-color: #c87619;\n}\n.bp4-tag.bp4-intent-warning .bp4-tag-remove {\n  color: rgba(28, 33, 39, 0.7);\n}\n.bp4-tag.bp4-intent-warning .bp4-tag-remove:hover, .bp4-tag.bp4-intent-warning .bp4-tag-remove:active {\n  color: #1c2127;\n}\n.bp4-tag.bp4-intent-danger {\n  background: #cd4246;\n  color: #ffffff;\n}\n.bp4-tag.bp4-intent-danger.bp4-interactive:hover {\n  background-color: #ac2f33;\n}\n.bp4-tag.bp4-intent-danger.bp4-interactive:active, .bp4-tag.bp4-intent-danger.bp4-interactive.bp4-active {\n  background-color: #8e292c;\n}\n.bp4-tag.bp4-intent-danger .bp4-tag-remove {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-tag.bp4-intent-danger .bp4-tag-remove:hover, .bp4-tag.bp4-intent-danger .bp4-tag-remove:active {\n  color: #ffffff;\n}\n.bp4-tag.bp4-fill {\n  display: flex;\n  width: 100%;\n}\n.bp4-tag.bp4-minimal > .bp4-icon, .bp4-tag.bp4-minimal .bp4-icon-standard, .bp4-tag.bp4-minimal .bp4-icon-large {\n  fill: #5f6b7c;\n}\n.bp4-tag.bp4-minimal:not([class*=bp4-intent-]) {\n  background-color: rgba(143, 153, 168, 0.15);\n  color: #1c2127;\n}\n.bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive {\n  cursor: pointer;\n}\n.bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:hover {\n  background-color: rgba(143, 153, 168, 0.3);\n  color: #111418;\n}\n.bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive.bp4-active, .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:active {\n  background-color: rgba(143, 153, 168, 0.35);\n  color: #111418;\n}\n.bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove {\n  color: #5f6b7c;\n}\n.bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:hover, .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:active {\n  color: #404854;\n}\n.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) {\n  background-color: rgba(143, 153, 168, 0.15);\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive {\n  cursor: pointer;\n}\n.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:hover {\n  background-color: rgba(143, 153, 168, 0.3);\n  color: #ffffff;\n}\n.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive.bp4-active, .bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]).bp4-interactive:active {\n  background-color: rgba(143, 153, 168, 0.35);\n  color: #ffffff;\n}\n.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal:not([class*=bp4-intent-]) .bp4-tag-remove:active {\n  color: #d3d8de;\n}\n.bp4-tag.bp4-minimal.bp4-intent-primary {\n  background-color: rgba(45, 114, 210, 0.1);\n  color: #215db0;\n}\n.bp4-tag.bp4-minimal.bp4-intent-primary > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-icon-large {\n  fill: #215db0;\n}\n.bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:hover {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #184a90;\n}\n.bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive.bp4-active {\n  background-color: rgba(45, 114, 210, 0.3);\n  color: #184a90;\n}\n.bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove {\n  color: #215db0;\n}\n.bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:active {\n  color: #184a90;\n}\n.bp4-tag.bp4-minimal.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.1);\n  color: #1c6e42;\n}\n.bp4-tag.bp4-minimal.bp4-intent-success > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-success .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-success .bp4-icon-large {\n  fill: #1c6e42;\n}\n.bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:hover {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #165a36;\n}\n.bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive.bp4-active {\n  background-color: rgba(35, 133, 81, 0.3);\n  color: #165a36;\n}\n.bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove {\n  color: #1c6e42;\n}\n.bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:active {\n  color: #165a36;\n}\n.bp4-tag.bp4-minimal.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.1);\n  color: #935610;\n}\n.bp4-tag.bp4-minimal.bp4-intent-warning > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-icon-large {\n  fill: #935610;\n}\n.bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:hover {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #77450d;\n}\n.bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive.bp4-active {\n  background-color: rgba(200, 118, 25, 0.3);\n  color: #77450d;\n}\n.bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove {\n  color: #935610;\n}\n.bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:active {\n  color: #77450d;\n}\n.bp4-tag.bp4-minimal.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.1);\n  color: #ac2f33;\n}\n.bp4-tag.bp4-minimal.bp4-intent-danger > .bp4-icon, .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-icon-standard, .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-icon-large {\n  fill: #ac2f33;\n}\n.bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:hover {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #8e292c;\n}\n.bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:active, .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive.bp4-active {\n  background-color: rgba(205, 66, 70, 0.3);\n  color: #8e292c;\n}\n.bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove {\n  color: #ac2f33;\n}\n.bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:hover, .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:active {\n  color: #8e292c;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary {\n  background-color: rgba(45, 114, 210, 0.2);\n  color: #8abbff;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:hover {\n  background-color: rgba(45, 114, 210, 0.3);\n  color: #99c4ff;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary.bp4-interactive.bp4-active {\n  background-color: rgba(45, 114, 210, 0.35);\n  color: #99c4ff;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove {\n  color: #8abbff;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-primary .bp4-tag-remove:active {\n  color: #99c4ff;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success {\n  background-color: rgba(35, 133, 81, 0.2);\n  color: #72ca9b;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:hover {\n  background-color: rgba(35, 133, 81, 0.3);\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success.bp4-interactive.bp4-active {\n  background-color: rgba(35, 133, 81, 0.35);\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-success .bp4-tag-remove:active {\n  color: #7cd7a2;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning {\n  background-color: rgba(200, 118, 25, 0.2);\n  color: #fbb360;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:hover {\n  background-color: rgba(200, 118, 25, 0.3);\n  color: #f5c186;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning.bp4-interactive.bp4-active {\n  background-color: rgba(200, 118, 25, 0.35);\n  color: #f5c186;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove {\n  color: #fbb360;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-warning .bp4-tag-remove:active {\n  color: #f5c186;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger {\n  background-color: rgba(205, 66, 70, 0.2);\n  color: #fa999c;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:hover {\n  background-color: rgba(205, 66, 70, 0.3);\n  color: #ffa1a4;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive:active, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger.bp4-interactive.bp4-active {\n  background-color: rgba(205, 66, 70, 0.35);\n  color: #ffa1a4;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove {\n  color: #fa999c;\n}\n.bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:hover, .bp4-dark .bp4-tag.bp4-minimal.bp4-intent-danger .bp4-tag-remove:active {\n  color: #ffa1a4;\n}\n\n.bp4-tag-remove {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  display: flex;\n  margin-bottom: -2px;\n  /* stylelint-disable-next-line declaration-no-important */\n  margin-right: -6px !important;\n  margin-top: -2px;\n  padding: 2px;\n  padding-left: 0;\n}\n.bp4-tag-remove:hover {\n  background: none;\n  color: inherit;\n  text-decoration: none;\n}\n.bp4-tag-remove .bp4-icon:first-child {\n  color: inherit;\n}\n.bp4-tag-remove:hover, .bp4-tag-remove:active {\n  color: #ffffff;\n}\n.bp4-tag-remove:empty::before {\n  font-family: \"blueprint-icons-16\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  content: \"\\f2ba\";\n}\n.bp4-large .bp4-tag-remove {\n  /* stylelint-disable-next-line declaration-no-important */\n  margin-right: -10px !important;\n  padding: 0 5px 0 0;\n}\n.bp4-large .bp4-tag-remove:empty::before {\n  font-family: \"blueprint-icons-20\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 1;\n}\n.bp4-dark .bp4-tag-remove {\n  color: rgba(28, 33, 39, 0.7);\n}\n.bp4-dark .bp4-tag-remove:hover, .bp4-dark .bp4-tag-remove:active {\n  color: #1c2127;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nCSS `border` property issues:\n- An element can only have one border.\n- Borders can't stack with shadows.\n- Borders modify the size of the element they're applied to.\n- Border positioning requires the extra `box-sizing` property.\n\n`box-shadow` doesn't have these issues, we're using it instead of `border`.\n*/\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-tag-input {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  cursor: text;\n  height: auto;\n  line-height: inherit;\n  min-height: 30px;\n  padding-left: 5px;\n  padding-right: 0;\n}\n.bp4-tag-input > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-tag-input > .bp4-tag-input-values {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-tag-input .bp4-tag-input-icon {\n  color: #5f6b7c;\n  margin-left: 2px;\n  margin-right: 7px;\n  margin-top: 7px;\n}\n.bp4-tag-input .bp4-tag-input-values {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  flex-wrap: wrap;\n  margin-right: 7px;\n  margin-top: 5px;\n  min-width: 0;\n  position: relative;\n}\n.bp4-tag-input .bp4-tag-input-values > * {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.bp4-tag-input .bp4-tag-input-values > .bp4-fill {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n.bp4-tag-input .bp4-tag-input-values::before,\n.bp4-tag-input .bp4-tag-input-values > * {\n  margin-right: 5px;\n}\n.bp4-tag-input .bp4-tag-input-values:empty::before,\n.bp4-tag-input .bp4-tag-input-values > :last-child {\n  margin-right: 0;\n}\n.bp4-tag-input .bp4-tag-input-values:first-child .bp4-tag ~ .bp4-input-ghost {\n  padding-left: 0;\n}\n.bp4-tag-input .bp4-tag-input-values:first-child .bp4-input-ghost {\n  padding-left: 5px;\n}\n.bp4-tag-input .bp4-tag-input-values > * {\n  margin-bottom: 5px;\n}\n.bp4-tag-input .bp4-tag {\n  overflow-wrap: break-word;\n}\n.bp4-tag-input .bp4-tag.bp4-active {\n  outline: rgba(45, 114, 210, 0.6) solid 2px;\n  outline-offset: 0;\n  -moz-outline-radius: 6px;\n}\n.bp4-tag-input .bp4-input-ghost {\n  flex: 1 1 auto;\n  line-height: 20px;\n  width: 80px;\n}\n.bp4-tag-input .bp4-input-ghost:disabled, .bp4-tag-input .bp4-input-ghost.bp4-disabled {\n  cursor: not-allowed;\n}\n.bp4-tag-input .bp4-button,\n.bp4-tag-input .bp4-spinner {\n  margin: 3px;\n  margin-left: 0;\n}\n.bp4-tag-input .bp4-button {\n  min-height: 24px;\n  min-width: 24px;\n  padding: 0 7px;\n}\n.bp4-tag-input.bp4-large {\n  height: auto;\n  min-height: 40px;\n}\n.bp4-tag-input.bp4-large::before,\n.bp4-tag-input.bp4-large > * {\n  margin-right: 10px;\n}\n.bp4-tag-input.bp4-large:empty::before,\n.bp4-tag-input.bp4-large > :last-child {\n  margin-right: 0;\n}\n.bp4-tag-input.bp4-large .bp4-tag-input-icon {\n  margin-left: 5px;\n  margin-top: 10px;\n}\n.bp4-tag-input.bp4-large .bp4-input-ghost {\n  line-height: 30px;\n}\n.bp4-tag-input.bp4-large .bp4-button {\n  min-height: 30px;\n  min-width: 30px;\n  padding: 5px 10px;\n  margin: 5px;\n  margin-left: 0;\n}\n.bp4-tag-input.bp4-large .bp4-spinner {\n  margin: 8px;\n  margin-left: 0;\n}\n.bp4-tag-input.bp4-active {\n  background-color: #ffffff;\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-tag-input.bp4-active.bp4-intent-primary {\n  box-shadow: inset 0 0 0 1px #2d72d2, 0 0 0 2px rgba(45, 114, 210, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-tag-input.bp4-active.bp4-intent-success {\n  box-shadow: inset 0 0 0 1px #238551, 0 0 0 2px rgba(35, 133, 81, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-tag-input.bp4-active.bp4-intent-warning {\n  box-shadow: inset 0 0 0 1px #c87619, 0 0 0 2px rgba(200, 118, 25, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-tag-input.bp4-active.bp4-intent-danger {\n  box-shadow: inset 0 0 0 1px #cd4246, 0 0 0 2px rgba(205, 66, 70, 0.3), inset 0 1px 1px rgba(17, 20, 24, 0.2);\n}\n.bp4-dark .bp4-tag-input .bp4-tag-input-icon, .bp4-tag-input.bp4-dark .bp4-tag-input-icon {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-tag-input .bp4-input-ghost, .bp4-tag-input.bp4-dark .bp4-input-ghost {\n  color: #f6f7f9;\n}\n.bp4-dark .bp4-tag-input .bp4-input-ghost::placeholder, .bp4-tag-input.bp4-dark .bp4-input-ghost::placeholder {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-tag-input.bp4-active, .bp4-tag-input.bp4-dark.bp4-active {\n  background-color: rgba(17, 20, 24, 0.3);\n  box-shadow: inset 0 0 0 1px #4c90f0, inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-primary, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-primary {\n  box-shadow: inset 0 0 0 1px #4c90f0, 0 0 0 2px rgba(76, 144, 240, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-success, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-success {\n  box-shadow: inset 0 0 0 1px #32a467, 0 0 0 2px rgba(50, 164, 103, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-warning, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-warning {\n  box-shadow: inset 0 0 0 1px #ec9a3c, 0 0 0 2px rgba(236, 154, 60, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n.bp4-dark .bp4-tag-input.bp4-active.bp4-intent-danger, .bp4-tag-input.bp4-dark.bp4-active.bp4-intent-danger {\n  box-shadow: inset 0 0 0 1px #e76a6e, 0 0 0 2px rgba(231, 106, 110, 0.3), inset 0 0 0 1px rgba(255, 255, 255, 0.2), inset 0 -1px 1px 0 #8f99a8;\n}\n\n.bp4-input-ghost {\n  background: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n.bp4-input-ghost::placeholder {\n  color: #5f6b7c;\n  opacity: 1;\n}\n.bp4-input-ghost:focus {\n  /* stylelint-disable-next-line declaration-no-important */\n  outline: none !important;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n.bp4-resizable-input-span {\n  max-height: 0;\n  max-width: 100%;\n  min-width: 80px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  z-index: -1;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n.bp4-toast {\n  align-items: flex-start;\n  background-color: #ffffff;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n  display: flex;\n  margin: 20px 0 0;\n  max-width: 500px;\n  min-width: 300px;\n  pointer-events: all;\n  /* stylelint-disable-next-line declaration-no-important */\n  position: relative !important;\n}\n.bp4-toast.bp4-toast-enter, .bp4-toast.bp4-toast-appear {\n  transform: translateY(-40px);\n}\n.bp4-toast.bp4-toast-enter-active, .bp4-toast.bp4-toast-appear-active {\n  transform: translateY(0);\n  transition-delay: 0;\n  transition-duration: 300ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n}\n.bp4-toast.bp4-toast-enter ~ .bp4-toast, .bp4-toast.bp4-toast-appear ~ .bp4-toast {\n  transform: translateY(-40px);\n}\n.bp4-toast.bp4-toast-enter-active ~ .bp4-toast, .bp4-toast.bp4-toast-appear-active ~ .bp4-toast {\n  transform: translateY(0);\n  transition-delay: 0;\n  transition-duration: 300ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.54, 1.12, 0.38, 1.11);\n}\n.bp4-toast.bp4-toast-exit {\n  opacity: 1;\n  filter: blur(0);\n}\n.bp4-toast.bp4-toast-exit-active {\n  opacity: 0;\n  filter: blur(10px);\n  transition-delay: 0;\n  transition-duration: 300ms;\n  transition-property: opacity, filter;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-toast.bp4-toast-exit ~ .bp4-toast {\n  transform: translateY(0);\n}\n.bp4-toast.bp4-toast-exit-active ~ .bp4-toast {\n  transform: translateY(-40px);\n  transition-delay: 50ms;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-toast .bp4-button-group {\n  flex: 0 0 auto;\n  padding: 5px;\n  padding-left: 0;\n}\n.bp4-toast > .bp4-icon {\n  color: #5f6b7c;\n  margin: 12px;\n  margin-right: 0;\n}\n.bp4-toast.bp4-dark, .bp4-dark .bp4-toast {\n  background-color: #404854;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n}\n.bp4-toast.bp4-dark > .bp4-icon, .bp4-dark .bp4-toast > .bp4-icon {\n  color: #abb3bf;\n}\n.bp4-toast.bp4-dark .bp4-button .bp4-icon, .bp4-dark .bp4-toast .bp4-button .bp4-icon {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-toast[class*=bp4-intent-] a {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-toast[class*=bp4-intent-] a:hover {\n  color: #ffffff;\n}\n.bp4-toast[class*=bp4-intent-] > .bp4-icon {\n  color: #ffffff;\n}\n.bp4-toast.bp4-intent-primary {\n  background-color: #2d72d2;\n  color: #ffffff;\n  /* stylelint-disable declaration-no-important */\n  /* stylelint-enable declaration-no-important */\n}\n.bp4-toast.bp4-intent-primary .bp4-icon:first-child {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-toast.bp4-intent-primary .bp4-button {\n  background-color: #2d72d2 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-primary .bp4-button:hover {\n  background-color: #215db0 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-primary .bp4-button:active {\n  background-color: #184a90 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-primary .bp4-button:focus {\n  outline-color: rgba(255, 255, 255, 0.5);\n}\n.bp4-toast.bp4-intent-primary .bp4-button:last-child > .bp4-icon-cross {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n.bp4-toast.bp4-intent-success {\n  background-color: #238551;\n  color: #ffffff;\n  /* stylelint-disable declaration-no-important */\n  /* stylelint-enable declaration-no-important */\n}\n.bp4-toast.bp4-intent-success .bp4-icon:first-child {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-toast.bp4-intent-success .bp4-button {\n  background-color: #238551 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-success .bp4-button:hover {\n  background-color: #1c6e42 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-success .bp4-button:active {\n  background-color: #165a36 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-success .bp4-button:focus {\n  outline-color: rgba(255, 255, 255, 0.5);\n}\n.bp4-toast.bp4-intent-success .bp4-button:last-child > .bp4-icon-cross {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n.bp4-toast.bp4-intent-warning {\n  background-color: #fbb360;\n  color: #1c2127;\n  /* stylelint-disable declaration-no-important */\n  /* stylelint-enable declaration-no-important */\n}\n.bp4-toast.bp4-intent-warning .bp4-icon:first-child {\n  color: rgba(28, 33, 39, 0.7);\n}\n.bp4-toast.bp4-intent-warning .bp4-button {\n  background-color: #fbb360 !important;\n  color: #1c2127 !important;\n}\n.bp4-toast.bp4-intent-warning .bp4-button:hover {\n  background-color: #ec9a3c !important;\n  color: #1c2127 !important;\n}\n.bp4-toast.bp4-intent-warning .bp4-button:active {\n  background-color: #c87619 !important;\n  color: #1c2127 !important;\n}\n.bp4-toast.bp4-intent-warning .bp4-button:focus {\n  outline-color: rgba(255, 255, 255, 0.5);\n}\n.bp4-toast.bp4-intent-warning .bp4-button:last-child > .bp4-icon-cross {\n  color: rgba(28, 33, 39, 0.7) !important;\n}\n.bp4-toast.bp4-intent-danger {\n  background-color: #cd4246;\n  color: #ffffff;\n  /* stylelint-disable declaration-no-important */\n  /* stylelint-enable declaration-no-important */\n}\n.bp4-toast.bp4-intent-danger .bp4-icon:first-child {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-toast.bp4-intent-danger .bp4-button {\n  background-color: #cd4246 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-danger .bp4-button:hover {\n  background-color: #ac2f33 !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-danger .bp4-button:active {\n  background-color: #8e292c !important;\n  color: #ffffff !important;\n}\n.bp4-toast.bp4-intent-danger .bp4-button:focus {\n  outline-color: rgba(255, 255, 255, 0.5);\n}\n.bp4-toast.bp4-intent-danger .bp4-button:last-child > .bp4-icon-cross {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.bp4-toast-message {\n  flex: 1 1 auto;\n  padding: 11px;\n  word-break: break-word;\n}\n\n.bp4-toast-container {\n  align-items: center;\n  /* stylelint-disable-next-line declaration-no-important */\n  display: flex !important;\n  flex-direction: column;\n  left: 0;\n  overflow: hidden;\n  padding: 0 20px 20px;\n  pointer-events: none;\n  right: 0;\n  z-index: 40;\n}\n.bp4-toast-container.bp4-toast-container-in-portal {\n  position: fixed;\n}\n.bp4-toast-container.bp4-toast-container-inline {\n  position: absolute;\n}\n.bp4-toast-container.bp4-toast-container-top {\n  top: 0;\n}\n.bp4-toast-container.bp4-toast-container-bottom {\n  bottom: 0;\n  flex-direction: column-reverse;\n  top: auto;\n}\n.bp4-toast-container.bp4-toast-container-left {\n  align-items: flex-start;\n}\n.bp4-toast-container.bp4-toast-container-right {\n  align-items: flex-end;\n}\n\n.bp4-toast-container-bottom .bp4-toast.bp4-toast-enter:not(.bp4-toast-enter-active), .bp4-toast-container-bottom .bp4-toast.bp4-toast-enter:not(.bp4-toast-enter-active) ~ .bp4-toast, .bp4-toast-container-bottom .bp4-toast.bp4-toast-appear:not(.bp4-toast-appear-active), .bp4-toast-container-bottom .bp4-toast.bp4-toast-appear:not(.bp4-toast-appear-active) ~ .bp4-toast, .bp4-toast-container-bottom .bp4-toast.bp4-toast-exit-active ~ .bp4-toast, .bp4-toast-container-bottom .bp4-toast.bp4-toast-leave-active ~ .bp4-toast {\n  transform: translateY(60px);\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nA mixin to generate the classes for a React CSSTransition which animates any number of CSS\nproperties at once.\n\nTransitioned properties are specificed as a map of property names to lists of (inital value, final\nvalue). For enter & appear transitions, each property will transition from its initial to its final\nvalue. For exit transitions, each property will transition in reverse, from final to initial.\n\n**Simple example:**\n`@include react-transition(\"popover\", (opacity: 0 1), $before: \"&\");`\nTransition named \"popover\" moves opacity from 0 to 1. `\"&\"` indicates that the\nTransition classes are expected to be applied to this element, where the mixin is invoked.\n\n**Params:**\n$name: React transitionName prop\n$properties: map of CSS property to (initial, final) values\n$duration: transition duration\n$easing: transition easing function\n$delay: transition delay\n$before: selector text to insert before transition name (often to select self: &)\n$after: selector text to insert after transiton name (to select children)\n*/\n/*\nA mixin to generate the classes for one phase of a React CSSTransition.\n`$phase` must be `appear` or `enter` or `exit`.\nIf `enter` phase is given then `appear` phase will be generated at the same time.\nIf `exit` phase is given then property values are animated in reverse, from final to initial.\n\n**Example:**\n@include react-transition-phase(toast, enter, $enter-translate, $before: \"&\");\n@include react-transition-phase(toast, leave, $leave-blur, $pt-transition-duration * 3, $before: \"&\");\n*/\n/*\nGiven map of properties to values, set each property to the value at the given index.\n(remember that sass indices are 1-based).\n\nExample: `each-prop((opacity: 0 1), 2)` will print \"opacity: 1\"\n*/\n/*\nFormat transition class name with all the bits.\n\"enter\" phase will include \"appear\" phase in returned name.\n*/\n.bp4-tooltip {\n  /* stylelint-disable-next-line max-line-length */\n  /* stylelint-disable-next-line max-line-length */\n  /* stylelint-disable-next-line max-line-length */\n  /* stylelint-disable-next-line max-line-length */\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 2px 4px rgba(17, 20, 24, 0.2), 0 8px 24px rgba(17, 20, 24, 0.2);\n  transform: scale(1);\n  color: #f6f7f9;\n}\n.bp4-tooltip .bp4-popover-arrow {\n  height: 22px;\n  position: absolute;\n  width: 22px;\n}\n.bp4-tooltip .bp4-popover-arrow::before {\n  height: 14px;\n  margin: 4px;\n  width: 14px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-tooltip {\n  margin-bottom: 11px;\n  margin-top: -11px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-tooltip > .bp4-popover-arrow {\n  bottom: -8px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-top > .bp4-tooltip > .bp4-popover-arrow svg {\n  transform: rotate(-90deg);\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-tooltip {\n  margin-left: 11px;\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-tooltip > .bp4-popover-arrow {\n  left: -8px;\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-right > .bp4-tooltip > .bp4-popover-arrow svg {\n  transform: rotate(0);\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-tooltip {\n  margin-top: 11px;\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-tooltip > .bp4-popover-arrow {\n  top: -8px;\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-bottom > .bp4-tooltip > .bp4-popover-arrow svg {\n  transform: rotate(90deg);\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-tooltip {\n  margin-left: -11px;\n  margin-right: 11px;\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-tooltip > .bp4-popover-arrow {\n  right: -8px;\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-left > .bp4-tooltip > .bp4-popover-arrow svg {\n  transform: rotate(180deg);\n}\n.bp4-tether-element-attached-middle > .bp4-tooltip > .bp4-popover-arrow {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.bp4-tether-element-attached-center > .bp4-tooltip > .bp4-popover-arrow {\n  right: 50%;\n  transform: translateX(50%);\n}\n.bp4-tether-element-attached-top.bp4-tether-target-attached-top > .bp4-tooltip > .bp4-popover-arrow {\n  top: -0.2218253939px;\n}\n.bp4-tether-element-attached-right.bp4-tether-target-attached-right > .bp4-tooltip > .bp4-popover-arrow {\n  right: -0.2218253939px;\n}\n.bp4-tether-element-attached-left.bp4-tether-target-attached-left > .bp4-tooltip > .bp4-popover-arrow {\n  left: -0.2218253939px;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-target-attached-bottom > .bp4-tooltip > .bp4-popover-arrow {\n  bottom: -0.2218253939px;\n}\n.bp4-tether-element-attached-top.bp4-tether-element-attached-left > .bp4-tooltip {\n  transform-origin: top left;\n}\n.bp4-tether-element-attached-top.bp4-tether-element-attached-center > .bp4-tooltip {\n  transform-origin: top center;\n}\n.bp4-tether-element-attached-top.bp4-tether-element-attached-right > .bp4-tooltip {\n  transform-origin: top right;\n}\n.bp4-tether-element-attached-middle.bp4-tether-element-attached-left > .bp4-tooltip {\n  transform-origin: center left;\n}\n.bp4-tether-element-attached-middle.bp4-tether-element-attached-center > .bp4-tooltip {\n  transform-origin: center center;\n}\n.bp4-tether-element-attached-middle.bp4-tether-element-attached-right > .bp4-tooltip {\n  transform-origin: center right;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-element-attached-left > .bp4-tooltip {\n  transform-origin: bottom left;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-element-attached-center > .bp4-tooltip {\n  transform-origin: bottom center;\n}\n.bp4-tether-element-attached-bottom.bp4-tether-element-attached-right > .bp4-tooltip {\n  transform-origin: bottom right;\n}\n.bp4-tooltip .bp4-popover-content {\n  background: #404854;\n}\n.bp4-tooltip .bp4-popover-content,\n.bp4-tooltip .bp4-heading {\n  color: #f6f7f9;\n}\n.bp4-tooltip .bp4-popover-arrow::before {\n  box-shadow: 1px 1px 6px rgba(17, 20, 24, 0.2);\n}\n.bp4-tooltip .bp4-popover-arrow-border {\n  fill: #111418;\n  fill-opacity: 0.1;\n}\n.bp4-tooltip .bp4-popover-arrow-fill {\n  fill: #404854;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tooltip .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n.bp4-popover-enter > .bp4-tooltip, .bp4-popover-appear > .bp4-tooltip {\n  transform: scale(0.8);\n}\n.bp4-popover-enter-active > .bp4-tooltip, .bp4-popover-appear-active > .bp4-tooltip {\n  transform: scale(1);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-popover-exit > .bp4-tooltip {\n  transform: scale(1);\n}\n.bp4-popover-exit-active > .bp4-tooltip {\n  transform: scale(0.8);\n  transition-delay: 0;\n  transition-duration: 100ms;\n  transition-property: transform;\n  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */\n  transition-timing-function: cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-tooltip .bp4-text-muted {\n  color: #abb3bf;\n}\n.bp4-tooltip .bp4-text-disabled {\n  color: rgba(171, 179, 191, 0.6);\n}\n.bp4-tooltip .bp4-running-text hr {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.bp4-tooltip a {\n  color: #8abbff;\n}\n.bp4-tooltip a:hover {\n  color: #8abbff;\n}\n.bp4-tooltip a .bp4-icon, .bp4-tooltip a .bp4-icon-standard, .bp4-tooltip a .bp4-icon-large {\n  color: inherit;\n}\n.bp4-tooltip a code {\n  color: inherit;\n}\n.bp4-tooltip .bp4-code,\n.bp4-tooltip .bp4-running-text code {\n  background: rgba(17, 20, 24, 0.3);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.4);\n  color: #abb3bf;\n}\na > .bp4-tooltip .bp4-code,\na > .bp4-tooltip .bp4-running-text code {\n  color: inherit;\n}\n.bp4-tooltip .bp4-code-block,\n.bp4-tooltip .bp4-running-text pre {\n  background: rgba(17, 20, 24, 0.3);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.4);\n  color: #f6f7f9;\n}\n.bp4-tooltip .bp4-code-block > code,\n.bp4-tooltip .bp4-running-text pre > code {\n  background: none;\n  box-shadow: none;\n  color: inherit;\n}\n.bp4-tooltip .bp4-key,\n.bp4-tooltip .bp4-running-text kbd {\n  background: #383e47;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 1px 1px 0 rgba(17, 20, 24, 0.4);\n  color: #abb3bf;\n}\n.bp4-tooltip .bp4-icon.bp4-intent-primary, .bp4-tooltip .bp4-icon-standard.bp4-intent-primary, .bp4-tooltip .bp4-icon-large.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-tooltip .bp4-icon.bp4-intent-success, .bp4-tooltip .bp4-icon-standard.bp4-intent-success, .bp4-tooltip .bp4-icon-large.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-tooltip .bp4-icon.bp4-intent-warning, .bp4-tooltip .bp4-icon-standard.bp4-intent-warning, .bp4-tooltip .bp4-icon-large.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-tooltip .bp4-icon.bp4-intent-danger, .bp4-tooltip .bp4-icon-standard.bp4-intent-danger, .bp4-tooltip .bp4-icon-large.bp4-intent-danger {\n  color: #fa999c;\n}\n.bp4-tooltip .bp4-popover-content {\n  padding: 10px 12px;\n}\n.bp4-tooltip.bp4-dark, .bp4-dark .bp4-tooltip {\n  box-shadow: 0 2px 4px rgba(17, 20, 24, 0.4), 0 8px 24px rgba(17, 20, 24, 0.4);\n}\n.bp4-tooltip.bp4-dark .bp4-popover-content, .bp4-dark .bp4-tooltip .bp4-popover-content {\n  background: #e5e8eb;\n}\n.bp4-tooltip.bp4-dark .bp4-popover-content,\n.bp4-tooltip.bp4-dark .bp4-heading, .bp4-dark .bp4-tooltip .bp4-popover-content,\n.bp4-dark .bp4-tooltip .bp4-heading {\n  color: #404854;\n}\n.bp4-tooltip.bp4-dark .bp4-popover-arrow::before, .bp4-dark .bp4-tooltip .bp4-popover-arrow::before {\n  box-shadow: 1px 1px 6px rgba(17, 20, 24, 0.4);\n}\n.bp4-tooltip.bp4-dark .bp4-popover-arrow-border, .bp4-dark .bp4-tooltip .bp4-popover-arrow-border {\n  fill: #111418;\n  fill-opacity: 0.2;\n}\n.bp4-tooltip.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-tooltip .bp4-popover-arrow-fill {\n  fill: #e5e8eb;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tooltip.bp4-dark .bp4-popover-arrow-fill, .bp4-dark .bp4-tooltip .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n.bp4-tooltip.bp4-dark .bp4-text-muted, .bp4-dark .bp4-tooltip .bp4-text-muted {\n  color: #5f6b7c;\n}\n.bp4-tooltip.bp4-dark .bp4-text-disabled, .bp4-dark .bp4-tooltip .bp4-text-disabled {\n  color: rgba(95, 107, 124, 0.6);\n}\n.bp4-tooltip.bp4-dark .bp4-running-text hr, .bp4-dark .bp4-tooltip .bp4-running-text hr {\n  border-color: rgba(17, 20, 24, 0.15);\n}\n.bp4-tooltip.bp4-dark a, .bp4-dark .bp4-tooltip a {\n  color: #215db0;\n}\n.bp4-tooltip.bp4-dark a:hover, .bp4-dark .bp4-tooltip a:hover {\n  color: #215db0;\n}\n.bp4-tooltip.bp4-dark a .bp4-icon, .bp4-tooltip.bp4-dark a .bp4-icon-standard, .bp4-tooltip.bp4-dark a .bp4-icon-large, .bp4-dark .bp4-tooltip a .bp4-icon, .bp4-dark .bp4-tooltip a .bp4-icon-standard, .bp4-dark .bp4-tooltip a .bp4-icon-large {\n  color: inherit;\n}\n.bp4-tooltip.bp4-dark a code, .bp4-dark .bp4-tooltip a code {\n  color: inherit;\n}\n.bp4-tooltip.bp4-dark .bp4-code,\n.bp4-tooltip.bp4-dark .bp4-running-text code, .bp4-dark .bp4-tooltip .bp4-code,\n.bp4-dark .bp4-tooltip .bp4-running-text code {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2);\n  color: #5f6b7c;\n}\na > .bp4-tooltip.bp4-dark .bp4-code,\na > .bp4-tooltip.bp4-dark .bp4-running-text code, a > .bp4-dark .bp4-tooltip .bp4-code,\na > .bp4-dark .bp4-tooltip .bp4-running-text code {\n  color: #2d72d2;\n}\n.bp4-tooltip.bp4-dark .bp4-code-block,\n.bp4-tooltip.bp4-dark .bp4-running-text pre, .bp4-dark .bp4-tooltip .bp4-code-block,\n.bp4-dark .bp4-tooltip .bp4-running-text pre {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.15);\n  color: #1c2127;\n}\n.bp4-tooltip.bp4-dark .bp4-code-block > code,\n.bp4-tooltip.bp4-dark .bp4-running-text pre > code, .bp4-dark .bp4-tooltip .bp4-code-block > code,\n.bp4-dark .bp4-tooltip .bp4-running-text pre > code {\n  background: none;\n  box-shadow: none;\n  color: inherit;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tooltip.bp4-dark .bp4-code-block,\n  .bp4-tooltip.bp4-dark .bp4-running-text pre, .bp4-dark .bp4-tooltip .bp4-code-block,\n  .bp4-dark .bp4-tooltip .bp4-running-text pre {\n    border: 1px solid buttonborder;\n    box-shadow: none;\n  }\n}\n.bp4-tooltip.bp4-dark .bp4-key,\n.bp4-tooltip.bp4-dark .bp4-running-text kbd, .bp4-dark .bp4-tooltip .bp4-key,\n.bp4-dark .bp4-tooltip .bp4-running-text kbd {\n  background: #ffffff;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.2);\n  color: #5f6b7c;\n}\n.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-primary, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-primary, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-primary, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-primary, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-primary, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-primary {\n  color: #215db0;\n}\n.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-success, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-success, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-success, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-success, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-success, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-success {\n  color: #1c6e42;\n}\n.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-warning, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-warning, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-warning, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-warning, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-warning, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-warning {\n  color: #935610;\n}\n.bp4-tooltip.bp4-dark .bp4-icon.bp4-intent-danger, .bp4-tooltip.bp4-dark .bp4-icon-standard.bp4-intent-danger, .bp4-tooltip.bp4-dark .bp4-icon-large.bp4-intent-danger, .bp4-dark .bp4-tooltip .bp4-icon.bp4-intent-danger, .bp4-dark .bp4-tooltip .bp4-icon-standard.bp4-intent-danger, .bp4-dark .bp4-tooltip .bp4-icon-large.bp4-intent-danger {\n  color: #ac2f33;\n}\n.bp4-tooltip.bp4-intent-primary .bp4-popover-content {\n  background: #2d72d2;\n  color: #ffffff;\n}\n.bp4-tooltip.bp4-intent-primary .bp4-popover-arrow-fill {\n  fill: #2d72d2;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tooltip.bp4-intent-primary .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n.bp4-tooltip.bp4-intent-success .bp4-popover-content {\n  background: #238551;\n  color: #ffffff;\n}\n.bp4-tooltip.bp4-intent-success .bp4-popover-arrow-fill {\n  fill: #238551;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tooltip.bp4-intent-success .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n.bp4-tooltip.bp4-intent-warning .bp4-popover-content {\n  background: #c87619;\n  color: #ffffff;\n}\n.bp4-tooltip.bp4-intent-warning .bp4-popover-arrow-fill {\n  fill: #c87619;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tooltip.bp4-intent-warning .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n.bp4-tooltip.bp4-intent-danger .bp4-popover-content {\n  background: #cd4246;\n  color: #ffffff;\n}\n.bp4-tooltip.bp4-intent-danger .bp4-popover-arrow-fill {\n  fill: #cd4246;\n}\n@media (forced-colors: active) and (prefers-color-scheme: dark) {\n  .bp4-tooltip.bp4-intent-danger .bp4-popover-arrow-fill {\n    fill: buttonborder;\n  }\n}\n\n.bp4-tooltip-indicator {\n  border-bottom: dotted 1px;\n  cursor: help;\n}\n\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\n * Copyright 2023 Palantir Technologies, Inc. All rights reserved.\n */\n/*\nTrees\n\nMarkup:\n<div class=\"bp4-tree bp4-elevation-0\">\n  <ul class=\"bp4-tree-node-list bp4-tree-root\">\n    <li class=\"bp4-tree-node bp4-tree-node-expanded\">\n      <div class=\"bp4-tree-node-content\">\n        <span class=\"bp4-tree-node-caret bp4-tree-node-caret-open bp4-icon-standard\"></span>\n        <span class=\"bp4-tree-node-icon bp4-icon-standard bp4-icon-folder-close\"></span>\n        <span class=\"bp4-tree-node-label\">Label</span>\n        <span class=\"bp4-tree-node-secondary-label\">Secondary label</span>\n      </div>\n      <ul class=\"bp4-tree-node-list\">\n        <li class=\"bp4-tree-node\">\n          <div class=\"bp4-tree-node-content\">\n            <span class=\"bp4-tree-node-caret-none bp4-icon-standard\"></span>\n            <span class=\"bp4-tree-node-icon bp4-icon-standard bp4-icon-document\"></span>\n          <span class=\"bp4-tree-node-label\">A Document</span>\n          </div>\n        </li>\n        <li class=\"bp4-tree-node\">\n          <div class=\"bp4-tree-node-content\">\n            <span class=\"bp4-tree-node-caret-none bp4-icon-standard\"></span>\n            <span class=\"bp4-tree-node-icon bp4-icon-standard bp4-icon-document\"></span>\n            <span class=\"bp4-tree-node-label\">Another Document</span>\n          </div>\n        </li>\n      </ul>\n    </li>\n  </ul>\n</div>\n\nStyleguide tree\n*/\n.bp4-tree .bp4-icon, .bp4-tree .bp4-icon-standard, .bp4-tree .bp4-icon-large {\n  color: #5f6b7c;\n}\n.bp4-tree .bp4-icon.bp4-intent-primary, .bp4-tree .bp4-icon-standard.bp4-intent-primary, .bp4-tree .bp4-icon-large.bp4-intent-primary {\n  color: #2d72d2;\n}\n.bp4-tree .bp4-icon.bp4-intent-success, .bp4-tree .bp4-icon-standard.bp4-intent-success, .bp4-tree .bp4-icon-large.bp4-intent-success {\n  color: #238551;\n}\n.bp4-tree .bp4-icon.bp4-intent-warning, .bp4-tree .bp4-icon-standard.bp4-intent-warning, .bp4-tree .bp4-icon-large.bp4-intent-warning {\n  color: #c87619;\n}\n.bp4-tree .bp4-icon.bp4-intent-danger, .bp4-tree .bp4-icon-standard.bp4-intent-danger, .bp4-tree .bp4-icon-large.bp4-intent-danger {\n  color: #cd4246;\n}\n\n.bp4-tree-node-list {\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n}\n\n.bp4-tree-root {\n  background-color: transparent;\n  cursor: default;\n  padding-left: 0;\n  position: relative;\n}\n\n.bp4-tree-node-content-0 {\n  padding-left: 0px;\n}\n\n.bp4-tree-node-content-1 {\n  padding-left: 23px;\n}\n\n.bp4-tree-node-content-2 {\n  padding-left: 46px;\n}\n\n.bp4-tree-node-content-3 {\n  padding-left: 69px;\n}\n\n.bp4-tree-node-content-4 {\n  padding-left: 92px;\n}\n\n.bp4-tree-node-content-5 {\n  padding-left: 115px;\n}\n\n.bp4-tree-node-content-6 {\n  padding-left: 138px;\n}\n\n.bp4-tree-node-content-7 {\n  padding-left: 161px;\n}\n\n.bp4-tree-node-content-8 {\n  padding-left: 184px;\n}\n\n.bp4-tree-node-content-9 {\n  padding-left: 207px;\n}\n\n.bp4-tree-node-content-10 {\n  padding-left: 230px;\n}\n\n.bp4-tree-node-content-11 {\n  padding-left: 253px;\n}\n\n.bp4-tree-node-content-12 {\n  padding-left: 276px;\n}\n\n.bp4-tree-node-content-13 {\n  padding-left: 299px;\n}\n\n.bp4-tree-node-content-14 {\n  padding-left: 322px;\n}\n\n.bp4-tree-node-content-15 {\n  padding-left: 345px;\n}\n\n.bp4-tree-node-content-16 {\n  padding-left: 368px;\n}\n\n.bp4-tree-node-content-17 {\n  padding-left: 391px;\n}\n\n.bp4-tree-node-content-18 {\n  padding-left: 414px;\n}\n\n.bp4-tree-node-content-19 {\n  padding-left: 437px;\n}\n\n.bp4-tree-node-content-20 {\n  padding-left: 460px;\n}\n\n.bp4-tree-node-content {\n  align-items: center;\n  background: none;\n  display: flex;\n  height: 30px;\n  padding-right: 5px;\n  width: 100%;\n}\n.bp4-tree-node-content:hover {\n  background-color: rgba(143, 153, 168, 0.15);\n}\n.bp4-tree-node-content:active {\n  background-color: rgba(143, 153, 168, 0.3);\n}\n\n.bp4-tree-node-caret,\n.bp4-tree-node-caret-none {\n  min-width: 30px;\n}\n\n.bp4-tree-node-caret {\n  color: #5f6b7c;\n  cursor: pointer;\n  padding: 7px;\n  transform: rotate(0deg);\n  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9);\n}\n.bp4-tree-node-caret:hover {\n  color: #1c2127;\n}\n.bp4-dark .bp4-tree-node-caret {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-tree-node-caret:hover {\n  color: #f6f7f9;\n}\n.bp4-tree-node-caret.bp4-tree-node-caret-open {\n  transform: rotate(90deg);\n}\n.bp4-tree-node-caret.bp4-icon-standard::before {\n  content: \"\\f14d\";\n}\n\n.bp4-tree-node-icon {\n  margin-right: 7px;\n  position: relative;\n}\n\n.bp4-tree-node-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  flex: 1 1 auto;\n  position: relative;\n  user-select: none;\n}\n.bp4-tree-node-label span {\n  display: inline;\n}\n\n.bp4-tree-node-secondary-label {\n  padding: 0 5px;\n  user-select: none;\n}\n.bp4-tree-node-secondary-label .bp4-popover-wrapper,\n.bp4-tree-node-secondary-label .bp4-popover-target {\n  align-items: center;\n  display: flex;\n}\n\n.bp4-tree-node.bp4-disabled .bp4-tree-node-content {\n  background-color: inherit;\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n.bp4-tree-node.bp4-disabled .bp4-tree-node-caret,\n.bp4-tree-node.bp4-disabled .bp4-tree-node-icon {\n  color: rgba(95, 107, 124, 0.6);\n  cursor: not-allowed;\n}\n\n.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content {\n  background-color: #2d72d2;\n}\n.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content,\n.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon, .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-standard, .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-large {\n  color: #ffffff;\n}\n.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-tree-node-caret::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n.bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-tree-node-caret:hover::before {\n  color: #ffffff;\n}\n\n.bp4-dark .bp4-tree-node-content:hover {\n  background-color: rgba(95, 107, 124, 0.3);\n}\n.bp4-dark .bp4-tree .bp4-icon, .bp4-dark .bp4-tree .bp4-icon-standard, .bp4-dark .bp4-tree .bp4-icon-large {\n  color: #abb3bf;\n}\n.bp4-dark .bp4-tree .bp4-icon.bp4-intent-primary, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-primary, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-primary {\n  color: #8abbff;\n}\n.bp4-dark .bp4-tree .bp4-icon.bp4-intent-success, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-success, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-success {\n  color: #72ca9b;\n}\n.bp4-dark .bp4-tree .bp4-icon.bp4-intent-warning, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-warning, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-warning {\n  color: #fbb360;\n}\n.bp4-dark .bp4-tree .bp4-icon.bp4-intent-danger, .bp4-dark .bp4-tree .bp4-icon-standard.bp4-intent-danger, .bp4-dark .bp4-tree .bp4-icon-large.bp4-intent-danger {\n  color: #fa999c;\n}\n.bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content {\n  background-color: #2d72d2;\n}\n.bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon, .bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-standard, .bp4-dark .bp4-tree-node.bp4-tree-node-selected > .bp4-tree-node-content .bp4-icon-large {\n  color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
